var ri = function(t, e) {
  return ri = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
    n.__proto__ = a;
  } || function(n, a) {
    for (var r in a)
      Object.prototype.hasOwnProperty.call(a, r) && (n[r] = a[r]);
  }, ri(t, e);
};
function ye(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  ri(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
function fp(t, e, n, a) {
  function r(i) {
    return i instanceof n ? i : new n(function(s) {
      s(i);
    });
  }
  return new (n || (n = Promise))(function(i, s) {
    function o(f) {
      try {
        u(a.next(f));
      } catch (m) {
        s(m);
      }
    }
    function l(f) {
      try {
        u(a.throw(f));
      } catch (m) {
        s(m);
      }
    }
    function u(f) {
      f.done ? i(f.value) : r(f.value).then(o, l);
    }
    u((a = a.apply(t, e || [])).next());
  });
}
function Yo(t, e) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, a, r, i, s;
  return s = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function o(u) {
    return function(f) {
      return l([u, f]);
    };
  }
  function l(u) {
    if (a)
      throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, u[0] && (n = 0)), n; )
      try {
        if (a = 1, r && (i = u[0] & 2 ? r.return : u[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, u[1])).done)
          return i;
        switch (r = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
          case 0:
          case 1:
            i = u;
            break;
          case 4:
            return n.label++, { value: u[1], done: !1 };
          case 5:
            n.label++, r = u[1], u = [0];
            continue;
          case 7:
            u = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              n = 0;
              continue;
            }
            if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
              n.label = u[1];
              break;
            }
            if (u[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = u;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(u);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        u = e.call(t, n);
      } catch (f) {
        u = [6, f], r = 0;
      } finally {
        a = i = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function En(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], a = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && a >= t.length && (t = void 0), { value: t && t[a++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function fe(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var a = n.call(t), r, i = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(r = a.next()).done; )
      i.push(r.value);
  } catch (o) {
    s = { error: o };
  } finally {
    try {
      r && !r.done && (n = a.return) && n.call(a);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return i;
}
function Te(t, e, n) {
  if (n || arguments.length === 2)
    for (var a = 0, r = e.length, i; a < r; a++)
      (i || !(a in e)) && (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
  return t.concat(i || Array.prototype.slice.call(e));
}
function kn(t) {
  return this instanceof kn ? (this.v = t, this) : new kn(t);
}
function pp(t, e, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var a = n.apply(t, e || []), r, i = [];
  return r = {}, s("next"), s("throw"), s("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r;
  function s(y) {
    a[y] && (r[y] = function(_) {
      return new Promise(function(S, h) {
        i.push([y, _, S, h]) > 1 || o(y, _);
      });
    });
  }
  function o(y, _) {
    try {
      l(a[y](_));
    } catch (S) {
      m(i[0][3], S);
    }
  }
  function l(y) {
    y.value instanceof kn ? Promise.resolve(y.value.v).then(u, f) : m(i[0][2], y);
  }
  function u(y) {
    o("next", y);
  }
  function f(y) {
    o("throw", y);
  }
  function m(y, _) {
    y(_), i.shift(), i.length && o(i[0][0], i[0][1]);
  }
}
function mp(t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof En == "function" ? En(t) : t[Symbol.iterator](), n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function a(i) {
    n[i] = t[i] && function(s) {
      return new Promise(function(o, l) {
        s = t[i](s), r(o, l, s.done, s.value);
      });
    };
  }
  function r(i, s, o, l) {
    Promise.resolve(l).then(function(u) {
      i({ value: u, done: o });
    }, s);
  }
}
function et(t) {
  return typeof t == "function";
}
function ns(t) {
  var e = function(a) {
    Error.call(a), a.stack = new Error().stack;
  }, n = t(e);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var Ur = ns(function(t) {
  return function(n) {
    t(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(a, r) {
      return r + 1 + ") " + a.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function $a(t, e) {
  if (t) {
    var n = t.indexOf(e);
    0 <= n && t.splice(n, 1);
  }
}
var _e = function() {
  function t(e) {
    this.initialTeardown = e, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return t.prototype.unsubscribe = function() {
    var e, n, a, r, i;
    if (!this.closed) {
      this.closed = !0;
      var s = this._parentage;
      if (s)
        if (this._parentage = null, Array.isArray(s))
          try {
            for (var o = En(s), l = o.next(); !l.done; l = o.next()) {
              var u = l.value;
              u.remove(this);
            }
          } catch (h) {
            e = { error: h };
          } finally {
            try {
              l && !l.done && (n = o.return) && n.call(o);
            } finally {
              if (e)
                throw e.error;
            }
          }
        else
          s.remove(this);
      var f = this.initialTeardown;
      if (et(f))
        try {
          f();
        } catch (h) {
          i = h instanceof Ur ? h.errors : [h];
        }
      var m = this._finalizers;
      if (m) {
        this._finalizers = null;
        try {
          for (var y = En(m), _ = y.next(); !_.done; _ = y.next()) {
            var S = _.value;
            try {
              Hs(S);
            } catch (h) {
              i = i ?? [], h instanceof Ur ? i = Te(Te([], fe(i)), fe(h.errors)) : i.push(h);
            }
          }
        } catch (h) {
          a = { error: h };
        } finally {
          try {
            _ && !_.done && (r = y.return) && r.call(y);
          } finally {
            if (a)
              throw a.error;
          }
        }
      }
      if (i)
        throw new Ur(i);
    }
  }, t.prototype.add = function(e) {
    var n;
    if (e && e !== this)
      if (this.closed)
        Hs(e);
      else {
        if (e instanceof t) {
          if (e.closed || e._hasParent(this))
            return;
          e._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(e);
      }
  }, t.prototype._hasParent = function(e) {
    var n = this._parentage;
    return n === e || Array.isArray(n) && n.includes(e);
  }, t.prototype._addParent = function(e) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(e), n) : n ? [n, e] : e;
  }, t.prototype._removeParent = function(e) {
    var n = this._parentage;
    n === e ? this._parentage = null : Array.isArray(n) && $a(n, e);
  }, t.prototype.remove = function(e) {
    var n = this._finalizers;
    n && $a(n, e), e instanceof t && e._removeParent(this);
  }, t.EMPTY = function() {
    var e = new t();
    return e.closed = !0, e;
  }(), t;
}(), Xo = _e.EMPTY;
function Qo(t) {
  return t instanceof _e || t && "closed" in t && et(t.remove) && et(t.add) && et(t.unsubscribe);
}
function Hs(t) {
  et(t) ? t() : t.unsubscribe();
}
var tu = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, ii = {
  setTimeout: function(t, e) {
    for (var n = [], a = 2; a < arguments.length; a++)
      n[a - 2] = arguments[a];
    var r = ii.delegate;
    return r != null && r.setTimeout ? r.setTimeout.apply(r, Te([t, e], fe(n))) : setTimeout.apply(void 0, Te([t, e], fe(n)));
  },
  clearTimeout: function(t) {
    var e = ii.delegate;
    return ((e == null ? void 0 : e.clearTimeout) || clearTimeout)(t);
  },
  delegate: void 0
};
function eu(t) {
  ii.setTimeout(function() {
    throw t;
  });
}
function si() {
}
function Ja(t) {
  t();
}
var as = function(t) {
  ye(e, t);
  function e(n) {
    var a = t.call(this) || this;
    return a.isStopped = !1, n ? (a.destination = n, Qo(n) && n.add(a)) : a.destination = hp, a;
  }
  return e.create = function(n, a, r) {
    return new Ua(n, a, r);
  }, e.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, e.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this), this.destination = null);
  }, e.prototype._next = function(n) {
    this.destination.next(n);
  }, e.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, e.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, e;
}(_e), yp = Function.prototype.bind;
function Lr(t, e) {
  return yp.call(t, e);
}
var _p = function() {
  function t(e) {
    this.partialObserver = e;
  }
  return t.prototype.next = function(e) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(e);
      } catch (a) {
        Fa(a);
      }
  }, t.prototype.error = function(e) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(e);
      } catch (a) {
        Fa(a);
      }
    else
      Fa(e);
  }, t.prototype.complete = function() {
    var e = this.partialObserver;
    if (e.complete)
      try {
        e.complete();
      } catch (n) {
        Fa(n);
      }
  }, t;
}(), Ua = function(t) {
  ye(e, t);
  function e(n, a, r) {
    var i = t.call(this) || this, s;
    if (et(n) || !n)
      s = {
        next: n ?? void 0,
        error: a ?? void 0,
        complete: r ?? void 0
      };
    else {
      var o;
      i && tu.useDeprecatedNextContext ? (o = Object.create(n), o.unsubscribe = function() {
        return i.unsubscribe();
      }, s = {
        next: n.next && Lr(n.next, o),
        error: n.error && Lr(n.error, o),
        complete: n.complete && Lr(n.complete, o)
      }) : s = n;
    }
    return i.destination = new _p(s), i;
  }
  return e;
}(as);
function Fa(t) {
  eu(t);
}
function gp(t) {
  throw t;
}
var hp = {
  closed: !0,
  next: si,
  error: gp,
  complete: si
}, rs = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function vn(t) {
  return t;
}
function vp(t) {
  return t.length === 0 ? vn : t.length === 1 ? t[0] : function(n) {
    return t.reduce(function(a, r) {
      return r(a);
    }, n);
  };
}
var Tt = function() {
  function t(e) {
    e && (this._subscribe = e);
  }
  return t.prototype.lift = function(e) {
    var n = new t();
    return n.source = this, n.operator = e, n;
  }, t.prototype.subscribe = function(e, n, a) {
    var r = this, i = Sp(e) ? e : new Ua(e, n, a);
    return Ja(function() {
      var s = r, o = s.operator, l = s.source;
      i.add(o ? o.call(i, l) : l ? r._subscribe(i) : r._trySubscribe(i));
    }), i;
  }, t.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (n) {
      e.error(n);
    }
  }, t.prototype.forEach = function(e, n) {
    var a = this;
    return n = Ys(n), new n(function(r, i) {
      var s = new Ua({
        next: function(o) {
          try {
            e(o);
          } catch (l) {
            i(l), s.unsubscribe();
          }
        },
        error: i,
        complete: r
      });
      a.subscribe(s);
    });
  }, t.prototype._subscribe = function(e) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(e);
  }, t.prototype[rs] = function() {
    return this;
  }, t.prototype.pipe = function() {
    for (var e = [], n = 0; n < arguments.length; n++)
      e[n] = arguments[n];
    return vp(e)(this);
  }, t.prototype.toPromise = function(e) {
    var n = this;
    return e = Ys(e), new e(function(a, r) {
      var i;
      n.subscribe(function(s) {
        return i = s;
      }, function(s) {
        return r(s);
      }, function() {
        return a(i);
      });
    });
  }, t.create = function(e) {
    return new t(e);
  }, t;
}();
function Ys(t) {
  var e;
  return (e = t ?? tu.Promise) !== null && e !== void 0 ? e : Promise;
}
function bp(t) {
  return t && et(t.next) && et(t.error) && et(t.complete);
}
function Sp(t) {
  return t && t instanceof as || bp(t) && Qo(t);
}
function Op(t) {
  return et(t == null ? void 0 : t.lift);
}
function Bt(t) {
  return function(e) {
    if (Op(e))
      return e.lift(function(n) {
        try {
          return t(n, this);
        } catch (a) {
          this.error(a);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function At(t, e, n, a, r) {
  return new Np(t, e, n, a, r);
}
var Np = function(t) {
  ye(e, t);
  function e(n, a, r, i, s, o) {
    var l = t.call(this, n) || this;
    return l.onFinalize = s, l.shouldUnsubscribe = o, l._next = a ? function(u) {
      try {
        a(u);
      } catch (f) {
        n.error(f);
      }
    } : t.prototype._next, l._error = i ? function(u) {
      try {
        i(u);
      } catch (f) {
        n.error(f);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._error, l._complete = r ? function() {
      try {
        r();
      } catch (u) {
        n.error(u);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._complete, l;
  }
  return e.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var a = this.closed;
      t.prototype.unsubscribe.call(this), !a && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, e;
}(as), wp = ns(function(t) {
  return function() {
    t(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), Vt = function(t) {
  ye(e, t);
  function e() {
    var n = t.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return e.prototype.lift = function(n) {
    var a = new Xs(this, this);
    return a.operator = n, a;
  }, e.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new wp();
  }, e.prototype.next = function(n) {
    var a = this;
    Ja(function() {
      var r, i;
      if (a._throwIfClosed(), !a.isStopped) {
        a.currentObservers || (a.currentObservers = Array.from(a.observers));
        try {
          for (var s = En(a.currentObservers), o = s.next(); !o.done; o = s.next()) {
            var l = o.value;
            l.next(n);
          }
        } catch (u) {
          r = { error: u };
        } finally {
          try {
            o && !o.done && (i = s.return) && i.call(s);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
    });
  }, e.prototype.error = function(n) {
    var a = this;
    Ja(function() {
      if (a._throwIfClosed(), !a.isStopped) {
        a.hasError = a.isStopped = !0, a.thrownError = n;
        for (var r = a.observers; r.length; )
          r.shift().error(n);
      }
    });
  }, e.prototype.complete = function() {
    var n = this;
    Ja(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var a = n.observers; a.length; )
          a.shift().complete();
      }
    });
  }, e.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(e.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), t.prototype._trySubscribe.call(this, n);
  }, e.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, e.prototype._innerSubscribe = function(n) {
    var a = this, r = this, i = r.hasError, s = r.isStopped, o = r.observers;
    return i || s ? Xo : (this.currentObservers = null, o.push(n), new _e(function() {
      a.currentObservers = null, $a(o, n);
    }));
  }, e.prototype._checkFinalizedStatuses = function(n) {
    var a = this, r = a.hasError, i = a.thrownError, s = a.isStopped;
    r ? n.error(i) : s && n.complete();
  }, e.prototype.asObservable = function() {
    var n = new Tt();
    return n.source = this, n;
  }, e.create = function(n, a) {
    return new Xs(n, a);
  }, e;
}(Tt), Xs = function(t) {
  ye(e, t);
  function e(n, a) {
    var r = t.call(this) || this;
    return r.destination = n, r.source = a, r;
  }
  return e.prototype.next = function(n) {
    var a, r;
    (r = (a = this.destination) === null || a === void 0 ? void 0 : a.next) === null || r === void 0 || r.call(a, n);
  }, e.prototype.error = function(n) {
    var a, r;
    (r = (a = this.destination) === null || a === void 0 ? void 0 : a.error) === null || r === void 0 || r.call(a, n);
  }, e.prototype.complete = function() {
    var n, a;
    (a = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || a === void 0 || a.call(n);
  }, e.prototype._subscribe = function(n) {
    var a, r;
    return (r = (a = this.source) === null || a === void 0 ? void 0 : a.subscribe(n)) !== null && r !== void 0 ? r : Xo;
  }, e;
}(Vt), it = function(t) {
  ye(e, t);
  function e(n) {
    var a = t.call(this) || this;
    return a._value = n, a;
  }
  return Object.defineProperty(e.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype._subscribe = function(n) {
    var a = t.prototype._subscribe.call(this, n);
    return !a.closed && n.next(this._value), a;
  }, e.prototype.getValue = function() {
    var n = this, a = n.hasError, r = n.thrownError, i = n._value;
    if (a)
      throw r;
    return this._throwIfClosed(), i;
  }, e.prototype.next = function(n) {
    t.prototype.next.call(this, this._value = n);
  }, e;
}(Vt), is = {
  now: function() {
    return (is.delegate || Date).now();
  },
  delegate: void 0
}, Tp = function(t) {
  ye(e, t);
  function e(n, a, r) {
    n === void 0 && (n = 1 / 0), a === void 0 && (a = 1 / 0), r === void 0 && (r = is);
    var i = t.call(this) || this;
    return i._bufferSize = n, i._windowTime = a, i._timestampProvider = r, i._buffer = [], i._infiniteTimeWindow = !0, i._infiniteTimeWindow = a === 1 / 0, i._bufferSize = Math.max(1, n), i._windowTime = Math.max(1, a), i;
  }
  return e.prototype.next = function(n) {
    var a = this, r = a.isStopped, i = a._buffer, s = a._infiniteTimeWindow, o = a._timestampProvider, l = a._windowTime;
    r || (i.push(n), !s && i.push(o.now() + l)), this._trimBuffer(), t.prototype.next.call(this, n);
  }, e.prototype._subscribe = function(n) {
    this._throwIfClosed(), this._trimBuffer();
    for (var a = this._innerSubscribe(n), r = this, i = r._infiniteTimeWindow, s = r._buffer, o = s.slice(), l = 0; l < o.length && !n.closed; l += i ? 1 : 2)
      n.next(o[l]);
    return this._checkFinalizedStatuses(n), a;
  }, e.prototype._trimBuffer = function() {
    var n = this, a = n._bufferSize, r = n._timestampProvider, i = n._buffer, s = n._infiniteTimeWindow, o = (s ? 1 : 2) * a;
    if (a < 1 / 0 && o < i.length && i.splice(0, i.length - o), !s) {
      for (var l = r.now(), u = 0, f = 1; f < i.length && i[f] <= l; f += 2)
        u = f;
      u && i.splice(0, u + 1);
    }
  }, e;
}(Vt), Ap = function(t) {
  ye(e, t);
  function e(n, a) {
    return t.call(this) || this;
  }
  return e.prototype.schedule = function(n, a) {
    return this;
  }, e;
}(_e), La = {
  setInterval: function(t, e) {
    for (var n = [], a = 2; a < arguments.length; a++)
      n[a - 2] = arguments[a];
    var r = La.delegate;
    return r != null && r.setInterval ? r.setInterval.apply(r, Te([t, e], fe(n))) : setInterval.apply(void 0, Te([t, e], fe(n)));
  },
  clearInterval: function(t) {
    var e = La.delegate;
    return ((e == null ? void 0 : e.clearInterval) || clearInterval)(t);
  },
  delegate: void 0
}, kp = function(t) {
  ye(e, t);
  function e(n, a) {
    var r = t.call(this, n, a) || this;
    return r.scheduler = n, r.work = a, r.pending = !1, r;
  }
  return e.prototype.schedule = function(n, a) {
    var r;
    if (a === void 0 && (a = 0), this.closed)
      return this;
    this.state = n;
    var i = this.id, s = this.scheduler;
    return i != null && (this.id = this.recycleAsyncId(s, i, a)), this.pending = !0, this.delay = a, this.id = (r = this.id) !== null && r !== void 0 ? r : this.requestAsyncId(s, this.id, a), this;
  }, e.prototype.requestAsyncId = function(n, a, r) {
    return r === void 0 && (r = 0), La.setInterval(n.flush.bind(n, this), r);
  }, e.prototype.recycleAsyncId = function(n, a, r) {
    if (r === void 0 && (r = 0), r != null && this.delay === r && this.pending === !1)
      return a;
    a != null && La.clearInterval(a);
  }, e.prototype.execute = function(n, a) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var r = this._execute(n, a);
    if (r)
      return r;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, e.prototype._execute = function(n, a) {
    var r = !1, i;
    try {
      this.work(n);
    } catch (s) {
      r = !0, i = s || new Error("Scheduled action threw falsy error");
    }
    if (r)
      return this.unsubscribe(), i;
  }, e.prototype.unsubscribe = function() {
    if (!this.closed) {
      var n = this, a = n.id, r = n.scheduler, i = r.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, $a(i, this), a != null && (this.id = this.recycleAsyncId(r, a, null)), this.delay = null, t.prototype.unsubscribe.call(this);
    }
  }, e;
}(Ap), Qs = function() {
  function t(e, n) {
    n === void 0 && (n = t.now), this.schedulerActionCtor = e, this.now = n;
  }
  return t.prototype.schedule = function(e, n, a) {
    return n === void 0 && (n = 0), new this.schedulerActionCtor(this, e).schedule(a, n);
  }, t.now = is.now, t;
}(), Fp = function(t) {
  ye(e, t);
  function e(n, a) {
    a === void 0 && (a = Qs.now);
    var r = t.call(this, n, a) || this;
    return r.actions = [], r._active = !1, r;
  }
  return e.prototype.flush = function(n) {
    var a = this.actions;
    if (this._active) {
      a.push(n);
      return;
    }
    var r;
    this._active = !0;
    do
      if (r = n.execute(n.state, n.delay))
        break;
    while (n = a.shift());
    if (this._active = !1, r) {
      for (; n = a.shift(); )
        n.unsubscribe();
      throw r;
    }
  }, e;
}(Qs), nu = new Fp(kp), xp = nu, au = new Tt(function(t) {
  return t.complete();
});
function ru(t) {
  return t && et(t.schedule);
}
function ss(t) {
  return t[t.length - 1];
}
function iu(t) {
  return et(ss(t)) ? t.pop() : void 0;
}
function os(t) {
  return ru(ss(t)) ? t.pop() : void 0;
}
function Ep(t, e) {
  return typeof ss(t) == "number" ? t.pop() : e;
}
var us = function(t) {
  return t && typeof t.length == "number" && typeof t != "function";
};
function su(t) {
  return et(t == null ? void 0 : t.then);
}
function ou(t) {
  return et(t[rs]);
}
function uu(t) {
  return Symbol.asyncIterator && et(t == null ? void 0 : t[Symbol.asyncIterator]);
}
function lu(t) {
  return new TypeError("You provided " + (t !== null && typeof t == "object" ? "an invalid object" : "'" + t + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function Rp() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var cu = Rp();
function du(t) {
  return et(t == null ? void 0 : t[cu]);
}
function fu(t) {
  return pp(this, arguments, function() {
    var n, a, r, i;
    return Yo(this, function(s) {
      switch (s.label) {
        case 0:
          n = t.getReader(), s.label = 1;
        case 1:
          s.trys.push([1, , 9, 10]), s.label = 2;
        case 2:
          return [4, kn(n.read())];
        case 3:
          return a = s.sent(), r = a.value, i = a.done, i ? [4, kn(void 0)] : [3, 5];
        case 4:
          return [2, s.sent()];
        case 5:
          return [4, kn(r)];
        case 6:
          return [4, s.sent()];
        case 7:
          return s.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function pu(t) {
  return et(t == null ? void 0 : t.getReader);
}
function Re(t) {
  if (t instanceof Tt)
    return t;
  if (t != null) {
    if (ou(t))
      return Ip(t);
    if (us(t))
      return Pp(t);
    if (su(t))
      return Vp(t);
    if (uu(t))
      return mu(t);
    if (du(t))
      return Jp(t);
    if (pu(t))
      return Cp(t);
  }
  throw lu(t);
}
function Ip(t) {
  return new Tt(function(e) {
    var n = t[rs]();
    if (et(n.subscribe))
      return n.subscribe(e);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function Pp(t) {
  return new Tt(function(e) {
    for (var n = 0; n < t.length && !e.closed; n++)
      e.next(t[n]);
    e.complete();
  });
}
function Vp(t) {
  return new Tt(function(e) {
    t.then(function(n) {
      e.closed || (e.next(n), e.complete());
    }, function(n) {
      return e.error(n);
    }).then(null, eu);
  });
}
function Jp(t) {
  return new Tt(function(e) {
    var n, a;
    try {
      for (var r = En(t), i = r.next(); !i.done; i = r.next()) {
        var s = i.value;
        if (e.next(s), e.closed)
          return;
      }
    } catch (o) {
      n = { error: o };
    } finally {
      try {
        i && !i.done && (a = r.return) && a.call(r);
      } finally {
        if (n)
          throw n.error;
      }
    }
    e.complete();
  });
}
function mu(t) {
  return new Tt(function(e) {
    Dp(t, e).catch(function(n) {
      return e.error(n);
    });
  });
}
function Cp(t) {
  return mu(fu(t));
}
function Dp(t, e) {
  var n, a, r, i;
  return fp(this, void 0, void 0, function() {
    var s, o;
    return Yo(this, function(l) {
      switch (l.label) {
        case 0:
          l.trys.push([0, 5, 6, 11]), n = mp(t), l.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (a = l.sent(), !!a.done)
            return [3, 4];
          if (s = a.value, e.next(s), e.closed)
            return [2];
          l.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return o = l.sent(), r = { error: o }, [3, 11];
        case 6:
          return l.trys.push([6, , 9, 10]), a && !a.done && (i = n.return) ? [4, i.call(n)] : [3, 8];
        case 7:
          l.sent(), l.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (r)
            throw r.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return e.complete(), [2];
      }
    });
  });
}
function Ne(t, e, n, a, r) {
  a === void 0 && (a = 0), r === void 0 && (r = !1);
  var i = e.schedule(function() {
    n(), r ? t.add(this.schedule(null, a)) : this.unsubscribe();
  }, a);
  if (t.add(i), !r)
    return i;
}
function yu(t, e) {
  return e === void 0 && (e = 0), Bt(function(n, a) {
    n.subscribe(At(a, function(r) {
      return Ne(a, t, function() {
        return a.next(r);
      }, e);
    }, function() {
      return Ne(a, t, function() {
        return a.complete();
      }, e);
    }, function(r) {
      return Ne(a, t, function() {
        return a.error(r);
      }, e);
    }));
  });
}
function _u(t, e) {
  return e === void 0 && (e = 0), Bt(function(n, a) {
    a.add(t.schedule(function() {
      return n.subscribe(a);
    }, e));
  });
}
function Mp(t, e) {
  return Re(t).pipe(_u(e), yu(e));
}
function qp(t, e) {
  return Re(t).pipe(_u(e), yu(e));
}
function $p(t, e) {
  return new Tt(function(n) {
    var a = 0;
    return e.schedule(function() {
      a === t.length ? n.complete() : (n.next(t[a++]), n.closed || this.schedule());
    });
  });
}
function Up(t, e) {
  return new Tt(function(n) {
    var a;
    return Ne(n, e, function() {
      a = t[cu](), Ne(n, e, function() {
        var r, i, s;
        try {
          r = a.next(), i = r.value, s = r.done;
        } catch (o) {
          n.error(o);
          return;
        }
        s ? n.complete() : n.next(i);
      }, 0, !0);
    }), function() {
      return et(a == null ? void 0 : a.return) && a.return();
    };
  });
}
function gu(t, e) {
  if (!t)
    throw new Error("Iterable cannot be null");
  return new Tt(function(n) {
    Ne(n, e, function() {
      var a = t[Symbol.asyncIterator]();
      Ne(n, e, function() {
        a.next().then(function(r) {
          r.done ? n.complete() : n.next(r.value);
        });
      }, 0, !0);
    });
  });
}
function Lp(t, e) {
  return gu(fu(t), e);
}
function jp(t, e) {
  if (t != null) {
    if (ou(t))
      return Mp(t, e);
    if (us(t))
      return $p(t, e);
    if (su(t))
      return qp(t, e);
    if (uu(t))
      return gu(t, e);
    if (du(t))
      return Up(t, e);
    if (pu(t))
      return Lp(t, e);
  }
  throw lu(t);
}
function pr(t, e) {
  return e ? jp(t, e) : Re(t);
}
function ls() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var n = os(t);
  return pr(t, n);
}
var cs = ns(function(t) {
  return function() {
    t(this), this.name = "EmptyError", this.message = "no elements in sequence";
  };
});
function oi(t, e) {
  var n = typeof e == "object";
  return new Promise(function(a, r) {
    var i = new Ua({
      next: function(s) {
        a(s), i.unsubscribe();
      },
      error: r,
      complete: function() {
        n ? a(e.defaultValue) : r(new cs());
      }
    });
    t.subscribe(i);
  });
}
function Kp(t) {
  return t instanceof Date && !isNaN(t);
}
function oe(t, e) {
  return Bt(function(n, a) {
    var r = 0;
    n.subscribe(At(a, function(i) {
      a.next(t.call(e, i, r++));
    }));
  });
}
var Bp = Array.isArray;
function Zp(t, e) {
  return Bp(e) ? t.apply(void 0, Te([], fe(e))) : t(e);
}
function hu(t) {
  return oe(function(e) {
    return Zp(t, e);
  });
}
var zp = Array.isArray, Gp = Object.getPrototypeOf, Wp = Object.prototype, Hp = Object.keys;
function Yp(t) {
  if (t.length === 1) {
    var e = t[0];
    if (zp(e))
      return { args: e, keys: null };
    if (Xp(e)) {
      var n = Hp(e);
      return {
        args: n.map(function(a) {
          return e[a];
        }),
        keys: n
      };
    }
  }
  return { args: t, keys: null };
}
function Xp(t) {
  return t && typeof t == "object" && Gp(t) === Wp;
}
function Qp(t, e) {
  return t.reduce(function(n, a, r) {
    return n[a] = e[r], n;
  }, {});
}
function to() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var n = os(t), a = iu(t), r = Yp(t), i = r.args, s = r.keys;
  if (i.length === 0)
    return pr([], n);
  var o = new Tt(tm(i, n, s ? function(l) {
    return Qp(s, l);
  } : vn));
  return a ? o.pipe(hu(a)) : o;
}
function tm(t, e, n) {
  return n === void 0 && (n = vn), function(a) {
    eo(e, function() {
      for (var r = t.length, i = new Array(r), s = r, o = r, l = function(f) {
        eo(e, function() {
          var m = pr(t[f], e), y = !1;
          m.subscribe(At(a, function(_) {
            i[f] = _, y || (y = !0, o--), o || a.next(n(i.slice()));
          }, function() {
            --s || a.complete();
          }));
        }, a);
      }, u = 0; u < r; u++)
        l(u);
    }, a);
  };
}
function eo(t, e, n) {
  t ? Ne(n, t, e) : e();
}
function em(t, e, n, a, r, i, s, o) {
  var l = [], u = 0, f = 0, m = !1, y = function() {
    m && !l.length && !u && e.complete();
  }, _ = function(h) {
    return u < a ? S(h) : l.push(h);
  }, S = function(h) {
    i && e.next(h), u++;
    var $ = !1;
    Re(n(h, f++)).subscribe(At(e, function(z) {
      r == null || r(z), i ? _(z) : e.next(z);
    }, function() {
      $ = !0;
    }, void 0, function() {
      if ($)
        try {
          u--;
          for (var z = function() {
            var F = l.shift();
            s ? Ne(e, s, function() {
              return S(F);
            }) : S(F);
          }; l.length && u < a; )
            z();
          y();
        } catch (F) {
          e.error(F);
        }
    }));
  };
  return t.subscribe(At(e, _, function() {
    m = !0, y();
  })), function() {
    o == null || o();
  };
}
function mr(t, e, n) {
  return n === void 0 && (n = 1 / 0), et(e) ? mr(function(a, r) {
    return oe(function(i, s) {
      return e(a, i, r, s);
    })(Re(t(a, r)));
  }, n) : (typeof e == "number" && (n = e), Bt(function(a, r) {
    return em(a, r, t, n);
  }));
}
function nm(t) {
  return t === void 0 && (t = 1 / 0), mr(vn, t);
}
var am = ["addListener", "removeListener"], rm = ["addEventListener", "removeEventListener"], im = ["on", "off"];
function se(t, e, n, a) {
  if (et(n) && (a = n, n = void 0), a)
    return se(t, e, n).pipe(hu(a));
  var r = fe(um(t) ? rm.map(function(o) {
    return function(l) {
      return t[o](e, l, n);
    };
  }) : sm(t) ? am.map(no(t, e)) : om(t) ? im.map(no(t, e)) : [], 2), i = r[0], s = r[1];
  if (!i && us(t))
    return mr(function(o) {
      return se(o, e, n);
    })(Re(t));
  if (!i)
    throw new TypeError("Invalid event target");
  return new Tt(function(o) {
    var l = function() {
      for (var u = [], f = 0; f < arguments.length; f++)
        u[f] = arguments[f];
      return o.next(1 < u.length ? u : u[0]);
    };
    return i(l), function() {
      return s(l);
    };
  });
}
function no(t, e) {
  return function(n) {
    return function(a) {
      return t[n](e, a);
    };
  };
}
function sm(t) {
  return et(t.addListener) && et(t.removeListener);
}
function om(t) {
  return et(t.on) && et(t.off);
}
function um(t) {
  return et(t.addEventListener) && et(t.removeEventListener);
}
function ui(t, e, n) {
  t === void 0 && (t = 0), n === void 0 && (n = xp);
  var a = -1;
  return e != null && (ru(e) ? n = e : a = e), new Tt(function(r) {
    var i = Kp(t) ? +t - n.now() : t;
    i < 0 && (i = 0);
    var s = 0;
    return n.schedule(function() {
      r.closed || (r.next(s++), 0 <= a ? this.schedule(void 0, a) : r.complete());
    }, i);
  });
}
function Rn() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var n = os(t), a = Ep(t, 1 / 0), r = t;
  return r.length ? r.length === 1 ? Re(r[0]) : nm(a)(pr(r, n)) : au;
}
function pe(t, e) {
  return Bt(function(n, a) {
    var r = 0;
    n.subscribe(At(a, function(i) {
      return t.call(e, i, r++) && a.next(i);
    }));
  });
}
function lm(t, e) {
  return e === void 0 && (e = nu), Bt(function(n, a) {
    var r = null, i = null, s = null, o = function() {
      if (r) {
        r.unsubscribe(), r = null;
        var u = i;
        i = null, a.next(u);
      }
    };
    function l() {
      var u = s + t, f = e.now();
      if (f < u) {
        r = this.schedule(void 0, u - f), a.add(r);
        return;
      }
      o();
    }
    n.subscribe(At(a, function(u) {
      i = u, s = e.now(), r || (r = e.schedule(l, t), a.add(r));
    }, function() {
      o(), a.complete();
    }, void 0, function() {
      i = r = null;
    }));
  });
}
function cm(t) {
  return Bt(function(e, n) {
    var a = !1;
    e.subscribe(At(n, function(r) {
      a = !0, n.next(r);
    }, function() {
      a || n.next(t), n.complete();
    }));
  });
}
function dm(t) {
  return t <= 0 ? function() {
    return au;
  } : Bt(function(e, n) {
    var a = 0;
    e.subscribe(At(n, function(r) {
      ++a <= t && (n.next(r), t <= a && n.complete());
    }));
  });
}
function fm(t) {
  return t === void 0 && (t = pm), Bt(function(e, n) {
    var a = !1;
    e.subscribe(At(n, function(r) {
      a = !0, n.next(r);
    }, function() {
      return a ? n.complete() : n.error(t());
    }));
  });
}
function pm() {
  return new cs();
}
function vu(t, e) {
  var n = arguments.length >= 2;
  return function(a) {
    return a.pipe(t ? pe(function(r, i) {
      return t(r, i, a);
    }) : vn, dm(1), n ? cm(e) : fm(function() {
      return new cs();
    }));
  };
}
function mm(t) {
  return pe(function(e, n) {
    return t <= n;
  });
}
function we(t, e) {
  return Bt(function(n, a) {
    var r = null, i = 0, s = !1, o = function() {
      return s && !r && a.complete();
    };
    n.subscribe(At(a, function(l) {
      r == null || r.unsubscribe();
      var u = 0, f = i++;
      Re(t(l, f)).subscribe(r = At(a, function(m) {
        return a.next(e ? e(l, m, f, u++) : m);
      }, function() {
        r = null, o();
      }));
    }, function() {
      s = !0, o();
    }));
  });
}
function W(t, e, n) {
  var a = et(t) || e || n ? { next: t, error: e, complete: n } : t;
  return a ? Bt(function(r, i) {
    var s;
    (s = a.subscribe) === null || s === void 0 || s.call(a);
    var o = !0;
    r.subscribe(At(i, function(l) {
      var u;
      (u = a.next) === null || u === void 0 || u.call(a, l), i.next(l);
    }, function() {
      var l;
      o = !1, (l = a.complete) === null || l === void 0 || l.call(a), i.complete();
    }, function(l) {
      var u;
      o = !1, (u = a.error) === null || u === void 0 || u.call(a, l), i.error(l);
    }, function() {
      var l, u;
      o && ((l = a.unsubscribe) === null || l === void 0 || l.call(a)), (u = a.finalize) === null || u === void 0 || u.call(a);
    }));
  }) : vn;
}
function jr() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var n = iu(t);
  return Bt(function(a, r) {
    for (var i = t.length, s = new Array(i), o = t.map(function() {
      return !1;
    }), l = !1, u = function(m) {
      Re(t[m]).subscribe(At(r, function(y) {
        s[m] = y, !l && !o[m] && (o[m] = !0, (l = o.every(vn)) && (o = null));
      }, si));
    }, f = 0; f < i; f++)
      u(f);
    a.subscribe(At(r, function(m) {
      if (l) {
        var y = Te([m], fe(s));
        r.next(n ? n.apply(void 0, Te([], fe(y))) : y);
      }
    }));
  });
}
function Kr(t, e, n, a) {
  function r(i) {
    return i instanceof n ? i : new n(function(s) {
      s(i);
    });
  }
  return new (n || (n = Promise))(function(i, s) {
    function o(f) {
      try {
        u(a.next(f));
      } catch (m) {
        s(m);
      }
    }
    function l(f) {
      try {
        u(a.throw(f));
      } catch (m) {
        s(m);
      }
    }
    function u(f) {
      f.done ? i(f.value) : r(f.value).then(o, l);
    }
    u((a = a.apply(t, e || [])).next());
  });
}
function Br(t, e) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, a, r, i, s;
  return s = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function o(u) {
    return function(f) {
      return l([u, f]);
    };
  }
  function l(u) {
    if (a)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (a = 1, r && (i = u[0] & 2 ? r.return : u[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, u[1])).done)
          return i;
        switch (r = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
          case 0:
          case 1:
            i = u;
            break;
          case 4:
            return n.label++, { value: u[1], done: !1 };
          case 5:
            n.label++, r = u[1], u = [0];
            continue;
          case 7:
            u = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              n = 0;
              continue;
            }
            if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
              n.label = u[1];
              break;
            }
            if (u[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = u;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(u);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        u = e.call(t, n);
      } catch (f) {
        u = [6, f], r = 0;
      } finally {
        a = i = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function ja(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var a = n.call(t), r, i = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(r = a.next()).done; )
      i.push(r.value);
  } catch (o) {
    s = { error: o };
  } finally {
    try {
      r && !r.done && (n = a.return) && n.call(a);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return i;
}
function ln(t, e, n) {
  if (n || arguments.length === 2)
    for (var a = 0, r = e.length, i; a < r; a++)
      (i || !(a in e)) && (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
  return t.concat(i || Array.prototype.slice.call(e));
}
var ym = {
  withStackTrace: !1
}, bu = function(t, e, n) {
  n === void 0 && (n = ym);
  var a = e.isOk() ? { type: "Ok", value: e.value } : { type: "Err", value: e.error }, r = n.withStackTrace ? new Error().stack : void 0;
  return {
    data: a,
    message: t,
    stack: r
  };
}, ge = (
  /** @class */
  function() {
    function t(e) {
      this._promise = e;
    }
    return t.fromSafePromise = function(e) {
      var n = e.then(function(a) {
        return new Qe(a);
      });
      return new t(n);
    }, t.fromPromise = function(e, n) {
      var a = e.then(function(r) {
        return new Qe(r);
      }).catch(function(r) {
        return new rn(n(r));
      });
      return new t(a);
    }, t.combine = function(e) {
      return gm(e);
    }, t.combineWithAllErrors = function(e) {
      return hm(e);
    }, t.prototype.map = function(e) {
      var n = this;
      return new t(this._promise.then(function(a) {
        return Kr(n, void 0, void 0, function() {
          var r;
          return Br(this, function(i) {
            switch (i.label) {
              case 0:
                return a.isErr() ? [2, new rn(a.error)] : (r = Qe.bind, [4, e(a.value)]);
              case 1:
                return [2, new (r.apply(Qe, [void 0, i.sent()]))()];
            }
          });
        });
      }));
    }, t.prototype.mapErr = function(e) {
      var n = this;
      return new t(this._promise.then(function(a) {
        return Kr(n, void 0, void 0, function() {
          var r;
          return Br(this, function(i) {
            switch (i.label) {
              case 0:
                return a.isOk() ? [2, new Qe(a.value)] : (r = rn.bind, [4, e(a.error)]);
              case 1:
                return [2, new (r.apply(rn, [void 0, i.sent()]))()];
            }
          });
        });
      }));
    }, t.prototype.andThen = function(e) {
      return new t(this._promise.then(function(n) {
        if (n.isErr())
          return new rn(n.error);
        var a = e(n.value);
        return a instanceof t ? a._promise : a;
      }));
    }, t.prototype.orElse = function(e) {
      var n = this;
      return new t(this._promise.then(function(a) {
        return Kr(n, void 0, void 0, function() {
          return Br(this, function(r) {
            return a.isErr() ? [2, e(a.error)] : [2, new Qe(a.value)];
          });
        });
      }));
    }, t.prototype.match = function(e, n) {
      return this._promise.then(function(a) {
        return a.match(e, n);
      });
    }, t.prototype.unwrapOr = function(e) {
      return this._promise.then(function(n) {
        return n.unwrapOr(e);
      });
    }, t.prototype.then = function(e, n) {
      return this._promise.then(e, n);
    }, t;
  }()
), ao = function(t) {
  return new ge(Promise.resolve(new rn(t)));
};
ge.fromPromise;
ge.fromSafePromise;
var _m = function(t) {
  return function(e) {
    return ln(ln([], ja(e), !1), [t], !1);
  };
}, Su = function(t) {
  return t.reduce(function(e, n) {
    return e.isOk() ? n.isErr() ? Lt(n.error) : e.map(_m(n.value)) : e;
  }, ue([]));
}, gm = function(t) {
  return ge.fromSafePromise(Promise.all(t)).andThen(Su);
}, Ou = function(t) {
  return t.reduce(function(e, n) {
    return n.isErr() ? e.isErr() ? Lt(ln(ln([], ja(e.error), !1), [n.error], !1)) : Lt([n.error]) : e.isErr() ? e : ue(ln(ln([], ja(e.value), !1), [n.value], !1));
  }, ue([]));
}, hm = function(t) {
  return ge.fromSafePromise(Promise.all(t)).andThen(Ou);
}, li;
(function(t) {
  function e(r, i) {
    return function() {
      for (var s = [], o = 0; o < arguments.length; o++)
        s[o] = arguments[o];
      try {
        var l = r.apply(void 0, ln([], ja(s), !1));
        return ue(l);
      } catch (u) {
        return Lt(i ? i(u) : u);
      }
    };
  }
  t.fromThrowable = e;
  function n(r) {
    return Su(r);
  }
  t.combine = n;
  function a(r) {
    return Ou(r);
  }
  t.combineWithAllErrors = a;
})(li || (li = {}));
var ue = function(t) {
  return new Qe(t);
}, Lt = function(t) {
  return new rn(t);
}, Qe = (
  /** @class */
  function() {
    function t(e) {
      this.value = e;
    }
    return t.prototype.isOk = function() {
      return !0;
    }, t.prototype.isErr = function() {
      return !this.isOk();
    }, t.prototype.map = function(e) {
      return ue(e(this.value));
    }, t.prototype.mapErr = function(e) {
      return ue(this.value);
    }, t.prototype.andThen = function(e) {
      return e(this.value);
    }, t.prototype.orElse = function(e) {
      return ue(this.value);
    }, t.prototype.asyncAndThen = function(e) {
      return e(this.value);
    }, t.prototype.asyncMap = function(e) {
      return ge.fromSafePromise(e(this.value));
    }, t.prototype.unwrapOr = function(e) {
      return this.value;
    }, t.prototype.match = function(e, n) {
      return e(this.value);
    }, t.prototype._unsafeUnwrap = function(e) {
      return this.value;
    }, t.prototype._unsafeUnwrapErr = function(e) {
      throw bu("Called `_unsafeUnwrapErr` on an Ok", this, e);
    }, t;
  }()
), rn = (
  /** @class */
  function() {
    function t(e) {
      this.error = e;
    }
    return t.prototype.isOk = function() {
      return !1;
    }, t.prototype.isErr = function() {
      return !this.isOk();
    }, t.prototype.map = function(e) {
      return Lt(this.error);
    }, t.prototype.mapErr = function(e) {
      return Lt(e(this.error));
    }, t.prototype.andThen = function(e) {
      return Lt(this.error);
    }, t.prototype.orElse = function(e) {
      return e(this.error);
    }, t.prototype.asyncAndThen = function(e) {
      return ao(this.error);
    }, t.prototype.asyncMap = function(e) {
      return ao(this.error);
    }, t.prototype.unwrapOr = function(e) {
      return e;
    }, t.prototype.match = function(e, n) {
      return n(this.error);
    }, t.prototype._unsafeUnwrap = function(e) {
      throw bu("Called `_unsafeUnwrap` on an Err", this, e);
    }, t.prototype._unsafeUnwrapErr = function(e) {
      return this.error;
    }, t;
  }()
);
li.fromThrowable;
var Y;
(function(t) {
  t.assertEqual = (r) => r;
  function e(r) {
  }
  t.assertIs = e;
  function n(r) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (r) => {
    const i = {};
    for (const s of r)
      i[s] = s;
    return i;
  }, t.getValidEnumValues = (r) => {
    const i = t.objectKeys(r).filter((o) => typeof r[r[o]] != "number"), s = {};
    for (const o of i)
      s[o] = r[o];
    return t.objectValues(s);
  }, t.objectValues = (r) => t.objectKeys(r).map(function(i) {
    return r[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (r) => Object.keys(r) : (r) => {
    const i = [];
    for (const s in r)
      Object.prototype.hasOwnProperty.call(r, s) && i.push(s);
    return i;
  }, t.find = (r, i) => {
    for (const s of r)
      if (i(s))
        return s;
  }, t.isInteger = typeof Number.isInteger == "function" ? (r) => Number.isInteger(r) : (r) => typeof r == "number" && isFinite(r) && Math.floor(r) === r;
  function a(r, i = " | ") {
    return r.map((s) => typeof s == "string" ? `'${s}'` : s).join(i);
  }
  t.joinValues = a, t.jsonStringifyReplacer = (r, i) => typeof i == "bigint" ? i.toString() : i;
})(Y || (Y = {}));
var ro;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})(ro || (ro = {}));
const k = Y.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), sn = (t) => {
  switch (typeof t) {
    case "undefined":
      return k.undefined;
    case "string":
      return k.string;
    case "number":
      return isNaN(t) ? k.nan : k.number;
    case "boolean":
      return k.boolean;
    case "function":
      return k.function;
    case "bigint":
      return k.bigint;
    case "symbol":
      return k.symbol;
    case "object":
      return Array.isArray(t) ? k.array : t === null ? k.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? k.promise : typeof Map < "u" && t instanceof Map ? k.map : typeof Set < "u" && t instanceof Set ? k.set : typeof Date < "u" && t instanceof Date ? k.date : k.object;
    default:
      return k.unknown;
  }
}, O = Y.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
let pn = class extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (a) => {
      this.issues = [...this.issues, a];
    }, this.addIssues = (a = []) => {
      this.issues = [...this.issues, ...a];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const n = e || function(i) {
      return i.message;
    }, a = { _errors: [] }, r = (i) => {
      for (const s of i.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(r);
        else if (s.code === "invalid_return_type")
          r(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          r(s.argumentsError);
        else if (s.path.length === 0)
          a._errors.push(n(s));
        else {
          let o = a, l = 0;
          for (; l < s.path.length; ) {
            const u = s.path[l];
            l === s.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(n(s))) : o[u] = o[u] || { _errors: [] }, o = o[u], l++;
          }
        }
    };
    return r(this), a;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Y.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, a = [];
    for (const r of this.issues)
      r.path.length > 0 ? (n[r.path[0]] = n[r.path[0]] || [], n[r.path[0]].push(e(r))) : a.push(e(r));
    return { formErrors: a, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
};
pn.create = (t) => new pn(t);
const Nu = (t, e) => {
  let n;
  switch (t.code) {
    case O.invalid_type:
      t.received === k.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case O.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, Y.jsonStringifyReplacer)}`;
      break;
    case O.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${Y.joinValues(t.keys, ", ")}`;
      break;
    case O.invalid_union:
      n = "Invalid input";
      break;
    case O.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${Y.joinValues(t.options)}`;
      break;
    case O.invalid_enum_value:
      n = `Invalid enum value. Expected ${Y.joinValues(t.options)}, received '${t.received}'`;
      break;
    case O.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case O.invalid_return_type:
      n = "Invalid function return type";
      break;
    case O.invalid_date:
      n = "Invalid date";
      break;
    case O.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : Y.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case O.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case O.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case O.custom:
      n = "Invalid input";
      break;
    case O.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case O.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case O.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, Y.assertNever(t);
  }
  return { message: n };
};
let vm = Nu;
function bm() {
  return vm;
}
const Sm = (t) => {
  const { data: e, path: n, errorMaps: a, issueData: r } = t, i = [...n, ...r.path || []], s = {
    ...r,
    path: i
  };
  let o = "";
  const l = a.filter((u) => !!u).slice().reverse();
  for (const u of l)
    o = u(s, { data: e, defaultError: o }).message;
  return {
    ...r,
    path: i,
    message: r.message || o
  };
};
function A(t, e) {
  const n = Sm({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      bm(),
      Nu
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
let ne = class wu {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const a = [];
    for (const r of n) {
      if (r.status === "aborted")
        return K;
      r.status === "dirty" && e.dirty(), a.push(r.value);
    }
    return { status: e.value, value: a };
  }
  static async mergeObjectAsync(e, n) {
    const a = [];
    for (const r of n)
      a.push({
        key: await r.key,
        value: await r.value
      });
    return wu.mergeObjectSync(e, a);
  }
  static mergeObjectSync(e, n) {
    const a = {};
    for (const r of n) {
      const { key: i, value: s } = r;
      if (i.status === "aborted" || s.status === "aborted")
        return K;
      i.status === "dirty" && e.dirty(), s.status === "dirty" && e.dirty(), (typeof s.value < "u" || r.alwaysSet) && (a[i.value] = s.value);
    }
    return { status: e.value, value: a };
  }
};
const K = Object.freeze({
  status: "aborted"
}), Om = (t) => ({ status: "dirty", value: t }), Zt = (t) => ({ status: "valid", value: t }), io = (t) => t.status === "aborted", so = (t) => t.status === "dirty", ci = (t) => t.status === "valid", di = (t) => typeof Promise < "u" && t instanceof Promise;
var E;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(E || (E = {}));
let je = class {
  constructor(e, n, a, r) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = a, this._key = r;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const oo = (t, e) => {
  if (ci(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new pn(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function j(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: a, description: r } = t;
  if (e && (n || a))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: r } : { errorMap: (i, s) => i.code !== "invalid_type" ? { message: s.defaultError } : typeof s.data > "u" ? { message: a ?? s.defaultError } : { message: n ?? s.defaultError }, description: r };
}
let H = class {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return sn(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: sn(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new ne(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: sn(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (di(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const a = this.safeParse(e, n);
    if (a.success)
      return a.data;
    throw a.error;
  }
  safeParse(e, n) {
    var a;
    const r = {
      common: {
        issues: [],
        async: (a = n == null ? void 0 : n.async) !== null && a !== void 0 ? a : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: sn(e)
    }, i = this._parseSync({ data: e, path: r.path, parent: r });
    return oo(r, i);
  }
  async parseAsync(e, n) {
    const a = await this.safeParseAsync(e, n);
    if (a.success)
      return a.data;
    throw a.error;
  }
  async safeParseAsync(e, n) {
    const a = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: sn(e)
    }, r = this._parse({ data: e, path: a.path, parent: a }), i = await (di(r) ? r : Promise.resolve(r));
    return oo(a, i);
  }
  refine(e, n) {
    const a = (r) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(r) : n;
    return this._refinement((r, i) => {
      const s = e(r), o = () => i.addIssue({
        code: O.custom,
        ...a(r)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((l) => l ? !0 : (o(), !1)) : s ? !0 : (o(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((a, r) => e(a) ? !0 : (r.addIssue(typeof n == "function" ? n(a, r) : n), !1));
  }
  _refinement(e) {
    return new Pn({
      schema: this,
      typeName: V.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return $e.create(this, this._def);
  }
  nullable() {
    return Vn.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return In.create(this, this._def);
  }
  promise() {
    return Za.create(this, this._def);
  }
  or(e) {
    return Ka.create([this, e], this._def);
  }
  and(e) {
    return Ba.create(this, e, this._def);
  }
  transform(e) {
    return new Pn({
      ...j(this._def),
      schema: this,
      typeName: V.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new bi({
      ...j(this._def),
      innerType: this,
      defaultValue: n,
      typeName: V.ZodDefault
    });
  }
  brand() {
    return new Vm({
      typeName: V.ZodBranded,
      type: this,
      ...j(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Si({
      ...j(this._def),
      innerType: this,
      catchValue: n,
      typeName: V.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Jm.create(this, e);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const Nm = /^c[^\s-]{8,}$/i, wm = /^[a-z][a-z0-9]*$/, Tm = /[0-9A-HJKMNP-TV-Z]{26}/, Am = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i, km = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/, Fm = /^(\p{Extended_Pictographic}|\p{Emoji_Component})+$/u, xm = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, Em = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, Rm = (t) => t.precision ? t.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}Z$`) : t.precision === 0 ? t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function Im(t, e) {
  return !!((e === "v4" || !e) && xm.test(t) || (e === "v6" || !e) && Em.test(t));
}
class qe extends H {
  constructor() {
    super(...arguments), this._regex = (e, n, a) => this.refinement((r) => e.test(r), {
      validation: n,
      code: O.invalid_string,
      ...E.errToObj(a)
    }), this.nonempty = (e) => this.min(1, E.errToObj(e)), this.trim = () => new qe({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    }), this.toLowerCase = () => new qe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }), this.toUpperCase = () => new qe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== k.string) {
      const r = this._getOrReturnCtx(e);
      return A(
        r,
        {
          code: O.invalid_type,
          expected: k.string,
          received: r.parsedType
        }
        //
      ), K;
    }
    const n = new ne();
    let a;
    for (const r of this._def.checks)
      if (r.kind === "min")
        e.data.length < r.value && (a = this._getOrReturnCtx(e, a), A(a, {
          code: O.too_small,
          minimum: r.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: r.message
        }), n.dirty());
      else if (r.kind === "max")
        e.data.length > r.value && (a = this._getOrReturnCtx(e, a), A(a, {
          code: O.too_big,
          maximum: r.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: r.message
        }), n.dirty());
      else if (r.kind === "length") {
        const i = e.data.length > r.value, s = e.data.length < r.value;
        (i || s) && (a = this._getOrReturnCtx(e, a), i ? A(a, {
          code: O.too_big,
          maximum: r.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: r.message
        }) : s && A(a, {
          code: O.too_small,
          minimum: r.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: r.message
        }), n.dirty());
      } else if (r.kind === "email")
        km.test(e.data) || (a = this._getOrReturnCtx(e, a), A(a, {
          validation: "email",
          code: O.invalid_string,
          message: r.message
        }), n.dirty());
      else if (r.kind === "emoji")
        Fm.test(e.data) || (a = this._getOrReturnCtx(e, a), A(a, {
          validation: "emoji",
          code: O.invalid_string,
          message: r.message
        }), n.dirty());
      else if (r.kind === "uuid")
        Am.test(e.data) || (a = this._getOrReturnCtx(e, a), A(a, {
          validation: "uuid",
          code: O.invalid_string,
          message: r.message
        }), n.dirty());
      else if (r.kind === "cuid")
        Nm.test(e.data) || (a = this._getOrReturnCtx(e, a), A(a, {
          validation: "cuid",
          code: O.invalid_string,
          message: r.message
        }), n.dirty());
      else if (r.kind === "cuid2")
        wm.test(e.data) || (a = this._getOrReturnCtx(e, a), A(a, {
          validation: "cuid2",
          code: O.invalid_string,
          message: r.message
        }), n.dirty());
      else if (r.kind === "ulid")
        Tm.test(e.data) || (a = this._getOrReturnCtx(e, a), A(a, {
          validation: "ulid",
          code: O.invalid_string,
          message: r.message
        }), n.dirty());
      else if (r.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), A(a, {
            validation: "url",
            code: O.invalid_string,
            message: r.message
          }), n.dirty();
        }
      else
        r.kind === "regex" ? (r.regex.lastIndex = 0, r.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), A(a, {
          validation: "regex",
          code: O.invalid_string,
          message: r.message
        }), n.dirty())) : r.kind === "trim" ? e.data = e.data.trim() : r.kind === "includes" ? e.data.includes(r.value, r.position) || (a = this._getOrReturnCtx(e, a), A(a, {
          code: O.invalid_string,
          validation: { includes: r.value, position: r.position },
          message: r.message
        }), n.dirty()) : r.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : r.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : r.kind === "startsWith" ? e.data.startsWith(r.value) || (a = this._getOrReturnCtx(e, a), A(a, {
          code: O.invalid_string,
          validation: { startsWith: r.value },
          message: r.message
        }), n.dirty()) : r.kind === "endsWith" ? e.data.endsWith(r.value) || (a = this._getOrReturnCtx(e, a), A(a, {
          code: O.invalid_string,
          validation: { endsWith: r.value },
          message: r.message
        }), n.dirty()) : r.kind === "datetime" ? Rm(r).test(e.data) || (a = this._getOrReturnCtx(e, a), A(a, {
          code: O.invalid_string,
          validation: "datetime",
          message: r.message
        }), n.dirty()) : r.kind === "ip" ? Im(e.data, r.version) || (a = this._getOrReturnCtx(e, a), A(a, {
          validation: "ip",
          code: O.invalid_string,
          message: r.message
        }), n.dirty()) : Y.assertNever(r);
    return { status: n.value, value: e.data };
  }
  _addCheck(e) {
    return new qe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...E.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...E.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...E.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...E.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...E.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...E.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...E.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...E.errToObj(e) });
  }
  datetime(e) {
    var n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (n = e == null ? void 0 : e.offset) !== null && n !== void 0 ? n : !1,
      ...E.errToObj(e == null ? void 0 : e.message)
    });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...E.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n == null ? void 0 : n.position,
      ...E.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...E.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...E.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...E.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...E.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...E.errToObj(n)
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
qe.create = (t) => {
  var e;
  return new qe({
    checks: [],
    typeName: V.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...j(t)
  });
};
function Pm(t, e) {
  const n = (t.toString().split(".")[1] || "").length, a = (e.toString().split(".")[1] || "").length, r = n > a ? n : a, i = parseInt(t.toFixed(r).replace(".", "")), s = parseInt(e.toFixed(r).replace(".", ""));
  return i % s / Math.pow(10, r);
}
let fi = class pi extends H {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== k.number) {
      const r = this._getOrReturnCtx(e);
      return A(r, {
        code: O.invalid_type,
        expected: k.number,
        received: r.parsedType
      }), K;
    }
    let n;
    const a = new ne();
    for (const r of this._def.checks)
      r.kind === "int" ? Y.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), A(n, {
        code: O.invalid_type,
        expected: "integer",
        received: "float",
        message: r.message
      }), a.dirty()) : r.kind === "min" ? (r.inclusive ? e.data < r.value : e.data <= r.value) && (n = this._getOrReturnCtx(e, n), A(n, {
        code: O.too_small,
        minimum: r.value,
        type: "number",
        inclusive: r.inclusive,
        exact: !1,
        message: r.message
      }), a.dirty()) : r.kind === "max" ? (r.inclusive ? e.data > r.value : e.data >= r.value) && (n = this._getOrReturnCtx(e, n), A(n, {
        code: O.too_big,
        maximum: r.value,
        type: "number",
        inclusive: r.inclusive,
        exact: !1,
        message: r.message
      }), a.dirty()) : r.kind === "multipleOf" ? Pm(e.data, r.value) !== 0 && (n = this._getOrReturnCtx(e, n), A(n, {
        code: O.not_multiple_of,
        multipleOf: r.value,
        message: r.message
      }), a.dirty()) : r.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), A(n, {
        code: O.not_finite,
        message: r.message
      }), a.dirty()) : Y.assertNever(r);
    return { status: a.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, E.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, E.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, E.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, E.toString(n));
  }
  setLimit(e, n, a, r) {
    return new pi({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: a,
          message: E.toString(r)
        }
      ]
    });
  }
  _addCheck(e) {
    return new pi({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: E.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: E.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: E.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: E.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: E.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: E.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: E.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: E.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: E.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && Y.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const a of this._def.checks) {
      if (a.kind === "finite" || a.kind === "int" || a.kind === "multipleOf")
        return !0;
      a.kind === "min" ? (n === null || a.value > n) && (n = a.value) : a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
};
fi.create = (t) => new fi({
  checks: [],
  typeName: V.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...j(t)
});
let uo = class mi extends H {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== k.bigint) {
      const r = this._getOrReturnCtx(e);
      return A(r, {
        code: O.invalid_type,
        expected: k.bigint,
        received: r.parsedType
      }), K;
    }
    let n;
    const a = new ne();
    for (const r of this._def.checks)
      r.kind === "min" ? (r.inclusive ? e.data < r.value : e.data <= r.value) && (n = this._getOrReturnCtx(e, n), A(n, {
        code: O.too_small,
        type: "bigint",
        minimum: r.value,
        inclusive: r.inclusive,
        message: r.message
      }), a.dirty()) : r.kind === "max" ? (r.inclusive ? e.data > r.value : e.data >= r.value) && (n = this._getOrReturnCtx(e, n), A(n, {
        code: O.too_big,
        type: "bigint",
        maximum: r.value,
        inclusive: r.inclusive,
        message: r.message
      }), a.dirty()) : r.kind === "multipleOf" ? e.data % r.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), A(n, {
        code: O.not_multiple_of,
        multipleOf: r.value,
        message: r.message
      }), a.dirty()) : Y.assertNever(r);
    return { status: a.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, E.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, E.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, E.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, E.toString(n));
  }
  setLimit(e, n, a, r) {
    return new mi({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: a,
          message: E.toString(r)
        }
      ]
    });
  }
  _addCheck(e) {
    return new mi({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: E.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: E.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: E.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: E.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: E.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
};
uo.create = (t) => {
  var e;
  return new uo({
    checks: [],
    typeName: V.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...j(t)
  });
};
let yi = class extends H {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== k.boolean) {
      const n = this._getOrReturnCtx(e);
      return A(n, {
        code: O.invalid_type,
        expected: k.boolean,
        received: n.parsedType
      }), K;
    }
    return Zt(e.data);
  }
};
yi.create = (t) => new yi({
  typeName: V.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...j(t)
});
let lo = class Tu extends H {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== k.date) {
      const r = this._getOrReturnCtx(e);
      return A(r, {
        code: O.invalid_type,
        expected: k.date,
        received: r.parsedType
      }), K;
    }
    if (isNaN(e.data.getTime())) {
      const r = this._getOrReturnCtx(e);
      return A(r, {
        code: O.invalid_date
      }), K;
    }
    const n = new ne();
    let a;
    for (const r of this._def.checks)
      r.kind === "min" ? e.data.getTime() < r.value && (a = this._getOrReturnCtx(e, a), A(a, {
        code: O.too_small,
        message: r.message,
        inclusive: !0,
        exact: !1,
        minimum: r.value,
        type: "date"
      }), n.dirty()) : r.kind === "max" ? e.data.getTime() > r.value && (a = this._getOrReturnCtx(e, a), A(a, {
        code: O.too_big,
        message: r.message,
        inclusive: !0,
        exact: !1,
        maximum: r.value,
        type: "date"
      }), n.dirty()) : Y.assertNever(r);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Tu({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: E.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: E.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
};
lo.create = (t) => new lo({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: V.ZodDate,
  ...j(t)
});
let co = class extends H {
  _parse(e) {
    if (this._getType(e) !== k.symbol) {
      const n = this._getOrReturnCtx(e);
      return A(n, {
        code: O.invalid_type,
        expected: k.symbol,
        received: n.parsedType
      }), K;
    }
    return Zt(e.data);
  }
};
co.create = (t) => new co({
  typeName: V.ZodSymbol,
  ...j(t)
});
let fo = class extends H {
  _parse(e) {
    if (this._getType(e) !== k.undefined) {
      const n = this._getOrReturnCtx(e);
      return A(n, {
        code: O.invalid_type,
        expected: k.undefined,
        received: n.parsedType
      }), K;
    }
    return Zt(e.data);
  }
};
fo.create = (t) => new fo({
  typeName: V.ZodUndefined,
  ...j(t)
});
let po = class extends H {
  _parse(e) {
    if (this._getType(e) !== k.null) {
      const n = this._getOrReturnCtx(e);
      return A(n, {
        code: O.invalid_type,
        expected: k.null,
        received: n.parsedType
      }), K;
    }
    return Zt(e.data);
  }
};
po.create = (t) => new po({
  typeName: V.ZodNull,
  ...j(t)
});
let mo = class extends H {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Zt(e.data);
  }
};
mo.create = (t) => new mo({
  typeName: V.ZodAny,
  ...j(t)
});
let yo = class extends H {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Zt(e.data);
  }
};
yo.create = (t) => new yo({
  typeName: V.ZodUnknown,
  ...j(t)
});
let Ke = class extends H {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return A(n, {
      code: O.invalid_type,
      expected: k.never,
      received: n.parsedType
    }), K;
  }
};
Ke.create = (t) => new Ke({
  typeName: V.ZodNever,
  ...j(t)
});
let _o = class extends H {
  _parse(e) {
    if (this._getType(e) !== k.undefined) {
      const n = this._getOrReturnCtx(e);
      return A(n, {
        code: O.invalid_type,
        expected: k.void,
        received: n.parsedType
      }), K;
    }
    return Zt(e.data);
  }
};
_o.create = (t) => new _o({
  typeName: V.ZodVoid,
  ...j(t)
});
let In = class Ca extends H {
  _parse(e) {
    const { ctx: n, status: a } = this._processInputParams(e), r = this._def;
    if (n.parsedType !== k.array)
      return A(n, {
        code: O.invalid_type,
        expected: k.array,
        received: n.parsedType
      }), K;
    if (r.exactLength !== null) {
      const s = n.data.length > r.exactLength.value, o = n.data.length < r.exactLength.value;
      (s || o) && (A(n, {
        code: s ? O.too_big : O.too_small,
        minimum: o ? r.exactLength.value : void 0,
        maximum: s ? r.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: r.exactLength.message
      }), a.dirty());
    }
    if (r.minLength !== null && n.data.length < r.minLength.value && (A(n, {
      code: O.too_small,
      minimum: r.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.minLength.message
    }), a.dirty()), r.maxLength !== null && n.data.length > r.maxLength.value && (A(n, {
      code: O.too_big,
      maximum: r.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.maxLength.message
    }), a.dirty()), n.common.async)
      return Promise.all([...n.data].map((s, o) => r.type._parseAsync(new je(n, s, n.path, o)))).then((s) => ne.mergeArray(a, s));
    const i = [...n.data].map((s, o) => r.type._parseSync(new je(n, s, n.path, o)));
    return ne.mergeArray(a, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new Ca({
      ...this._def,
      minLength: { value: e, message: E.toString(n) }
    });
  }
  max(e, n) {
    return new Ca({
      ...this._def,
      maxLength: { value: e, message: E.toString(n) }
    });
  }
  length(e, n) {
    return new Ca({
      ...this._def,
      exactLength: { value: e, message: E.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
In.create = (t, e) => new In({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: V.ZodArray,
  ...j(e)
});
function On(t) {
  if (t instanceof ae) {
    const e = {};
    for (const n in t.shape) {
      const a = t.shape[n];
      e[n] = $e.create(On(a));
    }
    return new ae({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof In ? new In({
      ...t._def,
      type: On(t.element)
    }) : t instanceof $e ? $e.create(On(t.unwrap())) : t instanceof Vn ? Vn.create(On(t.unwrap())) : t instanceof na ? na.create(t.items.map((e) => On(e))) : t;
}
let ae = class Yt extends H {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = Y.objectKeys(e);
    return this._cached = { shape: e, keys: n };
  }
  _parse(e) {
    if (this._getType(e) !== k.object) {
      const l = this._getOrReturnCtx(e);
      return A(l, {
        code: O.invalid_type,
        expected: k.object,
        received: l.parsedType
      }), K;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: r, keys: i } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Ke && this._def.unknownKeys === "strip"))
      for (const l in a.data)
        i.includes(l) || s.push(l);
    const o = [];
    for (const l of i) {
      const u = r[l], f = a.data[l];
      o.push({
        key: { status: "valid", value: l },
        value: u._parse(new je(a, f, a.path, l)),
        alwaysSet: l in a.data
      });
    }
    if (this._def.catchall instanceof Ke) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const u of s)
          o.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (l === "strict")
        s.length > 0 && (A(a, {
          code: O.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (l !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const u of s) {
        const f = a.data[u];
        o.push({
          key: { status: "valid", value: u },
          value: l._parse(
            new je(a, f, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const u of o) {
        const f = await u.key;
        l.push({
          key: f,
          value: await u.value,
          alwaysSet: u.alwaysSet
        });
      }
      return l;
    }).then((l) => ne.mergeObjectSync(n, l)) : ne.mergeObjectSync(n, o);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return E.errToObj, new Yt({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, a) => {
          var r, i, s, o;
          const l = (s = (i = (r = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(r, n, a).message) !== null && s !== void 0 ? s : a.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (o = E.errToObj(e).message) !== null && o !== void 0 ? o : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new Yt({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Yt({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Yt({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Yt({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: V.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Yt({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    return Y.objectKeys(e).forEach((a) => {
      e[a] && this.shape[a] && (n[a] = this.shape[a]);
    }), new Yt({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    return Y.objectKeys(this.shape).forEach((a) => {
      e[a] || (n[a] = this.shape[a]);
    }), new Yt({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return On(this);
  }
  partial(e) {
    const n = {};
    return Y.objectKeys(this.shape).forEach((a) => {
      const r = this.shape[a];
      e && !e[a] ? n[a] = r : n[a] = r.optional();
    }), new Yt({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    return Y.objectKeys(this.shape).forEach((a) => {
      if (e && !e[a])
        n[a] = this.shape[a];
      else {
        let r = this.shape[a];
        for (; r instanceof $e; )
          r = r._def.innerType;
        n[a] = r;
      }
    }), new Yt({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return ku(Y.objectKeys(this.shape));
  }
};
ae.create = (t, e) => new ae({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Ke.create(),
  typeName: V.ZodObject,
  ...j(e)
});
ae.strictCreate = (t, e) => new ae({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Ke.create(),
  typeName: V.ZodObject,
  ...j(e)
});
ae.lazycreate = (t, e) => new ae({
  shape: t,
  unknownKeys: "strip",
  catchall: Ke.create(),
  typeName: V.ZodObject,
  ...j(e)
});
let Ka = class extends H {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), a = this._def.options;
    function r(i) {
      for (const o of i)
        if (o.result.status === "valid")
          return o.result;
      for (const o of i)
        if (o.result.status === "dirty")
          return n.common.issues.push(...o.ctx.common.issues), o.result;
      const s = i.map((o) => new pn(o.ctx.common.issues));
      return A(n, {
        code: O.invalid_union,
        unionErrors: s
      }), K;
    }
    if (n.common.async)
      return Promise.all(a.map(async (i) => {
        const s = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: n.data,
            path: n.path,
            parent: s
          }),
          ctx: s
        };
      })).then(r);
    {
      let i;
      const s = [];
      for (const l of a) {
        const u = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, f = l._parseSync({
          data: n.data,
          path: n.path,
          parent: u
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !i && (i = { result: f, ctx: u }), u.common.issues.length && s.push(u.common.issues);
      }
      if (i)
        return n.common.issues.push(...i.ctx.common.issues), i.result;
      const o = s.map((l) => new pn(l));
      return A(n, {
        code: O.invalid_union,
        unionErrors: o
      }), K;
    }
  }
  get options() {
    return this._def.options;
  }
};
Ka.create = (t, e) => new Ka({
  options: t,
  typeName: V.ZodUnion,
  ...j(e)
});
function _i(t, e) {
  const n = sn(t), a = sn(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === k.object && a === k.object) {
    const r = Y.objectKeys(e), i = Y.objectKeys(t).filter((o) => r.indexOf(o) !== -1), s = { ...t, ...e };
    for (const o of i) {
      const l = _i(t[o], e[o]);
      if (!l.valid)
        return { valid: !1 };
      s[o] = l.data;
    }
    return { valid: !0, data: s };
  } else if (n === k.array && a === k.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const r = [];
    for (let i = 0; i < t.length; i++) {
      const s = t[i], o = e[i], l = _i(s, o);
      if (!l.valid)
        return { valid: !1 };
      r.push(l.data);
    }
    return { valid: !0, data: r };
  } else
    return n === k.date && a === k.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
let Ba = class extends H {
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e), r = (i, s) => {
      if (io(i) || io(s))
        return K;
      const o = _i(i.value, s.value);
      return o.valid ? ((so(i) || so(s)) && n.dirty(), { status: n.value, value: o.data }) : (A(a, {
        code: O.invalid_intersection_types
      }), K);
    };
    return a.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: a.data,
        path: a.path,
        parent: a
      }),
      this._def.right._parseAsync({
        data: a.data,
        path: a.path,
        parent: a
      })
    ]).then(([i, s]) => r(i, s)) : r(this._def.left._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }), this._def.right._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }));
  }
};
Ba.create = (t, e, n) => new Ba({
  left: t,
  right: e,
  typeName: V.ZodIntersection,
  ...j(n)
});
let na = class Au extends H {
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== k.array)
      return A(a, {
        code: O.invalid_type,
        expected: k.array,
        received: a.parsedType
      }), K;
    if (a.data.length < this._def.items.length)
      return A(a, {
        code: O.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), K;
    !this._def.rest && a.data.length > this._def.items.length && (A(a, {
      code: O.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const r = [...a.data].map((i, s) => {
      const o = this._def.items[s] || this._def.rest;
      return o ? o._parse(new je(a, i, a.path, s)) : null;
    }).filter((i) => !!i);
    return a.common.async ? Promise.all(r).then((i) => ne.mergeArray(n, i)) : ne.mergeArray(n, r);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Au({
      ...this._def,
      rest: e
    });
  }
};
na.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new na({
    items: t,
    typeName: V.ZodTuple,
    rest: null,
    ...j(e)
  });
};
let go = class extends H {
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== k.map)
      return A(a, {
        code: O.invalid_type,
        expected: k.map,
        received: a.parsedType
      }), K;
    const r = this._def.keyType, i = this._def.valueType, s = [...a.data.entries()].map(([o, l], u) => ({
      key: r._parse(new je(a, o, a.path, [u, "key"])),
      value: i._parse(new je(a, l, a.path, [u, "value"]))
    }));
    if (a.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of s) {
          const u = await l.key, f = await l.value;
          if (u.status === "aborted" || f.status === "aborted")
            return K;
          (u.status === "dirty" || f.status === "dirty") && n.dirty(), o.set(u.value, f.value);
        }
        return { status: n.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const l of s) {
        const u = l.key, f = l.value;
        if (u.status === "aborted" || f.status === "aborted")
          return K;
        (u.status === "dirty" || f.status === "dirty") && n.dirty(), o.set(u.value, f.value);
      }
      return { status: n.value, value: o };
    }
  }
};
go.create = (t, e, n) => new go({
  valueType: e,
  keyType: t,
  typeName: V.ZodMap,
  ...j(n)
});
let ho = class gi extends H {
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== k.set)
      return A(a, {
        code: O.invalid_type,
        expected: k.set,
        received: a.parsedType
      }), K;
    const r = this._def;
    r.minSize !== null && a.data.size < r.minSize.value && (A(a, {
      code: O.too_small,
      minimum: r.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.minSize.message
    }), n.dirty()), r.maxSize !== null && a.data.size > r.maxSize.value && (A(a, {
      code: O.too_big,
      maximum: r.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.maxSize.message
    }), n.dirty());
    const i = this._def.valueType;
    function s(l) {
      const u = /* @__PURE__ */ new Set();
      for (const f of l) {
        if (f.status === "aborted")
          return K;
        f.status === "dirty" && n.dirty(), u.add(f.value);
      }
      return { status: n.value, value: u };
    }
    const o = [...a.data.values()].map((l, u) => i._parse(new je(a, l, a.path, u)));
    return a.common.async ? Promise.all(o).then((l) => s(l)) : s(o);
  }
  min(e, n) {
    return new gi({
      ...this._def,
      minSize: { value: e, message: E.toString(n) }
    });
  }
  max(e, n) {
    return new gi({
      ...this._def,
      maxSize: { value: e, message: E.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
ho.create = (t, e) => new ho({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: V.ZodSet,
  ...j(e)
});
let vo = class extends H {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
};
vo.create = (t, e) => new vo({
  getter: t,
  typeName: V.ZodLazy,
  ...j(e)
});
let hi = class extends H {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return A(n, {
        received: n.data,
        code: O.invalid_literal,
        expected: this._def.value
      }), K;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
hi.create = (t, e) => new hi({
  value: t,
  typeName: V.ZodLiteral,
  ...j(e)
});
function ku(t, e) {
  return new ds({
    values: t,
    typeName: V.ZodEnum,
    ...j(e)
  });
}
let ds = class vi extends H {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), a = this._def.values;
      return A(n, {
        expected: Y.joinValues(a),
        received: n.parsedType,
        code: O.invalid_type
      }), K;
    }
    if (this._def.values.indexOf(e.data) === -1) {
      const n = this._getOrReturnCtx(e), a = this._def.values;
      return A(n, {
        received: n.data,
        code: O.invalid_enum_value,
        options: a
      }), K;
    }
    return Zt(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e) {
    return vi.create(e);
  }
  exclude(e) {
    return vi.create(this.options.filter((n) => !e.includes(n)));
  }
};
ds.create = ku;
let bo = class extends H {
  _parse(e) {
    const n = Y.getValidEnumValues(this._def.values), a = this._getOrReturnCtx(e);
    if (a.parsedType !== k.string && a.parsedType !== k.number) {
      const r = Y.objectValues(n);
      return A(a, {
        expected: Y.joinValues(r),
        received: a.parsedType,
        code: O.invalid_type
      }), K;
    }
    if (n.indexOf(e.data) === -1) {
      const r = Y.objectValues(n);
      return A(a, {
        received: a.data,
        code: O.invalid_enum_value,
        options: r
      }), K;
    }
    return Zt(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
bo.create = (t, e) => new bo({
  values: t,
  typeName: V.ZodNativeEnum,
  ...j(e)
});
let Za = class extends H {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== k.promise && n.common.async === !1)
      return A(n, {
        code: O.invalid_type,
        expected: k.promise,
        received: n.parsedType
      }), K;
    const a = n.parsedType === k.promise ? n.data : Promise.resolve(n.data);
    return Zt(a.then((r) => this._def.type.parseAsync(r, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
};
Za.create = (t, e) => new Za({
  type: t,
  typeName: V.ZodPromise,
  ...j(e)
});
let Pn = class extends H {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === V.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e), r = this._def.effect || null;
    if (r.type === "preprocess") {
      const s = r.transform(a.data);
      return a.common.async ? Promise.resolve(s).then((o) => this._def.schema._parseAsync({
        data: o,
        path: a.path,
        parent: a
      })) : this._def.schema._parseSync({
        data: s,
        path: a.path,
        parent: a
      });
    }
    const i = {
      addIssue: (s) => {
        A(a, s), s.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return a.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), r.type === "refinement") {
      const s = (o) => {
        const l = r.refinement(o, i);
        if (a.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (a.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: a.data,
          path: a.path,
          parent: a
        });
        return o.status === "aborted" ? K : (o.status === "dirty" && n.dirty(), s(o.value), { status: n.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: a.data, path: a.path, parent: a }).then((o) => o.status === "aborted" ? K : (o.status === "dirty" && n.dirty(), s(o.value).then(() => ({ status: n.value, value: o.value }))));
    }
    if (r.type === "transform")
      if (a.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: a.data,
          path: a.path,
          parent: a
        });
        if (!ci(s))
          return s;
        const o = r.transform(s.value, i);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: a.data, path: a.path, parent: a }).then((s) => ci(s) ? Promise.resolve(r.transform(s.value, i)).then((o) => ({ status: n.value, value: o })) : s);
    Y.assertNever(r);
  }
};
Pn.create = (t, e, n) => new Pn({
  schema: t,
  typeName: V.ZodEffects,
  effect: e,
  ...j(n)
});
Pn.createWithPreprocess = (t, e, n) => new Pn({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: V.ZodEffects,
  ...j(n)
});
let $e = class extends H {
  _parse(e) {
    return this._getType(e) === k.undefined ? Zt(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
$e.create = (t, e) => new $e({
  innerType: t,
  typeName: V.ZodOptional,
  ...j(e)
});
let Vn = class extends H {
  _parse(e) {
    return this._getType(e) === k.null ? Zt(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
Vn.create = (t, e) => new Vn({
  innerType: t,
  typeName: V.ZodNullable,
  ...j(e)
});
let bi = class extends H {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let a = n.data;
    return n.parsedType === k.undefined && (a = this._def.defaultValue()), this._def.innerType._parse({
      data: a,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
bi.create = (t, e) => new bi({
  innerType: t,
  typeName: V.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...j(e)
});
let Si = class extends H {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), a = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, r = this._def.innerType._parse({
      data: a.data,
      path: a.path,
      parent: {
        ...a
      }
    });
    return di(r) ? r.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new pn(a.common.issues);
        },
        input: a.data
      })
    })) : {
      status: "valid",
      value: r.status === "valid" ? r.value : this._def.catchValue({
        get error() {
          return new pn(a.common.issues);
        },
        input: a.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
Si.create = (t, e) => new Si({
  innerType: t,
  typeName: V.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...j(e)
});
let So = class extends H {
  _parse(e) {
    if (this._getType(e) !== k.nan) {
      const n = this._getOrReturnCtx(e);
      return A(n, {
        code: O.invalid_type,
        expected: k.nan,
        received: n.parsedType
      }), K;
    }
    return { status: "valid", value: e.data };
  }
};
So.create = (t) => new So({
  typeName: V.ZodNaN,
  ...j(t)
});
let Vm = class extends H {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), a = n.data;
    return this._def.type._parse({
      data: a,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}, Jm = class Fu extends H {
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e);
    if (a.common.async)
      return (async () => {
        const r = await this._def.in._parseAsync({
          data: a.data,
          path: a.path,
          parent: a
        });
        return r.status === "aborted" ? K : r.status === "dirty" ? (n.dirty(), Om(r.value)) : this._def.out._parseAsync({
          data: r.value,
          path: a.path,
          parent: a
        });
      })();
    {
      const r = this._def.in._parseSync({
        data: a.data,
        path: a.path,
        parent: a
      });
      return r.status === "aborted" ? K : r.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: r.value
      }) : this._def.out._parseSync({
        data: r.value,
        path: a.path,
        parent: a
      });
    }
  }
  static create(e, n) {
    return new Fu({
      in: e,
      out: n,
      typeName: V.ZodPipeline
    });
  }
};
ae.lazycreate;
var V;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline";
})(V || (V = {}));
const Q = qe.create, yr = fi.create, aa = yi.create;
Ke.create;
const ra = In.create, G = ae.create;
ae.strictCreate;
const Rt = Ka.create;
Ba.create;
na.create;
const tt = hi.create;
ds.create;
Za.create;
$e.create;
Vn.create;
const xu = G({
  address: Q(),
  label: Q(),
  appearanceId: yr()
}), ca = G({
  publicKey: Q(),
  signature: Q(),
  curve: Rt([tt("curve25519"), tt("secp256k1")])
}), Cm = G({
  accountAddress: Q(),
  proof: ca
}), da = G({ identityAddress: Q(), label: Q() }), Oo = {
  western: "western",
  eastern: "eastern"
}, Dm = Rt([
  tt(Oo.eastern),
  tt(Oo.western)
]), Eu = G({
  variant: Dm,
  familyName: Q(),
  nickname: Q(),
  givenNames: Q()
}), le = G({
  quantifier: Rt([tt("exactly"), tt("atLeast")]),
  quantity: yr().gte(0)
}), Oi = G({
  challenge: Q().optional(),
  numberOfAccounts: le
}), Ni = G({
  accounts: ra(xu),
  challenge: Q().optional(),
  proofs: ra(Cm).optional()
}).refine((t) => {
  var e;
  return t.challenge || t != null && t.proofs ? t.challenge && ((e = t == null ? void 0 : t.proofs) == null ? void 0 : e.length) : !0;
}, "missing challenge or proofs"), za = G({
  isRequestingName: aa().optional(),
  numberOfRequestedEmailAddresses: le.optional(),
  numberOfRequestedPhoneNumbers: le.optional()
}), wi = G({
  name: Eu.optional(),
  emailAddresses: ra(Q()).optional(),
  phoneNumbers: ra(Q()).optional()
}), Mm = G({
  accounts: aa(),
  personaData: aa()
}), ST = G({
  persona: da,
  challenge: Q().optional(),
  proof: ca.optional()
}).refine((t) => t.challenge || t.proof ? t.challenge && t.proof : !0, "missing challenge or proof"), qm = G({
  discriminator: tt("unauthorizedRequest"),
  oneTimeAccounts: Oi.optional(),
  oneTimePersonaData: za.optional()
}), $m = G({
  discriminator: tt("usePersona"),
  identityAddress: Q()
}), Um = G({
  discriminator: tt("loginWithoutChallenge")
}), Lm = G({
  discriminator: tt("loginWithChallenge"),
  challenge: Q()
}), jm = Rt([
  Um,
  Lm
]), Km = Rt([
  $m,
  jm
]), Bm = G({
  discriminator: tt("authorizedRequest"),
  auth: Km,
  reset: Mm.optional(),
  oneTimeAccounts: Oi.optional(),
  ongoingAccounts: Oi.optional(),
  oneTimePersonaData: za.optional(),
  ongoingPersonaData: za.optional()
}), Zm = Rt([
  qm,
  Bm
]), zm = G({
  transactionManifest: Q(),
  version: yr(),
  blobs: ra(Q()).optional(),
  message: Q().optional()
}), Gm = G({
  discriminator: tt("transaction"),
  send: zm
}), Wm = G({
  transactionIntentHash: Q()
}), Hm = G({
  discriminator: tt("transaction"),
  send: Wm
}), Ym = G({
  discriminator: tt("cancelRequest")
}), Xm = Rt([
  Zm,
  Gm,
  Ym
]), Ru = G({
  version: tt(2),
  networkId: yr(),
  dAppDefinitionAddress: Q()
}), Qm = G({
  interactionId: Q(),
  metadata: Ru,
  items: Xm
}), ty = G({
  discriminator: tt("unauthorizedRequest"),
  oneTimeAccounts: Ni.optional(),
  oneTimePersonaData: wi.optional()
}), ey = G({
  discriminator: tt("loginWithoutChallenge"),
  persona: da
}), ny = G({
  discriminator: tt("loginWithChallenge"),
  persona: da,
  challenge: Q(),
  proof: ca
}), ay = Rt([
  ey,
  ny
]), ry = G({
  discriminator: tt("usePersona"),
  persona: da
}), iy = Rt([
  ry,
  ay
]), sy = G({
  discriminator: tt("authorizedRequest"),
  auth: iy,
  oneTimeAccounts: Ni.optional(),
  ongoingAccounts: Ni.optional(),
  oneTimePersonaData: wi.optional(),
  ongoingPersonaData: wi.optional()
}), oy = Rt([
  ty,
  sy
]), uy = Rt([
  oy,
  Hm
]), ly = G({
  discriminator: tt("success"),
  interactionId: Q(),
  items: uy
}), cy = G({
  discriminator: tt("failure"),
  interactionId: Q(),
  error: Q(),
  message: Q().optional()
}), Iu = Rt([
  ly,
  cy
]), OT = G({
  interactionId: Q(),
  discriminator: tt("extensionStatus")
}), Nn = {
  extensionStatus: "extensionStatus",
  receivedByExtension: "receivedByExtension",
  receivedByWallet: "receivedByWallet",
  requestCancelSuccess: "requestCancelSuccess",
  requestCancelFail: "requestCancelFail"
}, NT = G({
  eventType: tt(Nn.extensionStatus),
  interactionId: Q(),
  isWalletLinked: aa(),
  isExtensionAvailable: aa()
}), dy = G({
  eventType: Rt([
    tt(Nn.extensionStatus),
    tt(Nn.receivedByExtension),
    tt(Nn.receivedByWallet),
    tt(Nn.requestCancelSuccess),
    tt(Nn.requestCancelFail)
  ]),
  interactionId: Q()
});
Rt([
  dy,
  Iu
]);
const xa = {
  outgoingMessage: "radix#chromeExtension#send",
  incomingMessage: "radix#chromeExtension#receive"
}, fy = (t, e) => ge.fromPromise(
  t.parseAsync(e),
  (n) => n.issues
), Pu = (t) => (e, n, a = crypto.randomUUID()) => {
  const r = {
    items: n,
    interactionId: a,
    metadata: e
  };
  return fy(Qm, r).mapErr((i) => (t == null || t.error("🔵⬆️❌ invalidWalletInteraction", i), fn(
    Qn.walletRequestValidation,
    r.interactionId
  )));
}, wT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  walletInteractionFactory: Pu
}, Symbol.toStringTag, { value: "Module" })), py = (t) => t, Qn = {
  rejectedByUser: "rejectedByUser",
  missingExtension: "missingExtension",
  canceledByUser: "canceledByUser",
  walletRequestValidation: "walletRequestValidation",
  walletResponseValidation: "walletResponseValidation",
  wrongNetwork: "wrongNetwork",
  failedToPrepareTransaction: "failedToPrepareTransaction",
  failedToCompileTransaction: "failedToCompileTransaction",
  failedToSignTransaction: "failedToSignTransaction",
  failedToSubmitTransaction: "failedToSubmitTransaction",
  failedToPollSubmittedTransaction: "failedToPollSubmittedTransaction",
  submittedTransactionWasDuplicate: "submittedTransactionWasDuplicate",
  submittedTransactionHasFailedTransactionStatus: "submittedTransactionHasFailedTransactionStatus",
  submittedTransactionHasRejectedTransactionStatus: "submittedTransactionHasRejectedTransactionStatus",
  failedToFindAccountWithEnoughFundsToLockFee: "failedToFindAccountWithEnoughFundsToLockFee",
  wrongAccountType: "wrongAccountType",
  unknownWebsite: "unknownWebsite",
  radixJsonNotFound: "radixJsonNotFound",
  unknownDappDefinitionAddress: "unknownDappDefinitionAddress",
  invalidPersona: "invalidPersona"
}, my = (/* @__PURE__ */ new Map()).set(Qn.missingExtension, "extension could not be found").set(Qn.rejectedByUser, "user rejected request").set(Qn.canceledByUser, "user has canceled the request"), fn = (t, e, n) => ({
  error: t,
  interactionId: e,
  message: n || my.get(t) || ""
}), No = (t) => ge.fromPromise(
  Iu.parseAsync(t),
  (e) => e.issues
).andThen(
  (e) => e.discriminator === "success" ? ue(e) : Lt(e)
).mapErr(() => fn("walletResponseValidation", "")), yy = (t, e) => {
  const n = t.logger, a = Pu(n);
  return {
    request: (r, i = {}) => a(t, r).andThen(
      (s) => e.send(s, i)
    ).andThen(No).map((s) => s.items),
    sendTransaction: (r, i = {}) => a(t, {
      discriminator: "transaction",
      send: r
    }).andThen(
      (s) => e.send(s, i)
    ).andThen(No).map(
      (s) => s.items.send
    ),
    extensionStatus$: e.extensionStatus$,
    openPopup: e.openPopup
  };
};
var Ti = function(t, e) {
  return Ti = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
    n.__proto__ = a;
  } || function(n, a) {
    for (var r in a)
      Object.prototype.hasOwnProperty.call(a, r) && (n[r] = a[r]);
  }, Ti(t, e);
};
function Ze(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Ti(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
function _y(t, e, n, a) {
  function r(i) {
    return i instanceof n ? i : new n(function(s) {
      s(i);
    });
  }
  return new (n || (n = Promise))(function(i, s) {
    function o(f) {
      try {
        u(a.next(f));
      } catch (m) {
        s(m);
      }
    }
    function l(f) {
      try {
        u(a.throw(f));
      } catch (m) {
        s(m);
      }
    }
    function u(f) {
      f.done ? i(f.value) : r(f.value).then(o, l);
    }
    u((a = a.apply(t, e || [])).next());
  });
}
function Vu(t, e) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, a, r, i, s;
  return s = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function o(u) {
    return function(f) {
      return l([u, f]);
    };
  }
  function l(u) {
    if (a)
      throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, u[0] && (n = 0)), n; )
      try {
        if (a = 1, r && (i = u[0] & 2 ? r.return : u[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, u[1])).done)
          return i;
        switch (r = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
          case 0:
          case 1:
            i = u;
            break;
          case 4:
            return n.label++, { value: u[1], done: !1 };
          case 5:
            n.label++, r = u[1], u = [0];
            continue;
          case 7:
            u = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              n = 0;
              continue;
            }
            if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
              n.label = u[1];
              break;
            }
            if (u[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = u;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(u);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        u = e.call(t, n);
      } catch (f) {
        u = [6, f], r = 0;
      } finally {
        a = i = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function Jn(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], a = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && a >= t.length && (t = void 0), { value: t && t[a++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Cn(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var a = n.call(t), r, i = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(r = a.next()).done; )
      i.push(r.value);
  } catch (o) {
    s = { error: o };
  } finally {
    try {
      r && !r.done && (n = a.return) && n.call(a);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return i;
}
function Dn(t, e, n) {
  if (n || arguments.length === 2)
    for (var a = 0, r = e.length, i; a < r; a++)
      (i || !(a in e)) && (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
  return t.concat(i || Array.prototype.slice.call(e));
}
function Fn(t) {
  return this instanceof Fn ? (this.v = t, this) : new Fn(t);
}
function gy(t, e, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var a = n.apply(t, e || []), r, i = [];
  return r = {}, s("next"), s("throw"), s("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r;
  function s(y) {
    a[y] && (r[y] = function(_) {
      return new Promise(function(S, h) {
        i.push([y, _, S, h]) > 1 || o(y, _);
      });
    });
  }
  function o(y, _) {
    try {
      l(a[y](_));
    } catch (S) {
      m(i[0][3], S);
    }
  }
  function l(y) {
    y.value instanceof Fn ? Promise.resolve(y.value.v).then(u, f) : m(i[0][2], y);
  }
  function u(y) {
    o("next", y);
  }
  function f(y) {
    o("throw", y);
  }
  function m(y, _) {
    y(_), i.shift(), i.length && o(i[0][0], i[0][1]);
  }
}
function hy(t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof Jn == "function" ? Jn(t) : t[Symbol.iterator](), n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function a(i) {
    n[i] = t[i] && function(s) {
      return new Promise(function(o, l) {
        s = t[i](s), r(o, l, s.done, s.value);
      });
    };
  }
  function r(i, s, o, l) {
    Promise.resolve(l).then(function(u) {
      i({ value: u, done: o });
    }, s);
  }
}
function ft(t) {
  return typeof t == "function";
}
function fs(t) {
  var e = function(a) {
    Error.call(a), a.stack = new Error().stack;
  }, n = t(e);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var Zr = fs(function(t) {
  return function(e) {
    t(this), this.message = e ? e.length + ` errors occurred during unsubscription:
` + e.map(function(n, a) {
      return a + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = e;
  };
});
function Ga(t, e) {
  if (t) {
    var n = t.indexOf(e);
    0 <= n && t.splice(n, 1);
  }
}
var Bn = function() {
  function t(e) {
    this.initialTeardown = e, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return t.prototype.unsubscribe = function() {
    var e, n, a, r, i;
    if (!this.closed) {
      this.closed = !0;
      var s = this._parentage;
      if (s)
        if (this._parentage = null, Array.isArray(s))
          try {
            for (var o = Jn(s), l = o.next(); !l.done; l = o.next()) {
              var u = l.value;
              u.remove(this);
            }
          } catch (h) {
            e = { error: h };
          } finally {
            try {
              l && !l.done && (n = o.return) && n.call(o);
            } finally {
              if (e)
                throw e.error;
            }
          }
        else
          s.remove(this);
      var f = this.initialTeardown;
      if (ft(f))
        try {
          f();
        } catch (h) {
          i = h instanceof Zr ? h.errors : [h];
        }
      var m = this._finalizers;
      if (m) {
        this._finalizers = null;
        try {
          for (var y = Jn(m), _ = y.next(); !_.done; _ = y.next()) {
            var S = _.value;
            try {
              wo(S);
            } catch (h) {
              i = i ?? [], h instanceof Zr ? i = Dn(Dn([], Cn(i)), Cn(h.errors)) : i.push(h);
            }
          }
        } catch (h) {
          a = { error: h };
        } finally {
          try {
            _ && !_.done && (r = y.return) && r.call(y);
          } finally {
            if (a)
              throw a.error;
          }
        }
      }
      if (i)
        throw new Zr(i);
    }
  }, t.prototype.add = function(e) {
    var n;
    if (e && e !== this)
      if (this.closed)
        wo(e);
      else {
        if (e instanceof t) {
          if (e.closed || e._hasParent(this))
            return;
          e._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(e);
      }
  }, t.prototype._hasParent = function(e) {
    var n = this._parentage;
    return n === e || Array.isArray(n) && n.includes(e);
  }, t.prototype._addParent = function(e) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(e), n) : n ? [n, e] : e;
  }, t.prototype._removeParent = function(e) {
    var n = this._parentage;
    n === e ? this._parentage = null : Array.isArray(n) && Ga(n, e);
  }, t.prototype.remove = function(e) {
    var n = this._finalizers;
    n && Ga(n, e), e instanceof t && e._removeParent(this);
  }, t.EMPTY = function() {
    var e = new t();
    return e.closed = !0, e;
  }(), t;
}(), Ju = Bn.EMPTY;
function Cu(t) {
  return t instanceof Bn || t && "closed" in t && ft(t.remove) && ft(t.add) && ft(t.unsubscribe);
}
function wo(t) {
  ft(t) ? t() : t.unsubscribe();
}
var Du = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, vy = {
  setTimeout: function(t, e) {
    for (var n = [], a = 2; a < arguments.length; a++)
      n[a - 2] = arguments[a];
    return setTimeout.apply(void 0, Dn([t, e], Cn(n)));
  },
  clearTimeout: function(t) {
    return clearTimeout(t);
  },
  delegate: void 0
};
function Mu(t) {
  vy.setTimeout(function() {
    throw t;
  });
}
function Ai() {
}
function Da(t) {
  t();
}
var ps = function(t) {
  Ze(e, t);
  function e(n) {
    var a = t.call(this) || this;
    return a.isStopped = !1, n ? (a.destination = n, Cu(n) && n.add(a)) : a.destination = Ny, a;
  }
  return e.create = function(n, a, r) {
    return new Mn(n, a, r);
  }, e.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, e.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this), this.destination = null);
  }, e.prototype._next = function(n) {
    this.destination.next(n);
  }, e.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, e.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, e;
}(Bn), by = Function.prototype.bind;
function zr(t, e) {
  return by.call(t, e);
}
var Sy = function() {
  function t(e) {
    this.partialObserver = e;
  }
  return t.prototype.next = function(e) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(e);
      } catch (a) {
        Ea(a);
      }
  }, t.prototype.error = function(e) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(e);
      } catch (a) {
        Ea(a);
      }
    else
      Ea(e);
  }, t.prototype.complete = function() {
    var e = this.partialObserver;
    if (e.complete)
      try {
        e.complete();
      } catch (n) {
        Ea(n);
      }
  }, t;
}(), Mn = function(t) {
  Ze(e, t);
  function e(n, a, r) {
    var i = t.call(this) || this, s;
    if (ft(n) || !n)
      s = {
        next: n ?? void 0,
        error: a ?? void 0,
        complete: r ?? void 0
      };
    else {
      var o;
      i && Du.useDeprecatedNextContext ? (o = Object.create(n), o.unsubscribe = function() {
        return i.unsubscribe();
      }, s = {
        next: n.next && zr(n.next, o),
        error: n.error && zr(n.error, o),
        complete: n.complete && zr(n.complete, o)
      }) : s = n;
    }
    return i.destination = new Sy(s), i;
  }
  return e;
}(ps);
function Ea(t) {
  Mu(t);
}
function Oy(t) {
  throw t;
}
var Ny = {
  closed: !0,
  next: Ai,
  error: Oy,
  complete: Ai
}, ms = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function _r(t) {
  return t;
}
function wy(t) {
  return t.length === 0 ? _r : t.length === 1 ? t[0] : function(e) {
    return t.reduce(function(n, a) {
      return a(n);
    }, e);
  };
}
var xt = function() {
  function t(e) {
    e && (this._subscribe = e);
  }
  return t.prototype.lift = function(e) {
    var n = new t();
    return n.source = this, n.operator = e, n;
  }, t.prototype.subscribe = function(e, n, a) {
    var r = this, i = Ay(e) ? e : new Mn(e, n, a);
    return Da(function() {
      var s = r, o = s.operator, l = s.source;
      i.add(o ? o.call(i, l) : l ? r._subscribe(i) : r._trySubscribe(i));
    }), i;
  }, t.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (n) {
      e.error(n);
    }
  }, t.prototype.forEach = function(e, n) {
    var a = this;
    return n = To(n), new n(function(r, i) {
      var s = new Mn({
        next: function(o) {
          try {
            e(o);
          } catch (l) {
            i(l), s.unsubscribe();
          }
        },
        error: i,
        complete: r
      });
      a.subscribe(s);
    });
  }, t.prototype._subscribe = function(e) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(e);
  }, t.prototype[ms] = function() {
    return this;
  }, t.prototype.pipe = function() {
    for (var e = [], n = 0; n < arguments.length; n++)
      e[n] = arguments[n];
    return wy(e)(this);
  }, t.prototype.toPromise = function(e) {
    var n = this;
    return e = To(e), new e(function(a, r) {
      var i;
      n.subscribe(function(s) {
        return i = s;
      }, function(s) {
        return r(s);
      }, function() {
        return a(i);
      });
    });
  }, t.create = function(e) {
    return new t(e);
  }, t;
}();
function To(t) {
  var e;
  return (e = t ?? Du.Promise) !== null && e !== void 0 ? e : Promise;
}
function Ty(t) {
  return t && ft(t.next) && ft(t.error) && ft(t.complete);
}
function Ay(t) {
  return t && t instanceof ps || Ty(t) && Cu(t);
}
function ky(t) {
  return ft(t == null ? void 0 : t.lift);
}
function zt(t) {
  return function(e) {
    if (ky(e))
      return e.lift(function(n) {
        try {
          return t(n, this);
        } catch (a) {
          this.error(a);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Jt(t, e, n, a, r) {
  return new Fy(t, e, n, a, r);
}
var Fy = function(t) {
  Ze(e, t);
  function e(n, a, r, i, s, o) {
    var l = t.call(this, n) || this;
    return l.onFinalize = s, l.shouldUnsubscribe = o, l._next = a ? function(u) {
      try {
        a(u);
      } catch (f) {
        n.error(f);
      }
    } : t.prototype._next, l._error = i ? function(u) {
      try {
        i(u);
      } catch (f) {
        n.error(f);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._error, l._complete = r ? function() {
      try {
        r();
      } catch (u) {
        n.error(u);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._complete, l;
  }
  return e.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var a = this.closed;
      t.prototype.unsubscribe.call(this), !a && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, e;
}(ps), xy = fs(function(t) {
  return function() {
    t(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), cn = function(t) {
  Ze(e, t);
  function e() {
    var n = t.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return e.prototype.lift = function(n) {
    var a = new Ao(this, this);
    return a.operator = n, a;
  }, e.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new xy();
  }, e.prototype.next = function(n) {
    var a = this;
    Da(function() {
      var r, i;
      if (a._throwIfClosed(), !a.isStopped) {
        a.currentObservers || (a.currentObservers = Array.from(a.observers));
        try {
          for (var s = Jn(a.currentObservers), o = s.next(); !o.done; o = s.next()) {
            var l = o.value;
            l.next(n);
          }
        } catch (u) {
          r = { error: u };
        } finally {
          try {
            o && !o.done && (i = s.return) && i.call(s);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
    });
  }, e.prototype.error = function(n) {
    var a = this;
    Da(function() {
      if (a._throwIfClosed(), !a.isStopped) {
        a.hasError = a.isStopped = !0, a.thrownError = n;
        for (var r = a.observers; r.length; )
          r.shift().error(n);
      }
    });
  }, e.prototype.complete = function() {
    var n = this;
    Da(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var a = n.observers; a.length; )
          a.shift().complete();
      }
    });
  }, e.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(e.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), t.prototype._trySubscribe.call(this, n);
  }, e.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, e.prototype._innerSubscribe = function(n) {
    var a = this, r = this, i = r.hasError, s = r.isStopped, o = r.observers;
    return i || s ? Ju : (this.currentObservers = null, o.push(n), new Bn(function() {
      a.currentObservers = null, Ga(o, n);
    }));
  }, e.prototype._checkFinalizedStatuses = function(n) {
    var a = this, r = a.hasError, i = a.thrownError, s = a.isStopped;
    r ? n.error(i) : s && n.complete();
  }, e.prototype.asObservable = function() {
    var n = new xt();
    return n.source = this, n;
  }, e.create = function(n, a) {
    return new Ao(n, a);
  }, e;
}(xt), Ao = function(t) {
  Ze(e, t);
  function e(n, a) {
    var r = t.call(this) || this;
    return r.destination = n, r.source = a, r;
  }
  return e.prototype.next = function(n) {
    var a, r;
    (r = (a = this.destination) === null || a === void 0 ? void 0 : a.next) === null || r === void 0 || r.call(a, n);
  }, e.prototype.error = function(n) {
    var a, r;
    (r = (a = this.destination) === null || a === void 0 ? void 0 : a.error) === null || r === void 0 || r.call(a, n);
  }, e.prototype.complete = function() {
    var n, a;
    (a = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || a === void 0 || a.call(n);
  }, e.prototype._subscribe = function(n) {
    var a, r;
    return (r = (a = this.source) === null || a === void 0 ? void 0 : a.subscribe(n)) !== null && r !== void 0 ? r : Ju;
  }, e;
}(cn), Ey = {
  now: function() {
    return Date.now();
  },
  delegate: void 0
}, Ry = function(t) {
  Ze(e, t);
  function e(n, a) {
    return t.call(this) || this;
  }
  return e.prototype.schedule = function(n, a) {
    return this;
  }, e;
}(Bn), ki = {
  setInterval: function(t, e) {
    for (var n = [], a = 2; a < arguments.length; a++)
      n[a - 2] = arguments[a];
    var r = ki.delegate;
    return r != null && r.setInterval ? r.setInterval.apply(r, Dn([t, e], Cn(n))) : setInterval.apply(void 0, Dn([t, e], Cn(n)));
  },
  clearInterval: function(t) {
    return clearInterval(t);
  },
  delegate: void 0
}, Iy = function(t) {
  Ze(e, t);
  function e(n, a) {
    var r = t.call(this, n, a) || this;
    return r.scheduler = n, r.work = a, r.pending = !1, r;
  }
  return e.prototype.schedule = function(n, a) {
    var r;
    if (a === void 0 && (a = 0), this.closed)
      return this;
    this.state = n;
    var i = this.id, s = this.scheduler;
    return i != null && (this.id = this.recycleAsyncId(s, i, a)), this.pending = !0, this.delay = a, this.id = (r = this.id) !== null && r !== void 0 ? r : this.requestAsyncId(s, this.id, a), this;
  }, e.prototype.requestAsyncId = function(n, a, r) {
    return r === void 0 && (r = 0), ki.setInterval(n.flush.bind(n, this), r);
  }, e.prototype.recycleAsyncId = function(n, a, r) {
    if (r === void 0 && (r = 0), r != null && this.delay === r && this.pending === !1)
      return a;
    a != null && ki.clearInterval(a);
  }, e.prototype.execute = function(n, a) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var r = this._execute(n, a);
    if (r)
      return r;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, e.prototype._execute = function(n, a) {
    var r = !1, i;
    try {
      this.work(n);
    } catch (s) {
      r = !0, i = s || new Error("Scheduled action threw falsy error");
    }
    if (r)
      return this.unsubscribe(), i;
  }, e.prototype.unsubscribe = function() {
    if (!this.closed) {
      var n = this, a = n.id, r = n.scheduler, i = r.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, Ga(i, this), a != null && (this.id = this.recycleAsyncId(r, a, null)), this.delay = null, t.prototype.unsubscribe.call(this);
    }
  }, e;
}(Ry), ko = function() {
  function t(e, n) {
    n === void 0 && (n = t.now), this.schedulerActionCtor = e, this.now = n;
  }
  return t.prototype.schedule = function(e, n, a) {
    return n === void 0 && (n = 0), new this.schedulerActionCtor(this, e).schedule(a, n);
  }, t.now = Ey.now, t;
}(), Py = function(t) {
  Ze(e, t);
  function e(n, a) {
    a === void 0 && (a = ko.now);
    var r = t.call(this, n, a) || this;
    return r.actions = [], r._active = !1, r;
  }
  return e.prototype.flush = function(n) {
    var a = this.actions;
    if (this._active) {
      a.push(n);
      return;
    }
    var r;
    this._active = !0;
    do
      if (r = n.execute(n.state, n.delay))
        break;
    while (n = a.shift());
    if (this._active = !1, r) {
      for (; n = a.shift(); )
        n.unsubscribe();
      throw r;
    }
  }, e;
}(ko), Vy = new Py(Iy), Jy = Vy, qu = new xt(function(t) {
  return t.complete();
});
function $u(t) {
  return t && ft(t.schedule);
}
function Uu(t) {
  return t[t.length - 1];
}
function Lu(t) {
  return $u(Uu(t)) ? t.pop() : void 0;
}
function Cy(t, e) {
  return typeof Uu(t) == "number" ? t.pop() : e;
}
var ju = function(t) {
  return t && typeof t.length == "number" && typeof t != "function";
};
function Ku(t) {
  return ft(t == null ? void 0 : t.then);
}
function Bu(t) {
  return ft(t[ms]);
}
function Zu(t) {
  return Symbol.asyncIterator && ft(t == null ? void 0 : t[Symbol.asyncIterator]);
}
function zu(t) {
  return new TypeError("You provided " + (t !== null && typeof t == "object" ? "an invalid object" : "'" + t + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function Dy() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var Gu = Dy();
function Wu(t) {
  return ft(t == null ? void 0 : t[Gu]);
}
function Hu(t) {
  return gy(this, arguments, function() {
    var e, n, a, r;
    return Vu(this, function(i) {
      switch (i.label) {
        case 0:
          e = t.getReader(), i.label = 1;
        case 1:
          i.trys.push([1, , 9, 10]), i.label = 2;
        case 2:
          return [4, Fn(e.read())];
        case 3:
          return n = i.sent(), a = n.value, r = n.done, r ? [4, Fn(void 0)] : [3, 5];
        case 4:
          return [2, i.sent()];
        case 5:
          return [4, Fn(a)];
        case 6:
          return [4, i.sent()];
        case 7:
          return i.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return e.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function Yu(t) {
  return ft(t == null ? void 0 : t.getReader);
}
function Gt(t) {
  if (t instanceof xt)
    return t;
  if (t != null) {
    if (Bu(t))
      return My(t);
    if (ju(t))
      return qy(t);
    if (Ku(t))
      return $y(t);
    if (Zu(t))
      return Xu(t);
    if (Wu(t))
      return Uy(t);
    if (Yu(t))
      return Ly(t);
  }
  throw zu(t);
}
function My(t) {
  return new xt(function(e) {
    var n = t[ms]();
    if (ft(n.subscribe))
      return n.subscribe(e);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function qy(t) {
  return new xt(function(e) {
    for (var n = 0; n < t.length && !e.closed; n++)
      e.next(t[n]);
    e.complete();
  });
}
function $y(t) {
  return new xt(function(e) {
    t.then(function(n) {
      e.closed || (e.next(n), e.complete());
    }, function(n) {
      return e.error(n);
    }).then(null, Mu);
  });
}
function Uy(t) {
  return new xt(function(e) {
    var n, a;
    try {
      for (var r = Jn(t), i = r.next(); !i.done; i = r.next()) {
        var s = i.value;
        if (e.next(s), e.closed)
          return;
      }
    } catch (o) {
      n = { error: o };
    } finally {
      try {
        i && !i.done && (a = r.return) && a.call(r);
      } finally {
        if (n)
          throw n.error;
      }
    }
    e.complete();
  });
}
function Xu(t) {
  return new xt(function(e) {
    jy(t, e).catch(function(n) {
      return e.error(n);
    });
  });
}
function Ly(t) {
  return Xu(Hu(t));
}
function jy(t, e) {
  var n, a, r, i;
  return _y(this, void 0, void 0, function() {
    var s, o;
    return Vu(this, function(l) {
      switch (l.label) {
        case 0:
          l.trys.push([0, 5, 6, 11]), n = hy(t), l.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (a = l.sent(), !!a.done)
            return [3, 4];
          if (s = a.value, e.next(s), e.closed)
            return [2];
          l.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return o = l.sent(), r = { error: o }, [3, 11];
        case 6:
          return l.trys.push([6, , 9, 10]), a && !a.done && (i = n.return) ? [4, i.call(n)] : [3, 8];
        case 7:
          l.sent(), l.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (r)
            throw r.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return e.complete(), [2];
      }
    });
  });
}
function Ue(t, e, n, a, r) {
  a === void 0 && (a = 0), r === void 0 && (r = !1);
  var i = e.schedule(function() {
    n(), r ? t.add(this.schedule(null, a)) : this.unsubscribe();
  }, a);
  if (t.add(i), !r)
    return i;
}
function Qu(t, e) {
  return e === void 0 && (e = 0), zt(function(n, a) {
    n.subscribe(Jt(a, function(r) {
      return Ue(a, t, function() {
        return a.next(r);
      }, e);
    }, function() {
      return Ue(a, t, function() {
        return a.complete();
      }, e);
    }, function(r) {
      return Ue(a, t, function() {
        return a.error(r);
      }, e);
    }));
  });
}
function tl(t, e) {
  return e === void 0 && (e = 0), zt(function(n, a) {
    a.add(t.schedule(function() {
      return n.subscribe(a);
    }, e));
  });
}
function Ky(t, e) {
  return Gt(t).pipe(tl(e), Qu(e));
}
function By(t, e) {
  return Gt(t).pipe(tl(e), Qu(e));
}
function Zy(t, e) {
  return new xt(function(n) {
    var a = 0;
    return e.schedule(function() {
      a === t.length ? n.complete() : (n.next(t[a++]), n.closed || this.schedule());
    });
  });
}
function zy(t, e) {
  return new xt(function(n) {
    var a;
    return Ue(n, e, function() {
      a = t[Gu](), Ue(n, e, function() {
        var r, i, s;
        try {
          r = a.next(), i = r.value, s = r.done;
        } catch (o) {
          n.error(o);
          return;
        }
        s ? n.complete() : n.next(i);
      }, 0, !0);
    }), function() {
      return ft(a == null ? void 0 : a.return) && a.return();
    };
  });
}
function el(t, e) {
  if (!t)
    throw new Error("Iterable cannot be null");
  return new xt(function(n) {
    Ue(n, e, function() {
      var a = t[Symbol.asyncIterator]();
      Ue(n, e, function() {
        a.next().then(function(r) {
          r.done ? n.complete() : n.next(r.value);
        });
      }, 0, !0);
    });
  });
}
function Gy(t, e) {
  return el(Hu(t), e);
}
function Wy(t, e) {
  if (t != null) {
    if (Bu(t))
      return Ky(t, e);
    if (ju(t))
      return Zy(t, e);
    if (Ku(t))
      return By(t, e);
    if (Zu(t))
      return el(t, e);
    if (Wu(t))
      return zy(t, e);
    if (Yu(t))
      return Gy(t, e);
  }
  throw zu(t);
}
function nl(t, e) {
  return e ? Wy(t, e) : Gt(t);
}
function Fo() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var n = Lu(t);
  return nl(t, n);
}
var ys = fs(function(t) {
  return function() {
    t(this), this.name = "EmptyError", this.message = "no elements in sequence";
  };
});
function al(t, e) {
  var n = typeof e == "object";
  return new Promise(function(a, r) {
    var i = new Mn({
      next: function(s) {
        a(s), i.unsubscribe();
      },
      error: r,
      complete: function() {
        n ? a(e.defaultValue) : r(new ys());
      }
    });
    t.subscribe(i);
  });
}
function Hy(t) {
  return t instanceof Date && !isNaN(t);
}
function tn(t, e) {
  return zt(function(n, a) {
    var r = 0;
    n.subscribe(Jt(a, function(i) {
      a.next(t.call(e, i, r++));
    }));
  });
}
function Yy(t, e, n, a, r, i, s, o) {
  var l = [], u = 0, f = 0, m = !1, y = function() {
    m && !l.length && !u && e.complete();
  }, _ = function(h) {
    return u < a ? S(h) : l.push(h);
  }, S = function(h) {
    i && e.next(h), u++;
    var $ = !1;
    Gt(n(h, f++)).subscribe(Jt(e, function(z) {
      r == null || r(z), i ? _(z) : e.next(z);
    }, function() {
      $ = !0;
    }, void 0, function() {
      if ($)
        try {
          u--;
          for (var z = function() {
            var F = l.shift();
            s ? Ue(e, s, function() {
              return S(F);
            }) : S(F);
          }; l.length && u < a; )
            z();
          y();
        } catch (F) {
          e.error(F);
        }
    }));
  };
  return t.subscribe(Jt(e, _, function() {
    m = !0, y();
  })), function() {
    o == null || o();
  };
}
function rl(t, e, n) {
  return n === void 0 && (n = 1 / 0), ft(e) ? rl(function(a, r) {
    return tn(function(i, s) {
      return e(a, i, r, s);
    })(Gt(t(a, r)));
  }, n) : (typeof e == "number" && (n = e), zt(function(a, r) {
    return Yy(a, r, t, n);
  }));
}
function Xy(t) {
  return t === void 0 && (t = 1 / 0), rl(_r, t);
}
function xo(t, e, n) {
  t === void 0 && (t = 0), n === void 0 && (n = Jy);
  var a = -1;
  return e != null && ($u(e) ? n = e : a = e), new xt(function(r) {
    var i = Hy(t) ? +t - n.now() : t;
    i < 0 && (i = 0);
    var s = 0;
    return n.schedule(function() {
      r.closed || (r.next(s++), 0 <= a ? this.schedule(void 0, a) : r.complete());
    }, i);
  });
}
function Xn() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var n = Lu(t), a = Cy(t, 1 / 0), r = t;
  return r.length ? r.length === 1 ? Gt(r[0]) : Xy(a)(nl(r, n)) : qu;
}
var Qy = Array.isArray;
function t_(t) {
  return t.length === 1 && Qy(t[0]) ? t[0] : t;
}
function en(t, e) {
  return zt(function(n, a) {
    var r = 0;
    n.subscribe(Jt(a, function(i) {
      return t.call(e, i, r++) && a.next(i);
    }));
  });
}
function e_() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return t = t_(t), t.length === 1 ? Gt(t[0]) : new xt(n_(t));
}
function n_(t) {
  return function(e) {
    for (var n = [], a = function(i) {
      n.push(Gt(t[i]).subscribe(Jt(e, function(s) {
        if (n) {
          for (var o = 0; o < n.length; o++)
            o !== i && n[o].unsubscribe();
          n = null;
        }
        e.next(s);
      })));
    }, r = 0; n && !e.closed && r < t.length; r++)
      a(r);
  };
}
function a_(t) {
  return zt(function(e, n) {
    var a = !1;
    e.subscribe(Jt(n, function(r) {
      a = !0, n.next(r);
    }, function() {
      a || n.next(t), n.complete();
    }));
  });
}
function r_(t) {
  return t <= 0 ? function() {
    return qu;
  } : zt(function(e, n) {
    var a = 0;
    e.subscribe(Jt(n, function(r) {
      ++a <= t && (n.next(r), t <= a && n.complete());
    }));
  });
}
function i_(t) {
  return t === void 0 && (t = s_), zt(function(e, n) {
    var a = !1;
    e.subscribe(Jt(n, function(r) {
      a = !0, n.next(r);
    }, function() {
      return a ? n.complete() : n.error(t());
    }));
  });
}
function s_() {
  return new ys();
}
function Eo(t, e) {
  var n = arguments.length >= 2;
  return function(a) {
    return a.pipe(t ? en(function(r, i) {
      return t(r, i, a);
    }) : _r, r_(1), n ? a_(e) : i_(function() {
      return new ys();
    }));
  };
}
function o_(t) {
  t === void 0 && (t = {});
  var e = t.connector, n = e === void 0 ? function() {
    return new cn();
  } : e, a = t.resetOnError, r = a === void 0 ? !0 : a, i = t.resetOnComplete, s = i === void 0 ? !0 : i, o = t.resetOnRefCountZero, l = o === void 0 ? !0 : o;
  return function(u) {
    var f, m, y, _ = 0, S = !1, h = !1, $ = function() {
      m == null || m.unsubscribe(), m = void 0;
    }, z = function() {
      $(), f = y = void 0, S = h = !1;
    }, F = function() {
      var v = f;
      z(), v == null || v.unsubscribe();
    };
    return zt(function(v, x) {
      _++, !h && !S && $();
      var q = y = y ?? n();
      x.add(function() {
        _--, _ === 0 && !h && !S && (m = Gr(F, l));
      }), q.subscribe(x), !f && _ > 0 && (f = new Mn({
        next: function(U) {
          return q.next(U);
        },
        error: function(U) {
          h = !0, $(), m = Gr(z, r, U), q.error(U);
        },
        complete: function() {
          S = !0, $(), m = Gr(z, s), q.complete();
        }
      }), Gt(v).subscribe(f));
    })(u);
  };
}
function Gr(t, e) {
  for (var n = [], a = 2; a < arguments.length; a++)
    n[a - 2] = arguments[a];
  if (e === !0) {
    t();
    return;
  }
  if (e !== !1) {
    var r = new Mn({
      next: function() {
        r.unsubscribe(), t();
      }
    });
    return Gt(e.apply(void 0, Dn([], Cn(n)))).subscribe(r);
  }
}
function u_(t, e) {
  return zt(function(n, a) {
    var r = null, i = 0, s = !1, o = function() {
      return s && !r && a.complete();
    };
    n.subscribe(Jt(a, function(l) {
      r == null || r.unsubscribe();
      var u = 0, f = i++;
      Gt(t(l, f)).subscribe(r = Jt(a, function(m) {
        return a.next(e ? e(l, m, f, u++) : m);
      }, function() {
        r = null, o();
      }));
    }, function() {
      s = !0, o();
    }));
  });
}
function l_(t) {
  return zt(function(e, n) {
    Gt(t).subscribe(Jt(n, function() {
      return n.complete();
    }, Ai)), !n.closed && e.subscribe(n);
  });
}
function Sn(t, e, n) {
  var a = ft(t) || e || n ? { next: t, error: e, complete: n } : t;
  return a ? zt(function(r, i) {
    var s;
    (s = a.subscribe) === null || s === void 0 || s.call(a);
    var o = !0;
    r.subscribe(Jt(i, function(l) {
      var u;
      (u = a.next) === null || u === void 0 || u.call(a, l), i.next(l);
    }, function() {
      var l;
      o = !1, (l = a.complete) === null || l === void 0 || l.call(a), i.complete();
    }, function(l) {
      var u;
      o = !1, (u = a.error) === null || u === void 0 || u.call(a, l), i.error(l);
    }, function() {
      var l, u;
      o && ((l = a.unsubscribe) === null || l === void 0 || l.call(a)), (u = a.finalize) === null || u === void 0 || u.call(a);
    }));
  }) : _r;
}
const c_ = () => ({
  outgoingMessageSubject: new cn(),
  incomingMessageSubject: new cn(),
  responseSubject: new cn(),
  messageLifeCycleEventSubject: new cn()
}), d_ = (t) => ge.fromPromise(al(t), py).andThen(
  (e) => e
), Ro = {
  extensionDetectionTime: 100
}, f_ = (t) => {
  const e = t == null ? void 0 : t.logger, n = (t == null ? void 0 : t.subjects) ?? c_(), a = new Bn();
  a.add(
    n.incomingMessageSubject.pipe(
      Sn((o) => {
        "eventType" in o ? (e == null || e.debug("🔵💬⬇️ messageLifecycleEvent", o), n.messageLifeCycleEventSubject.next(o)) : (e == null || e.debug("🔵⬇️ walletResponse", o), n.responseSubject.next(o));
      })
    ).subscribe()
  ), a.add(
    n.outgoingMessageSubject.pipe(
      Sn((o) => {
        e == null || e.debug("🔵⬆️ walletRequest", o), window.dispatchEvent(
          new CustomEvent(xa.outgoingMessage, {
            detail: o
          })
        );
      })
    ).subscribe()
  );
  const r = (o) => {
    const l = o.detail;
    n.incomingMessageSubject.next(l);
  };
  addEventListener(xa.incomingMessage, r);
  const i = (o, l) => {
    const u = new cn(), f = n.responseSubject.pipe(
      en(
        (v) => v.interactionId === o.interactionId
      ),
      tn(
        (v) => v.discriminator === "success" ? ue(v) : Lt(v)
      )
    ), m = n.messageLifeCycleEventSubject.pipe(
      en(
        ({ interactionId: v, eventType: x }) => o.interactionId === v && ["requestCancelSuccess", "requestCancelFail"].includes(x)
      ),
      tn((v) => {
        const x = fn("canceledByUser", v.interactionId);
        return e == null || e.debug("🔵⬆️❌ walletRequestCanceled", x), v;
      })
    ), y = () => (n.outgoingMessageSubject.next({
      interactionId: o.interactionId,
      items: { discriminator: "cancelRequest" },
      metadata: o.metadata
    }), setTimeout(() => {
      u.next(
        Lt(fn("canceledByUser", o.interactionId))
      );
    }), ge.fromSafePromise(
      al(
        Xn(
          f.pipe(tn(() => "requestCancelFail")),
          m.pipe(tn(({ eventType: v }) => v))
        )
      )
    ));
    l.requestControl && l.requestControl({
      cancelRequest: () => y().andThen(
        (v) => v === "requestCancelSuccess" ? ue("requestCancelSuccess") : Lt("requestCancelFail")
      ),
      getRequest: () => o
    });
    const _ = Xn(
      f,
      u
    ).pipe(Eo()), S = n.messageLifeCycleEventSubject.pipe(
      en(
        ({ interactionId: v }) => o.interactionId === v
      ),
      Sn((v) => {
        l.eventCallback && l.eventCallback(v.eventType);
      }),
      l_(f),
      o_()
    ), h = S.subscribe(), $ = xo(Ro.extensionDetectionTime).pipe(
      tn(
        () => Lt(fn("missingExtension", o.interactionId))
      )
    ), z = Xn(
      $,
      S
    ).pipe(
      Eo(),
      en((v) => !("eventType" in v))
    ), F = Fo(o).pipe(
      Sn((v) => {
        n.outgoingMessageSubject.next(v);
      }),
      en((v) => !1)
    );
    return d_(
      Xn(
        _,
        z,
        F
      ).pipe(
        Sn(() => {
          h.unsubscribe();
        })
      )
    );
  }, s = n.messageLifeCycleEventSubject.pipe(
    en(
      (o) => o.eventType === "extensionStatus"
    )
  );
  return {
    send: i,
    destroy: () => {
      a.unsubscribe(), removeEventListener(xa.incomingMessage, r);
    },
    openPopup: () => {
      window.dispatchEvent(
        new CustomEvent(xa.outgoingMessage, {
          detail: { discriminator: "openPopup" }
        })
      );
    },
    extensionStatus$: Fo(!0).pipe(
      Sn(() => {
        n.outgoingMessageSubject.next({
          interactionId: crypto.randomUUID(),
          discriminator: "extensionStatus"
        });
      }),
      u_(
        () => e_(
          s,
          Xn(
            s,
            xo(Ro.extensionDetectionTime).pipe(
              tn(
                () => ({
                  eventType: "extensionStatus",
                  isWalletLinked: !1,
                  isExtensionAvailable: !1
                })
              )
            )
          )
        )
      )
    )
  };
}, Fi = {
  reset: [0, 0],
  bold: [1, 22],
  dim: [2, 22],
  italic: [3, 23],
  underline: [4, 24],
  overline: [53, 55],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],
  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  blackBright: [90, 39],
  redBright: [91, 39],
  greenBright: [92, 39],
  yellowBright: [93, 39],
  blueBright: [94, 39],
  magentaBright: [95, 39],
  cyanBright: [96, 39],
  whiteBright: [97, 39],
  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  bgBlackBright: [100, 49],
  bgRedBright: [101, 49],
  bgGreenBright: [102, 49],
  bgYellowBright: [103, 49],
  bgBlueBright: [104, 49],
  bgMagentaBright: [105, 49],
  bgCyanBright: [106, 49],
  bgWhiteBright: [107, 49]
};
function xi(t, e, n, a = !1) {
  const r = String(e), i = (o, l) => `\x1B[${l[0]}m${o}\x1B[${l[1]}m`, s = (o, l) => l != null && typeof l == "string" ? i(o, Fi[l]) : l != null && Array.isArray(l) ? l.reduce((u, f) => s(u, f), o) : l != null && l[o.trim()] != null ? s(o, l[o.trim()]) : l != null && l["*"] != null ? s(o, l["*"]) : o;
  return r.replace(/{{(.+?)}}/g, (o, l) => {
    var u;
    const f = n[l] != null ? n[l] : a ? "" : o;
    return t.stylePrettyLogs ? s(f, (u = t == null ? void 0 : t.prettyLogStyles) == null ? void 0 : u[l]) + i("", Fi.reset) : f;
  });
}
function il(t) {
  const e = /* @__PURE__ */ new Set();
  return JSON.stringify(t, (n, a) => {
    if (typeof a == "object" && a !== null) {
      if (e.has(a))
        return "[Circular]";
      e.add(a);
    }
    return a;
  });
}
function Ft(t, e) {
  const n = {
    seen: [],
    stylize: sl
  };
  return e != null && cl(n, e), Tn(n.showHidden) && (n.showHidden = !1), Tn(n.depth) && (n.depth = 2), Tn(n.colors) && (n.colors = !0), Tn(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = m_), Wa(n, t, n.depth);
}
Ft.colors = Fi;
Ft.styles = {
  special: "cyan",
  number: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  date: "magenta",
  regexp: "red"
};
function p_(t) {
  return typeof t == "boolean";
}
function Tn(t) {
  return t == null;
}
function sl(t) {
  return t;
}
function m_(t, e) {
  var n, a, r, i;
  const s = Ft.styles[e];
  return s != null && ((a = (n = Ft == null ? void 0 : Ft.colors) == null ? void 0 : n[s]) == null ? void 0 : a[0]) != null && ((i = (r = Ft == null ? void 0 : Ft.colors) == null ? void 0 : r[s]) == null ? void 0 : i[1]) != null ? "\x1B[" + Ft.colors[s][0] + "m" + t + "\x1B[" + Ft.colors[s][1] + "m" : t;
}
function Ra(t) {
  return typeof t == "function";
}
function ol(t) {
  return typeof t == "string";
}
function y_(t) {
  return typeof t == "number";
}
function ul(t) {
  return t === null;
}
function ll(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function Wr(t) {
  return gr(t) && _s(t) === "[object RegExp]";
}
function gr(t) {
  return typeof t == "object" && t !== null;
}
function Hr(t) {
  return gr(t) && (_s(t) === "[object Error]" || t instanceof Error);
}
function Io(t) {
  return gr(t) && _s(t) === "[object Date]";
}
function _s(t) {
  return Object.prototype.toString.call(t);
}
function __(t) {
  const e = {};
  return t.forEach((n) => {
    e[n] = !0;
  }), e;
}
function g_(t, e, n, a, r) {
  const i = [];
  for (let s = 0, o = e.length; s < o; ++s)
    ll(e, String(s)) ? i.push(Ei(t, e, n, a, String(s), !0)) : i.push("");
  return r.forEach((s) => {
    s.match(/^\d+$/) || i.push(Ei(t, e, n, a, s, !0));
  }), i;
}
function Yr(t) {
  return "[" + Error.prototype.toString.call(t) + "]";
}
function Wa(t, e, n = 0) {
  if (t.customInspect && e != null && Ra(e) && (e == null ? void 0 : e.inspect) !== Ft && !(e != null && e.constructor && (e == null ? void 0 : e.constructor.prototype) === e)) {
    if (typeof e.inspect != "function" && e.toString != null)
      return e.toString();
    let f = e == null ? void 0 : e.inspect(n, t);
    return ol(f) || (f = Wa(t, f, n)), f;
  }
  const a = nn(t, e);
  if (a)
    return a;
  let r = Object.keys(e);
  const i = __(r);
  try {
    t.showHidden && Object.getOwnPropertyNames && (r = Object.getOwnPropertyNames(e));
  } catch {
  }
  if (Hr(e) && (r.indexOf("message") >= 0 || r.indexOf("description") >= 0))
    return Yr(e);
  if (r.length === 0)
    if (Ra(t.stylize)) {
      if (Ra(e)) {
        const f = e.name ? ": " + e.name : "";
        return t.stylize("[Function" + f + "]", "special");
      }
      if (Wr(e))
        return t.stylize(RegExp.prototype.toString.call(e), "regexp");
      if (Io(e))
        return t.stylize(Date.prototype.toString.call(e), "date");
      if (Hr(e))
        return Yr(e);
    } else
      return e;
  let s = "", o = !1, l = [`{
`, `
}`];
  if (Array.isArray(e) && (o = !0, l = [`[
`, `
]`]), Ra(e) && (s = " [Function" + (e.name ? ": " + e.name : "") + "]"), Wr(e) && (s = " " + RegExp.prototype.toString.call(e)), Io(e) && (s = " " + Date.prototype.toUTCString.call(e)), Hr(e) && (s = " " + Yr(e)), r.length === 0 && (!o || e.length == 0))
    return l[0] + s + l[1];
  if (n < 0)
    return Wr(e) ? t.stylize(RegExp.prototype.toString.call(e), "regexp") : t.stylize("[Object]", "special");
  t.seen.push(e);
  let u;
  return o ? u = g_(t, e, n, i, r) : u = r.map((f) => Ei(t, e, n, i, f, o)), t.seen.pop(), h_(u, s, l);
}
function Ei(t, e, n, a, r, i) {
  let s, o, l;
  l = { value: void 0 };
  try {
    l.value = e[r];
  } catch {
  }
  try {
    Object.getOwnPropertyDescriptor && (l = Object.getOwnPropertyDescriptor(e, r) || l);
  } catch {
  }
  if (l.get ? l.set ? o = t.stylize("[Getter/Setter]", "special") : o = t.stylize("[Getter]", "special") : l.set && (o = t.stylize("[Setter]", "special")), ll(a, r) || (s = "[" + r + "]"), o || (t.seen.indexOf(l.value) < 0 ? (ul(n) ? o = Wa(t, l.value, void 0) : o = Wa(t, l.value, n - 1), o.indexOf(`
`) > -1 && (i ? o = o.split(`
`).map((u) => "  " + u).join(`
`).substr(2) : o = `
` + o.split(`
`).map((u) => "   " + u).join(`
`))) : o = t.stylize("[Circular]", "special")), Tn(s)) {
    if (i && r.match(/^\d+$/))
      return o;
    s = JSON.stringify("" + r), s.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s = s.substr(1, s.length - 2), s = t.stylize(s, "name")) : (s = s.replace(/'/g, "\\'").replace(/\\"/g, "\\'").replace(/(^"|"$)/g, "'"), s = t.stylize(s, "string"));
  }
  return s + ": " + o;
}
function nn(t, e) {
  if (Tn(e))
    return t.stylize("undefined", "undefined");
  if (ol(e)) {
    const n = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, "\\'") + "'";
    return t.stylize(n, "string");
  }
  if (y_(e))
    return t.stylize("" + e, "number");
  if (p_(e))
    return t.stylize("" + e, "boolean");
  if (ul(e))
    return t.stylize("null", "null");
}
function h_(t, e, n) {
  return n[0] + (e === "" ? "" : e + `
`) + "  " + t.join(`,
  `) + " " + n[1];
}
function cl(t, e) {
  if (!e || !gr(e))
    return t;
  const n = Object.keys(e);
  let a = n.length;
  for (; a--; )
    t[n[a]] = e[n[a]];
  return t;
}
function v_(t, ...e) {
  const n = {
    seen: [],
    stylize: sl
  };
  t != null && cl(n, t);
  const a = e[0];
  let r = 0, i = "", s = "";
  if (typeof a == "string") {
    if (e.length === 1)
      return a;
    let o, l = 0;
    for (let u = 0; u < a.length - 1; u++)
      if (a.charCodeAt(u) === 37) {
        const f = a.charCodeAt(++u);
        if (r + 1 !== e.length) {
          switch (f) {
            case 115: {
              const m = e[++r];
              typeof m == "number" || typeof m == "bigint" ? o = nn(n, m) : typeof m != "object" || m === null ? o = String(m) : o = Ft(m, {
                ...t,
                compact: 3,
                colors: !1,
                depth: 0
              });
              break;
            }
            case 106:
              o = il(e[++r]);
              break;
            case 100: {
              const m = e[++r];
              typeof m == "bigint" ? o = nn(n, m) : typeof m == "symbol" ? o = "NaN" : o = nn(n, m);
              break;
            }
            case 79:
              o = Ft(e[++r], t);
              break;
            case 111:
              o = Ft(e[++r], {
                ...t,
                showHidden: !0,
                showProxy: !0,
                depth: 4
              });
              break;
            case 105: {
              const m = e[++r];
              typeof m == "bigint" ? o = nn(n, m) : typeof m == "symbol" ? o = "NaN" : o = nn(n, parseInt(o));
              break;
            }
            case 102: {
              const m = e[++r];
              typeof m == "symbol" ? o = "NaN" : o = nn(n, parseInt(m));
              break;
            }
            case 99:
              r += 1, o = "";
              break;
            case 37:
              i += a.slice(l, u), l = u + 1;
              continue;
            default:
              continue;
          }
          l !== u - 1 && (i += a.slice(l, u - 1)), i += o, l = u + 1;
        } else
          f === 37 && (i += a.slice(l, u), l = u + 1);
      }
    l !== 0 && (r++, s = " ", l < a.length && (i += a.slice(l)));
  }
  for (; r < e.length; ) {
    const o = e[r];
    i += s, i += typeof o != "string" ? Ft(o, t) : o, s = " ", r++;
  }
  return i;
}
var Po;
const b_ = {
  runtime: [typeof window, typeof document].includes("undefined") ? "Generic" : "Browser",
  browser: (Po = globalThis == null ? void 0 : globalThis.navigator) == null ? void 0 : Po.userAgent
}, S_ = /(?:(?:file|https?|global code|[^@]+)@)?(?:file:)?((?:\/[^:/]+){2,})(?::(\d+))?(?::(\d+))?/;
function O_(t, e, n, a, r, i) {
  return Object.assign({}, b_, {
    name: r,
    parentNames: i,
    date: /* @__PURE__ */ new Date(),
    logLevelId: t,
    logLevelName: e,
    path: a ? void 0 : N_(n)
  });
}
function N_(t, e = Error()) {
  var n, a, r;
  return fl((r = (a = (n = e == null ? void 0 : e.stack) == null ? void 0 : n.split(`
`)) == null ? void 0 : a.filter((i) => !i.includes("Error: "))) == null ? void 0 : r[t]);
}
function dl(t) {
  var e, n, a;
  return (a = (n = (e = t == null ? void 0 : t.stack) == null ? void 0 : e.split(`
`)) == null ? void 0 : n.filter((r) => !r.includes("Error: "))) == null ? void 0 : a.reduce((r, i) => (r.push(fl(i)), r), []);
}
function fl(t) {
  const e = globalThis.location.origin, n = {
    fullFilePath: void 0,
    fileName: void 0,
    fileNameWithLine: void 0,
    fileColumn: void 0,
    fileLine: void 0,
    filePath: void 0,
    filePathWithLine: void 0,
    method: void 0
  };
  if (t != null) {
    const a = t.match(S_);
    if (a) {
      n.filePath = a[1].replace(/\?.*$/, ""), n.fullFilePath = `${e}${n.filePath}`;
      const r = n.filePath.split("/");
      n.fileName = r[r.length - 1], n.fileLine = a[2], n.fileColumn = a[3], n.filePathWithLine = `${n.filePath}:${n.fileLine}`, n.fileNameWithLine = `${n.fileName}:${n.fileLine}`;
    }
  }
  return n;
}
function Ri(t) {
  return t instanceof Error;
}
function w_(t, e) {
  return t.reduce((n, a) => (Ri(a) ? n.errors.push(T_(a, e)) : n.args.push(a), n), { args: [], errors: [] });
}
function T_(t, e) {
  const n = dl(t).map((r) => xi(e, e.prettyErrorStackTemplate, { ...r }, !0)), a = {
    errorName: ` ${t.name} `,
    errorMessage: t.message,
    errorStack: n.join(`
`)
  };
  return xi(e, e.prettyErrorTemplate, a);
}
function A_(t, e, n, a) {
  const r = (n.length > 0 && e.length > 0 ? `
` : "") + n.join(`
`);
  a.prettyInspectOptions.colors = a.stylePrettyLogs, console.log(t + v_(a.prettyInspectOptions, ...e) + r);
}
function k_(t) {
  console.log(il(t));
}
function $t(t, e = 2, n = 0) {
  return t != null && isNaN(t) ? "" : (t = t != null ? t + n : t, e === 2 ? t == null ? "--" : t < 10 ? "0" + t : t.toString() : t == null ? "---" : t < 10 ? "00" + t : t < 100 ? "0" + t : t.toString());
}
let F_ = class {
  constructor(e, n, a = 4) {
    var r, i, s, o, l, u, f;
    this.logObj = n, this.stackDepthLevel = a;
    const m = ![typeof window, typeof document].includes("undefined"), y = Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
    this.runtime = m ? "browser" : y ? "nodejs" : "unknown";
    const _ = m ? (((window == null ? void 0 : window.chrome) || window.Intl && (Intl == null ? void 0 : Intl.v8BreakIterator)) && "CSS" in window) != null : !1, S = m ? /^((?!chrome|android).)*safari/i.test(navigator == null ? void 0 : navigator.userAgent) : !1;
    this.stackDepthLevel = S ? 4 : this.stackDepthLevel, this.settings = {
      type: (e == null ? void 0 : e.type) ?? "pretty",
      name: e == null ? void 0 : e.name,
      parentNames: e == null ? void 0 : e.parentNames,
      minLevel: (e == null ? void 0 : e.minLevel) ?? 0,
      argumentsArrayName: e == null ? void 0 : e.argumentsArrayName,
      hideLogPositionForProduction: (e == null ? void 0 : e.hideLogPositionForProduction) ?? !1,
      prettyLogTemplate: (e == null ? void 0 : e.prettyLogTemplate) ?? "{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}	{{logLevelName}}	{{filePathWithLine}}{{nameWithDelimiterPrefix}}	",
      prettyErrorTemplate: (e == null ? void 0 : e.prettyErrorTemplate) ?? `
{{errorName}} {{errorMessage}}
error stack:
{{errorStack}}`,
      prettyErrorStackTemplate: (e == null ? void 0 : e.prettyErrorStackTemplate) ?? `  • {{fileName}}	{{method}}
	{{filePathWithLine}}`,
      prettyErrorParentNamesSeparator: (e == null ? void 0 : e.prettyErrorParentNamesSeparator) ?? ":",
      prettyErrorLoggerNameDelimiter: (e == null ? void 0 : e.prettyErrorLoggerNameDelimiter) ?? "	",
      stylePrettyLogs: (e == null ? void 0 : e.stylePrettyLogs) ?? !0,
      prettyLogTimeZone: (e == null ? void 0 : e.prettyLogTimeZone) ?? "UTC",
      prettyLogStyles: (e == null ? void 0 : e.prettyLogStyles) ?? {
        logLevelName: {
          "*": ["bold", "black", "bgWhiteBright", "dim"],
          SILLY: ["bold", "white"],
          TRACE: ["bold", "whiteBright"],
          DEBUG: ["bold", "green"],
          INFO: ["bold", "blue"],
          WARN: ["bold", "yellow"],
          ERROR: ["bold", "red"],
          FATAL: ["bold", "redBright"]
        },
        dateIsoStr: "white",
        filePathWithLine: "white",
        name: ["white", "bold"],
        nameWithDelimiterPrefix: ["white", "bold"],
        nameWithDelimiterSuffix: ["white", "bold"],
        errorName: ["bold", "bgRedBright", "whiteBright"],
        fileName: ["yellow"],
        fileNameWithLine: "white"
      },
      prettyInspectOptions: (e == null ? void 0 : e.prettyInspectOptions) ?? {
        colors: !0,
        compact: !1,
        depth: 1 / 0
      },
      metaProperty: (e == null ? void 0 : e.metaProperty) ?? "_meta",
      maskPlaceholder: (e == null ? void 0 : e.maskPlaceholder) ?? "[***]",
      maskValuesOfKeys: (e == null ? void 0 : e.maskValuesOfKeys) ?? ["password"],
      maskValuesOfKeysCaseInsensitive: (e == null ? void 0 : e.maskValuesOfKeysCaseInsensitive) ?? !1,
      maskValuesRegEx: e == null ? void 0 : e.maskValuesRegEx,
      prefix: [...(e == null ? void 0 : e.prefix) ?? []],
      attachedTransports: [...(e == null ? void 0 : e.attachedTransports) ?? []],
      overwrite: {
        mask: (r = e == null ? void 0 : e.overwrite) == null ? void 0 : r.mask,
        toLogObj: (i = e == null ? void 0 : e.overwrite) == null ? void 0 : i.toLogObj,
        addMeta: (s = e == null ? void 0 : e.overwrite) == null ? void 0 : s.addMeta,
        formatMeta: (o = e == null ? void 0 : e.overwrite) == null ? void 0 : o.formatMeta,
        formatLogObj: (l = e == null ? void 0 : e.overwrite) == null ? void 0 : l.formatLogObj,
        transportFormatted: (u = e == null ? void 0 : e.overwrite) == null ? void 0 : u.transportFormatted,
        transportJSON: (f = e == null ? void 0 : e.overwrite) == null ? void 0 : f.transportJSON
      }
    }, this.settings.stylePrettyLogs = this.settings.stylePrettyLogs && m && !_ ? !1 : this.settings.stylePrettyLogs;
  }
  log(e, n, ...a) {
    var r, i, s, o, l, u, f, m, y, _, S, h, $, z;
    if (e < this.settings.minLevel)
      return;
    const F = [...this.settings.prefix, ...a], v = ((r = this.settings.overwrite) == null ? void 0 : r.mask) != null ? (i = this.settings.overwrite) == null ? void 0 : i.mask(F) : this.settings.maskValuesOfKeys != null && this.settings.maskValuesOfKeys.length > 0 ? this._mask(F) : F, x = this.logObj != null ? this._recursiveCloneAndExecuteFunctions(this.logObj) : void 0, q = ((s = this.settings.overwrite) == null ? void 0 : s.toLogObj) != null ? (o = this.settings.overwrite) == null ? void 0 : o.toLogObj(v, x) : this._toLogObj(v, x), U = ((l = this.settings.overwrite) == null ? void 0 : l.addMeta) != null ? (u = this.settings.overwrite) == null ? void 0 : u.addMeta(q, e, n) : this._addMetaToLogObj(q, e, n);
    let I, D;
    return ((f = this.settings.overwrite) == null ? void 0 : f.formatMeta) != null && (I = (m = this.settings.overwrite) == null ? void 0 : m.formatMeta(U == null ? void 0 : U[this.settings.metaProperty])), ((y = this.settings.overwrite) == null ? void 0 : y.formatLogObj) != null && (D = (_ = this.settings.overwrite) == null ? void 0 : _.formatLogObj(v, this.settings)), this.settings.type === "pretty" && (I = I ?? this._prettyFormatLogObjMeta(U == null ? void 0 : U[this.settings.metaProperty]), D = D ?? w_(v, this.settings)), I != null && D != null ? ((S = this.settings.overwrite) == null ? void 0 : S.transportFormatted) != null ? (h = this.settings.overwrite) == null || h.transportFormatted(I, D.args, D.errors, this.settings) : A_(I, D.args, D.errors, this.settings) : (($ = this.settings.overwrite) == null ? void 0 : $.transportJSON) != null ? (z = this.settings.overwrite) == null || z.transportJSON(U) : this.settings.type !== "hidden" && k_(U), this.settings.attachedTransports != null && this.settings.attachedTransports.length > 0 && this.settings.attachedTransports.forEach((lt) => {
      lt(U);
    }), U;
  }
  attachTransport(e) {
    this.settings.attachedTransports.push(e);
  }
  getSubLogger(e, n) {
    var a, r, i;
    const s = {
      ...this.settings,
      ...e,
      parentNames: ((a = this.settings) == null ? void 0 : a.parentNames) != null && ((r = this.settings) == null ? void 0 : r.name) != null ? [...this.settings.parentNames, this.settings.name] : ((i = this.settings) == null ? void 0 : i.name) != null ? [this.settings.name] : void 0,
      prefix: [...this.settings.prefix, ...(e == null ? void 0 : e.prefix) ?? []]
    };
    return new this.constructor(s, n ?? this.logObj, this.stackDepthLevel);
  }
  _mask(e) {
    const n = this.settings.maskValuesOfKeysCaseInsensitive !== !0 ? this.settings.maskValuesOfKeys : this.settings.maskValuesOfKeys.map((a) => a.toLowerCase());
    return e == null ? void 0 : e.map((a) => this._recursiveCloneAndMaskValuesOfKeys(a, n));
  }
  _recursiveCloneAndMaskValuesOfKeys(e, n, a = []) {
    return a.includes(e) ? { ...e } : (typeof e == "object" && e != null && a.push(e), e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : Array.isArray(e) ? e.map((r) => this._recursiveCloneAndMaskValuesOfKeys(r, n, a)) : e instanceof Date ? new Date(e.getTime()) : Ri(e) ? Object.getOwnPropertyNames(e).reduce((r, i) => {
      var s;
      return r[i] = n.includes(((s = this.settings) == null ? void 0 : s.maskValuesOfKeysCaseInsensitive) !== !0 ? i : i.toLowerCase()) ? this.settings.maskPlaceholder : this._recursiveCloneAndMaskValuesOfKeys(e[i], n, a), r;
    }, this._cloneError(e)) : e != null && typeof e == "object" ? Object.getOwnPropertyNames(e).reduce((r, i) => {
      var s;
      return r[i] = n.includes(((s = this.settings) == null ? void 0 : s.maskValuesOfKeysCaseInsensitive) !== !0 ? i : i.toLowerCase()) ? this.settings.maskPlaceholder : this._recursiveCloneAndMaskValuesOfKeys(e[i], n, a), r;
    }, Object.create(Object.getPrototypeOf(e))) : ((r) => {
      var i, s;
      return (s = (i = this.settings) == null ? void 0 : i.maskValuesRegEx) == null || s.forEach((o) => {
        var l;
        r = (l = r == null ? void 0 : r.toString()) == null ? void 0 : l.replace(o, this.settings.maskPlaceholder);
      }), r;
    })(e));
  }
  _recursiveCloneAndExecuteFunctions(e, n = []) {
    return n.includes(e) ? { ...e } : (typeof e == "object" && n.push(e), Array.isArray(e) ? e.map((a) => this._recursiveCloneAndExecuteFunctions(a, n)) : e instanceof Date ? new Date(e.getTime()) : e && typeof e == "object" ? Object.getOwnPropertyNames(e).reduce((a, r) => (Object.defineProperty(a, r, Object.getOwnPropertyDescriptor(e, r)), a[r] = typeof e[r] == "function" ? e[r]() : this._recursiveCloneAndExecuteFunctions(e[r], n), a), Object.create(Object.getPrototypeOf(e))) : e);
  }
  _toLogObj(e, n = {}) {
    return e = e == null ? void 0 : e.map((a) => Ri(a) ? this._toErrorObject(a) : a), this.settings.argumentsArrayName == null ? e.length === 1 && !Array.isArray(e[0]) && (e[0], void 0 !== !0) && !(e[0] instanceof Date) ? n = typeof e[0] == "object" && e[0] != null ? { ...e[0], ...n } : { 0: e[0], ...n } : n = { ...n, ...e } : n = {
      ...n,
      [this.settings.argumentsArrayName]: e
    }, n;
  }
  _cloneError(e) {
    const n = e.constructor, a = new n(e.message);
    Object.assign(a, e);
    const r = Object.getOwnPropertyNames(a);
    for (const i of r) {
      const s = Object.getOwnPropertyDescriptor(a, i);
      s && (s.writable = !0, Object.defineProperty(a, i, s));
    }
    return a;
  }
  _toErrorObject(e) {
    return {
      nativeError: e,
      name: e.name ?? "Error",
      message: e.message,
      stack: dl(e)
    };
  }
  _addMetaToLogObj(e, n, a) {
    return {
      ...e,
      [this.settings.metaProperty]: O_(n, a, this.stackDepthLevel, this.settings.hideLogPositionForProduction, this.settings.name, this.settings.parentNames)
    };
  }
  _prettyFormatLogObjMeta(e) {
    var n, a, r, i, s, o, l, u, f, m, y, _, S, h, $, z, F, v, x, q;
    if (e == null)
      return "";
    let U = this.settings.prettyLogTemplate;
    const I = {};
    U.includes("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}") ? U = U.replace("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}", "{{dateIsoStr}}") : this.settings.prettyLogTimeZone === "UTC" ? (I.yyyy = ((n = e == null ? void 0 : e.date) == null ? void 0 : n.getUTCFullYear()) ?? "----", I.mm = $t((a = e == null ? void 0 : e.date) == null ? void 0 : a.getUTCMonth(), 2, 1), I.dd = $t((r = e == null ? void 0 : e.date) == null ? void 0 : r.getUTCDate(), 2), I.hh = $t((i = e == null ? void 0 : e.date) == null ? void 0 : i.getUTCHours(), 2), I.MM = $t((s = e == null ? void 0 : e.date) == null ? void 0 : s.getUTCMinutes(), 2), I.ss = $t((o = e == null ? void 0 : e.date) == null ? void 0 : o.getUTCSeconds(), 2), I.ms = $t((l = e == null ? void 0 : e.date) == null ? void 0 : l.getUTCMilliseconds(), 3)) : (I.yyyy = ((u = e == null ? void 0 : e.date) == null ? void 0 : u.getFullYear()) ?? "----", I.mm = $t((f = e == null ? void 0 : e.date) == null ? void 0 : f.getMonth(), 2, 1), I.dd = $t((m = e == null ? void 0 : e.date) == null ? void 0 : m.getDate(), 2), I.hh = $t((y = e == null ? void 0 : e.date) == null ? void 0 : y.getHours(), 2), I.MM = $t((_ = e == null ? void 0 : e.date) == null ? void 0 : _.getMinutes(), 2), I.ss = $t((S = e == null ? void 0 : e.date) == null ? void 0 : S.getSeconds(), 2), I.ms = $t((h = e == null ? void 0 : e.date) == null ? void 0 : h.getMilliseconds(), 3));
    const D = this.settings.prettyLogTimeZone === "UTC" ? e == null ? void 0 : e.date : new Date((($ = e == null ? void 0 : e.date) == null ? void 0 : $.getTime()) - ((z = e == null ? void 0 : e.date) == null ? void 0 : z.getTimezoneOffset()) * 6e4);
    I.rawIsoStr = D == null ? void 0 : D.toISOString(), I.dateIsoStr = D == null ? void 0 : D.toISOString().replace("T", " ").replace("Z", ""), I.logLevelName = e == null ? void 0 : e.logLevelName, I.fileNameWithLine = ((F = e == null ? void 0 : e.path) == null ? void 0 : F.fileNameWithLine) ?? "", I.filePathWithLine = ((v = e == null ? void 0 : e.path) == null ? void 0 : v.filePathWithLine) ?? "", I.fullFilePath = ((x = e == null ? void 0 : e.path) == null ? void 0 : x.fullFilePath) ?? "";
    let lt = (q = this.settings.parentNames) == null ? void 0 : q.join(this.settings.prettyErrorParentNamesSeparator);
    return lt = lt != null && (e == null ? void 0 : e.name) != null ? lt + this.settings.prettyErrorParentNamesSeparator : void 0, I.name = (e == null ? void 0 : e.name) != null || lt != null ? (lt ?? "") + (e == null ? void 0 : e.name) : "", I.nameWithDelimiterPrefix = I.name.length > 0 ? this.settings.prettyErrorLoggerNameDelimiter + I.name : "", I.nameWithDelimiterSuffix = I.name.length > 0 ? I.name + this.settings.prettyErrorLoggerNameDelimiter : "", xi(this.settings, U, I);
  }
}, x_ = class extends F_ {
  constructor(e, n) {
    super(e, n, 5);
  }
  log(e, n, ...a) {
    return super.log(e, n, ...a);
  }
  silly(...e) {
    return super.log(0, "SILLY", ...e);
  }
  trace(...e) {
    return super.log(1, "TRACE", ...e);
  }
  debug(...e) {
    return super.log(2, "DEBUG", ...e);
  }
  info(...e) {
    return super.log(3, "INFO", ...e);
  }
  warn(...e) {
    return super.log(4, "WARN", ...e);
  }
  error(...e) {
    return super.log(5, "ERROR", ...e);
  }
  fatal(...e) {
    return super.log(6, "FATAL", ...e);
  }
  getSubLogger(e, n) {
    return super.getSubLogger(e, n);
  }
};
const kT = (t) => new x_({
  minLevel: t,
  prettyLogTemplate: "{{hh}}:{{MM}}:{{ss}}:{{ms}}	{{logLevelName}}	"
}), E_ = (t) => {
  var e, n;
  const a = {
    version: 2,
    dAppDefinitionAddress: t.dAppDefinitionAddress,
    networkId: t.networkId
  };
  Ru.parse(a), (e = t.logger) == null || e.debug("🔵 walletSdkInstantiated", a);
  const r = t.logger, i = ((n = t.providers) == null ? void 0 : n.connectorExtensionClient) ?? f_({ logger: r });
  return {
    ...yy(
      {
        version: 2,
        logger: t.logger,
        dAppDefinitionAddress: t.dAppDefinitionAddress,
        networkId: t.networkId
      },
      i
    ),
    destroy: () => {
      r == null || r.debug("🔵🧹 walletSdkInstantiatedDestroyed"), i.destroy();
    }
  };
};
var X;
(function(t) {
  t.assertEqual = (r) => r;
  function e(r) {
  }
  t.assertIs = e;
  function n(r) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (r) => {
    const i = {};
    for (const s of r)
      i[s] = s;
    return i;
  }, t.getValidEnumValues = (r) => {
    const i = t.objectKeys(r).filter((o) => typeof r[r[o]] != "number"), s = {};
    for (const o of i)
      s[o] = r[o];
    return t.objectValues(s);
  }, t.objectValues = (r) => t.objectKeys(r).map(function(i) {
    return r[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (r) => Object.keys(r) : (r) => {
    const i = [];
    for (const s in r)
      Object.prototype.hasOwnProperty.call(r, s) && i.push(s);
    return i;
  }, t.find = (r, i) => {
    for (const s of r)
      if (i(s))
        return s;
  }, t.isInteger = typeof Number.isInteger == "function" ? (r) => Number.isInteger(r) : (r) => typeof r == "number" && isFinite(r) && Math.floor(r) === r;
  function a(r, i = " | ") {
    return r.map((s) => typeof s == "string" ? `'${s}'` : s).join(i);
  }
  t.joinValues = a, t.jsonStringifyReplacer = (r, i) => typeof i == "bigint" ? i.toString() : i;
})(X || (X = {}));
var Vo;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})(Vo || (Vo = {}));
const N = X.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), on = (t) => {
  switch (typeof t) {
    case "undefined":
      return N.undefined;
    case "string":
      return N.string;
    case "number":
      return isNaN(t) ? N.nan : N.number;
    case "boolean":
      return N.boolean;
    case "function":
      return N.function;
    case "bigint":
      return N.bigint;
    case "symbol":
      return N.symbol;
    case "object":
      return Array.isArray(t) ? N.array : t === null ? N.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? N.promise : typeof Map < "u" && t instanceof Map ? N.map : typeof Set < "u" && t instanceof Set ? N.set : typeof Date < "u" && t instanceof Date ? N.date : N.object;
    default:
      return N.unknown;
  }
}, b = X.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class ce extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (a) => {
      this.issues = [...this.issues, a];
    }, this.addIssues = (a = []) => {
      this.issues = [...this.issues, ...a];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const n = e || function(i) {
      return i.message;
    }, a = { _errors: [] }, r = (i) => {
      for (const s of i.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(r);
        else if (s.code === "invalid_return_type")
          r(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          r(s.argumentsError);
        else if (s.path.length === 0)
          a._errors.push(n(s));
        else {
          let o = a, l = 0;
          for (; l < s.path.length; ) {
            const u = s.path[l];
            l === s.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(n(s))) : o[u] = o[u] || { _errors: [] }, o = o[u], l++;
          }
        }
    };
    return r(this), a;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, X.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, a = [];
    for (const r of this.issues)
      r.path.length > 0 ? (n[r.path[0]] = n[r.path[0]] || [], n[r.path[0]].push(e(r))) : a.push(e(r));
    return { formErrors: a, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
ce.create = (t) => new ce(t);
const Ha = (t, e) => {
  let n;
  switch (t.code) {
    case b.invalid_type:
      t.received === N.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case b.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, X.jsonStringifyReplacer)}`;
      break;
    case b.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${X.joinValues(t.keys, ", ")}`;
      break;
    case b.invalid_union:
      n = "Invalid input";
      break;
    case b.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${X.joinValues(t.options)}`;
      break;
    case b.invalid_enum_value:
      n = `Invalid enum value. Expected ${X.joinValues(t.options)}, received '${t.received}'`;
      break;
    case b.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case b.invalid_return_type:
      n = "Invalid function return type";
      break;
    case b.invalid_date:
      n = "Invalid date";
      break;
    case b.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : X.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case b.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case b.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case b.custom:
      n = "Invalid input";
      break;
    case b.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case b.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case b.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, X.assertNever(t);
  }
  return { message: n };
};
let R_ = Ha;
function Ii() {
  return R_;
}
const Pi = (t) => {
  const { data: e, path: n, errorMaps: a, issueData: r } = t, i = [...n, ...r.path || []], s = {
    ...r,
    path: i
  };
  let o = "";
  const l = a.filter((u) => !!u).slice().reverse();
  for (const u of l)
    o = u(s, { data: e, defaultError: o }).message;
  return {
    ...r,
    path: i,
    message: r.message || o
  };
};
function T(t, e) {
  const n = Pi({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      Ii(),
      Ha
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
class kt {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const a = [];
    for (const r of n) {
      if (r.status === "aborted")
        return C;
      r.status === "dirty" && e.dirty(), a.push(r.value);
    }
    return { status: e.value, value: a };
  }
  static async mergeObjectAsync(e, n) {
    const a = [];
    for (const r of n)
      a.push({
        key: await r.key,
        value: await r.value
      });
    return kt.mergeObjectSync(e, a);
  }
  static mergeObjectSync(e, n) {
    const a = {};
    for (const r of n) {
      const { key: i, value: s } = r;
      if (i.status === "aborted" || s.status === "aborted")
        return C;
      i.status === "dirty" && e.dirty(), s.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof s.value < "u" || r.alwaysSet) && (a[i.value] = s.value);
    }
    return { status: e.value, value: a };
  }
}
const C = Object.freeze({
  status: "aborted"
}), I_ = (t) => ({ status: "dirty", value: t }), Et = (t) => ({ status: "valid", value: t }), Jo = (t) => t.status === "aborted", Co = (t) => t.status === "dirty", Ya = (t) => t.status === "valid", Vi = (t) => typeof Promise < "u" && t instanceof Promise;
var R;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(R || (R = {}));
class me {
  constructor(e, n, a, r) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = a, this._key = r;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Do = (t, e) => {
  if (Ya(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new ce(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function J(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: a, description: r } = t;
  if (e && (n || a))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: r } : { errorMap: (s, o) => s.code !== "invalid_type" ? { message: o.defaultError } : typeof o.data > "u" ? { message: a ?? o.defaultError } : { message: n ?? o.defaultError }, description: r };
}
class B {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return on(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: on(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new kt(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: on(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (Vi(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const a = this.safeParse(e, n);
    if (a.success)
      return a.data;
    throw a.error;
  }
  safeParse(e, n) {
    var a;
    const r = {
      common: {
        issues: [],
        async: (a = n == null ? void 0 : n.async) !== null && a !== void 0 ? a : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: on(e)
    }, i = this._parseSync({ data: e, path: r.path, parent: r });
    return Do(r, i);
  }
  async parseAsync(e, n) {
    const a = await this.safeParseAsync(e, n);
    if (a.success)
      return a.data;
    throw a.error;
  }
  async safeParseAsync(e, n) {
    const a = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: on(e)
    }, r = this._parse({ data: e, path: a.path, parent: a }), i = await (Vi(r) ? r : Promise.resolve(r));
    return Do(a, i);
  }
  refine(e, n) {
    const a = (r) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(r) : n;
    return this._refinement((r, i) => {
      const s = e(r), o = () => i.addIssue({
        code: b.custom,
        ...a(r)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((l) => l ? !0 : (o(), !1)) : s ? !0 : (o(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((a, r) => e(a) ? !0 : (r.addIssue(typeof n == "function" ? n(a, r) : n), !1));
  }
  _refinement(e) {
    return new ke({
      schema: this,
      typeName: P.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return Le.create(this, this._def);
  }
  nullable() {
    return Ln.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return de.create(this, this._def);
  }
  promise() {
    return sa.create(this, this._def);
  }
  or(e) {
    return tr.create([this, e], this._def);
  }
  and(e) {
    return er.create(this, e, this._def);
  }
  transform(e) {
    return new ke({
      ...J(this._def),
      schema: this,
      typeName: P.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new sr({
      ...J(this._def),
      innerType: this,
      defaultValue: n,
      typeName: P.ZodDefault
    });
  }
  brand() {
    return new K_({
      typeName: P.ZodBranded,
      type: this,
      ...J(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Ui({
      ...J(this._def),
      innerType: this,
      catchValue: n,
      typeName: P.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return hr.create(this, e);
  }
  readonly() {
    return ji.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const P_ = /^c[^\s-]{8,}$/i, V_ = /^[a-z][a-z0-9]*$/, J_ = /^[0-9A-HJKMNP-TV-Z]{26}$/, C_ = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, D_ = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, M_ = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Xr;
const q_ = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, $_ = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, U_ = (t) => t.precision ? t.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}Z$`) : t.precision === 0 ? t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function L_(t, e) {
  return !!((e === "v4" || !e) && q_.test(t) || (e === "v6" || !e) && $_.test(t));
}
class Oe extends B {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== N.string) {
      const i = this._getOrReturnCtx(e);
      return T(
        i,
        {
          code: b.invalid_type,
          expected: N.string,
          received: i.parsedType
        }
        //
      ), C;
    }
    const a = new kt();
    let r;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (r = this._getOrReturnCtx(e, r), T(r, {
          code: b.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), a.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (r = this._getOrReturnCtx(e, r), T(r, {
          code: b.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), a.dirty());
      else if (i.kind === "length") {
        const s = e.data.length > i.value, o = e.data.length < i.value;
        (s || o) && (r = this._getOrReturnCtx(e, r), s ? T(r, {
          code: b.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && T(r, {
          code: b.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), a.dirty());
      } else if (i.kind === "email")
        D_.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, {
          validation: "email",
          code: b.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "emoji")
        Xr || (Xr = new RegExp(M_, "u")), Xr.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, {
          validation: "emoji",
          code: b.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "uuid")
        C_.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, {
          validation: "uuid",
          code: b.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "cuid")
        P_.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, {
          validation: "cuid",
          code: b.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "cuid2")
        V_.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, {
          validation: "cuid2",
          code: b.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "ulid")
        J_.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, {
          validation: "ulid",
          code: b.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          r = this._getOrReturnCtx(e, r), T(r, {
            validation: "url",
            code: b.invalid_string,
            message: i.message
          }), a.dirty();
        }
      else
        i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, {
          validation: "regex",
          code: b.invalid_string,
          message: i.message
        }), a.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (r = this._getOrReturnCtx(e, r), T(r, {
          code: b.invalid_string,
          validation: { includes: i.value, position: i.position },
          message: i.message
        }), a.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (r = this._getOrReturnCtx(e, r), T(r, {
          code: b.invalid_string,
          validation: { startsWith: i.value },
          message: i.message
        }), a.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (r = this._getOrReturnCtx(e, r), T(r, {
          code: b.invalid_string,
          validation: { endsWith: i.value },
          message: i.message
        }), a.dirty()) : i.kind === "datetime" ? U_(i).test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, {
          code: b.invalid_string,
          validation: "datetime",
          message: i.message
        }), a.dirty()) : i.kind === "ip" ? L_(e.data, i.version) || (r = this._getOrReturnCtx(e, r), T(r, {
          validation: "ip",
          code: b.invalid_string,
          message: i.message
        }), a.dirty()) : X.assertNever(i);
    return { status: a.value, value: e.data };
  }
  _regex(e, n, a) {
    return this.refinement((r) => e.test(r), {
      validation: n,
      code: b.invalid_string,
      ...R.errToObj(a)
    });
  }
  _addCheck(e) {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...R.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...R.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...R.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...R.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...R.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...R.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...R.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...R.errToObj(e) });
  }
  datetime(e) {
    var n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (n = e == null ? void 0 : e.offset) !== null && n !== void 0 ? n : !1,
      ...R.errToObj(e == null ? void 0 : e.message)
    });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...R.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n == null ? void 0 : n.position,
      ...R.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...R.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...R.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...R.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...R.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...R.errToObj(n)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, R.errToObj(e));
  }
  trim() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
Oe.create = (t) => {
  var e;
  return new Oe({
    checks: [],
    typeName: P.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...J(t)
  });
};
function j_(t, e) {
  const n = (t.toString().split(".")[1] || "").length, a = (e.toString().split(".")[1] || "").length, r = n > a ? n : a, i = parseInt(t.toFixed(r).replace(".", "")), s = parseInt(e.toFixed(r).replace(".", ""));
  return i % s / Math.pow(10, r);
}
class qn extends B {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== N.number) {
      const i = this._getOrReturnCtx(e);
      return T(i, {
        code: b.invalid_type,
        expected: N.number,
        received: i.parsedType
      }), C;
    }
    let a;
    const r = new kt();
    for (const i of this._def.checks)
      i.kind === "int" ? X.isInteger(e.data) || (a = this._getOrReturnCtx(e, a), T(a, {
        code: b.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), r.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (a = this._getOrReturnCtx(e, a), T(a, {
        code: b.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (a = this._getOrReturnCtx(e, a), T(a, {
        code: b.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? j_(e.data, i.value) !== 0 && (a = this._getOrReturnCtx(e, a), T(a, {
        code: b.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (a = this._getOrReturnCtx(e, a), T(a, {
        code: b.not_finite,
        message: i.message
      }), r.dirty()) : X.assertNever(i);
    return { status: r.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, R.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, R.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, R.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, R.toString(n));
  }
  setLimit(e, n, a, r) {
    return new qn({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: a,
          message: R.toString(r)
        }
      ]
    });
  }
  _addCheck(e) {
    return new qn({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: R.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: R.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: R.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: R.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: R.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: R.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: R.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: R.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: R.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && X.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const a of this._def.checks) {
      if (a.kind === "finite" || a.kind === "int" || a.kind === "multipleOf")
        return !0;
      a.kind === "min" ? (n === null || a.value > n) && (n = a.value) : a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
qn.create = (t) => new qn({
  checks: [],
  typeName: P.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...J(t)
});
class $n extends B {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== N.bigint) {
      const i = this._getOrReturnCtx(e);
      return T(i, {
        code: b.invalid_type,
        expected: N.bigint,
        received: i.parsedType
      }), C;
    }
    let a;
    const r = new kt();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (a = this._getOrReturnCtx(e, a), T(a, {
        code: b.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (a = this._getOrReturnCtx(e, a), T(a, {
        code: b.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (a = this._getOrReturnCtx(e, a), T(a, {
        code: b.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : X.assertNever(i);
    return { status: r.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, R.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, R.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, R.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, R.toString(n));
  }
  setLimit(e, n, a, r) {
    return new $n({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: a,
          message: R.toString(r)
        }
      ]
    });
  }
  _addCheck(e) {
    return new $n({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: R.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: R.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: R.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: R.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: R.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
$n.create = (t) => {
  var e;
  return new $n({
    checks: [],
    typeName: P.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...J(t)
  });
};
class Ji extends B {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== N.boolean) {
      const a = this._getOrReturnCtx(e);
      return T(a, {
        code: b.invalid_type,
        expected: N.boolean,
        received: a.parsedType
      }), C;
    }
    return Et(e.data);
  }
}
Ji.create = (t) => new Ji({
  typeName: P.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...J(t)
});
class ia extends B {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== N.date) {
      const i = this._getOrReturnCtx(e);
      return T(i, {
        code: b.invalid_type,
        expected: N.date,
        received: i.parsedType
      }), C;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return T(i, {
        code: b.invalid_date
      }), C;
    }
    const a = new kt();
    let r;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (r = this._getOrReturnCtx(e, r), T(r, {
        code: b.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), a.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (r = this._getOrReturnCtx(e, r), T(r, {
        code: b.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), a.dirty()) : X.assertNever(i);
    return {
      status: a.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new ia({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: R.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: R.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
ia.create = (t) => new ia({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: P.ZodDate,
  ...J(t)
});
class Ci extends B {
  _parse(e) {
    if (this._getType(e) !== N.symbol) {
      const a = this._getOrReturnCtx(e);
      return T(a, {
        code: b.invalid_type,
        expected: N.symbol,
        received: a.parsedType
      }), C;
    }
    return Et(e.data);
  }
}
Ci.create = (t) => new Ci({
  typeName: P.ZodSymbol,
  ...J(t)
});
class Xa extends B {
  _parse(e) {
    if (this._getType(e) !== N.undefined) {
      const a = this._getOrReturnCtx(e);
      return T(a, {
        code: b.invalid_type,
        expected: N.undefined,
        received: a.parsedType
      }), C;
    }
    return Et(e.data);
  }
}
Xa.create = (t) => new Xa({
  typeName: P.ZodUndefined,
  ...J(t)
});
class Qa extends B {
  _parse(e) {
    if (this._getType(e) !== N.null) {
      const a = this._getOrReturnCtx(e);
      return T(a, {
        code: b.invalid_type,
        expected: N.null,
        received: a.parsedType
      }), C;
    }
    return Et(e.data);
  }
}
Qa.create = (t) => new Qa({
  typeName: P.ZodNull,
  ...J(t)
});
class Di extends B {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Et(e.data);
  }
}
Di.create = (t) => new Di({
  typeName: P.ZodAny,
  ...J(t)
});
class xn extends B {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Et(e.data);
  }
}
xn.create = (t) => new xn({
  typeName: P.ZodUnknown,
  ...J(t)
});
class Be extends B {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return T(n, {
      code: b.invalid_type,
      expected: N.never,
      received: n.parsedType
    }), C;
  }
}
Be.create = (t) => new Be({
  typeName: P.ZodNever,
  ...J(t)
});
class Mi extends B {
  _parse(e) {
    if (this._getType(e) !== N.undefined) {
      const a = this._getOrReturnCtx(e);
      return T(a, {
        code: b.invalid_type,
        expected: N.void,
        received: a.parsedType
      }), C;
    }
    return Et(e.data);
  }
}
Mi.create = (t) => new Mi({
  typeName: P.ZodVoid,
  ...J(t)
});
class de extends B {
  _parse(e) {
    const { ctx: n, status: a } = this._processInputParams(e), r = this._def;
    if (n.parsedType !== N.array)
      return T(n, {
        code: b.invalid_type,
        expected: N.array,
        received: n.parsedType
      }), C;
    if (r.exactLength !== null) {
      const s = n.data.length > r.exactLength.value, o = n.data.length < r.exactLength.value;
      (s || o) && (T(n, {
        code: s ? b.too_big : b.too_small,
        minimum: o ? r.exactLength.value : void 0,
        maximum: s ? r.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: r.exactLength.message
      }), a.dirty());
    }
    if (r.minLength !== null && n.data.length < r.minLength.value && (T(n, {
      code: b.too_small,
      minimum: r.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.minLength.message
    }), a.dirty()), r.maxLength !== null && n.data.length > r.maxLength.value && (T(n, {
      code: b.too_big,
      maximum: r.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.maxLength.message
    }), a.dirty()), n.common.async)
      return Promise.all([...n.data].map((s, o) => r.type._parseAsync(new me(n, s, n.path, o)))).then((s) => kt.mergeArray(a, s));
    const i = [...n.data].map((s, o) => r.type._parseSync(new me(n, s, n.path, o)));
    return kt.mergeArray(a, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new de({
      ...this._def,
      minLength: { value: e, message: R.toString(n) }
    });
  }
  max(e, n) {
    return new de({
      ...this._def,
      maxLength: { value: e, message: R.toString(n) }
    });
  }
  length(e, n) {
    return new de({
      ...this._def,
      exactLength: { value: e, message: R.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
de.create = (t, e) => new de({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: P.ZodArray,
  ...J(e)
});
function wn(t) {
  if (t instanceof ut) {
    const e = {};
    for (const n in t.shape) {
      const a = t.shape[n];
      e[n] = Le.create(wn(a));
    }
    return new ut({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof de ? new de({
      ...t._def,
      type: wn(t.element)
    }) : t instanceof Le ? Le.create(wn(t.unwrap())) : t instanceof Ln ? Ln.create(wn(t.unwrap())) : t instanceof Ae ? Ae.create(t.items.map((e) => wn(e))) : t;
}
class ut extends B {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = X.objectKeys(e);
    return this._cached = { shape: e, keys: n };
  }
  _parse(e) {
    if (this._getType(e) !== N.object) {
      const u = this._getOrReturnCtx(e);
      return T(u, {
        code: b.invalid_type,
        expected: N.object,
        received: u.parsedType
      }), C;
    }
    const { status: a, ctx: r } = this._processInputParams(e), { shape: i, keys: s } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Be && this._def.unknownKeys === "strip"))
      for (const u in r.data)
        s.includes(u) || o.push(u);
    const l = [];
    for (const u of s) {
      const f = i[u], m = r.data[u];
      l.push({
        key: { status: "valid", value: u },
        value: f._parse(new me(r, m, r.path, u)),
        alwaysSet: u in r.data
      });
    }
    if (this._def.catchall instanceof Be) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const f of o)
          l.push({
            key: { status: "valid", value: f },
            value: { status: "valid", value: r.data[f] }
          });
      else if (u === "strict")
        o.length > 0 && (T(r, {
          code: b.unrecognized_keys,
          keys: o
        }), a.dirty());
      else if (u !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const f of o) {
        const m = r.data[f];
        l.push({
          key: { status: "valid", value: f },
          value: u._parse(
            new me(r, m, r.path, f)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: f in r.data
        });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const f of l) {
        const m = await f.key;
        u.push({
          key: m,
          value: await f.value,
          alwaysSet: f.alwaysSet
        });
      }
      return u;
    }).then((u) => kt.mergeObjectSync(a, u)) : kt.mergeObjectSync(a, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return R.errToObj, new ut({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, a) => {
          var r, i, s, o;
          const l = (s = (i = (r = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(r, n, a).message) !== null && s !== void 0 ? s : a.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (o = R.errToObj(e).message) !== null && o !== void 0 ? o : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new ut({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ut({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new ut({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new ut({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: P.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new ut({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    return X.objectKeys(e).forEach((a) => {
      e[a] && this.shape[a] && (n[a] = this.shape[a]);
    }), new ut({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    return X.objectKeys(this.shape).forEach((a) => {
      e[a] || (n[a] = this.shape[a]);
    }), new ut({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return wn(this);
  }
  partial(e) {
    const n = {};
    return X.objectKeys(this.shape).forEach((a) => {
      const r = this.shape[a];
      e && !e[a] ? n[a] = r : n[a] = r.optional();
    }), new ut({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    return X.objectKeys(this.shape).forEach((a) => {
      if (e && !e[a])
        n[a] = this.shape[a];
      else {
        let i = this.shape[a];
        for (; i instanceof Le; )
          i = i._def.innerType;
        n[a] = i;
      }
    }), new ut({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return pl(X.objectKeys(this.shape));
  }
}
ut.create = (t, e) => new ut({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Be.create(),
  typeName: P.ZodObject,
  ...J(e)
});
ut.strictCreate = (t, e) => new ut({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Be.create(),
  typeName: P.ZodObject,
  ...J(e)
});
ut.lazycreate = (t, e) => new ut({
  shape: t,
  unknownKeys: "strip",
  catchall: Be.create(),
  typeName: P.ZodObject,
  ...J(e)
});
class tr extends B {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), a = this._def.options;
    function r(i) {
      for (const o of i)
        if (o.result.status === "valid")
          return o.result;
      for (const o of i)
        if (o.result.status === "dirty")
          return n.common.issues.push(...o.ctx.common.issues), o.result;
      const s = i.map((o) => new ce(o.ctx.common.issues));
      return T(n, {
        code: b.invalid_union,
        unionErrors: s
      }), C;
    }
    if (n.common.async)
      return Promise.all(a.map(async (i) => {
        const s = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: n.data,
            path: n.path,
            parent: s
          }),
          ctx: s
        };
      })).then(r);
    {
      let i;
      const s = [];
      for (const l of a) {
        const u = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, f = l._parseSync({
          data: n.data,
          path: n.path,
          parent: u
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !i && (i = { result: f, ctx: u }), u.common.issues.length && s.push(u.common.issues);
      }
      if (i)
        return n.common.issues.push(...i.ctx.common.issues), i.result;
      const o = s.map((l) => new ce(l));
      return T(n, {
        code: b.invalid_union,
        unionErrors: o
      }), C;
    }
  }
  get options() {
    return this._def.options;
  }
}
tr.create = (t, e) => new tr({
  options: t,
  typeName: P.ZodUnion,
  ...J(e)
});
const Ma = (t) => t instanceof ar ? Ma(t.schema) : t instanceof ke ? Ma(t.innerType()) : t instanceof rr ? [t.value] : t instanceof mn ? t.options : t instanceof ir ? Object.keys(t.enum) : t instanceof sr ? Ma(t._def.innerType) : t instanceof Xa ? [void 0] : t instanceof Qa ? [null] : null;
class gs extends B {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== N.object)
      return T(n, {
        code: b.invalid_type,
        expected: N.object,
        received: n.parsedType
      }), C;
    const a = this.discriminator, r = n.data[a], i = this.optionsMap.get(r);
    return i ? n.common.async ? i._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : i._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (T(n, {
      code: b.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [a]
    }), C);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, n, a) {
    const r = /* @__PURE__ */ new Map();
    for (const i of n) {
      const s = Ma(i.shape[e]);
      if (!s)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of s) {
        if (r.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        r.set(o, i);
      }
    }
    return new gs({
      typeName: P.ZodDiscriminatedUnion,
      discriminator: e,
      options: n,
      optionsMap: r,
      ...J(a)
    });
  }
}
function qi(t, e) {
  const n = on(t), a = on(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === N.object && a === N.object) {
    const r = X.objectKeys(e), i = X.objectKeys(t).filter((o) => r.indexOf(o) !== -1), s = { ...t, ...e };
    for (const o of i) {
      const l = qi(t[o], e[o]);
      if (!l.valid)
        return { valid: !1 };
      s[o] = l.data;
    }
    return { valid: !0, data: s };
  } else if (n === N.array && a === N.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const r = [];
    for (let i = 0; i < t.length; i++) {
      const s = t[i], o = e[i], l = qi(s, o);
      if (!l.valid)
        return { valid: !1 };
      r.push(l.data);
    }
    return { valid: !0, data: r };
  } else
    return n === N.date && a === N.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class er extends B {
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e), r = (i, s) => {
      if (Jo(i) || Jo(s))
        return C;
      const o = qi(i.value, s.value);
      return o.valid ? ((Co(i) || Co(s)) && n.dirty(), { status: n.value, value: o.data }) : (T(a, {
        code: b.invalid_intersection_types
      }), C);
    };
    return a.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: a.data,
        path: a.path,
        parent: a
      }),
      this._def.right._parseAsync({
        data: a.data,
        path: a.path,
        parent: a
      })
    ]).then(([i, s]) => r(i, s)) : r(this._def.left._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }), this._def.right._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }));
  }
}
er.create = (t, e, n) => new er({
  left: t,
  right: e,
  typeName: P.ZodIntersection,
  ...J(n)
});
class Ae extends B {
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== N.array)
      return T(a, {
        code: b.invalid_type,
        expected: N.array,
        received: a.parsedType
      }), C;
    if (a.data.length < this._def.items.length)
      return T(a, {
        code: b.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), C;
    !this._def.rest && a.data.length > this._def.items.length && (T(a, {
      code: b.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const i = [...a.data].map((s, o) => {
      const l = this._def.items[o] || this._def.rest;
      return l ? l._parse(new me(a, s, a.path, o)) : null;
    }).filter((s) => !!s);
    return a.common.async ? Promise.all(i).then((s) => kt.mergeArray(n, s)) : kt.mergeArray(n, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Ae({
      ...this._def,
      rest: e
    });
  }
}
Ae.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Ae({
    items: t,
    typeName: P.ZodTuple,
    rest: null,
    ...J(e)
  });
};
class nr extends B {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== N.object)
      return T(a, {
        code: b.invalid_type,
        expected: N.object,
        received: a.parsedType
      }), C;
    const r = [], i = this._def.keyType, s = this._def.valueType;
    for (const o in a.data)
      r.push({
        key: i._parse(new me(a, o, a.path, o)),
        value: s._parse(new me(a, a.data[o], a.path, o))
      });
    return a.common.async ? kt.mergeObjectAsync(n, r) : kt.mergeObjectSync(n, r);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, a) {
    return n instanceof B ? new nr({
      keyType: e,
      valueType: n,
      typeName: P.ZodRecord,
      ...J(a)
    }) : new nr({
      keyType: Oe.create(),
      valueType: e,
      typeName: P.ZodRecord,
      ...J(n)
    });
  }
}
class $i extends B {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== N.map)
      return T(a, {
        code: b.invalid_type,
        expected: N.map,
        received: a.parsedType
      }), C;
    const r = this._def.keyType, i = this._def.valueType, s = [...a.data.entries()].map(([o, l], u) => ({
      key: r._parse(new me(a, o, a.path, [u, "key"])),
      value: i._parse(new me(a, l, a.path, [u, "value"]))
    }));
    if (a.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of s) {
          const u = await l.key, f = await l.value;
          if (u.status === "aborted" || f.status === "aborted")
            return C;
          (u.status === "dirty" || f.status === "dirty") && n.dirty(), o.set(u.value, f.value);
        }
        return { status: n.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const l of s) {
        const u = l.key, f = l.value;
        if (u.status === "aborted" || f.status === "aborted")
          return C;
        (u.status === "dirty" || f.status === "dirty") && n.dirty(), o.set(u.value, f.value);
      }
      return { status: n.value, value: o };
    }
  }
}
$i.create = (t, e, n) => new $i({
  valueType: e,
  keyType: t,
  typeName: P.ZodMap,
  ...J(n)
});
class Un extends B {
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== N.set)
      return T(a, {
        code: b.invalid_type,
        expected: N.set,
        received: a.parsedType
      }), C;
    const r = this._def;
    r.minSize !== null && a.data.size < r.minSize.value && (T(a, {
      code: b.too_small,
      minimum: r.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.minSize.message
    }), n.dirty()), r.maxSize !== null && a.data.size > r.maxSize.value && (T(a, {
      code: b.too_big,
      maximum: r.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.maxSize.message
    }), n.dirty());
    const i = this._def.valueType;
    function s(l) {
      const u = /* @__PURE__ */ new Set();
      for (const f of l) {
        if (f.status === "aborted")
          return C;
        f.status === "dirty" && n.dirty(), u.add(f.value);
      }
      return { status: n.value, value: u };
    }
    const o = [...a.data.values()].map((l, u) => i._parse(new me(a, l, a.path, u)));
    return a.common.async ? Promise.all(o).then((l) => s(l)) : s(o);
  }
  min(e, n) {
    return new Un({
      ...this._def,
      minSize: { value: e, message: R.toString(n) }
    });
  }
  max(e, n) {
    return new Un({
      ...this._def,
      maxSize: { value: e, message: R.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Un.create = (t, e) => new Un({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: P.ZodSet,
  ...J(e)
});
class ta extends B {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== N.function)
      return T(n, {
        code: b.invalid_type,
        expected: N.function,
        received: n.parsedType
      }), C;
    function a(o, l) {
      return Pi({
        data: o,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Ii(),
          Ha
        ].filter((u) => !!u),
        issueData: {
          code: b.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function r(o, l) {
      return Pi({
        data: o,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Ii(),
          Ha
        ].filter((u) => !!u),
        issueData: {
          code: b.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: n.common.contextualErrorMap }, s = n.data;
    if (this._def.returns instanceof sa) {
      const o = this;
      return Et(async function(...l) {
        const u = new ce([]), f = await o._def.args.parseAsync(l, i).catch((_) => {
          throw u.addIssue(a(l, _)), u;
        }), m = await Reflect.apply(s, this, f);
        return await o._def.returns._def.type.parseAsync(m, i).catch((_) => {
          throw u.addIssue(r(m, _)), u;
        });
      });
    } else {
      const o = this;
      return Et(function(...l) {
        const u = o._def.args.safeParse(l, i);
        if (!u.success)
          throw new ce([a(l, u.error)]);
        const f = Reflect.apply(s, this, u.data), m = o._def.returns.safeParse(f, i);
        if (!m.success)
          throw new ce([r(f, m.error)]);
        return m.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ta({
      ...this._def,
      args: Ae.create(e).rest(xn.create())
    });
  }
  returns(e) {
    return new ta({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, n, a) {
    return new ta({
      args: e || Ae.create([]).rest(xn.create()),
      returns: n || xn.create(),
      typeName: P.ZodFunction,
      ...J(a)
    });
  }
}
class ar extends B {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
ar.create = (t, e) => new ar({
  getter: t,
  typeName: P.ZodLazy,
  ...J(e)
});
class rr extends B {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return T(n, {
        received: n.data,
        code: b.invalid_literal,
        expected: this._def.value
      }), C;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
rr.create = (t, e) => new rr({
  value: t,
  typeName: P.ZodLiteral,
  ...J(e)
});
function pl(t, e) {
  return new mn({
    values: t,
    typeName: P.ZodEnum,
    ...J(e)
  });
}
class mn extends B {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), a = this._def.values;
      return T(n, {
        expected: X.joinValues(a),
        received: n.parsedType,
        code: b.invalid_type
      }), C;
    }
    if (this._def.values.indexOf(e.data) === -1) {
      const n = this._getOrReturnCtx(e), a = this._def.values;
      return T(n, {
        received: n.data,
        code: b.invalid_enum_value,
        options: a
      }), C;
    }
    return Et(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e) {
    return mn.create(e);
  }
  exclude(e) {
    return mn.create(this.options.filter((n) => !e.includes(n)));
  }
}
mn.create = pl;
class ir extends B {
  _parse(e) {
    const n = X.getValidEnumValues(this._def.values), a = this._getOrReturnCtx(e);
    if (a.parsedType !== N.string && a.parsedType !== N.number) {
      const r = X.objectValues(n);
      return T(a, {
        expected: X.joinValues(r),
        received: a.parsedType,
        code: b.invalid_type
      }), C;
    }
    if (n.indexOf(e.data) === -1) {
      const r = X.objectValues(n);
      return T(a, {
        received: a.data,
        code: b.invalid_enum_value,
        options: r
      }), C;
    }
    return Et(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
ir.create = (t, e) => new ir({
  values: t,
  typeName: P.ZodNativeEnum,
  ...J(e)
});
class sa extends B {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== N.promise && n.common.async === !1)
      return T(n, {
        code: b.invalid_type,
        expected: N.promise,
        received: n.parsedType
      }), C;
    const a = n.parsedType === N.promise ? n.data : Promise.resolve(n.data);
    return Et(a.then((r) => this._def.type.parseAsync(r, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
sa.create = (t, e) => new sa({
  type: t,
  typeName: P.ZodPromise,
  ...J(e)
});
class ke extends B {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === P.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e), r = this._def.effect || null, i = {
      addIssue: (s) => {
        T(a, s), s.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return a.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), r.type === "preprocess") {
      const s = r.transform(a.data, i);
      return a.common.issues.length ? {
        status: "dirty",
        value: a.data
      } : a.common.async ? Promise.resolve(s).then((o) => this._def.schema._parseAsync({
        data: o,
        path: a.path,
        parent: a
      })) : this._def.schema._parseSync({
        data: s,
        path: a.path,
        parent: a
      });
    }
    if (r.type === "refinement") {
      const s = (o) => {
        const l = r.refinement(o, i);
        if (a.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (a.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: a.data,
          path: a.path,
          parent: a
        });
        return o.status === "aborted" ? C : (o.status === "dirty" && n.dirty(), s(o.value), { status: n.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: a.data, path: a.path, parent: a }).then((o) => o.status === "aborted" ? C : (o.status === "dirty" && n.dirty(), s(o.value).then(() => ({ status: n.value, value: o.value }))));
    }
    if (r.type === "transform")
      if (a.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: a.data,
          path: a.path,
          parent: a
        });
        if (!Ya(s))
          return s;
        const o = r.transform(s.value, i);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: a.data, path: a.path, parent: a }).then((s) => Ya(s) ? Promise.resolve(r.transform(s.value, i)).then((o) => ({ status: n.value, value: o })) : s);
    X.assertNever(r);
  }
}
ke.create = (t, e, n) => new ke({
  schema: t,
  typeName: P.ZodEffects,
  effect: e,
  ...J(n)
});
ke.createWithPreprocess = (t, e, n) => new ke({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: P.ZodEffects,
  ...J(n)
});
class Le extends B {
  _parse(e) {
    return this._getType(e) === N.undefined ? Et(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Le.create = (t, e) => new Le({
  innerType: t,
  typeName: P.ZodOptional,
  ...J(e)
});
class Ln extends B {
  _parse(e) {
    return this._getType(e) === N.null ? Et(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ln.create = (t, e) => new Ln({
  innerType: t,
  typeName: P.ZodNullable,
  ...J(e)
});
class sr extends B {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let a = n.data;
    return n.parsedType === N.undefined && (a = this._def.defaultValue()), this._def.innerType._parse({
      data: a,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
sr.create = (t, e) => new sr({
  innerType: t,
  typeName: P.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...J(e)
});
class Ui extends B {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), a = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, r = this._def.innerType._parse({
      data: a.data,
      path: a.path,
      parent: {
        ...a
      }
    });
    return Vi(r) ? r.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new ce(a.common.issues);
        },
        input: a.data
      })
    })) : {
      status: "valid",
      value: r.status === "valid" ? r.value : this._def.catchValue({
        get error() {
          return new ce(a.common.issues);
        },
        input: a.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ui.create = (t, e) => new Ui({
  innerType: t,
  typeName: P.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...J(e)
});
class Li extends B {
  _parse(e) {
    if (this._getType(e) !== N.nan) {
      const a = this._getOrReturnCtx(e);
      return T(a, {
        code: b.invalid_type,
        expected: N.nan,
        received: a.parsedType
      }), C;
    }
    return { status: "valid", value: e.data };
  }
}
Li.create = (t) => new Li({
  typeName: P.ZodNaN,
  ...J(t)
});
class K_ extends B {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), a = n.data;
    return this._def.type._parse({
      data: a,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class hr extends B {
  _parse(e) {
    const { status: n, ctx: a } = this._processInputParams(e);
    if (a.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: a.data,
          path: a.path,
          parent: a
        });
        return i.status === "aborted" ? C : i.status === "dirty" ? (n.dirty(), I_(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: a.path,
          parent: a
        });
      })();
    {
      const r = this._def.in._parseSync({
        data: a.data,
        path: a.path,
        parent: a
      });
      return r.status === "aborted" ? C : r.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: r.value
      }) : this._def.out._parseSync({
        data: r.value,
        path: a.path,
        parent: a
      });
    }
  }
  static create(e, n) {
    return new hr({
      in: e,
      out: n,
      typeName: P.ZodPipeline
    });
  }
}
class ji extends B {
  _parse(e) {
    const n = this._def.innerType._parse(e);
    return Ya(n) && (n.value = Object.freeze(n.value)), n;
  }
}
ji.create = (t, e) => new ji({
  innerType: t,
  typeName: P.ZodReadonly,
  ...J(e)
});
ut.lazycreate;
var P;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(P || (P = {}));
const te = Oe.create;
qn.create;
Li.create;
$n.create;
const Ut = Ji.create;
ia.create;
Ci.create;
Xa.create;
Qa.create;
Di.create;
xn.create;
Be.create;
Mi.create;
const ea = de.create, Ot = ut.create;
ut.strictCreate;
tr.create;
const ml = gs.create;
er.create;
Ae.create;
nr.create;
$i.create;
Un.create;
ta.create;
ar.create;
const fa = rr.create;
mn.create;
ir.create;
sa.create;
ke.create;
Le.create;
Ln.create;
ke.createWithPreprocess;
hr.create;
const An = {
  persona: "persona",
  account: "account"
}, B_ = Ot({
  challenge: te(),
  proof: ca,
  address: te(),
  type: fa(An.persona)
}), Z_ = Ot({
  challenge: te(),
  proof: ca,
  address: te(),
  type: fa(An.account)
}), z_ = ml("type", [
  B_,
  Z_
]), G_ = Ot({
  entry: fa("fullName"),
  fields: Eu
}), W_ = Ot({
  entry: fa("emailAddresses"),
  fields: ea(te())
}), H_ = Ot({
  entry: fa("phoneNumbers"),
  fields: ea(te())
}), Y_ = ml("entry", [
  G_,
  W_,
  H_
]), X_ = Ot({
  accounts: ea(xu),
  personaData: ea(Y_),
  persona: da.optional(),
  proofs: ea(z_)
}), Q_ = Ot({
  persona: Ot({ proof: Ut() }).optional(),
  ongoingAccounts: Ot({
    numberOfAccounts: le.optional(),
    proof: Ut()
  }).optional(),
  ongoingPersonaData: za.optional()
}), tg = Ot({
  loggedInTimestamp: te(),
  walletData: X_,
  sharedData: Q_
}), Ki = {
  accounts: [],
  personaData: [],
  proofs: [],
  persona: void 0
}, eg = () => ({
  walletData: new it(Ki),
  sharedData: new it({}),
  loggedInTimestamp: new it(""),
  initialized: new it(!1)
});
function Qr(t, e, n, a) {
  function r(i) {
    return i instanceof n ? i : new n(function(s) {
      s(i);
    });
  }
  return new (n || (n = Promise))(function(i, s) {
    function o(f) {
      try {
        u(a.next(f));
      } catch (m) {
        s(m);
      }
    }
    function l(f) {
      try {
        u(a.throw(f));
      } catch (m) {
        s(m);
      }
    }
    function u(f) {
      f.done ? i(f.value) : r(f.value).then(o, l);
    }
    u((a = a.apply(t, e || [])).next());
  });
}
function ti(t, e) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, a, r, i, s;
  return s = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function o(u) {
    return function(f) {
      return l([u, f]);
    };
  }
  function l(u) {
    if (a)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (a = 1, r && (i = u[0] & 2 ? r.return : u[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, u[1])).done)
          return i;
        switch (r = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
          case 0:
          case 1:
            i = u;
            break;
          case 4:
            return n.label++, { value: u[1], done: !1 };
          case 5:
            n.label++, r = u[1], u = [0];
            continue;
          case 7:
            u = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              n = 0;
              continue;
            }
            if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
              n.label = u[1];
              break;
            }
            if (u[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = u;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(u);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        u = e.call(t, n);
      } catch (f) {
        u = [6, f], r = 0;
      } finally {
        a = i = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function or(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var a = n.call(t), r, i = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(r = a.next()).done; )
      i.push(r.value);
  } catch (o) {
    s = { error: o };
  } finally {
    try {
      r && !r.done && (n = a.return) && n.call(a);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return i;
}
function dn(t, e, n) {
  if (n || arguments.length === 2)
    for (var a = 0, r = e.length, i; a < r; a++)
      (i || !(a in e)) && (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
  return t.concat(i || Array.prototype.slice.call(e));
}
var ng = {
  withStackTrace: !1
}, yl = function(t, e, n) {
  n === void 0 && (n = ng);
  var a = e.isOk() ? { type: "Ok", value: e.value } : { type: "Err", value: e.error }, r = n.withStackTrace ? new Error().stack : void 0;
  return {
    data: a,
    message: t,
    stack: r
  };
}, dt = (
  /** @class */
  function() {
    function t(e) {
      this._promise = e;
    }
    return t.fromSafePromise = function(e) {
      var n = e.then(function(a) {
        return new Me(a);
      });
      return new t(n);
    }, t.fromPromise = function(e, n) {
      var a = e.then(function(r) {
        return new Me(r);
      }).catch(function(r) {
        return new un(n(r));
      });
      return new t(a);
    }, t.combine = function(e) {
      return rg(e);
    }, t.combineWithAllErrors = function(e) {
      return ig(e);
    }, t.prototype.map = function(e) {
      var n = this;
      return new t(this._promise.then(function(a) {
        return Qr(n, void 0, void 0, function() {
          var r;
          return ti(this, function(i) {
            switch (i.label) {
              case 0:
                return a.isErr() ? [2, new un(a.error)] : (r = Me.bind, [4, e(a.value)]);
              case 1:
                return [2, new (r.apply(Me, [void 0, i.sent()]))()];
            }
          });
        });
      }));
    }, t.prototype.mapErr = function(e) {
      var n = this;
      return new t(this._promise.then(function(a) {
        return Qr(n, void 0, void 0, function() {
          var r;
          return ti(this, function(i) {
            switch (i.label) {
              case 0:
                return a.isOk() ? [2, new Me(a.value)] : (r = un.bind, [4, e(a.error)]);
              case 1:
                return [2, new (r.apply(un, [void 0, i.sent()]))()];
            }
          });
        });
      }));
    }, t.prototype.andThen = function(e) {
      return new t(this._promise.then(function(n) {
        if (n.isErr())
          return new un(n.error);
        var a = e(n.value);
        return a instanceof t ? a._promise : a;
      }));
    }, t.prototype.orElse = function(e) {
      var n = this;
      return new t(this._promise.then(function(a) {
        return Qr(n, void 0, void 0, function() {
          return ti(this, function(r) {
            return a.isErr() ? [2, e(a.error)] : [2, new Me(a.value)];
          });
        });
      }));
    }, t.prototype.match = function(e, n) {
      return this._promise.then(function(a) {
        return a.match(e, n);
      });
    }, t.prototype.unwrapOr = function(e) {
      return this._promise.then(function(n) {
        return n.unwrapOr(e);
      });
    }, t.prototype.then = function(e, n) {
      return this._promise.then(e, n);
    }, t;
  }()
), Mo = function(t) {
  return new dt(Promise.resolve(new Me(t)));
}, qo = function(t) {
  return new dt(Promise.resolve(new un(t)));
};
dt.fromPromise;
dt.fromSafePromise;
var ag = function(t) {
  return function(e) {
    return dn(dn([], or(e), !1), [t], !1);
  };
}, _l = function(t) {
  return t.reduce(function(e, n) {
    return e.isOk() ? n.isErr() ? ee(n.error) : e.map(ag(n.value)) : e;
  }, bt([]));
}, rg = function(t) {
  return dt.fromSafePromise(Promise.all(t)).andThen(_l);
}, gl = function(t) {
  return t.reduce(function(e, n) {
    return n.isErr() ? e.isErr() ? ee(dn(dn([], or(e.error), !1), [n.error], !1)) : ee([n.error]) : e.isErr() ? e : bt(dn(dn([], or(e.value), !1), [n.value], !1));
  }, bt([]));
}, ig = function(t) {
  return dt.fromSafePromise(Promise.all(t)).andThen(gl);
}, Bi;
(function(t) {
  function e(r, i) {
    return function() {
      for (var s = [], o = 0; o < arguments.length; o++)
        s[o] = arguments[o];
      try {
        var l = r.apply(void 0, dn([], or(s), !1));
        return bt(l);
      } catch (u) {
        return ee(i ? i(u) : u);
      }
    };
  }
  t.fromThrowable = e;
  function n(r) {
    return _l(r);
  }
  t.combine = n;
  function a(r) {
    return gl(r);
  }
  t.combineWithAllErrors = a;
})(Bi || (Bi = {}));
var bt = function(t) {
  return new Me(t);
}, ee = function(t) {
  return new un(t);
}, Me = (
  /** @class */
  function() {
    function t(e) {
      this.value = e;
    }
    return t.prototype.isOk = function() {
      return !0;
    }, t.prototype.isErr = function() {
      return !this.isOk();
    }, t.prototype.map = function(e) {
      return bt(e(this.value));
    }, t.prototype.mapErr = function(e) {
      return bt(this.value);
    }, t.prototype.andThen = function(e) {
      return e(this.value);
    }, t.prototype.orElse = function(e) {
      return bt(this.value);
    }, t.prototype.asyncAndThen = function(e) {
      return e(this.value);
    }, t.prototype.asyncMap = function(e) {
      return dt.fromSafePromise(e(this.value));
    }, t.prototype.unwrapOr = function(e) {
      return this.value;
    }, t.prototype.match = function(e, n) {
      return e(this.value);
    }, t.prototype._unsafeUnwrap = function(e) {
      return this.value;
    }, t.prototype._unsafeUnwrapErr = function(e) {
      throw yl("Called `_unsafeUnwrapErr` on an Ok", this, e);
    }, t;
  }()
), un = (
  /** @class */
  function() {
    function t(e) {
      this.error = e;
    }
    return t.prototype.isOk = function() {
      return !1;
    }, t.prototype.isErr = function() {
      return !this.isOk();
    }, t.prototype.map = function(e) {
      return ee(this.error);
    }, t.prototype.mapErr = function(e) {
      return ee(e(this.error));
    }, t.prototype.andThen = function(e) {
      return ee(this.error);
    }, t.prototype.orElse = function(e) {
      return e(this.error);
    }, t.prototype.asyncAndThen = function(e) {
      return qo(this.error);
    }, t.prototype.asyncMap = function(e) {
      return qo(this.error);
    }, t.prototype.unwrapOr = function(e) {
      return e;
    }, t.prototype.match = function(e, n) {
      return n(this.error);
    }, t.prototype._unsafeUnwrap = function(e) {
      throw yl("Called `_unsafeUnwrap` on an Err", this, e);
    }, t.prototype._unsafeUnwrapErr = function(e) {
      return this.error;
    }, t;
  }()
);
Bi.fromThrowable;
var hl = Symbol.for("immer-nothing"), $o = Symbol.for("immer-draftable"), Ct = Symbol.for("immer-state");
function Qt(t, ...e) {
  throw new Error(
    `[Immer] minified error nr: ${t}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var jn = Object.getPrototypeOf;
function Kn(t) {
  return !!t && !!t[Ct];
}
function yn(t) {
  var e;
  return t ? vl(t) || Array.isArray(t) || !!t[$o] || !!((e = t.constructor) != null && e[$o]) || br(t) || Sr(t) : !1;
}
var sg = Object.prototype.constructor.toString();
function vl(t) {
  if (!t || typeof t != "object")
    return !1;
  const e = jn(t);
  if (e === null)
    return !0;
  const n = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === sg;
}
function oa(t, e) {
  vr(t) === 0 ? Object.entries(t).forEach(([n, a]) => {
    e(n, a, t);
  }) : t.forEach((n, a) => e(a, n, t));
}
function vr(t) {
  const e = t[Ct];
  return e ? e.type_ : Array.isArray(t) ? 1 : br(t) ? 2 : Sr(t) ? 3 : 0;
}
function Zi(t, e) {
  return vr(t) === 2 ? t.has(e) : Object.prototype.hasOwnProperty.call(t, e);
}
function bl(t, e, n) {
  const a = vr(t);
  a === 2 ? t.set(e, n) : a === 3 ? t.add(n) : t[e] = n;
}
function og(t, e) {
  return t === e ? t !== 0 || 1 / t === 1 / e : t !== t && e !== e;
}
function br(t) {
  return t instanceof Map;
}
function Sr(t) {
  return t instanceof Set;
}
function an(t) {
  return t.copy_ || t.base_;
}
function zi(t, e) {
  if (br(t))
    return new Map(t);
  if (Sr(t))
    return new Set(t);
  if (Array.isArray(t))
    return Array.prototype.slice.call(t);
  if (!e && vl(t))
    return jn(t) ? { ...t } : Object.assign(/* @__PURE__ */ Object.create(null), t);
  const n = Object.getOwnPropertyDescriptors(t);
  delete n[Ct];
  let a = Reflect.ownKeys(n);
  for (let r = 0; r < a.length; r++) {
    const i = a[r], s = n[i];
    s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (n[i] = {
      configurable: !0,
      writable: !0,
      // could live with !!desc.set as well here...
      enumerable: s.enumerable,
      value: t[i]
    });
  }
  return Object.create(jn(t), n);
}
function hs(t, e = !1) {
  return Or(t) || Kn(t) || !yn(t) || (vr(t) > 1 && (t.set = t.add = t.clear = t.delete = ug), Object.freeze(t), e && oa(t, (n, a) => hs(a, !0))), t;
}
function ug() {
  Qt(2);
}
function Or(t) {
  return Object.isFrozen(t);
}
var lg = {};
function _n(t) {
  const e = lg[t];
  return e || Qt(0, t), e;
}
var ua;
function Sl() {
  return ua;
}
function cg(t, e) {
  return {
    drafts_: [],
    parent_: t,
    immer_: e,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function Uo(t, e) {
  e && (_n("Patches"), t.patches_ = [], t.inversePatches_ = [], t.patchListener_ = e);
}
function Gi(t) {
  Wi(t), t.drafts_.forEach(dg), t.drafts_ = null;
}
function Wi(t) {
  t === ua && (ua = t.parent_);
}
function Lo(t) {
  return ua = cg(ua, t);
}
function dg(t) {
  const e = t[Ct];
  e.type_ === 0 || e.type_ === 1 ? e.revoke_() : e.revoked_ = !0;
}
function jo(t, e) {
  e.unfinalizedDrafts_ = e.drafts_.length;
  const n = e.drafts_[0];
  return t !== void 0 && t !== n ? (n[Ct].modified_ && (Gi(e), Qt(4)), yn(t) && (t = ur(e, t), e.parent_ || lr(e, t)), e.patches_ && _n("Patches").generateReplacementPatches_(
    n[Ct].base_,
    t,
    e.patches_,
    e.inversePatches_
  )) : t = ur(e, n, []), Gi(e), e.patches_ && e.patchListener_(e.patches_, e.inversePatches_), t !== hl ? t : void 0;
}
function ur(t, e, n) {
  if (Or(e))
    return e;
  const a = e[Ct];
  if (!a)
    return oa(
      e,
      (r, i) => Ko(t, a, e, r, i, n)
    ), e;
  if (a.scope_ !== t)
    return e;
  if (!a.modified_)
    return lr(t, a.base_, !0), a.base_;
  if (!a.finalized_) {
    a.finalized_ = !0, a.scope_.unfinalizedDrafts_--;
    const r = a.copy_;
    let i = r, s = !1;
    a.type_ === 3 && (i = new Set(r), r.clear(), s = !0), oa(
      i,
      (o, l) => Ko(t, a, r, o, l, n, s)
    ), lr(t, r, !1), n && t.patches_ && _n("Patches").generatePatches_(
      a,
      n,
      t.patches_,
      t.inversePatches_
    );
  }
  return a.copy_;
}
function Ko(t, e, n, a, r, i, s) {
  if (Kn(r)) {
    const o = i && e && e.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Zi(e.assigned_, a) ? i.concat(a) : void 0, l = ur(t, r, o);
    if (bl(n, a, l), Kn(l))
      t.canAutoFreeze_ = !1;
    else
      return;
  } else
    s && n.add(r);
  if (yn(r) && !Or(r)) {
    if (!t.immer_.autoFreeze_ && t.unfinalizedDrafts_ < 1)
      return;
    ur(t, r), (!e || !e.scope_.parent_) && lr(t, r);
  }
}
function lr(t, e, n = !1) {
  !t.parent_ && t.immer_.autoFreeze_ && t.canAutoFreeze_ && hs(e, n);
}
function fg(t, e) {
  const n = Array.isArray(t), a = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: e ? e.scope_ : Sl(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: e,
    // The base state.
    base_: t,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let r = a, i = vs;
  n && (r = [a], i = la);
  const { revoke: s, proxy: o } = Proxy.revocable(r, i);
  return a.draft_ = o, a.revoke_ = s, o;
}
var vs = {
  get(t, e) {
    if (e === Ct)
      return t;
    const n = an(t);
    if (!Zi(n, e))
      return pg(t, n, e);
    const a = n[e];
    return t.finalized_ || !yn(a) ? a : a === ei(t.base_, e) ? (ni(t), t.copy_[e] = Yi(a, t)) : a;
  },
  has(t, e) {
    return e in an(t);
  },
  ownKeys(t) {
    return Reflect.ownKeys(an(t));
  },
  set(t, e, n) {
    const a = Ol(an(t), e);
    if (a != null && a.set)
      return a.set.call(t.draft_, n), !0;
    if (!t.modified_) {
      const r = ei(an(t), e), i = r == null ? void 0 : r[Ct];
      if (i && i.base_ === n)
        return t.copy_[e] = n, t.assigned_[e] = !1, !0;
      if (og(n, r) && (n !== void 0 || Zi(t.base_, e)))
        return !0;
      ni(t), Hi(t);
    }
    return t.copy_[e] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || e in t.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(t.copy_[e]) || (t.copy_[e] = n, t.assigned_[e] = !0), !0;
  },
  deleteProperty(t, e) {
    return ei(t.base_, e) !== void 0 || e in t.base_ ? (t.assigned_[e] = !1, ni(t), Hi(t)) : delete t.assigned_[e], t.copy_ && delete t.copy_[e], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(t, e) {
    const n = an(t), a = Reflect.getOwnPropertyDescriptor(n, e);
    return a && {
      writable: !0,
      configurable: t.type_ !== 1 || e !== "length",
      enumerable: a.enumerable,
      value: n[e]
    };
  },
  defineProperty() {
    Qt(11);
  },
  getPrototypeOf(t) {
    return jn(t.base_);
  },
  setPrototypeOf() {
    Qt(12);
  }
}, la = {};
oa(vs, (t, e) => {
  la[t] = function() {
    return arguments[0] = arguments[0][0], e.apply(this, arguments);
  };
});
la.deleteProperty = function(t, e) {
  return la.set.call(this, t, e, void 0);
};
la.set = function(t, e, n) {
  return vs.set.call(this, t[0], e, n, t[0]);
};
function ei(t, e) {
  const n = t[Ct];
  return (n ? an(n) : t)[e];
}
function pg(t, e, n) {
  var r;
  const a = Ol(e, n);
  return a ? "value" in a ? a.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (r = a.get) == null ? void 0 : r.call(t.draft_)
  ) : void 0;
}
function Ol(t, e) {
  if (!(e in t))
    return;
  let n = jn(t);
  for (; n; ) {
    const a = Object.getOwnPropertyDescriptor(n, e);
    if (a)
      return a;
    n = jn(n);
  }
}
function Hi(t) {
  t.modified_ || (t.modified_ = !0, t.parent_ && Hi(t.parent_));
}
function ni(t) {
  t.copy_ || (t.copy_ = zi(
    t.base_,
    t.scope_.immer_.useStrictShallowCopy_
  ));
}
var mg = class {
  constructor(t) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (e, n, a) => {
      if (typeof e == "function" && typeof n != "function") {
        const i = n;
        n = e;
        const s = this;
        return function(l = i, ...u) {
          return s.produce(l, (f) => n.call(this, f, ...u));
        };
      }
      typeof n != "function" && Qt(6), a !== void 0 && typeof a != "function" && Qt(7);
      let r;
      if (yn(e)) {
        const i = Lo(this), s = Yi(e, void 0);
        let o = !0;
        try {
          r = n(s), o = !1;
        } finally {
          o ? Gi(i) : Wi(i);
        }
        return Uo(i, a), jo(r, i);
      } else if (!e || typeof e != "object") {
        if (r = n(e), r === void 0 && (r = e), r === hl && (r = void 0), this.autoFreeze_ && hs(r, !0), a) {
          const i = [], s = [];
          _n("Patches").generateReplacementPatches_(e, r, i, s), a(i, s);
        }
        return r;
      } else
        Qt(1, e);
    }, this.produceWithPatches = (e, n) => {
      if (typeof e == "function")
        return (s, ...o) => this.produceWithPatches(s, (l) => e(l, ...o));
      let a, r;
      return [this.produce(e, n, (s, o) => {
        a = s, r = o;
      }), a, r];
    }, typeof (t == null ? void 0 : t.autoFreeze) == "boolean" && this.setAutoFreeze(t.autoFreeze), typeof (t == null ? void 0 : t.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(t.useStrictShallowCopy);
  }
  createDraft(t) {
    yn(t) || Qt(8), Kn(t) && (t = yg(t));
    const e = Lo(this), n = Yi(t, void 0);
    return n[Ct].isManual_ = !0, Wi(e), n;
  }
  finishDraft(t, e) {
    const n = t && t[Ct];
    (!n || !n.isManual_) && Qt(9);
    const { scope_: a } = n;
    return Uo(a, e), jo(void 0, a);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(t) {
    this.autoFreeze_ = t;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(t) {
    this.useStrictShallowCopy_ = t;
  }
  applyPatches(t, e) {
    let n;
    for (n = e.length - 1; n >= 0; n--) {
      const r = e[n];
      if (r.path.length === 0 && r.op === "replace") {
        t = r.value;
        break;
      }
    }
    n > -1 && (e = e.slice(n + 1));
    const a = _n("Patches").applyPatches_;
    return Kn(t) ? a(t, e) : this.produce(
      t,
      (r) => a(r, e)
    );
  }
};
function Yi(t, e) {
  const n = br(t) ? _n("MapSet").proxyMap_(t, e) : Sr(t) ? _n("MapSet").proxySet_(t, e) : fg(t, e);
  return (e ? e.scope_ : Sl()).drafts_.push(n), n;
}
function yg(t) {
  return Kn(t) || Qt(10, t), Nl(t);
}
function Nl(t) {
  if (!yn(t) || Or(t))
    return t;
  const e = t[Ct];
  let n;
  if (e) {
    if (!e.modified_)
      return e.base_;
    e.finalized_ = !0, n = zi(t, e.scope_.immer_.useStrictShallowCopy_);
  } else
    n = zi(t, !0);
  return oa(n, (a, r) => {
    bl(n, a, Nl(r));
  }), e && (e.finalized_ = !1), n;
}
var Dt = new mg(), st = Dt.produce;
Dt.produceWithPatches.bind(
  Dt
);
Dt.setAutoFreeze.bind(Dt);
Dt.setUseStrictShallowCopy.bind(Dt);
Dt.applyPatches.bind(Dt);
Dt.createDraft.bind(Dt);
Dt.finishDraft.bind(Dt);
var Ia = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _g(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var cr = { exports: {} };
cr.exports;
(function(t, e) {
  var n = 200, a = "__lodash_hash_undefined__", r = 1, i = 2, s = 9007199254740991, o = "[object Arguments]", l = "[object Array]", u = "[object AsyncFunction]", f = "[object Boolean]", m = "[object Date]", y = "[object Error]", _ = "[object Function]", S = "[object GeneratorFunction]", h = "[object Map]", $ = "[object Number]", z = "[object Null]", F = "[object Object]", v = "[object Promise]", x = "[object Proxy]", q = "[object RegExp]", U = "[object Set]", I = "[object String]", D = "[object Symbol]", lt = "[object Undefined]", Nt = "[object WeakMap]", Wt = "[object ArrayBuffer]", Ie = "[object DataView]", Z = "[object Float32Array]", L = "[object Float64Array]", gt = "[object Int8Array]", It = "[object Int16Array]", Pe = "[object Int32Array]", Ve = "[object Uint8Array]", va = "[object Uint8ClampedArray]", Er = "[object Uint16Array]", Rr = "[object Uint32Array]", Ir = /[\\^$.*+?()[\]{}|]/g, Xd = /^\[object .+?Constructor\]$/, Qd = /^(?:0|[1-9]\d*)$/, nt = {};
  nt[Z] = nt[L] = nt[gt] = nt[It] = nt[Pe] = nt[Ve] = nt[va] = nt[Er] = nt[Rr] = !0, nt[o] = nt[l] = nt[Wt] = nt[f] = nt[Ie] = nt[m] = nt[y] = nt[_] = nt[h] = nt[$] = nt[F] = nt[q] = nt[U] = nt[I] = nt[Nt] = !1;
  var As = typeof Ia == "object" && Ia && Ia.Object === Object && Ia, tf = typeof self == "object" && self && self.Object === Object && self, he = As || tf || Function("return this")(), ks = e && !e.nodeType && e, Fs = ks && !0 && t && !t.nodeType && t, xs = Fs && Fs.exports === ks, Pr = xs && As.process, Es = function() {
    try {
      return Pr && Pr.binding && Pr.binding("util");
    } catch {
    }
  }(), Rs = Es && Es.isTypedArray;
  function ef(d, p) {
    for (var g = -1, w = d == null ? 0 : d.length, at = 0, M = []; ++g < w; ) {
      var ot = d[g];
      p(ot, g, d) && (M[at++] = ot);
    }
    return M;
  }
  function nf(d, p) {
    for (var g = -1, w = p.length, at = d.length; ++g < w; )
      d[at + g] = p[g];
    return d;
  }
  function af(d, p) {
    for (var g = -1, w = d == null ? 0 : d.length; ++g < w; )
      if (p(d[g], g, d))
        return !0;
    return !1;
  }
  function rf(d, p) {
    for (var g = -1, w = Array(d); ++g < d; )
      w[g] = p(g);
    return w;
  }
  function sf(d) {
    return function(p) {
      return d(p);
    };
  }
  function of(d, p) {
    return d.has(p);
  }
  function uf(d, p) {
    return d == null ? void 0 : d[p];
  }
  function lf(d) {
    var p = -1, g = Array(d.size);
    return d.forEach(function(w, at) {
      g[++p] = [at, w];
    }), g;
  }
  function cf(d, p) {
    return function(g) {
      return d(p(g));
    };
  }
  function df(d) {
    var p = -1, g = Array(d.size);
    return d.forEach(function(w) {
      g[++p] = w;
    }), g;
  }
  var ff = Array.prototype, pf = Function.prototype, ba = Object.prototype, Vr = he["__core-js_shared__"], Is = pf.toString, re = ba.hasOwnProperty, Ps = function() {
    var d = /[^.]+$/.exec(Vr && Vr.keys && Vr.keys.IE_PROTO || "");
    return d ? "Symbol(src)_1." + d : "";
  }(), Vs = ba.toString, mf = RegExp(
    "^" + Is.call(re).replace(Ir, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Js = xs ? he.Buffer : void 0, Sa = he.Symbol, Cs = he.Uint8Array, Ds = ba.propertyIsEnumerable, yf = ff.splice, Ge = Sa ? Sa.toStringTag : void 0, Ms = Object.getOwnPropertySymbols, _f = Js ? Js.isBuffer : void 0, gf = cf(Object.keys, Object), Jr = bn(he, "DataView"), Gn = bn(he, "Map"), Cr = bn(he, "Promise"), Dr = bn(he, "Set"), Mr = bn(he, "WeakMap"), Wn = bn(Object, "create"), hf = Ye(Jr), vf = Ye(Gn), bf = Ye(Cr), Sf = Ye(Dr), Of = Ye(Mr), qs = Sa ? Sa.prototype : void 0, qr = qs ? qs.valueOf : void 0;
  function We(d) {
    var p = -1, g = d == null ? 0 : d.length;
    for (this.clear(); ++p < g; ) {
      var w = d[p];
      this.set(w[0], w[1]);
    }
  }
  function Nf() {
    this.__data__ = Wn ? Wn(null) : {}, this.size = 0;
  }
  function wf(d) {
    var p = this.has(d) && delete this.__data__[d];
    return this.size -= p ? 1 : 0, p;
  }
  function Tf(d) {
    var p = this.__data__;
    if (Wn) {
      var g = p[d];
      return g === a ? void 0 : g;
    }
    return re.call(p, d) ? p[d] : void 0;
  }
  function Af(d) {
    var p = this.__data__;
    return Wn ? p[d] !== void 0 : re.call(p, d);
  }
  function kf(d, p) {
    var g = this.__data__;
    return this.size += this.has(d) ? 0 : 1, g[d] = Wn && p === void 0 ? a : p, this;
  }
  We.prototype.clear = Nf, We.prototype.delete = wf, We.prototype.get = Tf, We.prototype.has = Af, We.prototype.set = kf;
  function ve(d) {
    var p = -1, g = d == null ? 0 : d.length;
    for (this.clear(); ++p < g; ) {
      var w = d[p];
      this.set(w[0], w[1]);
    }
  }
  function Ff() {
    this.__data__ = [], this.size = 0;
  }
  function xf(d) {
    var p = this.__data__, g = Na(p, d);
    if (g < 0)
      return !1;
    var w = p.length - 1;
    return g == w ? p.pop() : yf.call(p, g, 1), --this.size, !0;
  }
  function Ef(d) {
    var p = this.__data__, g = Na(p, d);
    return g < 0 ? void 0 : p[g][1];
  }
  function Rf(d) {
    return Na(this.__data__, d) > -1;
  }
  function If(d, p) {
    var g = this.__data__, w = Na(g, d);
    return w < 0 ? (++this.size, g.push([d, p])) : g[w][1] = p, this;
  }
  ve.prototype.clear = Ff, ve.prototype.delete = xf, ve.prototype.get = Ef, ve.prototype.has = Rf, ve.prototype.set = If;
  function He(d) {
    var p = -1, g = d == null ? 0 : d.length;
    for (this.clear(); ++p < g; ) {
      var w = d[p];
      this.set(w[0], w[1]);
    }
  }
  function Pf() {
    this.size = 0, this.__data__ = {
      hash: new We(),
      map: new (Gn || ve)(),
      string: new We()
    };
  }
  function Vf(d) {
    var p = wa(this, d).delete(d);
    return this.size -= p ? 1 : 0, p;
  }
  function Jf(d) {
    return wa(this, d).get(d);
  }
  function Cf(d) {
    return wa(this, d).has(d);
  }
  function Df(d, p) {
    var g = wa(this, d), w = g.size;
    return g.set(d, p), this.size += g.size == w ? 0 : 1, this;
  }
  He.prototype.clear = Pf, He.prototype.delete = Vf, He.prototype.get = Jf, He.prototype.has = Cf, He.prototype.set = Df;
  function Oa(d) {
    var p = -1, g = d == null ? 0 : d.length;
    for (this.__data__ = new He(); ++p < g; )
      this.add(d[p]);
  }
  function Mf(d) {
    return this.__data__.set(d, a), this;
  }
  function qf(d) {
    return this.__data__.has(d);
  }
  Oa.prototype.add = Oa.prototype.push = Mf, Oa.prototype.has = qf;
  function Je(d) {
    var p = this.__data__ = new ve(d);
    this.size = p.size;
  }
  function $f() {
    this.__data__ = new ve(), this.size = 0;
  }
  function Uf(d) {
    var p = this.__data__, g = p.delete(d);
    return this.size = p.size, g;
  }
  function Lf(d) {
    return this.__data__.get(d);
  }
  function jf(d) {
    return this.__data__.has(d);
  }
  function Kf(d, p) {
    var g = this.__data__;
    if (g instanceof ve) {
      var w = g.__data__;
      if (!Gn || w.length < n - 1)
        return w.push([d, p]), this.size = ++g.size, this;
      g = this.__data__ = new He(w);
    }
    return g.set(d, p), this.size = g.size, this;
  }
  Je.prototype.clear = $f, Je.prototype.delete = Uf, Je.prototype.get = Lf, Je.prototype.has = jf, Je.prototype.set = Kf;
  function Bf(d, p) {
    var g = Ta(d), w = !g && sp(d), at = !g && !w && $r(d), M = !g && !w && !at && Gs(d), ot = g || w || at || M, ht = ot ? rf(d.length, String) : [], St = ht.length;
    for (var rt in d)
      (p || re.call(d, rt)) && !(ot && // Safari 9 has enumerable `arguments.length` in strict mode.
      (rt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      at && (rt == "offset" || rt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      M && (rt == "buffer" || rt == "byteLength" || rt == "byteOffset") || // Skip index properties.
      ep(rt, St))) && ht.push(rt);
    return ht;
  }
  function Na(d, p) {
    for (var g = d.length; g--; )
      if (Ks(d[g][0], p))
        return g;
    return -1;
  }
  function Zf(d, p, g) {
    var w = p(d);
    return Ta(d) ? w : nf(w, g(d));
  }
  function Hn(d) {
    return d == null ? d === void 0 ? lt : z : Ge && Ge in Object(d) ? Qf(d) : ip(d);
  }
  function $s(d) {
    return Yn(d) && Hn(d) == o;
  }
  function Us(d, p, g, w, at) {
    return d === p ? !0 : d == null || p == null || !Yn(d) && !Yn(p) ? d !== d && p !== p : zf(d, p, g, w, Us, at);
  }
  function zf(d, p, g, w, at, M) {
    var ot = Ta(d), ht = Ta(p), St = ot ? l : Ce(d), rt = ht ? l : Ce(p);
    St = St == o ? F : St, rt = rt == o ? F : rt;
    var Pt = St == F, Ht = rt == F, wt = St == rt;
    if (wt && $r(d)) {
      if (!$r(p))
        return !1;
      ot = !0, Pt = !1;
    }
    if (wt && !Pt)
      return M || (M = new Je()), ot || Gs(d) ? Ls(d, p, g, w, at, M) : Yf(d, p, St, g, w, at, M);
    if (!(g & r)) {
      var Mt = Pt && re.call(d, "__wrapped__"), qt = Ht && re.call(p, "__wrapped__");
      if (Mt || qt) {
        var De = Mt ? d.value() : d, be = qt ? p.value() : p;
        return M || (M = new Je()), at(De, be, g, w, M);
      }
    }
    return wt ? (M || (M = new Je()), Xf(d, p, g, w, at, M)) : !1;
  }
  function Gf(d) {
    if (!zs(d) || ap(d))
      return !1;
    var p = Bs(d) ? mf : Xd;
    return p.test(Ye(d));
  }
  function Wf(d) {
    return Yn(d) && Zs(d.length) && !!nt[Hn(d)];
  }
  function Hf(d) {
    if (!rp(d))
      return gf(d);
    var p = [];
    for (var g in Object(d))
      re.call(d, g) && g != "constructor" && p.push(g);
    return p;
  }
  function Ls(d, p, g, w, at, M) {
    var ot = g & r, ht = d.length, St = p.length;
    if (ht != St && !(ot && St > ht))
      return !1;
    var rt = M.get(d);
    if (rt && M.get(p))
      return rt == p;
    var Pt = -1, Ht = !0, wt = g & i ? new Oa() : void 0;
    for (M.set(d, p), M.set(p, d); ++Pt < ht; ) {
      var Mt = d[Pt], qt = p[Pt];
      if (w)
        var De = ot ? w(qt, Mt, Pt, p, d, M) : w(Mt, qt, Pt, d, p, M);
      if (De !== void 0) {
        if (De)
          continue;
        Ht = !1;
        break;
      }
      if (wt) {
        if (!af(p, function(be, Xe) {
          if (!of(wt, Xe) && (Mt === be || at(Mt, be, g, w, M)))
            return wt.push(Xe);
        })) {
          Ht = !1;
          break;
        }
      } else if (!(Mt === qt || at(Mt, qt, g, w, M))) {
        Ht = !1;
        break;
      }
    }
    return M.delete(d), M.delete(p), Ht;
  }
  function Yf(d, p, g, w, at, M, ot) {
    switch (g) {
      case Ie:
        if (d.byteLength != p.byteLength || d.byteOffset != p.byteOffset)
          return !1;
        d = d.buffer, p = p.buffer;
      case Wt:
        return !(d.byteLength != p.byteLength || !M(new Cs(d), new Cs(p)));
      case f:
      case m:
      case $:
        return Ks(+d, +p);
      case y:
        return d.name == p.name && d.message == p.message;
      case q:
      case I:
        return d == p + "";
      case h:
        var ht = lf;
      case U:
        var St = w & r;
        if (ht || (ht = df), d.size != p.size && !St)
          return !1;
        var rt = ot.get(d);
        if (rt)
          return rt == p;
        w |= i, ot.set(d, p);
        var Pt = Ls(ht(d), ht(p), w, at, M, ot);
        return ot.delete(d), Pt;
      case D:
        if (qr)
          return qr.call(d) == qr.call(p);
    }
    return !1;
  }
  function Xf(d, p, g, w, at, M) {
    var ot = g & r, ht = js(d), St = ht.length, rt = js(p), Pt = rt.length;
    if (St != Pt && !ot)
      return !1;
    for (var Ht = St; Ht--; ) {
      var wt = ht[Ht];
      if (!(ot ? wt in p : re.call(p, wt)))
        return !1;
    }
    var Mt = M.get(d);
    if (Mt && M.get(p))
      return Mt == p;
    var qt = !0;
    M.set(d, p), M.set(p, d);
    for (var De = ot; ++Ht < St; ) {
      wt = ht[Ht];
      var be = d[wt], Xe = p[wt];
      if (w)
        var Ws = ot ? w(Xe, be, wt, p, d, M) : w(be, Xe, wt, d, p, M);
      if (!(Ws === void 0 ? be === Xe || at(be, Xe, g, w, M) : Ws)) {
        qt = !1;
        break;
      }
      De || (De = wt == "constructor");
    }
    if (qt && !De) {
      var Aa = d.constructor, ka = p.constructor;
      Aa != ka && "constructor" in d && "constructor" in p && !(typeof Aa == "function" && Aa instanceof Aa && typeof ka == "function" && ka instanceof ka) && (qt = !1);
    }
    return M.delete(d), M.delete(p), qt;
  }
  function js(d) {
    return Zf(d, lp, tp);
  }
  function wa(d, p) {
    var g = d.__data__;
    return np(p) ? g[typeof p == "string" ? "string" : "hash"] : g.map;
  }
  function bn(d, p) {
    var g = uf(d, p);
    return Gf(g) ? g : void 0;
  }
  function Qf(d) {
    var p = re.call(d, Ge), g = d[Ge];
    try {
      d[Ge] = void 0;
      var w = !0;
    } catch {
    }
    var at = Vs.call(d);
    return w && (p ? d[Ge] = g : delete d[Ge]), at;
  }
  var tp = Ms ? function(d) {
    return d == null ? [] : (d = Object(d), ef(Ms(d), function(p) {
      return Ds.call(d, p);
    }));
  } : cp, Ce = Hn;
  (Jr && Ce(new Jr(new ArrayBuffer(1))) != Ie || Gn && Ce(new Gn()) != h || Cr && Ce(Cr.resolve()) != v || Dr && Ce(new Dr()) != U || Mr && Ce(new Mr()) != Nt) && (Ce = function(d) {
    var p = Hn(d), g = p == F ? d.constructor : void 0, w = g ? Ye(g) : "";
    if (w)
      switch (w) {
        case hf:
          return Ie;
        case vf:
          return h;
        case bf:
          return v;
        case Sf:
          return U;
        case Of:
          return Nt;
      }
    return p;
  });
  function ep(d, p) {
    return p = p ?? s, !!p && (typeof d == "number" || Qd.test(d)) && d > -1 && d % 1 == 0 && d < p;
  }
  function np(d) {
    var p = typeof d;
    return p == "string" || p == "number" || p == "symbol" || p == "boolean" ? d !== "__proto__" : d === null;
  }
  function ap(d) {
    return !!Ps && Ps in d;
  }
  function rp(d) {
    var p = d && d.constructor, g = typeof p == "function" && p.prototype || ba;
    return d === g;
  }
  function ip(d) {
    return Vs.call(d);
  }
  function Ye(d) {
    if (d != null) {
      try {
        return Is.call(d);
      } catch {
      }
      try {
        return d + "";
      } catch {
      }
    }
    return "";
  }
  function Ks(d, p) {
    return d === p || d !== d && p !== p;
  }
  var sp = $s(function() {
    return arguments;
  }()) ? $s : function(d) {
    return Yn(d) && re.call(d, "callee") && !Ds.call(d, "callee");
  }, Ta = Array.isArray;
  function op(d) {
    return d != null && Zs(d.length) && !Bs(d);
  }
  var $r = _f || dp;
  function up(d, p) {
    return Us(d, p);
  }
  function Bs(d) {
    if (!zs(d))
      return !1;
    var p = Hn(d);
    return p == _ || p == S || p == u || p == x;
  }
  function Zs(d) {
    return typeof d == "number" && d > -1 && d % 1 == 0 && d <= s;
  }
  function zs(d) {
    var p = typeof d;
    return d != null && (p == "object" || p == "function");
  }
  function Yn(d) {
    return d != null && typeof d == "object";
  }
  var Gs = Rs ? sf(Rs) : Wf;
  function lp(d) {
    return op(d) ? Bf(d) : Hf(d);
  }
  function cp() {
    return [];
  }
  function dp() {
    return !1;
  }
  t.exports = up;
})(cr, cr.exports);
var gg = cr.exports;
const Xi = /* @__PURE__ */ _g(gg), hg = (t, e, n) => {
  const a = n.logger, r = n.subjects ?? eg(), i = new _e(), s = to([
    r.walletData,
    r.sharedData,
    r.loggedInTimestamp
  ]).pipe(
    oe(([_, S, h]) => ({
      walletData: _,
      sharedData: S,
      loggedInTimestamp: h
    }))
  ), o = () => e.getData(t).map((_) => (_ && (a == null || a.debug("readFromStorage")), _)), l = (_) => e.setData(
    t,
    st(_, (S) => {
      S.walletData.proofs = [];
    })
  ).map(() => {
    a == null || a.trace("writeToStorage", _);
  }), u = (_) => {
    const { walletData: S, sharedData: h, loggedInTimestamp: $ } = _;
    S && !Xi(r.walletData.value, S) && r.walletData.next(S), h && r.sharedData.next(h), $ !== void 0 && r.loggedInTimestamp.next($);
  }, f = () => {
    Xi(r.walletData.value, Ki) || r.walletData.next(Ki), r.sharedData.next({}), r.loggedInTimestamp.next("");
  };
  (() => o().andThen((_) => dt.fromPromise(
    tg.parseAsync(_),
    (S) => S
  )).mapErr(() => {
    a == null || a.debug("loadedCorruptedStateFromStorage"), f();
  }).map((_) => {
    if (_)
      return a == null || a.debug("initializeStateFromStorage"), u(
        st(_, (S) => (S.walletData.persona = S.walletData.persona ?? void 0, S))
      );
    a == null || a.debug("initializeStateFromDefault"), f();
  }))(), i.add(s.pipe(we(l)).subscribe()), i.add(
    s.pipe(
      mm(1),
      vu(),
      W(() => {
        r.initialized.next(!0);
      })
    ).subscribe()
  );
  const y = () => ({
    walletData: r.walletData.value,
    sharedData: r.sharedData.value,
    loggedInTimestamp: r.loggedInTimestamp.value
  });
  return {
    setState: u,
    getState: y,
    walletData$: to([
      r.initialized,
      r.walletData
    ]).pipe(
      lm(1),
      pe(([_]) => _),
      oe(() => r.walletData.value)
    ),
    getWalletData: () => r.walletData.value,
    state$: r.initialized.pipe(
      pe((_) => _),
      we(() => s)
    ),
    patchState: (_) => {
      u({ ...y(), ..._ });
    },
    reset: f,
    stateInitialized$: r.initialized.asObservable(),
    destroy: () => {
      f(), i.unsubscribe();
    }
  };
}, vg = () => ({
  onConnect: new Vt(),
  onDisconnect: new Vt(),
  onUpdateSharedData: new Vt(),
  connected: new Tp(1),
  requestItems: new it([]),
  onCancelRequestItem: new Vt(),
  accounts: new it([]),
  onShowPopover: new Vt(),
  status: new it(
    "default"
  ),
  loggedInTimestamp: new it(""),
  isMobile: new it(!1),
  isWalletLinked: new it(!1),
  isExtensionAvailable: new it(!1),
  fullWidth: new it(!1),
  activeTab: new it("sharing"),
  mode: new it("light"),
  theme: new it("radix-blue"),
  avatarUrl: new it(""),
  personaLabel: new it(""),
  personaData: new it([]),
  dAppName: new it(""),
  onLinkClick: new Vt()
}), bg = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  globalThis.navigator ? globalThis.navigator.userAgent : ""
), Sg = (t) => {
  import("./connect-button-83b00f42.mjs");
  const e = t.subjects || vg(), n = t.logger, a = (o) => {
    o();
  }, r = t.onConnect || a, i = () => document.querySelector("radix-connect-button"), s = new _e();
  return s.add(
    Rn(
      se(document, "onRender"),
      ls(i()).pipe(pe((o) => !!o))
    ).pipe(
      oe(() => i()),
      pe((o) => !!o),
      we((o) => {
        n == null || n.debug("connectButtonDiscovered");
        const l = se(o, "onConnect").pipe(
          W(() => {
            r((Z) => {
              !o.isWalletLinked || !o.isExtensionAvailable || e.onConnect.next(Z);
            });
          })
        ), u = se(
          o,
          "onDisconnect"
        ).pipe(
          W(() => {
            e.onDisconnect.next();
          })
        ), f = se(o, "onLinkClick").pipe(
          W((Z) => {
            e.onLinkClick.next(Z.detail);
          })
        ), m = se(o, "onDestroy").pipe(
          W(() => {
            n == null || n.debug("connectButtonRemovedFromDOM");
          })
        ), y = se(
          o,
          "onCancelRequestItem"
        ).pipe(
          W((Z) => {
            const L = Z.detail.id;
            n == null || n.debug("onCancelRequestItem", { id: L }), e.onCancelRequestItem.next(L);
          })
        ), _ = se(
          o,
          "onUpdateSharedData"
        ).pipe(
          W(() => {
            n == null || n.debug("onUpdateSharedData"), e.onUpdateSharedData.next();
          })
        ), S = se(
          o,
          "onShowPopover"
        ).pipe(
          W(() => {
            e.onShowPopover.next();
          })
        ), h = e.status.pipe(
          W((Z) => o.status = Z)
        ), $ = e.mode.pipe(
          W((Z) => o.mode = Z)
        ), z = e.connected.pipe(
          W((Z) => {
            o.connected = Z;
          })
        ), F = e.isMobile.pipe(
          W((Z) => {
            o.isMobile = Z;
          })
        ), v = e.isWalletLinked.pipe(
          W((Z) => {
            o.isWalletLinked = Z;
          })
        ), x = e.isExtensionAvailable.pipe(
          W((Z) => {
            o.isExtensionAvailable = Z;
          })
        ), q = e.loggedInTimestamp.pipe(
          W((Z) => {
            o.loggedInTimestamp = Z;
          })
        ), U = e.activeTab.pipe(
          W((Z) => {
            o.activeTab = Z;
          })
        ), I = e.requestItems.pipe(
          W((Z) => {
            o.requestItems = Z;
          })
        ), D = e.accounts.pipe(
          W((Z) => {
            o.accounts = Z;
          })
        ), lt = e.personaData.pipe(
          W((Z) => {
            o.personaData = Z;
          })
        ), Nt = e.personaLabel.pipe(
          W((Z) => {
            o.personaLabel = Z;
          })
        ), Wt = e.dAppName.pipe(
          W((Z) => {
            o.dAppName = Z;
          })
        ), Ie = e.theme.pipe(
          W((Z) => {
            o.theme = Z;
          })
        );
        return Rn(
          l,
          h,
          Ie,
          $,
          z,
          I,
          q,
          F,
          U,
          v,
          x,
          u,
          y,
          D,
          lt,
          Nt,
          m,
          _,
          S,
          Wt,
          f
        );
      })
    ).subscribe()
  ), {
    status$: e.status.asObservable(),
    onConnect$: e.onConnect.asObservable(),
    onDisconnect$: e.onDisconnect.asObservable(),
    onShowPopover$: e.onShowPopover.asObservable(),
    onUpdateSharedData$: e.onUpdateSharedData.asObservable(),
    onCancelRequestItem$: e.onCancelRequestItem.asObservable(),
    onLinkClick$: e.onLinkClick.asObservable(),
    setStatus: (o) => e.status.next(o),
    setTheme: (o) => e.theme.next(o),
    setMode: (o) => e.mode.next(o),
    setActiveTab: (o) => e.activeTab.next(o),
    setIsMobile: (o) => e.isMobile.next(o),
    setIsWalletLinked: (o) => e.isWalletLinked.next(o),
    setIsExtensionAvailable: (o) => e.isExtensionAvailable.next(o),
    setLoggedInTimestamp: (o) => e.loggedInTimestamp.next(o),
    setConnected: (o) => e.connected.next(o),
    setRequestItems: (o) => e.requestItems.next(o),
    setAccounts: (o) => e.accounts.next(o),
    setPersonaData: (o) => e.personaData.next(o),
    setPersonaLabel: (o) => e.personaLabel.next(o),
    setDappName: (o) => e.dAppName.next(o),
    disconnect: () => {
      e.connected.next(!1), e.status.next("default");
    },
    destroy: () => {
      s.unsubscribe();
    }
  };
};
var Og = Object.defineProperty, Ng = (t, e, n) => e in t ? Og(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Xt = (t, e, n) => (Ng(t, typeof e != "symbol" ? e + "" : e, n), n);
const wg = "https://mainnet.radixdlt.com".replace(/\/+$/, "");
class wl {
  constructor(e = {}) {
    this.configuration = e;
  }
  set config(e) {
    this.configuration = e;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : wg;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || Tl;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const e = this.configuration.apiKey;
    if (e)
      return typeof e == "function" ? e : () => e;
  }
  get accessToken() {
    const e = this.configuration.accessToken;
    if (e)
      return typeof e == "function" ? e : async () => e;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
}
const Tg = new wl();
class pa {
  constructor(e = Tg) {
    Xt(this, "middleware"), Xt(this, "fetchApi", async (n, a) => {
      let r = { url: n, init: a };
      for (const s of this.middleware)
        s.pre && (r = await s.pre({
          fetch: this.fetchApi,
          ...r
        }) || r);
      let i;
      try {
        i = await (this.configuration.fetchApi || fetch)(r.url, r.init);
      } catch (s) {
        for (const o of this.middleware)
          o.onError && (i = await o.onError({
            fetch: this.fetchApi,
            url: r.url,
            init: r.init,
            error: s,
            response: i ? i.clone() : void 0
          }) || i);
        if (i === void 0)
          throw s;
      }
      for (const s of this.middleware)
        s.post && (i = await s.post({
          fetch: this.fetchApi,
          url: r.url,
          init: r.init,
          response: i.clone()
        }) || i);
      return i;
    }), this.configuration = e, this.middleware = e.middleware;
  }
  withMiddleware(...e) {
    const n = this.clone();
    return n.middleware = n.middleware.concat(...e), n;
  }
  withPreMiddleware(...e) {
    const n = e.map((a) => ({ pre: a }));
    return this.withMiddleware(...n);
  }
  withPostMiddleware(...e) {
    const n = e.map((a) => ({ post: a }));
    return this.withMiddleware(...n);
  }
  async request(e, n) {
    const { url: a, init: r } = await this.createFetchParams(e, n), i = await this.fetchApi(a, r);
    if (i && i.status >= 200 && i.status < 300)
      return i;
    throw await dr.from(i);
  }
  async createFetchParams(e, n) {
    let a = this.configuration.basePath + e.path;
    e.query !== void 0 && Object.keys(e.query).length !== 0 && (a += "?" + this.configuration.queryParamsStringify(e.query));
    const r = Object.assign({}, this.configuration.headers, e.headers);
    Object.keys(r).forEach((u) => r[u] === void 0 ? delete r[u] : {});
    const i = typeof n == "function" ? n : async () => n, s = {
      method: e.method,
      headers: r,
      body: e.body,
      credentials: this.configuration.credentials
    }, o = {
      ...s,
      ...await i({
        init: s,
        context: e
      })
    }, l = {
      ...o,
      body: kg(o.body) || o.body instanceof URLSearchParams || Ag(o.body) ? o.body : JSON.stringify(o.body)
    };
    return { url: a, init: l };
  }
  clone() {
    const e = this.constructor, n = new e(this.configuration);
    return n.middleware = this.middleware.slice(), n;
  }
}
function Ag(t) {
  return typeof Blob < "u" && t instanceof Blob;
}
function kg(t) {
  return typeof FormData < "u" && t instanceof FormData;
}
class dr extends Error {
  constructor(e, n, a) {
    super(a ? JSON.stringify(a) : "Unknown error occurred"), Xt(this, "name", "ResponseError"), this.fetchResponse = e, this.status = n, this.errorResponse = a;
  }
  static async from(e) {
    const n = e.status;
    try {
      const a = await e.json();
      return new dr(e, n, a);
    } catch {
      return new dr(e, n, void 0);
    }
  }
}
class vt extends Error {
  constructor(e, n) {
    super(n), Xt(this, "name", "RequiredError"), this.field = e;
  }
}
const FT = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
function c(t, e) {
  return t[e] != null;
}
function Tl(t, e = "") {
  return Object.keys(t).map((n) => Al(n, t[n], e)).filter((n) => n.length > 0).join("&");
}
function Al(t, e, n = "") {
  const a = n + (n.length ? `[${t}]` : t);
  if (e instanceof Array) {
    const r = e.map((i) => encodeURIComponent(String(i))).join(`&${encodeURIComponent(a)}=`);
    return `${encodeURIComponent(a)}=${r}`;
  }
  if (e instanceof Set) {
    const r = Array.from(e);
    return Al(t, r, n);
  }
  return e instanceof Date ? `${encodeURIComponent(a)}=${encodeURIComponent(e.toISOString())}` : e instanceof Object ? Tl(e, a) : `${encodeURIComponent(a)}=${encodeURIComponent(String(e))}`;
}
function xT(t, e) {
  return Object.keys(t).reduce(
    (n, a) => ({ ...n, [a]: e(t[a]) }),
    {}
  );
}
function ET(t) {
  for (const e of t)
    if (e.contentType === "multipart/form-data")
      return !0;
  return !1;
}
class ct {
  constructor(e, n = (a) => a) {
    this.raw = e, this.transformer = n;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
}
class RT {
  constructor(e) {
    this.raw = e;
  }
  async value() {
  }
}
class IT {
  constructor(e) {
    this.raw = e;
  }
  async value() {
    return await this.raw.blob();
  }
}
class PT {
  constructor(e) {
    this.raw = e;
  }
  async value() {
    return await this.raw.text();
  }
}
function VT(t) {
  return !0;
}
function pt(t) {
  return Fg(t);
}
function Fg(t, e) {
  return t == null ? t : {
    state_version: c(t, "state_version") ? t.state_version : void 0,
    timestamp: c(t, "timestamp") ? t.timestamp === null ? null : new Date(t.timestamp) : void 0,
    epoch: c(t, "epoch") ? t.epoch : void 0,
    round: c(t, "round") ? t.round : void 0
  };
}
function mt(t) {
  if (t !== void 0)
    return t === null ? null : {
      state_version: t.state_version,
      timestamp: t.timestamp === void 0 ? void 0 : t.timestamp === null ? null : t.timestamp.toISOString(),
      epoch: t.epoch,
      round: t.round
    };
}
function JT(t) {
  return !0;
}
function CT(t) {
  return xg(t);
}
function xg(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0
  };
}
function DT(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state)
    };
}
function MT(t) {
  let e = !0;
  return e = e && "entity_address" in t, e = e && "resource_address" in t, e = e && "balance_change" in t, e;
}
function Eg(t) {
  return Rg(t);
}
function Rg(t, e) {
  return t == null ? t : {
    entity_address: t.entity_address,
    resource_address: t.resource_address,
    balance_change: t.balance_change
  };
}
function Ig(t) {
  if (t !== void 0)
    return t === null ? null : {
      entity_address: t.entity_address,
      resource_address: t.resource_address,
      balance_change: t.balance_change
    };
}
const qT = {
  FeePayment: "FeePayment",
  FeeDistributed: "FeeDistributed",
  TipDistributed: "TipDistributed",
  RoyaltyDistributed: "RoyaltyDistributed"
};
function Pg(t) {
  return Vg(t);
}
function Vg(t, e) {
  return t;
}
function $T(t) {
  return t;
}
function UT(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "entity_address" in t, e = e && "resource_address" in t, e = e && "balance_change" in t, e;
}
function Jg(t) {
  return Cg(t);
}
function Cg(t, e) {
  return t == null ? t : {
    type: Pg(t.type),
    entity_address: t.entity_address,
    resource_address: t.resource_address,
    balance_change: t.balance_change
  };
}
function Dg(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      entity_address: t.entity_address,
      resource_address: t.resource_address,
      balance_change: t.balance_change
    };
}
function LT(t) {
  let e = !0;
  return e = e && "entity_address" in t, e = e && "resource_address" in t, e = e && "added" in t, e = e && "removed" in t, e;
}
function Mg(t) {
  return qg(t);
}
function qg(t, e) {
  return t == null ? t : {
    entity_address: t.entity_address,
    resource_address: t.resource_address,
    added: t.added,
    removed: t.removed
  };
}
function $g(t) {
  if (t !== void 0)
    return t === null ? null : {
      entity_address: t.entity_address,
      resource_address: t.resource_address,
      added: t.added,
      removed: t.removed
    };
}
function jT(t) {
  let e = !0;
  return e = e && "fungible_fee_balance_changes" in t, e = e && "fungible_balance_changes" in t, e = e && "non_fungible_balance_changes" in t, e;
}
function Ug(t) {
  return Lg(t);
}
function Lg(t, e) {
  return t == null ? t : {
    fungible_fee_balance_changes: t.fungible_fee_balance_changes.map(Jg),
    fungible_balance_changes: t.fungible_balance_changes.map(Eg),
    non_fungible_balance_changes: t.non_fungible_balance_changes.map(Mg)
  };
}
function jg(t) {
  if (t !== void 0)
    return t === null ? null : {
      fungible_fee_balance_changes: t.fungible_fee_balance_changes.map(Dg),
      fungible_balance_changes: t.fungible_balance_changes.map(Ig),
      non_fungible_balance_changes: t.non_fungible_balance_changes.map($g)
    };
}
const KT = {
  Bool: "Bool",
  I8: "I8",
  I16: "I16",
  I32: "I32",
  I64: "I64",
  I128: "I128",
  U8: "U8",
  U16: "U16",
  U32: "U32",
  U64: "U64",
  U128: "U128",
  String: "String",
  Enum: "Enum",
  Array: "Array",
  Bytes: "Bytes",
  Map: "Map",
  Tuple: "Tuple",
  Reference: "Reference",
  Own: "Own",
  Decimal: "Decimal",
  PreciseDecimal: "PreciseDecimal",
  NonFungibleLocalId: "NonFungibleLocalId"
};
function Fe(t) {
  return Kg(t);
}
function Kg(t, e) {
  return t;
}
function BT(t) {
  return t;
}
const ZT = {
  Array: "Array"
};
function zT(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "element_kind" in t, e = e && "elements" in t, e;
}
function GT(t) {
  return kl(t);
}
function kl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    element_kind: Fe(t.element_kind),
    element_type_name: c(t, "element_type_name") ? t.element_type_name : void 0,
    elements: t.elements.map(jt)
  };
}
function Bg(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      element_kind: t.element_kind,
      element_type_name: t.element_type_name,
      elements: t.elements.map(Kt)
    };
}
const WT = {
  Bool: "Bool"
};
function HT(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function YT(t) {
  return Fl(t);
}
function Fl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function Zg(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const XT = {
  Bytes: "Bytes"
};
function QT(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "element_kind" in t, e = e && "hex" in t, e;
}
function tA(t) {
  return xl(t);
}
function xl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    element_kind: Fe(t.element_kind),
    element_type_name: c(t, "element_type_name") ? t.element_type_name : void 0,
    hex: t.hex
  };
}
function zg(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      element_kind: t.element_kind,
      element_type_name: t.element_type_name,
      hex: t.hex
    };
}
const eA = {
  Decimal: "Decimal"
};
function nA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function aA(t) {
  return El(t);
}
function El(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function Gg(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const rA = {
  Enum: "Enum"
};
function iA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "variant_id" in t, e = e && "fields" in t, e;
}
function sA(t) {
  return Rl(t);
}
function Rl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    variant_id: t.variant_id,
    variant_name: c(t, "variant_name") ? t.variant_name : void 0,
    fields: t.fields.map(jt)
  };
}
function Wg(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      variant_id: t.variant_id,
      variant_name: t.variant_name,
      fields: t.fields.map(Kt)
    };
}
const oA = {
  I128: "I128"
};
function uA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function lA(t) {
  return Il(t);
}
function Il(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function Hg(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const cA = {
  I16: "I16"
};
function dA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function fA(t) {
  return Pl(t);
}
function Pl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function Yg(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const pA = {
  I32: "I32"
};
function mA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function yA(t) {
  return Vl(t);
}
function Vl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function Xg(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const _A = {
  I64: "I64"
};
function gA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function hA(t) {
  return Jl(t);
}
function Jl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function Qg(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const vA = {
  I8: "I8"
};
function bA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function SA(t) {
  return Cl(t);
}
function Cl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function th(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
function OA(t) {
  let e = !0;
  return e = e && "key" in t, e = e && "value" in t, e;
}
function Dl(t) {
  return eh(t);
}
function eh(t, e) {
  return t == null ? t : {
    key: jt(t.key),
    value: jt(t.value)
  };
}
function Ml(t) {
  if (t !== void 0)
    return t === null ? null : {
      key: Kt(t.key),
      value: Kt(t.value)
    };
}
const NA = {
  Map: "Map"
};
function wA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "key_kind" in t, e = e && "value_kind" in t, e = e && "entries" in t, e;
}
function TA(t) {
  return ql(t);
}
function ql(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    key_kind: Fe(t.key_kind),
    key_type_name: c(t, "key_type_name") ? t.key_type_name : void 0,
    value_kind: Fe(t.value_kind),
    value_type_name: c(t, "value_type_name") ? t.value_type_name : void 0,
    entries: t.entries.map(Dl)
  };
}
function nh(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      key_kind: t.key_kind,
      key_type_name: t.key_type_name,
      value_kind: t.value_kind,
      value_type_name: t.value_type_name,
      entries: t.entries.map(Ml)
    };
}
const AA = {
  NonFungibleLocalId: "NonFungibleLocalId"
};
function kA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function FA(t) {
  return $l(t);
}
function $l(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function ah(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const xA = {
  Own: "Own"
};
function EA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function RA(t) {
  return Ul(t);
}
function Ul(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function rh(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const IA = {
  PreciseDecimal: "PreciseDecimal"
};
function PA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function VA(t) {
  return Ll(t);
}
function Ll(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function ih(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const JA = {
  Reference: "Reference"
};
function CA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function DA(t) {
  return jl(t);
}
function jl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function sh(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const MA = {
  String: "String"
};
function qA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function $A(t) {
  return Kl(t);
}
function Kl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function oh(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const UA = {
  Tuple: "Tuple"
};
function LA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "fields" in t, e;
}
function jA(t) {
  return Bl(t);
}
function Bl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    fields: t.fields.map(jt)
  };
}
function uh(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      fields: t.fields.map(Kt)
    };
}
const KA = {
  U128: "U128"
};
function BA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function ZA(t) {
  return Zl(t);
}
function Zl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function lh(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const zA = {
  U16: "U16"
};
function GA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function WA(t) {
  return zl(t);
}
function zl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function ch(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const HA = {
  U32: "U32"
};
function YA(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function XA(t) {
  return Gl(t);
}
function Gl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function dh(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const QA = {
  U64: "U64"
};
function tk(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function ek(t) {
  return Wl(t);
}
function Wl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function fh(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
const nk = {
  U8: "U8"
};
function ak(t) {
  let e = !0;
  return e = e && "kind" in t, e = e && "value" in t, e;
}
function rk(t) {
  return Hl(t);
}
function Hl(t, e) {
  return t == null ? t : {
    kind: t.kind,
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0,
    value: t.value
  };
}
function ph(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name,
      value: t.value
    };
}
function jt(t) {
  return mh(t);
}
function mh(t, e) {
  if (t == null)
    return t;
  switch (t.kind) {
    case "Array":
      return { ...kl(t), kind: "Array" };
    case "Bool":
      return { ...Fl(t), kind: "Bool" };
    case "Bytes":
      return { ...xl(t), kind: "Bytes" };
    case "Decimal":
      return { ...El(t), kind: "Decimal" };
    case "Enum":
      return { ...Rl(t), kind: "Enum" };
    case "I128":
      return { ...Il(t), kind: "I128" };
    case "I16":
      return { ...Pl(t), kind: "I16" };
    case "I32":
      return { ...Vl(t), kind: "I32" };
    case "I64":
      return { ...Jl(t), kind: "I64" };
    case "I8":
      return { ...Cl(t), kind: "I8" };
    case "Map":
      return { ...ql(t), kind: "Map" };
    case "NonFungibleLocalId":
      return { ...$l(t), kind: "NonFungibleLocalId" };
    case "Own":
      return { ...Ul(t), kind: "Own" };
    case "PreciseDecimal":
      return { ...Ll(t), kind: "PreciseDecimal" };
    case "Reference":
      return { ...jl(t), kind: "Reference" };
    case "String":
      return { ...Kl(t), kind: "String" };
    case "Tuple":
      return { ...Bl(t), kind: "Tuple" };
    case "U128":
      return { ...Zl(t), kind: "U128" };
    case "U16":
      return { ...zl(t), kind: "U16" };
    case "U32":
      return { ...Gl(t), kind: "U32" };
    case "U64":
      return { ...Wl(t), kind: "U64" };
    case "U8":
      return { ...Hl(t), kind: "U8" };
    default:
      throw new Error(`No variant of ProgrammaticScryptoSborValue exists with 'kind=${t.kind}'`);
  }
}
function Kt(t) {
  if (t !== void 0) {
    if (t === null)
      return null;
    switch (t.kind) {
      case "Array":
        return Bg(t);
      case "Bool":
        return Zg(t);
      case "Bytes":
        return zg(t);
      case "Decimal":
        return Gg(t);
      case "Enum":
        return Wg(t);
      case "I128":
        return Hg(t);
      case "I16":
        return Yg(t);
      case "I32":
        return Xg(t);
      case "I64":
        return Qg(t);
      case "I8":
        return th(t);
      case "Map":
        return nh(t);
      case "NonFungibleLocalId":
        return ah(t);
      case "Own":
        return rh(t);
      case "PreciseDecimal":
        return ih(t);
      case "Reference":
        return sh(t);
      case "String":
        return oh(t);
      case "Tuple":
        return uh(t);
      case "U128":
        return lh(t);
      case "U16":
        return ch(t);
      case "U32":
        return dh(t);
      case "U64":
        return fh(t);
      case "U8":
        return ph(t);
      default:
        throw new Error(`No variant of ProgrammaticScryptoSborValue exists with 'kind=${t.kind}'`);
    }
  }
}
function ik(t) {
  let e = !0;
  return e = e && "name" in t, e = e && "emitter" in t, e = e && "data" in t, e;
}
function yh(t) {
  return _h(t);
}
function _h(t, e) {
  return t == null ? t : {
    name: t.name,
    emitter: t.emitter,
    data: jt(t.data)
  };
}
function gh(t) {
  if (t !== void 0)
    return t === null ? null : {
      name: t.name,
      emitter: t.emitter,
      data: Kt(t.data)
    };
}
const Bo = {
  Unknown: "Unknown",
  CommittedSuccess: "CommittedSuccess",
  CommittedFailure: "CommittedFailure",
  Pending: "Pending",
  Rejected: "Rejected"
};
function ma(t) {
  return hh(t);
}
function hh(t, e) {
  return t;
}
function sk(t) {
  return t;
}
function ok(t) {
  return !0;
}
function vh(t) {
  return bh(t);
}
function bh(t, e) {
  return t == null ? t : {
    status: c(t, "status") ? ma(t.status) : void 0,
    fee_summary: c(t, "fee_summary") ? t.fee_summary : void 0,
    costing_parameters: c(t, "costing_parameters") ? t.costing_parameters : void 0,
    fee_destination: c(t, "fee_destination") ? t.fee_destination : void 0,
    fee_source: c(t, "fee_source") ? t.fee_source : void 0,
    state_updates: c(t, "state_updates") ? t.state_updates : void 0,
    next_epoch: c(t, "next_epoch") ? t.next_epoch : void 0,
    output: c(t, "output") ? t.output : void 0,
    events: c(t, "events") ? t.events.map(yh) : void 0,
    error_message: c(t, "error_message") ? t.error_message : void 0
  };
}
function Sh(t) {
  if (t !== void 0)
    return t === null ? null : {
      status: t.status,
      fee_summary: t.fee_summary,
      costing_parameters: t.costing_parameters,
      fee_destination: t.fee_destination,
      fee_source: t.fee_source,
      state_updates: t.state_updates,
      next_epoch: t.next_epoch,
      output: t.output,
      events: t.events === void 0 ? void 0 : t.events.map(gh),
      error_message: t.error_message
    };
}
function uk(t) {
  let e = !0;
  return e = e && "state_version" in t, e = e && "epoch" in t, e = e && "round" in t, e = e && "round_timestamp" in t, e = e && "transaction_status" in t, e;
}
function Nr(t) {
  return Oh(t);
}
function Oh(t, e) {
  return t == null ? t : {
    state_version: t.state_version,
    epoch: t.epoch,
    round: t.round,
    round_timestamp: t.round_timestamp,
    transaction_status: ma(t.transaction_status),
    payload_hash: c(t, "payload_hash") ? t.payload_hash : void 0,
    intent_hash: c(t, "intent_hash") ? t.intent_hash : void 0,
    fee_paid: c(t, "fee_paid") ? t.fee_paid : void 0,
    affected_global_entities: c(t, "affected_global_entities") ? t.affected_global_entities : void 0,
    confirmed_at: c(t, "confirmed_at") ? t.confirmed_at === null ? null : new Date(t.confirmed_at) : void 0,
    error_message: c(t, "error_message") ? t.error_message : void 0,
    raw_hex: c(t, "raw_hex") ? t.raw_hex : void 0,
    receipt: c(t, "receipt") ? vh(t.receipt) : void 0,
    message: c(t, "message") ? t.message : void 0,
    balance_changes: c(t, "balance_changes") ? Ug(t.balance_changes) : void 0
  };
}
function wr(t) {
  if (t !== void 0)
    return t === null ? null : {
      state_version: t.state_version,
      epoch: t.epoch,
      round: t.round,
      round_timestamp: t.round_timestamp,
      transaction_status: t.transaction_status,
      payload_hash: t.payload_hash,
      intent_hash: t.intent_hash,
      fee_paid: t.fee_paid,
      affected_global_entities: t.affected_global_entities,
      confirmed_at: t.confirmed_at === void 0 ? void 0 : t.confirmed_at === null ? null : t.confirmed_at.toISOString(),
      error_message: t.error_message,
      raw_hex: t.raw_hex,
      receipt: Sh(t.receipt),
      message: t.message,
      balance_changes: jg(t.balance_changes)
    };
}
const lk = {
  Explicit: "Explicit",
  Owner: "Owner"
};
function Nh(t) {
  return wh(t);
}
function wh(t, e) {
  return t;
}
function ck(t) {
  return t;
}
function dk(t) {
  let e = !0;
  return e = e && "resolution" in t, e;
}
function Th(t) {
  return Ah(t);
}
function Ah(t, e) {
  return t == null ? t : {
    resolution: Nh(t.resolution),
    explicit_rule: c(t, "explicit_rule") ? t.explicit_rule : void 0
  };
}
function kh(t) {
  if (t !== void 0)
    return t === null ? null : {
      resolution: t.resolution,
      explicit_rule: t.explicit_rule
    };
}
const fk = {
  Main: "Main",
  Metadata: "Metadata",
  Royalty: "Royalty",
  RoleAssignment: "RoleAssignment"
};
function Fh(t) {
  return xh(t);
}
function xh(t, e) {
  return t;
}
function pk(t) {
  return t;
}
function mk(t) {
  let e = !0;
  return e = e && "name" in t, e = e && "module" in t, e;
}
function Zo(t) {
  return Eh(t);
}
function Eh(t, e) {
  return t == null ? t : {
    name: t.name,
    module: Fh(t.module)
  };
}
function zo(t) {
  if (t !== void 0)
    return t === null ? null : {
      name: t.name,
      module: t.module
    };
}
function yk(t) {
  let e = !0;
  return e = e && "role_key" in t, e = e && "assignment" in t, e;
}
function Rh(t) {
  return Ih(t);
}
function Ih(t, e) {
  return t == null ? t : {
    role_key: Zo(t.role_key),
    assignment: Th(t.assignment),
    updater_roles: c(t, "updater_roles") ? t.updater_roles.map(Zo) : void 0
  };
}
function Ph(t) {
  if (t !== void 0)
    return t === null ? null : {
      role_key: zo(t.role_key),
      assignment: kh(t.assignment),
      updater_roles: t.updater_roles === void 0 ? void 0 : t.updater_roles.map(zo)
    };
}
function _k(t) {
  let e = !0;
  return e = e && "owner" in t, e = e && "entries" in t, e;
}
function Zn(t) {
  return Vh(t);
}
function Vh(t, e) {
  return t == null ? t : {
    owner: t.owner,
    entries: t.entries.map(Rh)
  };
}
function zn(t) {
  if (t !== void 0)
    return t === null ? null : {
      owner: t.owner,
      entries: t.entries.map(Ph)
    };
}
function gk(t) {
  return !0;
}
function hk(t) {
  return Jh(t);
}
function Jh(t, e) {
  return t == null ? t : {
    cursor: c(t, "cursor") ? t.cursor : void 0,
    limit_per_page: c(t, "limit_per_page") ? t.limit_per_page : void 0
  };
}
function vk(t) {
  if (t !== void 0)
    return t === null ? null : {
      cursor: t.cursor,
      limit_per_page: t.limit_per_page
    };
}
const bk = {
  BoolArray: "BoolArray"
};
function Sk(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function Ok(t) {
  return Yl(t);
}
function Yl(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function Ch(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const Nk = {
  Bool: "Bool"
};
function wk(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function Tk(t) {
  return Xl(t);
}
function Xl(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function Dh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
const Ak = {
  DecimalArray: "DecimalArray"
};
function kk(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function Fk(t) {
  return Ql(t);
}
function Ql(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function Mh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const xk = {
  Decimal: "Decimal"
};
function Ek(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function Rk(t) {
  return tc(t);
}
function tc(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function qh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
const Ik = {
  GlobalAddressArray: "GlobalAddressArray"
};
function Pk(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function Vk(t) {
  return ec(t);
}
function ec(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function $h(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const Jk = {
  GlobalAddress: "GlobalAddress"
};
function Ck(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function Dk(t) {
  return nc(t);
}
function nc(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function Uh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
const Mk = {
  I32Array: "I32Array"
};
function qk(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function $k(t) {
  return ac(t);
}
function ac(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function Lh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const Uk = {
  I32: "I32"
};
function Lk(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function jk(t) {
  return rc(t);
}
function rc(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function jh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
const Kk = {
  I64Array: "I64Array"
};
function Bk(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function Zk(t) {
  return ic(t);
}
function ic(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function Kh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const zk = {
  I64: "I64"
};
function Gk(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function Wk(t) {
  return sc(t);
}
function sc(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function Bh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
const Hk = {
  InstantArray: "InstantArray"
};
function Yk(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function Xk(t) {
  return oc(t);
}
function oc(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function Zh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const Qk = {
  Instant: "Instant"
};
function tF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function eF(t) {
  return uc(t);
}
function uc(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function zh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
function nF(t) {
  let e = !0;
  return e = e && "resource_address" in t, e = e && "non_fungible_id" in t, e;
}
function lc(t) {
  return Gh(t);
}
function Gh(t, e) {
  return t == null ? t : {
    resource_address: t.resource_address,
    non_fungible_id: t.non_fungible_id
  };
}
function cc(t) {
  if (t !== void 0)
    return t === null ? null : {
      resource_address: t.resource_address,
      non_fungible_id: t.non_fungible_id
    };
}
const aF = {
  NonFungibleGlobalIdArray: "NonFungibleGlobalIdArray"
};
function rF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function iF(t) {
  return dc(t);
}
function dc(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values.map(lc)
  };
}
function Wh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values.map(cc)
    };
}
const sF = {
  NonFungibleGlobalId: "NonFungibleGlobalId"
};
function oF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "resource_address" in t, e = e && "non_fungible_id" in t, e;
}
function uF(t) {
  return fc(t);
}
function fc(t, e) {
  return t == null ? t : {
    type: t.type,
    resource_address: t.resource_address,
    non_fungible_id: t.non_fungible_id
  };
}
function Hh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      resource_address: t.resource_address,
      non_fungible_id: t.non_fungible_id
    };
}
const lF = {
  NonFungibleLocalIdArray: "NonFungibleLocalIdArray"
};
function cF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function dF(t) {
  return pc(t);
}
function pc(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function Yh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const fF = {
  NonFungibleLocalId: "NonFungibleLocalId"
};
function pF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function mF(t) {
  return mc(t);
}
function mc(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function Xh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
const yF = {
  OriginArray: "OriginArray"
};
function _F(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function gF(t) {
  return yc(t);
}
function yc(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function Qh(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const hF = {
  Origin: "Origin"
};
function vF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function bF(t) {
  return _c(t);
}
function _c(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function tv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
const SF = {
  EcdsaSecp256k1: "EcdsaSecp256k1"
};
function OF(t) {
  let e = !0;
  return e = e && "key_type" in t, e = e && "key_hex" in t, e;
}
function NF(t) {
  return gc(t);
}
function gc(t, e) {
  return t == null ? t : {
    key_type: t.key_type,
    key_hex: t.key_hex
  };
}
function ev(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_type: t.key_type,
      key_hex: t.key_hex
    };
}
const wF = {
  EddsaEd25519: "EddsaEd25519"
};
function TF(t) {
  let e = !0;
  return e = e && "key_type" in t, e = e && "key_hex" in t, e;
}
function AF(t) {
  return hc(t);
}
function hc(t, e) {
  return t == null ? t : {
    key_type: t.key_type,
    key_hex: t.key_hex
  };
}
function nv(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_type: t.key_type,
      key_hex: t.key_hex
    };
}
function gn(t) {
  return av(t);
}
function av(t, e) {
  if (t == null)
    return t;
  switch (t.key_type) {
    case "EcdsaSecp256k1":
      return { ...gc(t), key_type: "EcdsaSecp256k1" };
    case "EddsaEd25519":
      return { ...hc(t), key_type: "EddsaEd25519" };
    default:
      throw new Error(`No variant of PublicKey exists with 'key_type=${t.key_type}'`);
  }
}
function hn(t) {
  if (t !== void 0) {
    if (t === null)
      return null;
    switch (t.key_type) {
      case "EcdsaSecp256k1":
        return ev(t);
      case "EddsaEd25519":
        return nv(t);
      default:
        throw new Error(`No variant of PublicKey exists with 'key_type=${t.key_type}'`);
    }
  }
}
const kF = {
  PublicKeyArray: "PublicKeyArray"
};
function FF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function xF(t) {
  return vc(t);
}
function vc(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values.map(gn)
  };
}
function rv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values.map(hn)
    };
}
const EF = {
  EcdsaSecp256k1: "EcdsaSecp256k1"
};
function RF(t) {
  let e = !0;
  return e = e && "key_hash_type" in t, e = e && "hash_hex" in t, e;
}
function IF(t) {
  return bc(t);
}
function bc(t, e) {
  return t == null ? t : {
    key_hash_type: t.key_hash_type,
    hash_hex: t.hash_hex
  };
}
function iv(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_hash_type: t.key_hash_type,
      hash_hex: t.hash_hex
    };
}
const PF = {
  EddsaEd25519: "EddsaEd25519"
};
function VF(t) {
  let e = !0;
  return e = e && "key_hash_type" in t, e = e && "hash_hex" in t, e;
}
function JF(t) {
  return Sc(t);
}
function Sc(t, e) {
  return t == null ? t : {
    key_hash_type: t.key_hash_type,
    hash_hex: t.hash_hex
  };
}
function sv(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_hash_type: t.key_hash_type,
      hash_hex: t.hash_hex
    };
}
function Tr(t) {
  return ov(t);
}
function ov(t, e) {
  if (t == null)
    return t;
  switch (t.key_hash_type) {
    case "EcdsaSecp256k1":
      return { ...bc(t), key_hash_type: "EcdsaSecp256k1" };
    case "EddsaEd25519":
      return { ...Sc(t), key_hash_type: "EddsaEd25519" };
    default:
      throw new Error(`No variant of PublicKeyHash exists with 'key_hash_type=${t.key_hash_type}'`);
  }
}
function Ar(t) {
  if (t !== void 0) {
    if (t === null)
      return null;
    switch (t.key_hash_type) {
      case "EcdsaSecp256k1":
        return iv(t);
      case "EddsaEd25519":
        return sv(t);
      default:
        throw new Error(`No variant of PublicKeyHash exists with 'key_hash_type=${t.key_hash_type}'`);
    }
  }
}
const CF = {
  PublicKeyHashArray: "PublicKeyHashArray"
};
function DF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function MF(t) {
  return Oc(t);
}
function Oc(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values.map(Tr)
  };
}
function uv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values.map(Ar)
    };
}
const qF = {
  PublicKeyHash: "PublicKeyHash"
};
function $F(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function UF(t) {
  return Nc(t);
}
function Nc(t, e) {
  return t == null ? t : {
    type: t.type,
    value: Tr(t.value)
  };
}
function lv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: Ar(t.value)
    };
}
const LF = {
  PublicKey: "PublicKey"
};
function jF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function KF(t) {
  return wc(t);
}
function wc(t, e) {
  return t == null ? t : {
    type: t.type,
    value: gn(t.value)
  };
}
function cv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: hn(t.value)
    };
}
const BF = {
  StringArray: "StringArray"
};
function ZF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function zF(t) {
  return Tc(t);
}
function Tc(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function dv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const GF = {
  String: "String"
};
function WF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function HF(t) {
  return Ac(t);
}
function Ac(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function fv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
const YF = {
  U32Array: "U32Array"
};
function XF(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function QF(t) {
  return kc(t);
}
function kc(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function pv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const tx = {
  U32: "U32"
};
function ex(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function nx(t) {
  return Fc(t);
}
function Fc(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function mv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
const ax = {
  U64Array: "U64Array"
};
function rx(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function ix(t) {
  return xc(t);
}
function xc(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function yv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const sx = {
  U64: "U64"
};
function ox(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function ux(t) {
  return Ec(t);
}
function Ec(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function _v(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
const lx = {
  U8Array: "U8Array"
};
function cx(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value_hex" in t, e;
}
function dx(t) {
  return Rc(t);
}
function Rc(t, e) {
  return t == null ? t : {
    type: t.type,
    value_hex: t.value_hex
  };
}
function gv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value_hex: t.value_hex
    };
}
const fx = {
  U8: "U8"
};
function px(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function mx(t) {
  return Ic(t);
}
function Ic(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function hv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
const yx = {
  UrlArray: "UrlArray"
};
function _x(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "values" in t, e;
}
function gx(t) {
  return Pc(t);
}
function Pc(t, e) {
  return t == null ? t : {
    type: t.type,
    values: t.values
  };
}
function vv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      values: t.values
    };
}
const hx = {
  Url: "Url"
};
function vx(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "value" in t, e;
}
function bx(t) {
  return Vc(t);
}
function Vc(t, e) {
  return t == null ? t : {
    type: t.type,
    value: t.value
  };
}
function bv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      value: t.value
    };
}
function Jc(t) {
  return Sv(t);
}
function Sv(t, e) {
  if (t == null)
    return t;
  switch (t.type) {
    case "Bool":
      return { ...Xl(t), type: "Bool" };
    case "BoolArray":
      return { ...Yl(t), type: "BoolArray" };
    case "Decimal":
      return { ...tc(t), type: "Decimal" };
    case "DecimalArray":
      return { ...Ql(t), type: "DecimalArray" };
    case "GlobalAddress":
      return { ...nc(t), type: "GlobalAddress" };
    case "GlobalAddressArray":
      return { ...ec(t), type: "GlobalAddressArray" };
    case "I32":
      return { ...rc(t), type: "I32" };
    case "I32Array":
      return { ...ac(t), type: "I32Array" };
    case "I64":
      return { ...sc(t), type: "I64" };
    case "I64Array":
      return { ...ic(t), type: "I64Array" };
    case "Instant":
      return { ...uc(t), type: "Instant" };
    case "InstantArray":
      return { ...oc(t), type: "InstantArray" };
    case "NonFungibleGlobalId":
      return { ...fc(t), type: "NonFungibleGlobalId" };
    case "NonFungibleGlobalIdArray":
      return { ...dc(t), type: "NonFungibleGlobalIdArray" };
    case "NonFungibleLocalId":
      return { ...mc(t), type: "NonFungibleLocalId" };
    case "NonFungibleLocalIdArray":
      return { ...pc(t), type: "NonFungibleLocalIdArray" };
    case "Origin":
      return { ..._c(t), type: "Origin" };
    case "OriginArray":
      return { ...yc(t), type: "OriginArray" };
    case "PublicKey":
      return { ...wc(t), type: "PublicKey" };
    case "PublicKeyArray":
      return { ...vc(t), type: "PublicKeyArray" };
    case "PublicKeyHash":
      return { ...Nc(t), type: "PublicKeyHash" };
    case "PublicKeyHashArray":
      return { ...Oc(t), type: "PublicKeyHashArray" };
    case "String":
      return { ...Ac(t), type: "String" };
    case "StringArray":
      return { ...Tc(t), type: "StringArray" };
    case "U32":
      return { ...Fc(t), type: "U32" };
    case "U32Array":
      return { ...kc(t), type: "U32Array" };
    case "U64":
      return { ...Ec(t), type: "U64" };
    case "U64Array":
      return { ...xc(t), type: "U64Array" };
    case "U8":
      return { ...Ic(t), type: "U8" };
    case "U8Array":
      return { ...Rc(t), type: "U8Array" };
    case "Url":
      return { ...Vc(t), type: "Url" };
    case "UrlArray":
      return { ...Pc(t), type: "UrlArray" };
    default:
      throw new Error(`No variant of MetadataTypedValue exists with 'type=${t.type}'`);
  }
}
function Cc(t) {
  if (t !== void 0) {
    if (t === null)
      return null;
    switch (t.type) {
      case "Bool":
        return Dh(t);
      case "BoolArray":
        return Ch(t);
      case "Decimal":
        return qh(t);
      case "DecimalArray":
        return Mh(t);
      case "GlobalAddress":
        return Uh(t);
      case "GlobalAddressArray":
        return $h(t);
      case "I32":
        return jh(t);
      case "I32Array":
        return Lh(t);
      case "I64":
        return Bh(t);
      case "I64Array":
        return Kh(t);
      case "Instant":
        return zh(t);
      case "InstantArray":
        return Zh(t);
      case "NonFungibleGlobalId":
        return Hh(t);
      case "NonFungibleGlobalIdArray":
        return Wh(t);
      case "NonFungibleLocalId":
        return Xh(t);
      case "NonFungibleLocalIdArray":
        return Yh(t);
      case "Origin":
        return tv(t);
      case "OriginArray":
        return Qh(t);
      case "PublicKey":
        return cv(t);
      case "PublicKeyArray":
        return rv(t);
      case "PublicKeyHash":
        return lv(t);
      case "PublicKeyHashArray":
        return uv(t);
      case "String":
        return fv(t);
      case "StringArray":
        return dv(t);
      case "U32":
        return mv(t);
      case "U32Array":
        return pv(t);
      case "U64":
        return _v(t);
      case "U64Array":
        return yv(t);
      case "U8":
        return hv(t);
      case "U8Array":
        return gv(t);
      case "Url":
        return bv(t);
      case "UrlArray":
        return vv(t);
      default:
        throw new Error(`No variant of MetadataTypedValue exists with 'type=${t.type}'`);
    }
  }
}
function Sx(t) {
  let e = !0;
  return e = e && "raw_hex" in t, e = e && "programmatic_json" in t, e = e && "typed" in t, e;
}
function Ov(t) {
  return Nv(t);
}
function Nv(t, e) {
  return t == null ? t : {
    raw_hex: t.raw_hex,
    programmatic_json: jt(t.programmatic_json),
    typed: Jc(t.typed)
  };
}
function wv(t) {
  if (t !== void 0)
    return t === null ? null : {
      raw_hex: t.raw_hex,
      programmatic_json: Kt(t.programmatic_json),
      typed: Cc(t.typed)
    };
}
function Ox(t) {
  let e = !0;
  return e = e && "key" in t, e = e && "value" in t, e = e && "is_locked" in t, e = e && "last_updated_at_state_version" in t, e;
}
function bs(t) {
  return Tv(t);
}
function Tv(t, e) {
  return t == null ? t : {
    key: t.key,
    value: Ov(t.value),
    is_locked: t.is_locked,
    last_updated_at_state_version: t.last_updated_at_state_version
  };
}
function Ss(t) {
  if (t !== void 0)
    return t === null ? null : {
      key: t.key,
      value: wv(t.value),
      is_locked: t.is_locked,
      last_updated_at_state_version: t.last_updated_at_state_version
    };
}
function Nx(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function xe(t) {
  return Av(t);
}
function Av(t, e) {
  return t == null ? t : {
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(bs)
  };
}
function Ee(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(Ss)
    };
}
function wx(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function Tx(t) {
  return kv(t);
}
function kv(t, e) {
  return t == null ? t : {
    items: t.items.map(bs)
  };
}
function Ax(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items.map(Ss)
    };
}
function kx(t) {
  let e = !0;
  return e = e && "typed" in t, e;
}
function Fx(t) {
  return Fv(t);
}
function Fv(t, e) {
  return t == null ? t : {
    typed: Jc(t.typed)
  };
}
function xx(t) {
  if (t !== void 0)
    return t === null ? null : {
      typed: Cc(t.typed)
    };
}
const Ex = {
  EntityNotFoundError: "EntityNotFoundError"
};
function Rx(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "address" in t, e;
}
function Ix(t) {
  return Dc(t);
}
function Dc(t, e) {
  return t == null ? t : {
    type: t.type,
    address: t.address
  };
}
function xv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      address: t.address
    };
}
const Px = {
  EntityNotFoundError: "EntityNotFoundError"
};
function Vx(t) {
  let e = !0;
  return e = e && "address" in t, e;
}
function Jx(t) {
  return Ev(t);
}
function Ev(t, e) {
  return t == null ? t : {
    address: t.address,
    type: c(t, "type") ? t.type : void 0
  };
}
function Cx(t) {
  if (t !== void 0)
    return t === null ? null : {
      address: t.address,
      type: t.type
    };
}
const Dx = {
  InternalServerError: "InternalServerError"
};
function Mx(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "exception" in t, e = e && "cause" in t, e;
}
function qx(t) {
  return Mc(t);
}
function Mc(t, e) {
  return t == null ? t : {
    type: t.type,
    exception: t.exception,
    cause: t.cause
  };
}
function Rv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      exception: t.exception,
      cause: t.cause
    };
}
const $x = {
  InvalidEntityError: "InvalidEntityError"
};
function Ux(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "address" in t, e;
}
function Lx(t) {
  return qc(t);
}
function qc(t, e) {
  return t == null ? t : {
    type: t.type,
    address: t.address
  };
}
function Iv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      address: t.address
    };
}
function jx(t) {
  let e = !0;
  return e = e && "path" in t, e = e && "errors" in t, e;
}
function $c(t) {
  return Pv(t);
}
function Pv(t, e) {
  return t == null ? t : {
    path: t.path,
    errors: t.errors
  };
}
function Uc(t) {
  if (t !== void 0)
    return t === null ? null : {
      path: t.path,
      errors: t.errors
    };
}
const Kx = {
  InvalidRequestError: "InvalidRequestError"
};
function Bx(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "validation_errors" in t, e;
}
function Zx(t) {
  return Lc(t);
}
function Lc(t, e) {
  return t == null ? t : {
    type: t.type,
    validation_errors: t.validation_errors.map($c)
  };
}
function Vv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      validation_errors: t.validation_errors.map(Uc)
    };
}
const zx = {
  InvalidTransactionError: "InvalidTransactionError"
};
function Gx(t) {
  let e = !0;
  return e = e && "type" in t, e;
}
function Wx(t) {
  return jc(t);
}
function jc(t, e) {
  return t == null ? t : {
    type: t.type
  };
}
function Jv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type
    };
}
const Hx = {
  NotSyncedUpError: "NotSyncedUpError"
};
function Yx(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "request_type" in t, e = e && "current_sync_delay_seconds" in t, e = e && "max_allowed_sync_delay_seconds" in t, e;
}
function Xx(t) {
  return Kc(t);
}
function Kc(t, e) {
  return t == null ? t : {
    type: t.type,
    request_type: t.request_type,
    current_sync_delay_seconds: t.current_sync_delay_seconds,
    max_allowed_sync_delay_seconds: t.max_allowed_sync_delay_seconds
  };
}
function Cv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      request_type: t.request_type,
      current_sync_delay_seconds: t.current_sync_delay_seconds,
      max_allowed_sync_delay_seconds: t.max_allowed_sync_delay_seconds
    };
}
const Qx = {
  TransactionNotFoundError: "TransactionNotFoundError"
};
function tE(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "intent_hash" in t, e;
}
function eE(t) {
  return Bc(t);
}
function Bc(t, e) {
  return t == null ? t : {
    type: t.type,
    intent_hash: t.intent_hash
  };
}
function Dv(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      intent_hash: t.intent_hash
    };
}
function Mv(t) {
  return qv(t);
}
function qv(t, e) {
  if (t == null)
    return t;
  switch (t.type) {
    case "EntityNotFoundError":
      return { ...Dc(t), type: "EntityNotFoundError" };
    case "InternalServerError":
      return { ...Mc(t), type: "InternalServerError" };
    case "InvalidEntityError":
      return { ...qc(t), type: "InvalidEntityError" };
    case "InvalidRequestError":
      return { ...Lc(t), type: "InvalidRequestError" };
    case "InvalidTransactionError":
      return { ...jc(t), type: "InvalidTransactionError" };
    case "NotSyncedUpError":
      return { ...Kc(t), type: "NotSyncedUpError" };
    case "TransactionNotFoundError":
      return { ...Bc(t), type: "TransactionNotFoundError" };
    default:
      throw new Error(`No variant of GatewayError exists with 'type=${t.type}'`);
  }
}
function $v(t) {
  if (t !== void 0) {
    if (t === null)
      return null;
    switch (t.type) {
      case "EntityNotFoundError":
        return xv(t);
      case "InternalServerError":
        return Rv(t);
      case "InvalidEntityError":
        return Iv(t);
      case "InvalidRequestError":
        return Vv(t);
      case "InvalidTransactionError":
        return Jv(t);
      case "NotSyncedUpError":
        return Cv(t);
      case "TransactionNotFoundError":
        return Dv(t);
      default:
        throw new Error(`No variant of GatewayError exists with 'type=${t.type}'`);
    }
  }
}
function nE(t) {
  let e = !0;
  return e = e && "message" in t, e;
}
function aE(t) {
  return Uv(t);
}
function Uv(t, e) {
  return t == null ? t : {
    message: t.message,
    code: c(t, "code") ? t.code : void 0,
    details: c(t, "details") ? Mv(t.details) : void 0,
    trace_id: c(t, "trace_id") ? t.trace_id : void 0
  };
}
function rE(t) {
  if (t !== void 0)
    return t === null ? null : {
      message: t.message,
      code: t.code,
      details: $v(t.details),
      trace_id: t.trace_id
    };
}
function iE(t) {
  return !0;
}
function sE(t) {
  return Lv(t);
}
function Lv(t, e) {
  return t == null ? t : {
    from_ledger_state: c(t, "from_ledger_state") ? pt(t.from_ledger_state) : void 0
  };
}
function oE(t) {
  if (t !== void 0)
    return t === null ? null : {
      from_ledger_state: mt(t.from_ledger_state)
    };
}
const uE = {
  Global: "Global"
};
function lE(t) {
  let e = !0;
  return e = e && "aggregation_level" in t, e = e && "resource_address" in t, e = e && "amount" in t, e = e && "last_updated_at_state_version" in t, e;
}
function cE(t) {
  return Zc(t);
}
function Zc(t, e) {
  return t == null ? t : {
    aggregation_level: t.aggregation_level,
    resource_address: t.resource_address,
    explicit_metadata: c(t, "explicit_metadata") ? xe(t.explicit_metadata) : void 0,
    amount: t.amount,
    last_updated_at_state_version: t.last_updated_at_state_version
  };
}
function jv(t) {
  if (t !== void 0)
    return t === null ? null : {
      aggregation_level: t.aggregation_level,
      resource_address: t.resource_address,
      explicit_metadata: Ee(t.explicit_metadata),
      amount: t.amount,
      last_updated_at_state_version: t.last_updated_at_state_version
    };
}
function dE(t) {
  let e = !0;
  return e = e && "vault_address" in t, e = e && "amount" in t, e = e && "last_updated_at_state_version" in t, e;
}
function ya(t) {
  return Kv(t);
}
function Kv(t, e) {
  return t == null ? t : {
    vault_address: t.vault_address,
    amount: t.amount,
    last_updated_at_state_version: t.last_updated_at_state_version
  };
}
function _a(t) {
  if (t !== void 0)
    return t === null ? null : {
      vault_address: t.vault_address,
      amount: t.amount,
      last_updated_at_state_version: t.last_updated_at_state_version
    };
}
function fE(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function zc(t) {
  return Bv(t);
}
function Bv(t, e) {
  return t == null ? t : {
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(ya)
  };
}
function Gc(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(_a)
    };
}
const pE = {
  Vault: "Vault"
};
function mE(t) {
  let e = !0;
  return e = e && "aggregation_level" in t, e = e && "resource_address" in t, e = e && "vaults" in t, e;
}
function yE(t) {
  return Wc(t);
}
function Wc(t, e) {
  return t == null ? t : {
    aggregation_level: t.aggregation_level,
    resource_address: t.resource_address,
    explicit_metadata: c(t, "explicit_metadata") ? xe(t.explicit_metadata) : void 0,
    vaults: zc(t.vaults)
  };
}
function Zv(t) {
  if (t !== void 0)
    return t === null ? null : {
      aggregation_level: t.aggregation_level,
      resource_address: t.resource_address,
      explicit_metadata: Ee(t.explicit_metadata),
      vaults: Gc(t.vaults)
    };
}
function Os(t) {
  return zv(t);
}
function zv(t, e) {
  if (t == null)
    return t;
  switch (t.aggregation_level) {
    case "Global":
      return { ...Zc(t), aggregation_level: "Global" };
    case "Vault":
      return { ...Wc(t), aggregation_level: "Vault" };
    default:
      throw new Error(`No variant of FungibleResourcesCollectionItem exists with 'aggregation_level=${t.aggregation_level}'`);
  }
}
function Ns(t) {
  if (t !== void 0) {
    if (t === null)
      return null;
    switch (t.aggregation_level) {
      case "Global":
        return jv(t);
      case "Vault":
        return Zv(t);
      default:
        throw new Error(`No variant of FungibleResourcesCollectionItem exists with 'aggregation_level=${t.aggregation_level}'`);
    }
  }
}
function _E(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function Gv(t) {
  return Wv(t);
}
function Wv(t, e) {
  return t == null ? t : {
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(Os)
  };
}
function Hv(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(Ns)
    };
}
function gE(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function hE(t) {
  return Yv(t);
}
function Yv(t, e) {
  return t == null ? t : {
    items: t.items.map(Os)
  };
}
function vE(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items.map(Ns)
    };
}
const Xv = {
  Global: "Global",
  Vault: "Vault"
};
function ze(t) {
  return Qv(t);
}
function Qv(t, e) {
  return t;
}
function bE(t) {
  return t;
}
function SE(t) {
  let e = !0;
  return e = e && "aggregation_level" in t, e = e && "resource_address" in t, e;
}
function OE(t) {
  return tb(t);
}
function tb(t, e) {
  return t == null ? t : {
    aggregation_level: ze(t.aggregation_level),
    resource_address: t.resource_address,
    explicit_metadata: c(t, "explicit_metadata") ? xe(t.explicit_metadata) : void 0
  };
}
function NE(t) {
  if (t !== void 0)
    return t === null ? null : {
      aggregation_level: t.aggregation_level,
      resource_address: t.resource_address,
      explicit_metadata: Ee(t.explicit_metadata)
    };
}
const wE = {
  Global: "Global"
};
function TE(t) {
  let e = !0;
  return e = e && "amount" in t, e = e && "last_updated_at_state_version" in t, e;
}
function AE(t) {
  return eb(t);
}
function eb(t, e) {
  return t == null ? t : {
    amount: t.amount,
    last_updated_at_state_version: t.last_updated_at_state_version,
    aggregation_level: c(t, "aggregation_level") ? t.aggregation_level : void 0
  };
}
function kE(t) {
  if (t !== void 0)
    return t === null ? null : {
      amount: t.amount,
      last_updated_at_state_version: t.last_updated_at_state_version,
      aggregation_level: t.aggregation_level
    };
}
const FE = {
  Vault: "Vault"
};
function xE(t) {
  let e = !0;
  return e = e && "vaults" in t, e;
}
function EE(t) {
  return nb(t);
}
function nb(t, e) {
  return t == null ? t : {
    vaults: zc(t.vaults),
    aggregation_level: c(t, "aggregation_level") ? t.aggregation_level : void 0
  };
}
function RE(t) {
  if (t !== void 0)
    return t === null ? null : {
      vaults: Gc(t.vaults),
      aggregation_level: t.aggregation_level
    };
}
function IE(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function PE(t) {
  return ab(t);
}
function ab(t, e) {
  return t == null ? t : {
    items: t.items.map(ya)
  };
}
function VE(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items.map(_a)
    };
}
function JE(t) {
  let e = !0;
  return e = e && "type" in t, e;
}
function CE(t) {
  return rb(t);
}
function rb(t, e) {
  return t == null ? t : {
    type: t.type
  };
}
function DE(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type
    };
}
function ME(t) {
  let e = !0;
  return e = e && "state_version" in t, e;
}
function qE(t) {
  return ib(t);
}
function ib(t, e) {
  return t == null ? t : {
    state_version: t.state_version
  };
}
function $E(t) {
  if (t !== void 0)
    return t === null ? null : {
      state_version: t.state_version
    };
}
function UE(t) {
  let e = !0;
  return e = e && "release_version" in t, e = e && "open_api_schema_version" in t, e = e && "image_tag" in t, e;
}
function Hc(t) {
  return sb(t);
}
function sb(t, e) {
  return t == null ? t : {
    release_version: t.release_version,
    open_api_schema_version: t.open_api_schema_version,
    image_tag: t.image_tag
  };
}
function Yc(t) {
  if (t !== void 0)
    return t === null ? null : {
      release_version: t.release_version,
      open_api_schema_version: t.open_api_schema_version,
      image_tag: t.image_tag
    };
}
function LE(t) {
  let e = !0;
  return e = e && "network" in t, e = e && "state_version" in t, e = e && "proposer_round_timestamp" in t, e = e && "epoch" in t, e = e && "round" in t, e;
}
function yt(t) {
  return ob(t);
}
function ob(t, e) {
  return t == null ? t : {
    network: t.network,
    state_version: t.state_version,
    proposer_round_timestamp: t.proposer_round_timestamp,
    epoch: t.epoch,
    round: t.round
  };
}
function _t(t) {
  if (t !== void 0)
    return t === null ? null : {
      network: t.network,
      state_version: t.state_version,
      proposer_round_timestamp: t.proposer_round_timestamp,
      epoch: t.epoch,
      round: t.round
    };
}
function jE(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "release_info" in t, e;
}
function ub(t) {
  return lb(t);
}
function lb(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    release_info: Hc(t.release_info)
  };
}
function KE(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      release_info: Yc(t.release_info)
    };
}
function BE(t) {
  let e = !0;
  return e = e && "release_info" in t, e;
}
function ZE(t) {
  return cb(t);
}
function cb(t, e) {
  return t == null ? t : {
    release_info: Hc(t.release_info)
  };
}
function zE(t) {
  if (t !== void 0)
    return t === null ? null : {
      release_info: Yc(t.release_info)
    };
}
const GE = {
  InternalServerError: "InternalServerError"
};
function WE(t) {
  let e = !0;
  return e = e && "exception" in t, e = e && "cause" in t, e;
}
function HE(t) {
  return db(t);
}
function db(t, e) {
  return t == null ? t : {
    exception: t.exception,
    cause: t.cause,
    type: c(t, "type") ? t.type : void 0
  };
}
function YE(t) {
  if (t !== void 0)
    return t === null ? null : {
      exception: t.exception,
      cause: t.cause,
      type: t.type
    };
}
const XE = {
  InvalidEntityError: "InvalidEntityError"
};
function QE(t) {
  let e = !0;
  return e = e && "address" in t, e;
}
function tR(t) {
  return fb(t);
}
function fb(t, e) {
  return t == null ? t : {
    address: t.address,
    type: c(t, "type") ? t.type : void 0
  };
}
function eR(t) {
  if (t !== void 0)
    return t === null ? null : {
      address: t.address,
      type: t.type
    };
}
const nR = {
  InvalidRequestError: "InvalidRequestError"
};
function aR(t) {
  let e = !0;
  return e = e && "validation_errors" in t, e;
}
function rR(t) {
  return pb(t);
}
function pb(t, e) {
  return t == null ? t : {
    validation_errors: t.validation_errors.map($c),
    type: c(t, "type") ? t.type : void 0
  };
}
function iR(t) {
  if (t !== void 0)
    return t === null ? null : {
      validation_errors: t.validation_errors.map(Uc),
      type: t.type
    };
}
const sR = {
  InvalidTransactionError: "InvalidTransactionError"
};
function oR(t) {
  return !0;
}
function uR(t) {
  return mb(t);
}
function mb(t, e) {
  return t == null ? t : {
    type: c(t, "type") ? t.type : void 0
  };
}
function lR(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type
    };
}
function cR(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e;
}
function dR(t) {
  return yb(t);
}
function yb(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state)
  };
}
function fR(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state)
    };
}
const pR = {
  BoolArray: "BoolArray"
};
function mR(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function yR(t) {
  return _b(t);
}
function _b(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function _R(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const gR = {
  Bool: "Bool"
};
function hR(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function vR(t) {
  return gb(t);
}
function gb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function bR(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const SR = {
  DecimalArray: "DecimalArray"
};
function OR(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function NR(t) {
  return hb(t);
}
function hb(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function wR(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const TR = {
  Decimal: "Decimal"
};
function AR(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function kR(t) {
  return vb(t);
}
function vb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function FR(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const xR = {
  GlobalAddressArray: "GlobalAddressArray"
};
function ER(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function RR(t) {
  return bb(t);
}
function bb(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function IR(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const PR = {
  GlobalAddress: "GlobalAddress"
};
function VR(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function JR(t) {
  return Sb(t);
}
function Sb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function CR(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const DR = {
  I32Array: "I32Array"
};
function MR(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function qR(t) {
  return Ob(t);
}
function Ob(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function $R(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const UR = {
  I32: "I32"
};
function LR(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function jR(t) {
  return Nb(t);
}
function Nb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function KR(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const BR = {
  I64Array: "I64Array"
};
function ZR(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function zR(t) {
  return wb(t);
}
function wb(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function GR(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const WR = {
  I64: "I64"
};
function HR(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function YR(t) {
  return Tb(t);
}
function Tb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function XR(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const QR = {
  InstantArray: "InstantArray"
};
function tI(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function eI(t) {
  return Ab(t);
}
function Ab(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function nI(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const aI = {
  Instant: "Instant"
};
function rI(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function iI(t) {
  return kb(t);
}
function kb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function sI(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const oI = {
  NonFungibleGlobalIdArray: "NonFungibleGlobalIdArray"
};
function uI(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function lI(t) {
  return Fb(t);
}
function Fb(t, e) {
  return t == null ? t : {
    values: t.values.map(lc),
    type: c(t, "type") ? t.type : void 0
  };
}
function cI(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values.map(cc),
      type: t.type
    };
}
const dI = {
  NonFungibleGlobalId: "NonFungibleGlobalId"
};
function fI(t) {
  let e = !0;
  return e = e && "resource_address" in t, e = e && "non_fungible_id" in t, e;
}
function pI(t) {
  return xb(t);
}
function xb(t, e) {
  return t == null ? t : {
    resource_address: t.resource_address,
    non_fungible_id: t.non_fungible_id,
    type: c(t, "type") ? t.type : void 0
  };
}
function mI(t) {
  if (t !== void 0)
    return t === null ? null : {
      resource_address: t.resource_address,
      non_fungible_id: t.non_fungible_id,
      type: t.type
    };
}
const yI = {
  NonFungibleLocalIdArray: "NonFungibleLocalIdArray"
};
function _I(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function gI(t) {
  return Eb(t);
}
function Eb(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function hI(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const vI = {
  NonFungibleLocalId: "NonFungibleLocalId"
};
function bI(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function SI(t) {
  return Rb(t);
}
function Rb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function OI(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const NI = {
  OriginArray: "OriginArray"
};
function wI(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function TI(t) {
  return Ib(t);
}
function Ib(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function AI(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const kI = {
  Origin: "Origin"
};
function FI(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function xI(t) {
  return Pb(t);
}
function Pb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function EI(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const RI = {
  PublicKeyArray: "PublicKeyArray"
};
function II(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function PI(t) {
  return Vb(t);
}
function Vb(t, e) {
  return t == null ? t : {
    values: t.values.map(gn),
    type: c(t, "type") ? t.type : void 0
  };
}
function VI(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values.map(hn),
      type: t.type
    };
}
const JI = {
  PublicKeyHashArray: "PublicKeyHashArray"
};
function CI(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function DI(t) {
  return Jb(t);
}
function Jb(t, e) {
  return t == null ? t : {
    values: t.values.map(Tr),
    type: c(t, "type") ? t.type : void 0
  };
}
function MI(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values.map(Ar),
      type: t.type
    };
}
const qI = {
  PublicKeyHash: "PublicKeyHash"
};
function $I(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function UI(t) {
  return Cb(t);
}
function Cb(t, e) {
  return t == null ? t : {
    value: Tr(t.value),
    type: c(t, "type") ? t.type : void 0
  };
}
function LI(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: Ar(t.value),
      type: t.type
    };
}
const jI = {
  PublicKey: "PublicKey"
};
function KI(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function BI(t) {
  return Db(t);
}
function Db(t, e) {
  return t == null ? t : {
    value: gn(t.value),
    type: c(t, "type") ? t.type : void 0
  };
}
function ZI(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: hn(t.value),
      type: t.type
    };
}
const zI = {
  StringArray: "StringArray"
};
function GI(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function WI(t) {
  return Mb(t);
}
function Mb(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function HI(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const YI = {
  String: "String"
};
function XI(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function QI(t) {
  return qb(t);
}
function qb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function tP(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const eP = {
  String: "String",
  Bool: "Bool",
  U8: "U8",
  U32: "U32",
  U64: "U64",
  I32: "I32",
  I64: "I64",
  Decimal: "Decimal",
  GlobalAddress: "GlobalAddress",
  PublicKey: "PublicKey",
  NonFungibleGlobalId: "NonFungibleGlobalId",
  NonFungibleLocalId: "NonFungibleLocalId",
  Instant: "Instant",
  Url: "Url",
  Origin: "Origin",
  PublicKeyHash: "PublicKeyHash",
  StringArray: "StringArray",
  BoolArray: "BoolArray",
  U8Array: "U8Array",
  U32Array: "U32Array",
  U64Array: "U64Array",
  I32Array: "I32Array",
  I64Array: "I64Array",
  DecimalArray: "DecimalArray",
  GlobalAddressArray: "GlobalAddressArray",
  PublicKeyArray: "PublicKeyArray",
  NonFungibleGlobalIdArray: "NonFungibleGlobalIdArray",
  NonFungibleLocalIdArray: "NonFungibleLocalIdArray",
  InstantArray: "InstantArray",
  UrlArray: "UrlArray",
  OriginArray: "OriginArray",
  PublicKeyHashArray: "PublicKeyHashArray"
};
function $b(t) {
  return Ub(t);
}
function Ub(t, e) {
  return t;
}
function nP(t) {
  return t;
}
function aP(t) {
  let e = !0;
  return e = e && "type" in t, e;
}
function rP(t) {
  return Lb(t);
}
function Lb(t, e) {
  return t == null ? t : {
    type: $b(t.type)
  };
}
function iP(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type
    };
}
const sP = {
  U32Array: "U32Array"
};
function oP(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function uP(t) {
  return jb(t);
}
function jb(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function lP(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const cP = {
  U32: "U32"
};
function dP(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function fP(t) {
  return Kb(t);
}
function Kb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function pP(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const mP = {
  U64Array: "U64Array"
};
function yP(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function _P(t) {
  return Bb(t);
}
function Bb(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function gP(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const hP = {
  U64: "U64"
};
function vP(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function bP(t) {
  return Zb(t);
}
function Zb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function SP(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const OP = {
  U8Array: "U8Array"
};
function NP(t) {
  let e = !0;
  return e = e && "value_hex" in t, e;
}
function wP(t) {
  return zb(t);
}
function zb(t, e) {
  return t == null ? t : {
    value_hex: t.value_hex,
    type: c(t, "type") ? t.type : void 0
  };
}
function TP(t) {
  if (t !== void 0)
    return t === null ? null : {
      value_hex: t.value_hex,
      type: t.type
    };
}
const AP = {
  U8: "U8"
};
function kP(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function FP(t) {
  return Gb(t);
}
function Gb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function xP(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
const EP = {
  UrlArray: "UrlArray"
};
function RP(t) {
  let e = !0;
  return e = e && "values" in t, e;
}
function IP(t) {
  return Wb(t);
}
function Wb(t, e) {
  return t == null ? t : {
    values: t.values,
    type: c(t, "type") ? t.type : void 0
  };
}
function PP(t) {
  if (t !== void 0)
    return t === null ? null : {
      values: t.values,
      type: t.type
    };
}
const VP = {
  Url: "Url"
};
function JP(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function CP(t) {
  return Hb(t);
}
function Hb(t, e) {
  return t == null ? t : {
    value: t.value,
    type: c(t, "type") ? t.type : void 0
  };
}
function DP(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      type: t.type
    };
}
function MP(t) {
  let e = !0;
  return e = e && "xrd" in t, e = e && "secp256k1_signature_virtual_badge" in t, e = e && "ed25519_signature_virtual_badge" in t, e = e && "package_of_direct_caller_virtual_badge" in t, e = e && "global_caller_virtual_badge" in t, e = e && "system_transaction_badge" in t, e = e && "package_owner_badge" in t, e = e && "validator_owner_badge" in t, e = e && "account_owner_badge" in t, e = e && "identity_owner_badge" in t, e = e && "package_package" in t, e = e && "resource_package" in t, e = e && "account_package" in t, e = e && "identity_package" in t, e = e && "consensus_manager_package" in t, e = e && "access_controller_package" in t, e = e && "transaction_processor_package" in t, e = e && "metadata_module_package" in t, e = e && "royalty_module_package" in t, e = e && "access_rules_package" in t, e = e && "genesis_helper_package" in t, e = e && "faucet_package" in t, e = e && "consensus_manager" in t, e = e && "genesis_helper" in t, e = e && "faucet" in t, e = e && "pool_package" in t, e;
}
function Yb(t) {
  return Xb(t);
}
function Xb(t, e) {
  return t == null ? t : {
    xrd: t.xrd,
    secp256k1_signature_virtual_badge: t.secp256k1_signature_virtual_badge,
    ed25519_signature_virtual_badge: t.ed25519_signature_virtual_badge,
    package_of_direct_caller_virtual_badge: t.package_of_direct_caller_virtual_badge,
    global_caller_virtual_badge: t.global_caller_virtual_badge,
    system_transaction_badge: t.system_transaction_badge,
    package_owner_badge: t.package_owner_badge,
    validator_owner_badge: t.validator_owner_badge,
    account_owner_badge: t.account_owner_badge,
    identity_owner_badge: t.identity_owner_badge,
    package_package: t.package_package,
    resource_package: t.resource_package,
    account_package: t.account_package,
    identity_package: t.identity_package,
    consensus_manager_package: t.consensus_manager_package,
    access_controller_package: t.access_controller_package,
    transaction_processor_package: t.transaction_processor_package,
    metadata_module_package: t.metadata_module_package,
    royalty_module_package: t.royalty_module_package,
    access_rules_package: t.access_rules_package,
    genesis_helper_package: t.genesis_helper_package,
    faucet_package: t.faucet_package,
    consensus_manager: t.consensus_manager,
    genesis_helper: t.genesis_helper,
    faucet: t.faucet,
    pool_package: t.pool_package
  };
}
function Qb(t) {
  if (t !== void 0)
    return t === null ? null : {
      xrd: t.xrd,
      secp256k1_signature_virtual_badge: t.secp256k1_signature_virtual_badge,
      ed25519_signature_virtual_badge: t.ed25519_signature_virtual_badge,
      package_of_direct_caller_virtual_badge: t.package_of_direct_caller_virtual_badge,
      global_caller_virtual_badge: t.global_caller_virtual_badge,
      system_transaction_badge: t.system_transaction_badge,
      package_owner_badge: t.package_owner_badge,
      validator_owner_badge: t.validator_owner_badge,
      account_owner_badge: t.account_owner_badge,
      identity_owner_badge: t.identity_owner_badge,
      package_package: t.package_package,
      resource_package: t.resource_package,
      account_package: t.account_package,
      identity_package: t.identity_package,
      consensus_manager_package: t.consensus_manager_package,
      access_controller_package: t.access_controller_package,
      transaction_processor_package: t.transaction_processor_package,
      metadata_module_package: t.metadata_module_package,
      royalty_module_package: t.royalty_module_package,
      access_rules_package: t.access_rules_package,
      genesis_helper_package: t.genesis_helper_package,
      faucet_package: t.faucet_package,
      consensus_manager: t.consensus_manager,
      genesis_helper: t.genesis_helper,
      faucet: t.faucet,
      pool_package: t.pool_package
    };
}
function qP(t) {
  let e = !0;
  return e = e && "network_id" in t, e = e && "network_name" in t, e = e && "well_known_addresses" in t, e;
}
function tS(t) {
  return eS(t);
}
function eS(t, e) {
  return t == null ? t : {
    network_id: t.network_id,
    network_name: t.network_name,
    well_known_addresses: Yb(t.well_known_addresses)
  };
}
function $P(t) {
  if (t !== void 0)
    return t === null ? null : {
      network_id: t.network_id,
      network_name: t.network_name,
      well_known_addresses: Qb(t.well_known_addresses)
    };
}
const UP = {
  String: "String",
  Integer: "Integer",
  Bytes: "Bytes",
  Ruid: "Ruid"
};
function kr(t) {
  return nS(t);
}
function nS(t, e) {
  return t;
}
function LP(t) {
  return t;
}
function jP(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function Xc(t) {
  return aS(t);
}
function aS(t, e) {
  return t == null ? t : {
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items
  };
}
function Qc(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items
    };
}
function KP(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function BP(t) {
  return rS(t);
}
function rS(t, e) {
  return t == null ? t : {
    items: t.items
  };
}
function ZP(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items
    };
}
const zP = {
  Global: "Global"
};
function GP(t) {
  let e = !0;
  return e = e && "aggregation_level" in t, e = e && "resource_address" in t, e = e && "amount" in t, e = e && "last_updated_at_state_version" in t, e;
}
function WP(t) {
  return td(t);
}
function td(t, e) {
  return t == null ? t : {
    aggregation_level: t.aggregation_level,
    resource_address: t.resource_address,
    explicit_metadata: c(t, "explicit_metadata") ? xe(t.explicit_metadata) : void 0,
    amount: t.amount,
    last_updated_at_state_version: t.last_updated_at_state_version
  };
}
function iS(t) {
  if (t !== void 0)
    return t === null ? null : {
      aggregation_level: t.aggregation_level,
      resource_address: t.resource_address,
      explicit_metadata: Ee(t.explicit_metadata),
      amount: t.amount,
      last_updated_at_state_version: t.last_updated_at_state_version
    };
}
function HP(t) {
  let e = !0;
  return e = e && "total_count" in t, e = e && "vault_address" in t, e = e && "last_updated_at_state_version" in t, e;
}
function ga(t) {
  return sS(t);
}
function sS(t, e) {
  return t == null ? t : {
    total_count: t.total_count,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: c(t, "items") ? t.items : void 0,
    vault_address: t.vault_address,
    last_updated_at_state_version: t.last_updated_at_state_version
  };
}
function ha(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items,
      vault_address: t.vault_address,
      last_updated_at_state_version: t.last_updated_at_state_version
    };
}
function YP(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function ed(t) {
  return oS(t);
}
function oS(t, e) {
  return t == null ? t : {
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(ga)
  };
}
function nd(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(ha)
    };
}
const XP = {
  Vault: "Vault"
};
function QP(t) {
  let e = !0;
  return e = e && "aggregation_level" in t, e = e && "resource_address" in t, e = e && "vaults" in t, e;
}
function tV(t) {
  return ad(t);
}
function ad(t, e) {
  return t == null ? t : {
    aggregation_level: t.aggregation_level,
    resource_address: t.resource_address,
    explicit_metadata: c(t, "explicit_metadata") ? xe(t.explicit_metadata) : void 0,
    vaults: ed(t.vaults)
  };
}
function uS(t) {
  if (t !== void 0)
    return t === null ? null : {
      aggregation_level: t.aggregation_level,
      resource_address: t.resource_address,
      explicit_metadata: Ee(t.explicit_metadata),
      vaults: nd(t.vaults)
    };
}
function ws(t) {
  return lS(t);
}
function lS(t, e) {
  if (t == null)
    return t;
  switch (t.aggregation_level) {
    case "Global":
      return { ...td(t), aggregation_level: "Global" };
    case "Vault":
      return { ...ad(t), aggregation_level: "Vault" };
    default:
      throw new Error(`No variant of NonFungibleResourcesCollectionItem exists with 'aggregation_level=${t.aggregation_level}'`);
  }
}
function Ts(t) {
  if (t !== void 0) {
    if (t === null)
      return null;
    switch (t.aggregation_level) {
      case "Global":
        return iS(t);
      case "Vault":
        return uS(t);
      default:
        throw new Error(`No variant of NonFungibleResourcesCollectionItem exists with 'aggregation_level=${t.aggregation_level}'`);
    }
  }
}
function eV(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function cS(t) {
  return dS(t);
}
function dS(t, e) {
  return t == null ? t : {
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(ws)
  };
}
function fS(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(Ts)
    };
}
function nV(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function aV(t) {
  return pS(t);
}
function pS(t, e) {
  return t == null ? t : {
    items: t.items.map(ws)
  };
}
function rV(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items.map(Ts)
    };
}
function iV(t) {
  let e = !0;
  return e = e && "aggregation_level" in t, e = e && "resource_address" in t, e;
}
function sV(t) {
  return mS(t);
}
function mS(t, e) {
  return t == null ? t : {
    aggregation_level: ze(t.aggregation_level),
    resource_address: t.resource_address,
    explicit_metadata: c(t, "explicit_metadata") ? xe(t.explicit_metadata) : void 0
  };
}
function oV(t) {
  if (t !== void 0)
    return t === null ? null : {
      aggregation_level: t.aggregation_level,
      resource_address: t.resource_address,
      explicit_metadata: Ee(t.explicit_metadata)
    };
}
const uV = {
  Global: "Global"
};
function lV(t) {
  let e = !0;
  return e = e && "amount" in t, e = e && "last_updated_at_state_version" in t, e;
}
function cV(t) {
  return yS(t);
}
function yS(t, e) {
  return t == null ? t : {
    amount: t.amount,
    last_updated_at_state_version: t.last_updated_at_state_version,
    aggregation_level: c(t, "aggregation_level") ? t.aggregation_level : void 0
  };
}
function dV(t) {
  if (t !== void 0)
    return t === null ? null : {
      amount: t.amount,
      last_updated_at_state_version: t.last_updated_at_state_version,
      aggregation_level: t.aggregation_level
    };
}
const fV = {
  Vault: "Vault"
};
function pV(t) {
  let e = !0;
  return e = e && "vaults" in t, e;
}
function mV(t) {
  return _S(t);
}
function _S(t, e) {
  return t == null ? t : {
    vaults: ed(t.vaults),
    aggregation_level: c(t, "aggregation_level") ? t.aggregation_level : void 0
  };
}
function yV(t) {
  if (t !== void 0)
    return t === null ? null : {
      vaults: nd(t.vaults),
      aggregation_level: t.aggregation_level
    };
}
function _V(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function gV(t) {
  return gS(t);
}
function gS(t, e) {
  return t == null ? t : {
    items: t.items.map(ga)
  };
}
function hV(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items.map(ha)
    };
}
function vV(t) {
  let e = !0;
  return e = e && "vault_address" in t, e = e && "total_count" in t, e = e && "last_updated_at_state_version" in t, e;
}
function bV(t) {
  return hS(t);
}
function hS(t, e) {
  return t == null ? t : {
    vault_address: t.vault_address,
    total_count: t.total_count,
    last_updated_at_state_version: t.last_updated_at_state_version
  };
}
function SV(t) {
  if (t !== void 0)
    return t === null ? null : {
      vault_address: t.vault_address,
      total_count: t.total_count,
      last_updated_at_state_version: t.last_updated_at_state_version
    };
}
const OV = {
  NotSyncedUpError: "NotSyncedUpError"
};
function NV(t) {
  let e = !0;
  return e = e && "request_type" in t, e = e && "current_sync_delay_seconds" in t, e = e && "max_allowed_sync_delay_seconds" in t, e;
}
function wV(t) {
  return vS(t);
}
function vS(t, e) {
  return t == null ? t : {
    request_type: t.request_type,
    current_sync_delay_seconds: t.current_sync_delay_seconds,
    max_allowed_sync_delay_seconds: t.max_allowed_sync_delay_seconds,
    type: c(t, "type") ? t.type : void 0
  };
}
function TV(t) {
  if (t !== void 0)
    return t === null ? null : {
      request_type: t.request_type,
      current_sync_delay_seconds: t.current_sync_delay_seconds,
      max_allowed_sync_delay_seconds: t.max_allowed_sync_delay_seconds,
      type: t.type
    };
}
function AV(t) {
  return !0;
}
function kV(t) {
  return bS(t);
}
function bS(t, e) {
  return t == null ? t : {
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: c(t, "items") ? t.items : void 0
  };
}
function FV(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items
    };
}
function xV(t) {
  return !0;
}
function EV(t) {
  return SS(t);
}
function SS(t, e) {
  return t == null ? t : {
    items: c(t, "items") ? t.items : void 0
  };
}
function RV(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items
    };
}
const IV = {
  Native: "Native",
  ScryptoV1: "ScryptoV1"
};
function rd(t) {
  return OS(t);
}
function OS(t, e) {
  return t;
}
function PV(t) {
  return t;
}
const VV = {
  Array: "Array"
};
function JV(t) {
  let e = !0;
  return e = e && "element_kind" in t, e = e && "elements" in t, e;
}
function CV(t) {
  return NS(t);
}
function NS(t, e) {
  return t == null ? t : {
    element_kind: Fe(t.element_kind),
    element_type_name: c(t, "element_type_name") ? t.element_type_name : void 0,
    elements: t.elements.map(jt),
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function DV(t) {
  if (t !== void 0)
    return t === null ? null : {
      element_kind: t.element_kind,
      element_type_name: t.element_type_name,
      elements: t.elements.map(Kt),
      kind: t.kind
    };
}
function MV(t) {
  let e = !0;
  return e = e && "kind" in t, e;
}
function qV(t) {
  return wS(t);
}
function wS(t, e) {
  return t == null ? t : {
    kind: Fe(t.kind),
    type_name: c(t, "type_name") ? t.type_name : void 0,
    field_name: c(t, "field_name") ? t.field_name : void 0
  };
}
function $V(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind: t.kind,
      type_name: t.type_name,
      field_name: t.field_name
    };
}
const UV = {
  Bool: "Bool"
};
function LV(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function jV(t) {
  return TS(t);
}
function TS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function KV(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const BV = {
  Bytes: "Bytes"
};
function ZV(t) {
  let e = !0;
  return e = e && "element_kind" in t, e = e && "hex" in t, e;
}
function zV(t) {
  return AS(t);
}
function AS(t, e) {
  return t == null ? t : {
    element_kind: Fe(t.element_kind),
    element_type_name: c(t, "element_type_name") ? t.element_type_name : void 0,
    hex: t.hex,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function GV(t) {
  if (t !== void 0)
    return t === null ? null : {
      element_kind: t.element_kind,
      element_type_name: t.element_type_name,
      hex: t.hex,
      kind: t.kind
    };
}
const WV = {
  Decimal: "Decimal"
};
function HV(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function YV(t) {
  return kS(t);
}
function kS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function XV(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const QV = {
  Enum: "Enum"
};
function tJ(t) {
  let e = !0;
  return e = e && "variant_id" in t, e = e && "fields" in t, e;
}
function eJ(t) {
  return FS(t);
}
function FS(t, e) {
  return t == null ? t : {
    variant_id: t.variant_id,
    variant_name: c(t, "variant_name") ? t.variant_name : void 0,
    fields: t.fields.map(jt),
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function nJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      variant_id: t.variant_id,
      variant_name: t.variant_name,
      fields: t.fields.map(Kt),
      kind: t.kind
    };
}
const aJ = {
  I128: "I128"
};
function rJ(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function iJ(t) {
  return xS(t);
}
function xS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function sJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const oJ = {
  I16: "I16"
};
function uJ(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function lJ(t) {
  return ES(t);
}
function ES(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function cJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const dJ = {
  I32: "I32"
};
function fJ(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function pJ(t) {
  return RS(t);
}
function RS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function mJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const yJ = {
  I64: "I64"
};
function _J(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function gJ(t) {
  return IS(t);
}
function IS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function hJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const vJ = {
  I8: "I8"
};
function bJ(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function SJ(t) {
  return PS(t);
}
function PS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function OJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const NJ = {
  Map: "Map"
};
function wJ(t) {
  let e = !0;
  return e = e && "key_kind" in t, e = e && "value_kind" in t, e = e && "entries" in t, e;
}
function TJ(t) {
  return VS(t);
}
function VS(t, e) {
  return t == null ? t : {
    key_kind: Fe(t.key_kind),
    key_type_name: c(t, "key_type_name") ? t.key_type_name : void 0,
    value_kind: Fe(t.value_kind),
    value_type_name: c(t, "value_type_name") ? t.value_type_name : void 0,
    entries: t.entries.map(Dl),
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function AJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_kind: t.key_kind,
      key_type_name: t.key_type_name,
      value_kind: t.value_kind,
      value_type_name: t.value_type_name,
      entries: t.entries.map(Ml),
      kind: t.kind
    };
}
const kJ = {
  NonFungibleLocalId: "NonFungibleLocalId"
};
function FJ(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function xJ(t) {
  return JS(t);
}
function JS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function EJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const RJ = {
  Own: "Own"
};
function IJ(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function PJ(t) {
  return CS(t);
}
function CS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function VJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const JJ = {
  PreciseDecimal: "PreciseDecimal"
};
function CJ(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function DJ(t) {
  return DS(t);
}
function DS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function MJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const qJ = {
  Reference: "Reference"
};
function $J(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function UJ(t) {
  return MS(t);
}
function MS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function LJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const jJ = {
  String: "String"
};
function KJ(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function BJ(t) {
  return qS(t);
}
function qS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function ZJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const zJ = {
  Tuple: "Tuple"
};
function GJ(t) {
  let e = !0;
  return e = e && "fields" in t, e;
}
function WJ(t) {
  return $S(t);
}
function $S(t, e) {
  return t == null ? t : {
    fields: t.fields.map(jt),
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function HJ(t) {
  if (t !== void 0)
    return t === null ? null : {
      fields: t.fields.map(Kt),
      kind: t.kind
    };
}
const YJ = {
  U128: "U128"
};
function XJ(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function QJ(t) {
  return US(t);
}
function US(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function t1(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const e1 = {
  U16: "U16"
};
function n1(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function a1(t) {
  return LS(t);
}
function LS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function r1(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const i1 = {
  U32: "U32"
};
function s1(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function o1(t) {
  return jS(t);
}
function jS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function u1(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const l1 = {
  U64: "U64"
};
function c1(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function d1(t) {
  return KS(t);
}
function KS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function f1(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const p1 = {
  U8: "U8"
};
function m1(t) {
  let e = !0;
  return e = e && "value" in t, e;
}
function y1(t) {
  return BS(t);
}
function BS(t, e) {
  return t == null ? t : {
    value: t.value,
    kind: c(t, "kind") ? t.kind : void 0
  };
}
function _1(t) {
  if (t !== void 0)
    return t === null ? null : {
      value: t.value,
      kind: t.kind
    };
}
const g1 = {
  EcdsaSecp256k1: "EcdsaSecp256k1",
  EddsaEd25519: "EddsaEd25519"
};
function ZS(t) {
  return zS(t);
}
function zS(t, e) {
  return t;
}
function h1(t) {
  return t;
}
function v1(t) {
  let e = !0;
  return e = e && "key_type" in t, e;
}
function b1(t) {
  return GS(t);
}
function GS(t, e) {
  return t == null ? t : {
    key_type: ZS(t.key_type)
  };
}
function S1(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_type: t.key_type
    };
}
const O1 = {
  EcdsaSecp256k1: "EcdsaSecp256k1"
};
function N1(t) {
  let e = !0;
  return e = e && "key_hex" in t, e;
}
function w1(t) {
  return WS(t);
}
function WS(t, e) {
  return t == null ? t : {
    key_hex: t.key_hex,
    key_type: c(t, "key_type") ? t.key_type : void 0
  };
}
function T1(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_hex: t.key_hex,
      key_type: t.key_type
    };
}
const A1 = {
  EddsaEd25519: "EddsaEd25519"
};
function k1(t) {
  let e = !0;
  return e = e && "key_hex" in t, e;
}
function F1(t) {
  return HS(t);
}
function HS(t, e) {
  return t == null ? t : {
    key_hex: t.key_hex,
    key_type: c(t, "key_type") ? t.key_type : void 0
  };
}
function x1(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_hex: t.key_hex,
      key_type: t.key_type
    };
}
const E1 = {
  EcdsaSecp256k1: "EcdsaSecp256k1",
  EddsaEd25519: "EddsaEd25519"
};
function YS(t) {
  return XS(t);
}
function XS(t, e) {
  return t;
}
function R1(t) {
  return t;
}
function I1(t) {
  let e = !0;
  return e = e && "key_hash_type" in t, e;
}
function P1(t) {
  return QS(t);
}
function QS(t, e) {
  return t == null ? t : {
    key_hash_type: YS(t.key_hash_type)
  };
}
function V1(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_hash_type: t.key_hash_type
    };
}
const J1 = {
  EcdsaSecp256k1: "EcdsaSecp256k1"
};
function C1(t) {
  let e = !0;
  return e = e && "hash_hex" in t, e;
}
function D1(t) {
  return tO(t);
}
function tO(t, e) {
  return t == null ? t : {
    hash_hex: t.hash_hex,
    key_hash_type: c(t, "key_hash_type") ? t.key_hash_type : void 0
  };
}
function M1(t) {
  if (t !== void 0)
    return t === null ? null : {
      hash_hex: t.hash_hex,
      key_hash_type: t.key_hash_type
    };
}
const q1 = {
  EddsaEd25519: "EddsaEd25519"
};
function $1(t) {
  let e = !0;
  return e = e && "hash_hex" in t, e;
}
function U1(t) {
  return eO(t);
}
function eO(t, e) {
  return t == null ? t : {
    hash_hex: t.hash_hex,
    key_hash_type: c(t, "key_hash_type") ? t.key_hash_type : void 0
  };
}
function L1(t) {
  if (t !== void 0)
    return t === null ? null : {
      hash_hex: t.hash_hex,
      key_hash_type: t.key_hash_type
    };
}
function j1(t) {
  return !0;
}
function K1(t) {
  return nO(t);
}
function nO(t, e) {
  return t == null ? t : {
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0
  };
}
function B1(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor
    };
}
function Z1(t) {
  let e = !0;
  return e = e && "raw_hex" in t, e = e && "programmatic_json" in t, e;
}
function Qi(t) {
  return aO(t);
}
function aO(t, e) {
  return t == null ? t : {
    raw_hex: t.raw_hex,
    programmatic_json: jt(t.programmatic_json)
  };
}
function ts(t) {
  if (t !== void 0)
    return t === null ? null : {
      raw_hex: t.raw_hex,
      programmatic_json: Kt(t.programmatic_json)
    };
}
function z1(t) {
  return !0;
}
function id(t) {
  return rO(t);
}
function rO(t, e) {
  return t == null ? t : {
    ancestor_identities: c(t, "ancestor_identities") ? t.ancestor_identities : void 0,
    component_royalty_vault_balance: c(t, "component_royalty_vault_balance") ? t.component_royalty_vault_balance : void 0,
    package_royalty_vault_balance: c(t, "package_royalty_vault_balance") ? t.package_royalty_vault_balance : void 0,
    non_fungible_include_nfids: c(t, "non_fungible_include_nfids") ? t.non_fungible_include_nfids : void 0,
    explicit_metadata: c(t, "explicit_metadata") ? t.explicit_metadata : void 0
  };
}
function sd(t) {
  if (t !== void 0)
    return t === null ? null : {
      ancestor_identities: t.ancestor_identities,
      component_royalty_vault_balance: t.component_royalty_vault_balance,
      package_royalty_vault_balance: t.package_royalty_vault_balance,
      non_fungible_include_nfids: t.non_fungible_include_nfids,
      explicit_metadata: t.explicit_metadata
    };
}
function G1(t) {
  let e = !0;
  return e = e && "addresses" in t, e;
}
function W1(t) {
  return iO(t);
}
function iO(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    opt_ins: c(t, "opt_ins") ? id(t.opt_ins) : void 0,
    addresses: t.addresses,
    aggregation_level: c(t, "aggregation_level") ? ze(t.aggregation_level) : void 0
  };
}
function sO(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      opt_ins: sd(t.opt_ins),
      addresses: t.addresses,
      aggregation_level: t.aggregation_level
    };
}
function H1(t) {
  let e = !0;
  return e = e && "addresses" in t, e;
}
function Y1(t) {
  return oO(t);
}
function oO(t, e) {
  return t == null ? t : {
    opt_ins: c(t, "opt_ins") ? id(t.opt_ins) : void 0,
    addresses: t.addresses,
    aggregation_level: c(t, "aggregation_level") ? ze(t.aggregation_level) : void 0
  };
}
function X1(t) {
  if (t !== void 0)
    return t === null ? null : {
      opt_ins: sd(t.opt_ins),
      addresses: t.addresses,
      aggregation_level: t.aggregation_level
    };
}
function Q1(t) {
  return !0;
}
function uO(t) {
  return lO(t);
}
function lO(t, e) {
  return t == null ? t : {
    parent_address: c(t, "parent_address") ? t.parent_address : void 0,
    owner_address: c(t, "owner_address") ? t.owner_address : void 0,
    global_address: c(t, "global_address") ? t.global_address : void 0
  };
}
function cO(t) {
  if (t !== void 0)
    return t === null ? null : {
      parent_address: t.parent_address,
      owner_address: t.owner_address,
      global_address: t.global_address
    };
}
const tC = {
  Component: "Component"
};
function eC(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "blueprint_name" in t, e = e && "blueprint_version" in t, e;
}
function nC(t) {
  return od(t);
}
function od(t, e) {
  return t == null ? t : {
    type: t.type,
    package_address: c(t, "package_address") ? t.package_address : void 0,
    blueprint_name: t.blueprint_name,
    blueprint_version: t.blueprint_version,
    state: c(t, "state") ? t.state : void 0,
    role_assignments: c(t, "role_assignments") ? Zn(t.role_assignments) : void 0,
    royalty_vault_balance: c(t, "royalty_vault_balance") ? t.royalty_vault_balance : void 0
  };
}
function dO(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      package_address: t.package_address,
      blueprint_name: t.blueprint_name,
      blueprint_version: t.blueprint_version,
      state: t.state,
      role_assignments: zn(t.role_assignments),
      royalty_vault_balance: t.royalty_vault_balance
    };
}
const aC = {
  FungibleResource: "FungibleResource"
};
function rC(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "role_assignments" in t, e = e && "divisibility" in t, e = e && "total_supply" in t, e = e && "total_minted" in t, e = e && "total_burned" in t, e;
}
function iC(t) {
  return ud(t);
}
function ud(t, e) {
  return t == null ? t : {
    type: t.type,
    role_assignments: Zn(t.role_assignments),
    divisibility: t.divisibility,
    total_supply: t.total_supply,
    total_minted: t.total_minted,
    total_burned: t.total_burned
  };
}
function fO(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      role_assignments: zn(t.role_assignments),
      divisibility: t.divisibility,
      total_supply: t.total_supply,
      total_minted: t.total_minted,
      total_burned: t.total_burned
    };
}
const sC = {
  FungibleVault: "FungibleVault"
};
function oC(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "resource_address" in t, e = e && "balance" in t, e;
}
function uC(t) {
  return ld(t);
}
function ld(t, e) {
  return t == null ? t : {
    type: t.type,
    resource_address: t.resource_address,
    balance: ya(t.balance)
  };
}
function pO(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      resource_address: t.resource_address,
      balance: _a(t.balance)
    };
}
const lC = {
  NonFungibleResource: "NonFungibleResource"
};
function cC(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "role_assignments" in t, e = e && "non_fungible_id_type" in t, e = e && "total_supply" in t, e = e && "total_minted" in t, e = e && "total_burned" in t, e;
}
function dC(t) {
  return cd(t);
}
function cd(t, e) {
  return t == null ? t : {
    type: t.type,
    role_assignments: Zn(t.role_assignments),
    non_fungible_id_type: kr(t.non_fungible_id_type),
    total_supply: t.total_supply,
    total_minted: t.total_minted,
    total_burned: t.total_burned
  };
}
function mO(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      role_assignments: zn(t.role_assignments),
      non_fungible_id_type: t.non_fungible_id_type,
      total_supply: t.total_supply,
      total_minted: t.total_minted,
      total_burned: t.total_burned
    };
}
const fC = {
  NonFungibleVault: "NonFungibleVault"
};
function pC(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "resource_address" in t, e = e && "balance" in t, e;
}
function mC(t) {
  return dd(t);
}
function dd(t, e) {
  return t == null ? t : {
    type: t.type,
    resource_address: t.resource_address,
    balance: ga(t.balance)
  };
}
function yO(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      resource_address: t.resource_address,
      balance: ha(t.balance)
    };
}
function yC(t) {
  let e = !0;
  return e = e && "name" in t, e = e && "version" in t, e = e && "definition" in t, e;
}
function fd(t) {
  return _O(t);
}
function _O(t, e) {
  return t == null ? t : {
    name: t.name,
    version: t.version,
    definition: t.definition,
    dependant_entities: c(t, "dependant_entities") ? t.dependant_entities : void 0,
    auth_template: c(t, "auth_template") ? t.auth_template : void 0,
    auth_template_is_locked: c(t, "auth_template_is_locked") ? t.auth_template_is_locked : void 0,
    royalty_config: c(t, "royalty_config") ? t.royalty_config : void 0,
    royalty_config_is_locked: c(t, "royalty_config_is_locked") ? t.royalty_config_is_locked : void 0
  };
}
function pd(t) {
  if (t !== void 0)
    return t === null ? null : {
      name: t.name,
      version: t.version,
      definition: t.definition,
      dependant_entities: t.dependant_entities,
      auth_template: t.auth_template,
      auth_template_is_locked: t.auth_template_is_locked,
      royalty_config: t.royalty_config,
      royalty_config_is_locked: t.royalty_config_is_locked
    };
}
function _C(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function md(t) {
  return gO(t);
}
function gO(t, e) {
  return t == null ? t : {
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(fd)
  };
}
function yd(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(pd)
    };
}
function gC(t) {
  let e = !0;
  return e = e && "schema_hash_hex" in t, e = e && "schema_hex" in t, e;
}
function _d(t) {
  return hO(t);
}
function hO(t, e) {
  return t == null ? t : {
    schema_hash_hex: t.schema_hash_hex,
    schema_hex: t.schema_hex
  };
}
function gd(t) {
  if (t !== void 0)
    return t === null ? null : {
      schema_hash_hex: t.schema_hash_hex,
      schema_hex: t.schema_hex
    };
}
function hC(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function hd(t) {
  return vO(t);
}
function vO(t, e) {
  return t == null ? t : {
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(_d)
  };
}
function vd(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(gd)
    };
}
const vC = {
  Package: "Package"
};
function bC(t) {
  let e = !0;
  return e = e && "type" in t, e = e && "vm_type" in t, e = e && "code_hash_hex" in t, e = e && "code_hex" in t, e;
}
function SC(t) {
  return bd(t);
}
function bd(t, e) {
  return t == null ? t : {
    type: t.type,
    vm_type: rd(t.vm_type),
    code_hash_hex: t.code_hash_hex,
    code_hex: t.code_hex,
    royalty_vault_balance: c(t, "royalty_vault_balance") ? t.royalty_vault_balance : void 0,
    blueprints: c(t, "blueprints") ? md(t.blueprints) : void 0,
    schemas: c(t, "schemas") ? hd(t.schemas) : void 0
  };
}
function bO(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type,
      vm_type: t.vm_type,
      code_hash_hex: t.code_hash_hex,
      code_hex: t.code_hex,
      royalty_vault_balance: t.royalty_vault_balance,
      blueprints: yd(t.blueprints),
      schemas: vd(t.schemas)
    };
}
function SO(t) {
  return OO(t);
}
function OO(t, e) {
  if (t == null)
    return t;
  switch (t.type) {
    case "Component":
      return { ...od(t), type: "Component" };
    case "FungibleResource":
      return { ...ud(t), type: "FungibleResource" };
    case "FungibleVault":
      return { ...ld(t), type: "FungibleVault" };
    case "NonFungibleResource":
      return { ...cd(t), type: "NonFungibleResource" };
    case "NonFungibleVault":
      return { ...dd(t), type: "NonFungibleVault" };
    case "Package":
      return { ...bd(t), type: "Package" };
    default:
      throw new Error(`No variant of StateEntityDetailsResponseItemDetails exists with 'type=${t.type}'`);
  }
}
function NO(t) {
  if (t !== void 0) {
    if (t === null)
      return null;
    switch (t.type) {
      case "Component":
        return dO(t);
      case "FungibleResource":
        return fO(t);
      case "FungibleVault":
        return pO(t);
      case "NonFungibleResource":
        return mO(t);
      case "NonFungibleVault":
        return yO(t);
      case "Package":
        return bO(t);
      default:
        throw new Error(`No variant of StateEntityDetailsResponseItemDetails exists with 'type=${t.type}'`);
    }
  }
}
function OC(t) {
  let e = !0;
  return e = e && "address" in t, e = e && "metadata" in t, e;
}
function Sd(t) {
  return wO(t);
}
function wO(t, e) {
  return t == null ? t : {
    address: t.address,
    fungible_resources: c(t, "fungible_resources") ? Gv(t.fungible_resources) : void 0,
    non_fungible_resources: c(t, "non_fungible_resources") ? cS(t.non_fungible_resources) : void 0,
    ancestor_identities: c(t, "ancestor_identities") ? uO(t.ancestor_identities) : void 0,
    metadata: xe(t.metadata),
    explicit_metadata: c(t, "explicit_metadata") ? xe(t.explicit_metadata) : void 0,
    details: c(t, "details") ? SO(t.details) : void 0
  };
}
function Od(t) {
  if (t !== void 0)
    return t === null ? null : {
      address: t.address,
      fungible_resources: Hv(t.fungible_resources),
      non_fungible_resources: fS(t.non_fungible_resources),
      ancestor_identities: cO(t.ancestor_identities),
      metadata: Ee(t.metadata),
      explicit_metadata: Ee(t.explicit_metadata),
      details: NO(t.details)
    };
}
function NC(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "items" in t, e;
}
function TO(t) {
  return AO(t);
}
function AO(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    items: t.items.map(Sd)
  };
}
function wC(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      items: t.items.map(Od)
    };
}
function TC(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function AC(t) {
  return kO(t);
}
function kO(t, e) {
  return t == null ? t : {
    items: t.items.map(Sd)
  };
}
function kC(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items.map(Od)
    };
}
const FC = {
  Component: "Component"
};
function xC(t) {
  let e = !0;
  return e = e && "blueprint_name" in t, e = e && "blueprint_version" in t, e;
}
function EC(t) {
  return FO(t);
}
function FO(t, e) {
  return t == null ? t : {
    package_address: c(t, "package_address") ? t.package_address : void 0,
    blueprint_name: t.blueprint_name,
    blueprint_version: t.blueprint_version,
    state: c(t, "state") ? t.state : void 0,
    role_assignments: c(t, "role_assignments") ? Zn(t.role_assignments) : void 0,
    royalty_vault_balance: c(t, "royalty_vault_balance") ? t.royalty_vault_balance : void 0,
    type: c(t, "type") ? t.type : void 0
  };
}
function RC(t) {
  if (t !== void 0)
    return t === null ? null : {
      package_address: t.package_address,
      blueprint_name: t.blueprint_name,
      blueprint_version: t.blueprint_version,
      state: t.state,
      role_assignments: zn(t.role_assignments),
      royalty_vault_balance: t.royalty_vault_balance,
      type: t.type
    };
}
const IC = {
  FungibleResource: "FungibleResource"
};
function PC(t) {
  let e = !0;
  return e = e && "role_assignments" in t, e = e && "divisibility" in t, e = e && "total_supply" in t, e = e && "total_minted" in t, e = e && "total_burned" in t, e;
}
function VC(t) {
  return xO(t);
}
function xO(t, e) {
  return t == null ? t : {
    role_assignments: Zn(t.role_assignments),
    divisibility: t.divisibility,
    total_supply: t.total_supply,
    total_minted: t.total_minted,
    total_burned: t.total_burned,
    type: c(t, "type") ? t.type : void 0
  };
}
function JC(t) {
  if (t !== void 0)
    return t === null ? null : {
      role_assignments: zn(t.role_assignments),
      divisibility: t.divisibility,
      total_supply: t.total_supply,
      total_minted: t.total_minted,
      total_burned: t.total_burned,
      type: t.type
    };
}
const CC = {
  FungibleVault: "FungibleVault"
};
function DC(t) {
  let e = !0;
  return e = e && "resource_address" in t, e = e && "balance" in t, e;
}
function MC(t) {
  return EO(t);
}
function EO(t, e) {
  return t == null ? t : {
    resource_address: t.resource_address,
    balance: ya(t.balance),
    type: c(t, "type") ? t.type : void 0
  };
}
function qC(t) {
  if (t !== void 0)
    return t === null ? null : {
      resource_address: t.resource_address,
      balance: _a(t.balance),
      type: t.type
    };
}
const $C = {
  FungibleResource: "FungibleResource",
  NonFungibleResource: "NonFungibleResource",
  FungibleVault: "FungibleVault",
  NonFungibleVault: "NonFungibleVault",
  Package: "Package",
  Component: "Component"
};
function RO(t) {
  return IO(t);
}
function IO(t, e) {
  return t;
}
function UC(t) {
  return t;
}
function LC(t) {
  let e = !0;
  return e = e && "type" in t, e;
}
function jC(t) {
  return PO(t);
}
function PO(t, e) {
  return t == null ? t : {
    type: RO(t.type)
  };
}
function KC(t) {
  if (t !== void 0)
    return t === null ? null : {
      type: t.type
    };
}
const BC = {
  NonFungibleResource: "NonFungibleResource"
};
function ZC(t) {
  let e = !0;
  return e = e && "role_assignments" in t, e = e && "non_fungible_id_type" in t, e = e && "total_supply" in t, e = e && "total_minted" in t, e = e && "total_burned" in t, e;
}
function zC(t) {
  return VO(t);
}
function VO(t, e) {
  return t == null ? t : {
    role_assignments: Zn(t.role_assignments),
    non_fungible_id_type: kr(t.non_fungible_id_type),
    total_supply: t.total_supply,
    total_minted: t.total_minted,
    total_burned: t.total_burned,
    type: c(t, "type") ? t.type : void 0
  };
}
function GC(t) {
  if (t !== void 0)
    return t === null ? null : {
      role_assignments: zn(t.role_assignments),
      non_fungible_id_type: t.non_fungible_id_type,
      total_supply: t.total_supply,
      total_minted: t.total_minted,
      total_burned: t.total_burned,
      type: t.type
    };
}
const WC = {
  NonFungibleVault: "NonFungibleVault"
};
function HC(t) {
  let e = !0;
  return e = e && "resource_address" in t, e = e && "balance" in t, e;
}
function YC(t) {
  return JO(t);
}
function JO(t, e) {
  return t == null ? t : {
    resource_address: t.resource_address,
    balance: ga(t.balance),
    type: c(t, "type") ? t.type : void 0
  };
}
function XC(t) {
  if (t !== void 0)
    return t === null ? null : {
      resource_address: t.resource_address,
      balance: ha(t.balance),
      type: t.type
    };
}
const QC = {
  Package: "Package"
};
function tD(t) {
  let e = !0;
  return e = e && "vm_type" in t, e = e && "code_hash_hex" in t, e = e && "code_hex" in t, e;
}
function eD(t) {
  return CO(t);
}
function CO(t, e) {
  return t == null ? t : {
    vm_type: rd(t.vm_type),
    code_hash_hex: t.code_hash_hex,
    code_hex: t.code_hex,
    royalty_vault_balance: c(t, "royalty_vault_balance") ? t.royalty_vault_balance : void 0,
    blueprints: c(t, "blueprints") ? md(t.blueprints) : void 0,
    schemas: c(t, "schemas") ? hd(t.schemas) : void 0,
    type: c(t, "type") ? t.type : void 0
  };
}
function nD(t) {
  if (t !== void 0)
    return t === null ? null : {
      vm_type: t.vm_type,
      code_hash_hex: t.code_hash_hex,
      code_hex: t.code_hex,
      royalty_vault_balance: t.royalty_vault_balance,
      blueprints: yd(t.blueprints),
      schemas: vd(t.schemas),
      type: t.type
    };
}
function aD(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function rD(t) {
  return DO(t);
}
function DO(t, e) {
  return t == null ? t : {
    items: t.items.map(fd)
  };
}
function iD(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items.map(pd)
    };
}
function sD(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function oD(t) {
  return MO(t);
}
function MO(t, e) {
  return t == null ? t : {
    items: t.items.map(_d)
  };
}
function uD(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items.map(gd)
    };
}
function lD(t) {
  let e = !0;
  return e = e && "address" in t, e = e && "resource_address" in t, e;
}
function cD(t) {
  return qO(t);
}
function qO(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    cursor: c(t, "cursor") ? t.cursor : void 0,
    limit_per_page: c(t, "limit_per_page") ? t.limit_per_page : void 0,
    address: t.address,
    resource_address: t.resource_address
  };
}
function $O(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      cursor: t.cursor,
      limit_per_page: t.limit_per_page,
      address: t.address,
      resource_address: t.resource_address
    };
}
function dD(t) {
  let e = !0;
  return e = e && "address" in t, e = e && "resource_address" in t, e;
}
function fD(t) {
  return UO(t);
}
function UO(t, e) {
  return t == null ? t : {
    address: t.address,
    resource_address: t.resource_address
  };
}
function pD(t) {
  if (t !== void 0)
    return t === null ? null : {
      address: t.address,
      resource_address: t.resource_address
    };
}
function mD(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "items" in t, e = e && "address" in t, e = e && "resource_address" in t, e;
}
function LO(t) {
  return jO(t);
}
function jO(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(ya),
    address: t.address,
    resource_address: t.resource_address
  };
}
function yD(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(_a),
      address: t.address,
      resource_address: t.resource_address
    };
}
function _D(t) {
  return !0;
}
function Nd(t) {
  return KO(t);
}
function KO(t, e) {
  return t == null ? t : {
    explicit_metadata: c(t, "explicit_metadata") ? t.explicit_metadata : void 0
  };
}
function wd(t) {
  if (t !== void 0)
    return t === null ? null : {
      explicit_metadata: t.explicit_metadata
    };
}
function gD(t) {
  let e = !0;
  return e = e && "address" in t, e;
}
function hD(t) {
  return BO(t);
}
function BO(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    cursor: c(t, "cursor") ? t.cursor : void 0,
    limit_per_page: c(t, "limit_per_page") ? t.limit_per_page : void 0,
    address: t.address,
    aggregation_level: c(t, "aggregation_level") ? ze(t.aggregation_level) : void 0,
    opt_ins: c(t, "opt_ins") ? Nd(t.opt_ins) : void 0
  };
}
function ZO(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      cursor: t.cursor,
      limit_per_page: t.limit_per_page,
      address: t.address,
      aggregation_level: t.aggregation_level,
      opt_ins: wd(t.opt_ins)
    };
}
function vD(t) {
  let e = !0;
  return e = e && "address" in t, e;
}
function bD(t) {
  return zO(t);
}
function zO(t, e) {
  return t == null ? t : {
    address: t.address,
    aggregation_level: c(t, "aggregation_level") ? ze(t.aggregation_level) : void 0,
    opt_ins: c(t, "opt_ins") ? Nd(t.opt_ins) : void 0
  };
}
function SD(t) {
  if (t !== void 0)
    return t === null ? null : {
      address: t.address,
      aggregation_level: t.aggregation_level,
      opt_ins: wd(t.opt_ins)
    };
}
function OD(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "items" in t, e = e && "address" in t, e;
}
function GO(t) {
  return WO(t);
}
function WO(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(Os),
    address: t.address
  };
}
function ND(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(Ns),
      address: t.address
    };
}
function wD(t) {
  let e = !0;
  return e = e && "address" in t, e;
}
function TD(t) {
  return HO(t);
}
function HO(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    cursor: c(t, "cursor") ? t.cursor : void 0,
    limit_per_page: c(t, "limit_per_page") ? t.limit_per_page : void 0,
    address: t.address
  };
}
function YO(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      cursor: t.cursor,
      limit_per_page: t.limit_per_page,
      address: t.address
    };
}
function AD(t) {
  let e = !0;
  return e = e && "address" in t, e;
}
function kD(t) {
  return XO(t);
}
function XO(t, e) {
  return t == null ? t : {
    address: t.address
  };
}
function FD(t) {
  if (t !== void 0)
    return t === null ? null : {
      address: t.address
    };
}
function xD(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "items" in t, e = e && "address" in t, e;
}
function QO(t) {
  return t0(t);
}
function t0(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(bs),
    address: t.address
  };
}
function ED(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(Ss),
      address: t.address
    };
}
function RD(t) {
  let e = !0;
  return e = e && "address" in t, e = e && "vault_address" in t, e = e && "resource_address" in t, e;
}
function ID(t) {
  return e0(t);
}
function e0(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    cursor: c(t, "cursor") ? t.cursor : void 0,
    limit_per_page: c(t, "limit_per_page") ? t.limit_per_page : void 0,
    address: t.address,
    vault_address: t.vault_address,
    resource_address: t.resource_address
  };
}
function n0(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      cursor: t.cursor,
      limit_per_page: t.limit_per_page,
      address: t.address,
      vault_address: t.vault_address,
      resource_address: t.resource_address
    };
}
function PD(t) {
  let e = !0;
  return e = e && "address" in t, e = e && "vault_address" in t, e = e && "resource_address" in t, e;
}
function VD(t) {
  return a0(t);
}
function a0(t, e) {
  return t == null ? t : {
    address: t.address,
    vault_address: t.vault_address,
    resource_address: t.resource_address
  };
}
function JD(t) {
  if (t !== void 0)
    return t === null ? null : {
      address: t.address,
      vault_address: t.vault_address,
      resource_address: t.resource_address
    };
}
function CD(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "items" in t, e = e && "address" in t, e = e && "resource_address" in t, e;
}
function r0(t) {
  return i0(t);
}
function i0(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items,
    address: t.address,
    resource_address: t.resource_address
  };
}
function DD(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items,
      address: t.address,
      resource_address: t.resource_address
    };
}
function MD(t) {
  return !0;
}
function Td(t) {
  return s0(t);
}
function s0(t, e) {
  return t == null ? t : {
    non_fungible_include_nfids: c(t, "non_fungible_include_nfids") ? t.non_fungible_include_nfids : void 0
  };
}
function Ad(t) {
  if (t !== void 0)
    return t === null ? null : {
      non_fungible_include_nfids: t.non_fungible_include_nfids
    };
}
function qD(t) {
  let e = !0;
  return e = e && "address" in t, e = e && "resource_address" in t, e;
}
function $D(t) {
  return o0(t);
}
function o0(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    cursor: c(t, "cursor") ? t.cursor : void 0,
    limit_per_page: c(t, "limit_per_page") ? t.limit_per_page : void 0,
    address: t.address,
    resource_address: t.resource_address,
    opt_ins: c(t, "opt_ins") ? Td(t.opt_ins) : void 0
  };
}
function u0(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      cursor: t.cursor,
      limit_per_page: t.limit_per_page,
      address: t.address,
      resource_address: t.resource_address,
      opt_ins: Ad(t.opt_ins)
    };
}
function UD(t) {
  let e = !0;
  return e = e && "address" in t, e = e && "resource_address" in t, e;
}
function LD(t) {
  return l0(t);
}
function l0(t, e) {
  return t == null ? t : {
    address: t.address,
    resource_address: t.resource_address,
    opt_ins: c(t, "opt_ins") ? Td(t.opt_ins) : void 0
  };
}
function jD(t) {
  if (t !== void 0)
    return t === null ? null : {
      address: t.address,
      resource_address: t.resource_address,
      opt_ins: Ad(t.opt_ins)
    };
}
function KD(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "items" in t, e = e && "address" in t, e = e && "resource_address" in t, e;
}
function c0(t) {
  return d0(t);
}
function d0(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(ga),
    address: t.address,
    resource_address: t.resource_address
  };
}
function BD(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(ha),
      address: t.address,
      resource_address: t.resource_address
    };
}
function ZD(t) {
  return !0;
}
function kd(t) {
  return f0(t);
}
function f0(t, e) {
  return t == null ? t : {
    non_fungible_include_nfids: c(t, "non_fungible_include_nfids") ? t.non_fungible_include_nfids : void 0,
    explicit_metadata: c(t, "explicit_metadata") ? t.explicit_metadata : void 0
  };
}
function Fd(t) {
  if (t !== void 0)
    return t === null ? null : {
      non_fungible_include_nfids: t.non_fungible_include_nfids,
      explicit_metadata: t.explicit_metadata
    };
}
function zD(t) {
  let e = !0;
  return e = e && "address" in t, e;
}
function GD(t) {
  return p0(t);
}
function p0(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    cursor: c(t, "cursor") ? t.cursor : void 0,
    limit_per_page: c(t, "limit_per_page") ? t.limit_per_page : void 0,
    address: t.address,
    aggregation_level: c(t, "aggregation_level") ? ze(t.aggregation_level) : void 0,
    opt_ins: c(t, "opt_ins") ? kd(t.opt_ins) : void 0
  };
}
function m0(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      cursor: t.cursor,
      limit_per_page: t.limit_per_page,
      address: t.address,
      aggregation_level: t.aggregation_level,
      opt_ins: Fd(t.opt_ins)
    };
}
function WD(t) {
  let e = !0;
  return e = e && "address" in t, e;
}
function HD(t) {
  return y0(t);
}
function y0(t, e) {
  return t == null ? t : {
    address: t.address,
    aggregation_level: c(t, "aggregation_level") ? ze(t.aggregation_level) : void 0,
    opt_ins: c(t, "opt_ins") ? kd(t.opt_ins) : void 0
  };
}
function YD(t) {
  if (t !== void 0)
    return t === null ? null : {
      address: t.address,
      aggregation_level: t.aggregation_level,
      opt_ins: Fd(t.opt_ins)
    };
}
function XD(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "items" in t, e = e && "address" in t, e;
}
function _0(t) {
  return g0(t);
}
function g0(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(ws),
    address: t.address
  };
}
function QD(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(Ts),
      address: t.address
    };
}
function tM(t) {
  return !0;
}
function xd(t) {
  return h0(t);
}
function h0(t, e) {
  return t == null ? t : {
    key_hex: c(t, "key_hex") ? t.key_hex : void 0,
    key_json: c(t, "key_json") ? jt(t.key_json) : void 0
  };
}
function Ed(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_hex: t.key_hex,
      key_json: Kt(t.key_json)
    };
}
function eM(t) {
  let e = !0;
  return e = e && "key_value_store_address" in t, e = e && "keys" in t, e;
}
function nM(t) {
  return v0(t);
}
function v0(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    key_value_store_address: t.key_value_store_address,
    keys: t.keys.map(xd)
  };
}
function b0(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      key_value_store_address: t.key_value_store_address,
      keys: t.keys.map(Ed)
    };
}
function aM(t) {
  let e = !0;
  return e = e && "key_value_store_address" in t, e = e && "keys" in t, e;
}
function rM(t) {
  return S0(t);
}
function S0(t, e) {
  return t == null ? t : {
    key_value_store_address: t.key_value_store_address,
    keys: t.keys.map(xd)
  };
}
function iM(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_value_store_address: t.key_value_store_address,
      keys: t.keys.map(Ed)
    };
}
function sM(t) {
  let e = !0;
  return e = e && "key" in t, e = e && "value" in t, e = e && "last_updated_at_state_version" in t, e = e && "is_locked" in t, e;
}
function Rd(t) {
  return O0(t);
}
function O0(t, e) {
  return t == null ? t : {
    key: Qi(t.key),
    value: Qi(t.value),
    last_updated_at_state_version: t.last_updated_at_state_version,
    is_locked: t.is_locked
  };
}
function Id(t) {
  if (t !== void 0)
    return t === null ? null : {
      key: ts(t.key),
      value: ts(t.value),
      last_updated_at_state_version: t.last_updated_at_state_version,
      is_locked: t.is_locked
    };
}
function oM(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "key_value_store_address" in t, e = e && "entries" in t, e;
}
function N0(t) {
  return w0(t);
}
function w0(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    key_value_store_address: t.key_value_store_address,
    entries: t.entries.map(Rd)
  };
}
function uM(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      key_value_store_address: t.key_value_store_address,
      entries: t.entries.map(Id)
    };
}
function lM(t) {
  let e = !0;
  return e = e && "key_value_store_address" in t, e = e && "entries" in t, e;
}
function cM(t) {
  return T0(t);
}
function T0(t, e) {
  return t == null ? t : {
    key_value_store_address: t.key_value_store_address,
    entries: t.entries.map(Rd)
  };
}
function dM(t) {
  if (t !== void 0)
    return t === null ? null : {
      key_value_store_address: t.key_value_store_address,
      entries: t.entries.map(Id)
    };
}
function fM(t) {
  let e = !0;
  return e = e && "resource_address" in t, e = e && "non_fungible_ids" in t, e;
}
function pM(t) {
  return A0(t);
}
function A0(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    resource_address: t.resource_address,
    non_fungible_ids: t.non_fungible_ids
  };
}
function k0(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      resource_address: t.resource_address,
      non_fungible_ids: t.non_fungible_ids
    };
}
function mM(t) {
  let e = !0;
  return e = e && "is_burned" in t, e = e && "non_fungible_id" in t, e = e && "last_updated_at_state_version" in t, e;
}
function Pd(t) {
  return F0(t);
}
function F0(t, e) {
  return t == null ? t : {
    is_burned: t.is_burned,
    non_fungible_id: t.non_fungible_id,
    data: c(t, "data") ? Qi(t.data) : void 0,
    last_updated_at_state_version: t.last_updated_at_state_version
  };
}
function Vd(t) {
  if (t !== void 0)
    return t === null ? null : {
      is_burned: t.is_burned,
      non_fungible_id: t.non_fungible_id,
      data: ts(t.data),
      last_updated_at_state_version: t.last_updated_at_state_version
    };
}
function yM(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "resource_address" in t, e = e && "non_fungible_id_type" in t, e = e && "non_fungible_ids" in t, e;
}
function x0(t) {
  return E0(t);
}
function E0(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    resource_address: t.resource_address,
    non_fungible_id_type: kr(t.non_fungible_id_type),
    non_fungible_ids: t.non_fungible_ids.map(Pd)
  };
}
function _M(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      resource_address: t.resource_address,
      non_fungible_id_type: t.non_fungible_id_type,
      non_fungible_ids: t.non_fungible_ids.map(Vd)
    };
}
function gM(t) {
  let e = !0;
  return e = e && "resource_address" in t, e = e && "non_fungible_id_type" in t, e = e && "non_fungible_ids" in t, e;
}
function hM(t) {
  return R0(t);
}
function R0(t, e) {
  return t == null ? t : {
    resource_address: t.resource_address,
    non_fungible_id_type: kr(t.non_fungible_id_type),
    non_fungible_ids: t.non_fungible_ids.map(Pd)
  };
}
function vM(t) {
  if (t !== void 0)
    return t === null ? null : {
      resource_address: t.resource_address,
      non_fungible_id_type: t.non_fungible_id_type,
      non_fungible_ids: t.non_fungible_ids.map(Vd)
    };
}
function bM(t) {
  let e = !0;
  return e = e && "resource_address" in t, e;
}
function SM(t) {
  return I0(t);
}
function I0(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    cursor: c(t, "cursor") ? t.cursor : void 0,
    limit_per_page: c(t, "limit_per_page") ? t.limit_per_page : void 0,
    resource_address: t.resource_address
  };
}
function P0(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      cursor: t.cursor,
      limit_per_page: t.limit_per_page,
      resource_address: t.resource_address
    };
}
function OM(t) {
  let e = !0;
  return e = e && "resource_address" in t, e;
}
function NM(t) {
  return V0(t);
}
function V0(t, e) {
  return t == null ? t : {
    resource_address: t.resource_address
  };
}
function wM(t) {
  if (t !== void 0)
    return t === null ? null : {
      resource_address: t.resource_address
    };
}
function TM(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "resource_address" in t, e = e && "non_fungible_ids" in t, e;
}
function J0(t) {
  return C0(t);
}
function C0(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    resource_address: t.resource_address,
    non_fungible_ids: Xc(t.non_fungible_ids)
  };
}
function AM(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      resource_address: t.resource_address,
      non_fungible_ids: Qc(t.non_fungible_ids)
    };
}
function kM(t) {
  let e = !0;
  return e = e && "resource_address" in t, e = e && "non_fungible_ids" in t, e;
}
function FM(t) {
  return D0(t);
}
function D0(t, e) {
  return t == null ? t : {
    resource_address: t.resource_address,
    non_fungible_ids: Xc(t.non_fungible_ids)
  };
}
function xM(t) {
  if (t !== void 0)
    return t === null ? null : {
      resource_address: t.resource_address,
      non_fungible_ids: Qc(t.non_fungible_ids)
    };
}
function EM(t) {
  let e = !0;
  return e = e && "resource_address" in t, e = e && "non_fungible_ids" in t, e;
}
function RM(t) {
  return M0(t);
}
function M0(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    resource_address: t.resource_address,
    non_fungible_ids: t.non_fungible_ids
  };
}
function q0(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      resource_address: t.resource_address,
      non_fungible_ids: t.non_fungible_ids
    };
}
function IM(t) {
  let e = !0;
  return e = e && "resource_address" in t, e = e && "non_fungible_ids" in t, e;
}
function PM(t) {
  return $0(t);
}
function $0(t, e) {
  return t == null ? t : {
    resource_address: t.resource_address,
    non_fungible_ids: t.non_fungible_ids
  };
}
function VM(t) {
  if (t !== void 0)
    return t === null ? null : {
      resource_address: t.resource_address,
      non_fungible_ids: t.non_fungible_ids
    };
}
function JM(t) {
  let e = !0;
  return e = e && "non_fungible_id" in t, e = e && "is_burned" in t, e = e && "last_updated_at_state_version" in t, e;
}
function Jd(t) {
  return U0(t);
}
function U0(t, e) {
  return t == null ? t : {
    non_fungible_id: t.non_fungible_id,
    owning_vault_address: c(t, "owning_vault_address") ? t.owning_vault_address : void 0,
    is_burned: t.is_burned,
    last_updated_at_state_version: t.last_updated_at_state_version
  };
}
function Cd(t) {
  if (t !== void 0)
    return t === null ? null : {
      non_fungible_id: t.non_fungible_id,
      owning_vault_address: t.owning_vault_address,
      is_burned: t.is_burned,
      last_updated_at_state_version: t.last_updated_at_state_version
    };
}
function CM(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "resource_address" in t, e = e && "non_fungible_ids" in t, e;
}
function L0(t) {
  return j0(t);
}
function j0(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    resource_address: t.resource_address,
    non_fungible_ids: t.non_fungible_ids.map(Jd)
  };
}
function DM(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      resource_address: t.resource_address,
      non_fungible_ids: t.non_fungible_ids.map(Cd)
    };
}
function MM(t) {
  let e = !0;
  return e = e && "resource_address" in t, e = e && "non_fungible_ids" in t, e;
}
function qM(t) {
  return K0(t);
}
function K0(t, e) {
  return t == null ? t : {
    resource_address: t.resource_address,
    non_fungible_ids: t.non_fungible_ids.map(Jd)
  };
}
function $M(t) {
  if (t !== void 0)
    return t === null ? null : {
      resource_address: t.resource_address,
      non_fungible_ids: t.non_fungible_ids.map(Cd)
    };
}
function UM(t) {
  return !0;
}
function LM(t) {
  return B0(t);
}
function B0(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    cursor: c(t, "cursor") ? t.cursor : void 0
  };
}
function Z0(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      cursor: t.cursor
    };
}
function jM(t) {
  return !0;
}
function KM(t) {
  return z0(t);
}
function z0(t, e) {
  return t == null ? t : {
    cursor: c(t, "cursor") ? t.cursor : void 0
  };
}
function BM(t) {
  if (t !== void 0)
    return t === null ? null : {
      cursor: t.cursor
    };
}
function ZM(t) {
  let e = !0;
  return e = e && "stake" in t, e = e && "stake_percentage" in t, e = e && "key" in t, e;
}
function G0(t) {
  return W0(t);
}
function W0(t, e) {
  return t == null ? t : {
    stake: t.stake,
    stake_percentage: t.stake_percentage,
    key: gn(t.key)
  };
}
function H0(t) {
  if (t !== void 0)
    return t === null ? null : {
      stake: t.stake,
      stake_percentage: t.stake_percentage,
      key: hn(t.key)
    };
}
function zM(t) {
  let e = !0;
  return e = e && "balance" in t, e = e && "last_changed_at_state_version" in t, e = e && "address" in t, e;
}
function Pa(t) {
  return Y0(t);
}
function Y0(t, e) {
  return t == null ? t : {
    balance: t.balance,
    last_changed_at_state_version: t.last_changed_at_state_version,
    address: t.address
  };
}
function Va(t) {
  if (t !== void 0)
    return t === null ? null : {
      balance: t.balance,
      last_changed_at_state_version: t.last_changed_at_state_version,
      address: t.address
    };
}
function GM(t) {
  let e = !0;
  return e = e && "address" in t, e = e && "stake_vault" in t, e = e && "pending_xrd_withdraw_vault" in t, e = e && "locked_owner_stake_unit_vault" in t, e = e && "pending_owner_stake_unit_unlock_vault" in t, e = e && "metadata" in t, e;
}
function Dd(t) {
  return X0(t);
}
function X0(t, e) {
  return t == null ? t : {
    address: t.address,
    stake_vault: Pa(t.stake_vault),
    pending_xrd_withdraw_vault: Pa(t.pending_xrd_withdraw_vault),
    locked_owner_stake_unit_vault: Pa(t.locked_owner_stake_unit_vault),
    pending_owner_stake_unit_unlock_vault: Pa(t.pending_owner_stake_unit_unlock_vault),
    state: c(t, "state") ? t.state : void 0,
    active_in_epoch: c(t, "active_in_epoch") ? G0(t.active_in_epoch) : void 0,
    metadata: xe(t.metadata)
  };
}
function Md(t) {
  if (t !== void 0)
    return t === null ? null : {
      address: t.address,
      stake_vault: Va(t.stake_vault),
      pending_xrd_withdraw_vault: Va(t.pending_xrd_withdraw_vault),
      locked_owner_stake_unit_vault: Va(t.locked_owner_stake_unit_vault),
      pending_owner_stake_unit_unlock_vault: Va(t.pending_owner_stake_unit_unlock_vault),
      state: t.state,
      active_in_epoch: H0(t.active_in_epoch),
      metadata: Ee(t.metadata)
    };
}
function WM(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function qd(t) {
  return Q0(t);
}
function Q0(t, e) {
  return t == null ? t : {
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(Dd)
  };
}
function $d(t) {
  if (t !== void 0)
    return t === null ? null : {
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(Md)
    };
}
function HM(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "validators" in t, e;
}
function tN(t) {
  return eN(t);
}
function eN(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    validators: qd(t.validators)
  };
}
function YM(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      validators: $d(t.validators)
    };
}
function XM(t) {
  let e = !0;
  return e = e && "validators" in t, e;
}
function QM(t) {
  return nN(t);
}
function nN(t, e) {
  return t == null ? t : {
    validators: qd(t.validators)
  };
}
function tq(t) {
  if (t !== void 0)
    return t === null ? null : {
      validators: $d(t.validators)
    };
}
const eq = {
  Deposit: "Deposit",
  Withdrawal: "Withdrawal"
};
function nq(t) {
  let e = !0;
  return e = e && "event" in t, e;
}
function Ud(t) {
  return aN(t);
}
function aN(t, e) {
  return t == null ? t : {
    event: t.event,
    emitter_address: c(t, "emitter_address") ? t.emitter_address : void 0,
    resource_address: c(t, "resource_address") ? t.resource_address : void 0
  };
}
function Ld(t) {
  if (t !== void 0)
    return t === null ? null : {
      event: t.event,
      emitter_address: t.emitter_address,
      resource_address: t.resource_address
    };
}
function aq(t) {
  return !0;
}
function Fr(t) {
  return rN(t);
}
function rN(t, e) {
  return t == null ? t : {
    raw_hex: c(t, "raw_hex") ? t.raw_hex : void 0,
    receipt_state_changes: c(t, "receipt_state_changes") ? t.receipt_state_changes : void 0,
    receipt_fee_summary: c(t, "receipt_fee_summary") ? t.receipt_fee_summary : void 0,
    receipt_fee_source: c(t, "receipt_fee_source") ? t.receipt_fee_source : void 0,
    receipt_fee_destination: c(t, "receipt_fee_destination") ? t.receipt_fee_destination : void 0,
    receipt_costing_parameters: c(t, "receipt_costing_parameters") ? t.receipt_costing_parameters : void 0,
    receipt_events: c(t, "receipt_events") ? t.receipt_events : void 0,
    receipt_output: c(t, "receipt_output") ? t.receipt_output : void 0,
    affected_global_entities: c(t, "affected_global_entities") ? t.affected_global_entities : void 0,
    balance_changes: c(t, "balance_changes") ? t.balance_changes : void 0
  };
}
function xr(t) {
  if (t !== void 0)
    return t === null ? null : {
      raw_hex: t.raw_hex,
      receipt_state_changes: t.receipt_state_changes,
      receipt_fee_summary: t.receipt_fee_summary,
      receipt_fee_source: t.receipt_fee_source,
      receipt_fee_destination: t.receipt_fee_destination,
      receipt_costing_parameters: t.receipt_costing_parameters,
      receipt_events: t.receipt_events,
      receipt_output: t.receipt_output,
      affected_global_entities: t.affected_global_entities,
      balance_changes: t.balance_changes
    };
}
const rq = {
  User: "User",
  EpochChange: "EpochChange",
  All: "All"
}, iq = {
  Asc: "Asc",
  Desc: "Desc"
};
function sq(t) {
  return !0;
}
function oq(t) {
  return iN(t);
}
function iN(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    from_ledger_state: c(t, "from_ledger_state") ? pt(t.from_ledger_state) : void 0,
    cursor: c(t, "cursor") ? t.cursor : void 0,
    limit_per_page: c(t, "limit_per_page") ? t.limit_per_page : void 0,
    kind_filter: c(t, "kind_filter") ? t.kind_filter : void 0,
    manifest_accounts_withdrawn_from_filter: c(t, "manifest_accounts_withdrawn_from_filter") ? t.manifest_accounts_withdrawn_from_filter : void 0,
    manifest_accounts_deposited_into_filter: c(t, "manifest_accounts_deposited_into_filter") ? t.manifest_accounts_deposited_into_filter : void 0,
    manifest_resources_filter: c(t, "manifest_resources_filter") ? t.manifest_resources_filter : void 0,
    affected_global_entities_filter: c(t, "affected_global_entities_filter") ? t.affected_global_entities_filter : void 0,
    events_filter: c(t, "events_filter") ? t.events_filter.map(Ud) : void 0,
    order: c(t, "order") ? t.order : void 0,
    opt_ins: c(t, "opt_ins") ? Fr(t.opt_ins) : void 0
  };
}
function sN(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      from_ledger_state: mt(t.from_ledger_state),
      cursor: t.cursor,
      limit_per_page: t.limit_per_page,
      kind_filter: t.kind_filter,
      manifest_accounts_withdrawn_from_filter: t.manifest_accounts_withdrawn_from_filter,
      manifest_accounts_deposited_into_filter: t.manifest_accounts_deposited_into_filter,
      manifest_resources_filter: t.manifest_resources_filter,
      affected_global_entities_filter: t.affected_global_entities_filter,
      events_filter: t.events_filter === void 0 ? void 0 : t.events_filter.map(Ld),
      order: t.order,
      opt_ins: xr(t.opt_ins)
    };
}
const uq = {
  User: "User",
  EpochChange: "EpochChange",
  All: "All"
}, lq = {
  Asc: "Asc",
  Desc: "Desc"
};
function cq(t) {
  return !0;
}
function dq(t) {
  return oN(t);
}
function oN(t, e) {
  return t == null ? t : {
    kind_filter: c(t, "kind_filter") ? t.kind_filter : void 0,
    manifest_accounts_withdrawn_from_filter: c(t, "manifest_accounts_withdrawn_from_filter") ? t.manifest_accounts_withdrawn_from_filter : void 0,
    manifest_accounts_deposited_into_filter: c(t, "manifest_accounts_deposited_into_filter") ? t.manifest_accounts_deposited_into_filter : void 0,
    manifest_resources_filter: c(t, "manifest_resources_filter") ? t.manifest_resources_filter : void 0,
    affected_global_entities_filter: c(t, "affected_global_entities_filter") ? t.affected_global_entities_filter : void 0,
    events_filter: c(t, "events_filter") ? t.events_filter.map(Ud) : void 0,
    order: c(t, "order") ? t.order : void 0,
    opt_ins: c(t, "opt_ins") ? Fr(t.opt_ins) : void 0
  };
}
function fq(t) {
  if (t !== void 0)
    return t === null ? null : {
      kind_filter: t.kind_filter,
      manifest_accounts_withdrawn_from_filter: t.manifest_accounts_withdrawn_from_filter,
      manifest_accounts_deposited_into_filter: t.manifest_accounts_deposited_into_filter,
      manifest_resources_filter: t.manifest_resources_filter,
      affected_global_entities_filter: t.affected_global_entities_filter,
      events_filter: t.events_filter === void 0 ? void 0 : t.events_filter.map(Ld),
      order: t.order,
      opt_ins: xr(t.opt_ins)
    };
}
function pq(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "items" in t, e;
}
function uN(t) {
  return lN(t);
}
function lN(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    total_count: c(t, "total_count") ? t.total_count : void 0,
    next_cursor: c(t, "next_cursor") ? t.next_cursor : void 0,
    items: t.items.map(Nr)
  };
}
function mq(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      total_count: t.total_count,
      next_cursor: t.next_cursor,
      items: t.items.map(wr)
    };
}
function yq(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function _q(t) {
  return cN(t);
}
function cN(t, e) {
  return t == null ? t : {
    items: t.items.map(Nr)
  };
}
function gq(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items.map(wr)
    };
}
function hq(t) {
  let e = !0;
  return e = e && "intent_hash" in t, e;
}
function vq(t) {
  return dN(t);
}
function dN(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    intent_hash: t.intent_hash,
    opt_ins: c(t, "opt_ins") ? Fr(t.opt_ins) : void 0
  };
}
function fN(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      intent_hash: t.intent_hash,
      opt_ins: xr(t.opt_ins)
    };
}
function bq(t) {
  let e = !0;
  return e = e && "intent_hash" in t, e;
}
function Sq(t) {
  return pN(t);
}
function pN(t, e) {
  return t == null ? t : {
    intent_hash: t.intent_hash,
    opt_ins: c(t, "opt_ins") ? Fr(t.opt_ins) : void 0
  };
}
function Oq(t) {
  if (t !== void 0)
    return t === null ? null : {
      intent_hash: t.intent_hash,
      opt_ins: xr(t.opt_ins)
    };
}
function Nq(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "transaction" in t, e;
}
function mN(t) {
  return yN(t);
}
function yN(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    transaction: Nr(t.transaction)
  };
}
function wq(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      transaction: wr(t.transaction)
    };
}
function Tq(t) {
  let e = !0;
  return e = e && "transaction" in t, e;
}
function Aq(t) {
  return _N(t);
}
function _N(t, e) {
  return t == null ? t : {
    transaction: Nr(t.transaction)
  };
}
function kq(t) {
  if (t !== void 0)
    return t === null ? null : {
      transaction: wr(t.transaction)
    };
}
function Fq(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e;
}
function gN(t) {
  return hN(t);
}
function hN(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state)
  };
}
function xq(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state)
    };
}
const Eq = {
  Unknown: "Unknown",
  CommittedSuccess: "CommittedSuccess",
  CommittedFailure: "CommittedFailure",
  CommitPendingOutcomeUnknown: "CommitPendingOutcomeUnknown",
  PermanentlyRejected: "PermanentlyRejected",
  LikelyButNotCertainRejection: "LikelyButNotCertainRejection",
  Pending: "Pending"
};
function jd(t) {
  return vN(t);
}
function vN(t, e) {
  return t;
}
function Rq(t) {
  return t;
}
const Iq = {
  TransactionNotFoundError: "TransactionNotFoundError"
};
function Pq(t) {
  let e = !0;
  return e = e && "intent_hash" in t, e;
}
function Vq(t) {
  return bN(t);
}
function bN(t, e) {
  return t == null ? t : {
    intent_hash: t.intent_hash,
    type: c(t, "type") ? t.type : void 0
  };
}
function Jq(t) {
  if (t !== void 0)
    return t === null ? null : {
      intent_hash: t.intent_hash,
      type: t.type
    };
}
const Cq = {
  HandlingSubmission: "HandlingSubmission",
  Concluded: "Concluded"
};
function SN(t) {
  return ON(t);
}
function ON(t, e) {
  return t;
}
function Dq(t) {
  return t;
}
const Mq = {
  Unknown: "Unknown",
  CommittedSuccess: "CommittedSuccess",
  CommittedFailure: "CommittedFailure",
  CommitPendingOutcomeUnknown: "CommitPendingOutcomeUnknown",
  PermanentlyRejected: "PermanentlyRejected",
  TemporarilyRejected: "TemporarilyRejected",
  Pending: "Pending"
};
function NN(t) {
  return wN(t);
}
function wN(t, e) {
  return t;
}
function qq(t) {
  return t;
}
function $q(t) {
  let e = !0;
  return e = e && "use_free_credit" in t, e = e && "assume_all_signature_proofs" in t, e = e && "skip_epoch_check" in t, e;
}
function TN(t) {
  return AN(t);
}
function AN(t, e) {
  return t == null ? t : {
    use_free_credit: t.use_free_credit,
    assume_all_signature_proofs: t.assume_all_signature_proofs,
    skip_epoch_check: t.skip_epoch_check
  };
}
function kN(t) {
  if (t !== void 0)
    return t === null ? null : {
      use_free_credit: t.use_free_credit,
      assume_all_signature_proofs: t.assume_all_signature_proofs,
      skip_epoch_check: t.skip_epoch_check
    };
}
function Uq(t) {
  let e = !0;
  return e = e && "manifest" in t, e = e && "start_epoch_inclusive" in t, e = e && "end_epoch_exclusive" in t, e = e && "tip_percentage" in t, e = e && "nonce" in t, e = e && "signer_public_keys" in t, e = e && "flags" in t, e;
}
function Lq(t) {
  return FN(t);
}
function FN(t, e) {
  return t == null ? t : {
    manifest: t.manifest,
    blobs_hex: c(t, "blobs_hex") ? t.blobs_hex : void 0,
    start_epoch_inclusive: t.start_epoch_inclusive,
    end_epoch_exclusive: t.end_epoch_exclusive,
    notary_public_key: c(t, "notary_public_key") ? gn(t.notary_public_key) : void 0,
    notary_is_signatory: c(t, "notary_is_signatory") ? t.notary_is_signatory : void 0,
    tip_percentage: t.tip_percentage,
    nonce: t.nonce,
    signer_public_keys: t.signer_public_keys.map(gn),
    flags: TN(t.flags)
  };
}
function xN(t) {
  if (t !== void 0)
    return t === null ? null : {
      manifest: t.manifest,
      blobs_hex: t.blobs_hex,
      start_epoch_inclusive: t.start_epoch_inclusive,
      end_epoch_exclusive: t.end_epoch_exclusive,
      notary_public_key: hn(t.notary_public_key),
      notary_is_signatory: t.notary_is_signatory,
      tip_percentage: t.tip_percentage,
      nonce: t.nonce,
      signer_public_keys: t.signer_public_keys.map(hn),
      flags: kN(t.flags)
    };
}
function jq(t) {
  let e = !0;
  return e = e && "level" in t, e = e && "message" in t, e;
}
function EN(t) {
  return RN(t);
}
function RN(t, e) {
  return t == null ? t : {
    level: t.level,
    message: t.message
  };
}
function IN(t) {
  if (t !== void 0)
    return t === null ? null : {
      level: t.level,
      message: t.message
    };
}
function Kq(t) {
  let e = !0;
  return e = e && "encoded_receipt" in t, e = e && "receipt" in t, e = e && "resource_changes" in t, e = e && "logs" in t, e;
}
function PN(t) {
  return VN(t);
}
function VN(t, e) {
  return t == null ? t : {
    encoded_receipt: t.encoded_receipt,
    receipt: t.receipt,
    resource_changes: t.resource_changes,
    logs: t.logs.map(EN)
  };
}
function Bq(t) {
  if (t !== void 0)
    return t === null ? null : {
      encoded_receipt: t.encoded_receipt,
      receipt: t.receipt,
      resource_changes: t.resource_changes,
      logs: t.logs.map(IN)
    };
}
function Zq(t) {
  let e = !0;
  return e = e && "intent_hash" in t, e;
}
function zq(t) {
  return JN(t);
}
function JN(t, e) {
  return t == null ? t : {
    intent_hash: t.intent_hash
  };
}
function CN(t) {
  if (t !== void 0)
    return t === null ? null : {
      intent_hash: t.intent_hash
    };
}
function Gq(t) {
  let e = !0;
  return e = e && "intent_hash" in t, e;
}
function Wq(t) {
  return DN(t);
}
function DN(t, e) {
  return t == null ? t : {
    intent_hash: t.intent_hash
  };
}
function Hq(t) {
  if (t !== void 0)
    return t === null ? null : {
      intent_hash: t.intent_hash
    };
}
function Yq(t) {
  let e = !0;
  return e = e && "payload_hash" in t, e = e && "status" in t, e;
}
function Kd(t) {
  return MN(t);
}
function MN(t, e) {
  return t == null ? t : {
    payload_hash: t.payload_hash,
    status: ma(t.status),
    payload_status: c(t, "payload_status") ? NN(t.payload_status) : void 0,
    payload_status_description: c(t, "payload_status_description") ? t.payload_status_description : void 0,
    error_message: c(t, "error_message") ? t.error_message : void 0,
    latest_error_message: c(t, "latest_error_message") ? t.latest_error_message : void 0,
    handling_status: c(t, "handling_status") ? SN(t.handling_status) : void 0,
    handling_status_reason: c(t, "handling_status_reason") ? t.handling_status_reason : void 0,
    submission_error: c(t, "submission_error") ? t.submission_error : void 0
  };
}
function Bd(t) {
  if (t !== void 0)
    return t === null ? null : {
      payload_hash: t.payload_hash,
      status: t.status,
      payload_status: t.payload_status,
      payload_status_description: t.payload_status_description,
      error_message: t.error_message,
      latest_error_message: t.latest_error_message,
      handling_status: t.handling_status,
      handling_status_reason: t.handling_status_reason,
      submission_error: t.submission_error
    };
}
function Xq(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "status" in t, e = e && "intent_status" in t, e = e && "intent_status_description" in t, e = e && "known_payloads" in t, e;
}
function qN(t) {
  return $N(t);
}
function $N(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    status: ma(t.status),
    intent_status: jd(t.intent_status),
    intent_status_description: t.intent_status_description,
    known_payloads: t.known_payloads.map(Kd),
    committed_state_version: c(t, "committed_state_version") ? t.committed_state_version : void 0,
    error_message: c(t, "error_message") ? t.error_message : void 0
  };
}
function Qq(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      status: t.status,
      intent_status: t.intent_status,
      intent_status_description: t.intent_status_description,
      known_payloads: t.known_payloads.map(Bd),
      committed_state_version: t.committed_state_version,
      error_message: t.error_message
    };
}
function t$(t) {
  let e = !0;
  return e = e && "status" in t, e = e && "intent_status" in t, e = e && "intent_status_description" in t, e = e && "known_payloads" in t, e;
}
function e$(t) {
  return UN(t);
}
function UN(t, e) {
  return t == null ? t : {
    status: ma(t.status),
    intent_status: jd(t.intent_status),
    intent_status_description: t.intent_status_description,
    known_payloads: t.known_payloads.map(Kd),
    committed_state_version: c(t, "committed_state_version") ? t.committed_state_version : void 0,
    error_message: c(t, "error_message") ? t.error_message : void 0
  };
}
function n$(t) {
  if (t !== void 0)
    return t === null ? null : {
      status: t.status,
      intent_status: t.intent_status,
      intent_status_description: t.intent_status_description,
      known_payloads: t.known_payloads.map(Bd),
      committed_state_version: t.committed_state_version,
      error_message: t.error_message
    };
}
function a$(t) {
  let e = !0;
  return e = e && "notarized_transaction_hex" in t, e;
}
function r$(t) {
  return LN(t);
}
function LN(t, e) {
  return t == null ? t : {
    notarized_transaction_hex: t.notarized_transaction_hex
  };
}
function jN(t) {
  if (t !== void 0)
    return t === null ? null : {
      notarized_transaction_hex: t.notarized_transaction_hex
    };
}
function i$(t) {
  let e = !0;
  return e = e && "duplicate" in t, e;
}
function KN(t) {
  return BN(t);
}
function BN(t, e) {
  return t == null ? t : {
    duplicate: t.duplicate
  };
}
function s$(t) {
  if (t !== void 0)
    return t === null ? null : {
      duplicate: t.duplicate
    };
}
function o$(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function u$(t) {
  return ZN(t);
}
function ZN(t, e) {
  return t == null ? t : {
    items: t.items.map(Dd)
  };
}
function l$(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items.map(Md)
    };
}
function c$(t) {
  let e = !0;
  return e = e && "address" in t, e = e && "epochs_active_in" in t, e;
}
function zN(t) {
  return GN(t);
}
function GN(t, e) {
  return t == null ? t : {
    address: t.address,
    proposals_made: c(t, "proposals_made") ? t.proposals_made : void 0,
    proposals_missed: c(t, "proposals_missed") ? t.proposals_missed : void 0,
    epochs_active_in: t.epochs_active_in
  };
}
function WN(t) {
  if (t !== void 0)
    return t === null ? null : {
      address: t.address,
      proposals_made: t.proposals_made,
      proposals_missed: t.proposals_missed,
      epochs_active_in: t.epochs_active_in
    };
}
function d$(t) {
  let e = !0;
  return e = e && "items" in t, e;
}
function Zd(t) {
  return HN(t);
}
function HN(t, e) {
  return t == null ? t : {
    items: t.items.map(zN)
  };
}
function zd(t) {
  if (t !== void 0)
    return t === null ? null : {
      items: t.items.map(WN)
    };
}
function f$(t) {
  return !0;
}
function p$(t) {
  return YN(t);
}
function YN(t, e) {
  return t == null ? t : {
    at_ledger_state: c(t, "at_ledger_state") ? pt(t.at_ledger_state) : void 0,
    from_ledger_state: c(t, "from_ledger_state") ? pt(t.from_ledger_state) : void 0,
    validator_addresses: c(t, "validator_addresses") ? t.validator_addresses : void 0
  };
}
function XN(t) {
  if (t !== void 0)
    return t === null ? null : {
      at_ledger_state: mt(t.at_ledger_state),
      from_ledger_state: mt(t.from_ledger_state),
      validator_addresses: t.validator_addresses
    };
}
function m$(t) {
  return !0;
}
function y$(t) {
  return QN(t);
}
function QN(t, e) {
  return t == null ? t : {
    validator_addresses: c(t, "validator_addresses") ? t.validator_addresses : void 0
  };
}
function _$(t) {
  if (t !== void 0)
    return t === null ? null : {
      validator_addresses: t.validator_addresses
    };
}
function g$(t) {
  let e = !0;
  return e = e && "ledger_state" in t, e = e && "validators" in t, e;
}
function tw(t) {
  return ew(t);
}
function ew(t, e) {
  return t == null ? t : {
    ledger_state: yt(t.ledger_state),
    validators: Zd(t.validators)
  };
}
function h$(t) {
  if (t !== void 0)
    return t === null ? null : {
      ledger_state: _t(t.ledger_state),
      validators: zd(t.validators)
    };
}
function v$(t) {
  let e = !0;
  return e = e && "validators" in t, e;
}
function b$(t) {
  return nw(t);
}
function nw(t, e) {
  return t == null ? t : {
    validators: Zd(t.validators)
  };
}
function S$(t) {
  if (t !== void 0)
    return t === null ? null : {
      validators: zd(t.validators)
    };
}
class aw extends pa {
  async entityFungibleResourceVaultPageRaw(e, n) {
    if (e.stateEntityFungibleResourceVaultsPageRequest === null || e.stateEntityFungibleResourceVaultsPageRequest === void 0)
      throw new vt("stateEntityFungibleResourceVaultsPageRequest", "Required parameter requestParameters.stateEntityFungibleResourceVaultsPageRequest was null or undefined when calling entityFungibleResourceVaultPage.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/entity/page/fungible-vaults/",
      method: "POST",
      headers: r,
      query: a,
      body: $O(e.stateEntityFungibleResourceVaultsPageRequest)
    }, n);
    return new ct(i, (s) => LO(s));
  }
  async entityFungibleResourceVaultPage(e, n) {
    return await (await this.entityFungibleResourceVaultPageRaw(e, n)).value();
  }
  async entityFungiblesPageRaw(e, n) {
    if (e.stateEntityFungiblesPageRequest === null || e.stateEntityFungiblesPageRequest === void 0)
      throw new vt("stateEntityFungiblesPageRequest", "Required parameter requestParameters.stateEntityFungiblesPageRequest was null or undefined when calling entityFungiblesPage.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/entity/page/fungibles/",
      method: "POST",
      headers: r,
      query: a,
      body: ZO(e.stateEntityFungiblesPageRequest)
    }, n);
    return new ct(i, (s) => GO(s));
  }
  async entityFungiblesPage(e, n) {
    return await (await this.entityFungiblesPageRaw(e, n)).value();
  }
  async entityMetadataPageRaw(e, n) {
    if (e.stateEntityMetadataPageRequest === null || e.stateEntityMetadataPageRequest === void 0)
      throw new vt("stateEntityMetadataPageRequest", "Required parameter requestParameters.stateEntityMetadataPageRequest was null or undefined when calling entityMetadataPage.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/entity/page/metadata",
      method: "POST",
      headers: r,
      query: a,
      body: YO(e.stateEntityMetadataPageRequest)
    }, n);
    return new ct(i, (s) => QO(s));
  }
  async entityMetadataPage(e, n) {
    return await (await this.entityMetadataPageRaw(e, n)).value();
  }
  async entityNonFungibleIdsPageRaw(e, n) {
    if (e.stateEntityNonFungibleIdsPageRequest === null || e.stateEntityNonFungibleIdsPageRequest === void 0)
      throw new vt("stateEntityNonFungibleIdsPageRequest", "Required parameter requestParameters.stateEntityNonFungibleIdsPageRequest was null or undefined when calling entityNonFungibleIdsPage.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/entity/page/non-fungible-vault/ids",
      method: "POST",
      headers: r,
      query: a,
      body: n0(e.stateEntityNonFungibleIdsPageRequest)
    }, n);
    return new ct(i, (s) => r0(s));
  }
  async entityNonFungibleIdsPage(e, n) {
    return await (await this.entityNonFungibleIdsPageRaw(e, n)).value();
  }
  async entityNonFungibleResourceVaultPageRaw(e, n) {
    if (e.stateEntityNonFungibleResourceVaultsPageRequest === null || e.stateEntityNonFungibleResourceVaultsPageRequest === void 0)
      throw new vt("stateEntityNonFungibleResourceVaultsPageRequest", "Required parameter requestParameters.stateEntityNonFungibleResourceVaultsPageRequest was null or undefined when calling entityNonFungibleResourceVaultPage.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/entity/page/non-fungible-vaults/",
      method: "POST",
      headers: r,
      query: a,
      body: u0(e.stateEntityNonFungibleResourceVaultsPageRequest)
    }, n);
    return new ct(i, (s) => c0(s));
  }
  async entityNonFungibleResourceVaultPage(e, n) {
    return await (await this.entityNonFungibleResourceVaultPageRaw(e, n)).value();
  }
  async entityNonFungiblesPageRaw(e, n) {
    if (e.stateEntityNonFungiblesPageRequest === null || e.stateEntityNonFungiblesPageRequest === void 0)
      throw new vt("stateEntityNonFungiblesPageRequest", "Required parameter requestParameters.stateEntityNonFungiblesPageRequest was null or undefined when calling entityNonFungiblesPage.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/entity/page/non-fungibles/",
      method: "POST",
      headers: r,
      query: a,
      body: m0(e.stateEntityNonFungiblesPageRequest)
    }, n);
    return new ct(i, (s) => _0(s));
  }
  async entityNonFungiblesPage(e, n) {
    return await (await this.entityNonFungiblesPageRaw(e, n)).value();
  }
  async keyValueStoreDataRaw(e, n) {
    if (e.stateKeyValueStoreDataRequest === null || e.stateKeyValueStoreDataRequest === void 0)
      throw new vt("stateKeyValueStoreDataRequest", "Required parameter requestParameters.stateKeyValueStoreDataRequest was null or undefined when calling keyValueStoreData.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/key-value-store/data",
      method: "POST",
      headers: r,
      query: a,
      body: b0(e.stateKeyValueStoreDataRequest)
    }, n);
    return new ct(i, (s) => N0(s));
  }
  async keyValueStoreData(e, n) {
    return await (await this.keyValueStoreDataRaw(e, n)).value();
  }
  async nonFungibleDataRaw(e, n) {
    if (e.stateNonFungibleDataRequest === null || e.stateNonFungibleDataRequest === void 0)
      throw new vt("stateNonFungibleDataRequest", "Required parameter requestParameters.stateNonFungibleDataRequest was null or undefined when calling nonFungibleData.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/non-fungible/data",
      method: "POST",
      headers: r,
      query: a,
      body: k0(e.stateNonFungibleDataRequest)
    }, n);
    return new ct(i, (s) => x0(s));
  }
  async nonFungibleData(e, n) {
    return await (await this.nonFungibleDataRaw(e, n)).value();
  }
  async nonFungibleIdsRaw(e, n) {
    if (e.stateNonFungibleIdsRequest === null || e.stateNonFungibleIdsRequest === void 0)
      throw new vt("stateNonFungibleIdsRequest", "Required parameter requestParameters.stateNonFungibleIdsRequest was null or undefined when calling nonFungibleIds.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/non-fungible/ids",
      method: "POST",
      headers: r,
      query: a,
      body: P0(e.stateNonFungibleIdsRequest)
    }, n);
    return new ct(i, (s) => J0(s));
  }
  async nonFungibleIds(e, n) {
    return await (await this.nonFungibleIdsRaw(e, n)).value();
  }
  async nonFungibleLocationRaw(e, n) {
    if (e.stateNonFungibleLocationRequest === null || e.stateNonFungibleLocationRequest === void 0)
      throw new vt("stateNonFungibleLocationRequest", "Required parameter requestParameters.stateNonFungibleLocationRequest was null or undefined when calling nonFungibleLocation.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/non-fungible/location",
      method: "POST",
      headers: r,
      query: a,
      body: q0(e.stateNonFungibleLocationRequest)
    }, n);
    return new ct(i, (s) => L0(s));
  }
  async nonFungibleLocation(e, n) {
    return await (await this.nonFungibleLocationRaw(e, n)).value();
  }
  async stateEntityDetailsRaw(e, n) {
    if (e.stateEntityDetailsRequest === null || e.stateEntityDetailsRequest === void 0)
      throw new vt("stateEntityDetailsRequest", "Required parameter requestParameters.stateEntityDetailsRequest was null or undefined when calling stateEntityDetails.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/entity/details",
      method: "POST",
      headers: r,
      query: a,
      body: sO(e.stateEntityDetailsRequest)
    }, n);
    return new ct(i, (s) => TO(s));
  }
  async stateEntityDetails(e, n) {
    return await (await this.stateEntityDetailsRaw(e, n)).value();
  }
  async stateValidatorsListRaw(e, n) {
    if (e.stateValidatorsListRequest === null || e.stateValidatorsListRequest === void 0)
      throw new vt("stateValidatorsListRequest", "Required parameter requestParameters.stateValidatorsListRequest was null or undefined when calling stateValidatorsList.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/state/validators/list",
      method: "POST",
      headers: r,
      query: a,
      body: Z0(e.stateValidatorsListRequest)
    }, n);
    return new ct(i, (s) => tN(s));
  }
  async stateValidatorsList(e, n) {
    return await (await this.stateValidatorsListRaw(e, n)).value();
  }
}
class rw extends pa {
  async validatorsUptimeRaw(e, n) {
    if (e.validatorsUptimeRequest === null || e.validatorsUptimeRequest === void 0)
      throw new vt("validatorsUptimeRequest", "Required parameter requestParameters.validatorsUptimeRequest was null or undefined when calling validatorsUptime.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/statistics/validators/uptime",
      method: "POST",
      headers: r,
      query: a,
      body: XN(e.validatorsUptimeRequest)
    }, n);
    return new ct(i, (s) => tw(s));
  }
  async validatorsUptime(e, n) {
    return await (await this.validatorsUptimeRaw(e, n)).value();
  }
}
class iw extends pa {
  async gatewayStatusRaw(e) {
    const n = {}, a = {}, r = await this.request({
      path: "/status/gateway-status",
      method: "POST",
      headers: a,
      query: n
    }, e);
    return new ct(r, (i) => ub(i));
  }
  async gatewayStatus(e) {
    return await (await this.gatewayStatusRaw(e)).value();
  }
  async networkConfigurationRaw(e) {
    const n = {}, a = {}, r = await this.request({
      path: "/status/network-configuration",
      method: "POST",
      headers: a,
      query: n
    }, e);
    return new ct(r, (i) => tS(i));
  }
  async networkConfiguration(e) {
    return await (await this.networkConfigurationRaw(e)).value();
  }
}
class sw extends pa {
  async streamTransactionsRaw(e, n) {
    if (e.streamTransactionsRequest === null || e.streamTransactionsRequest === void 0)
      throw new vt("streamTransactionsRequest", "Required parameter requestParameters.streamTransactionsRequest was null or undefined when calling streamTransactions.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/stream/transactions",
      method: "POST",
      headers: r,
      query: a,
      body: sN(e.streamTransactionsRequest)
    }, n);
    return new ct(i, (s) => uN(s));
  }
  async streamTransactions(e, n) {
    return await (await this.streamTransactionsRaw(e, n)).value();
  }
}
class ow extends pa {
  async transactionCommittedDetailsRaw(e, n) {
    if (e.transactionCommittedDetailsRequest === null || e.transactionCommittedDetailsRequest === void 0)
      throw new vt("transactionCommittedDetailsRequest", "Required parameter requestParameters.transactionCommittedDetailsRequest was null or undefined when calling transactionCommittedDetails.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/transaction/committed-details",
      method: "POST",
      headers: r,
      query: a,
      body: fN(e.transactionCommittedDetailsRequest)
    }, n);
    return new ct(i, (s) => mN(s));
  }
  async transactionCommittedDetails(e, n) {
    return await (await this.transactionCommittedDetailsRaw(e, n)).value();
  }
  async transactionConstructionRaw(e) {
    const n = {}, a = {}, r = await this.request({
      path: "/transaction/construction",
      method: "POST",
      headers: a,
      query: n
    }, e);
    return new ct(r, (i) => gN(i));
  }
  async transactionConstruction(e) {
    return await (await this.transactionConstructionRaw(e)).value();
  }
  async transactionPreviewRaw(e, n) {
    if (e.transactionPreviewRequest === null || e.transactionPreviewRequest === void 0)
      throw new vt("transactionPreviewRequest", "Required parameter requestParameters.transactionPreviewRequest was null or undefined when calling transactionPreview.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/transaction/preview",
      method: "POST",
      headers: r,
      query: a,
      body: xN(e.transactionPreviewRequest)
    }, n);
    return new ct(i, (s) => PN(s));
  }
  async transactionPreview(e, n) {
    return await (await this.transactionPreviewRaw(e, n)).value();
  }
  async transactionStatusRaw(e, n) {
    if (e.transactionStatusRequest === null || e.transactionStatusRequest === void 0)
      throw new vt("transactionStatusRequest", "Required parameter requestParameters.transactionStatusRequest was null or undefined when calling transactionStatus.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/transaction/status",
      method: "POST",
      headers: r,
      query: a,
      body: CN(e.transactionStatusRequest)
    }, n);
    return new ct(i, (s) => qN(s));
  }
  async transactionStatus(e, n) {
    return await (await this.transactionStatusRaw(e, n)).value();
  }
  async transactionSubmitRaw(e, n) {
    if (e.transactionSubmitRequest === null || e.transactionSubmitRequest === void 0)
      throw new vt("transactionSubmitRequest", "Required parameter requestParameters.transactionSubmitRequest was null or undefined when calling transactionSubmit.");
    const a = {}, r = {};
    r["Content-Type"] = "application/json";
    const i = await this.request({
      path: "/transaction/submit",
      method: "POST",
      headers: r,
      query: a,
      body: jN(e.transactionSubmitRequest)
    }, n);
    return new ct(i, (s) => KN(s));
  }
  async transactionSubmit(e, n) {
    return await (await this.transactionSubmitRaw(e, n)).value();
  }
}
const qa = (t, e) => {
  const n = [];
  for (let a = 0, r = t.length; a < r; a += e)
    n.push(t.slice(a, a + e));
  return n;
}, Go = async (t, e) => {
  let n = e;
  const a = [];
  do {
    const r = await t(n);
    a.push(...r.items), n = r.next_cursor;
  } while (n);
  return a;
}, Wo = async (t, e) => {
  let n = e;
  const a = [];
  let r;
  do {
    const i = await t(n);
    r = i.ledger_state, a.push(...i.items), n = i.next_cursor;
  } while (n);
  return {
    aggregatedEntities: a,
    ledger_state: r
  };
};
class uw {
  constructor(e, n) {
    this.innerClient = e, this.configuration = n;
  }
  async getEntityDetailsVaultAggregated(e, n, a) {
    var r, i, s, o, l;
    const u = Array.isArray(e);
    if (u && e.length === 0)
      return Promise.resolve([]);
    if (u && e.length > this.configuration.maxAddressesCount) {
      const y = qa(e, this.configuration.maxAddressesCount);
      return Promise.all(
        y.map(
          (_) => this.getEntityDetailsVaultAggregated(_, n, a)
        )
      ).then((_) => _.flat());
    }
    const { items: f, ledger_state: m } = await this.innerClient.stateEntityDetails({
      stateEntityDetailsRequest: {
        addresses: u ? e : [e],
        aggregation_level: Xv.Vault,
        opt_ins: {
          ancestor_identities: (r = n == null ? void 0 : n.ancestorIdentities) != null ? r : !1,
          component_royalty_vault_balance: (i = n == null ? void 0 : n.componentRoyaltyVaultBalance) != null ? i : !1,
          package_royalty_vault_balance: (s = n == null ? void 0 : n.packageRoyaltyVaultBalance) != null ? s : !1,
          non_fungible_include_nfids: (o = n == null ? void 0 : n.nonFungibleIncludeNfids) != null ? o : !0,
          explicit_metadata: (l = n == null ? void 0 : n.explicitMetadata) != null ? l : []
        },
        at_ledger_state: a
      }
    }).then((y) => this.ensureResourcesProperties(y));
    return u ? Promise.all(
      f.map(
        (y) => this.queryAllFungibles(
          y,
          a || {
            state_version: m.state_version
          }
        )
      )
    ) : this.queryAllFungibles(
      f[0],
      a || {
        state_version: m.state_version
      }
    );
  }
  async getEntityMetadata(e, n) {
    return this.innerClient.entityMetadataPage({
      stateEntityMetadataPageRequest: {
        address: e,
        cursor: n
      }
    });
  }
  async getNonFungibleLocation(e, n) {
    if (n.length > this.configuration.maxNftIdsCount) {
      const a = qa(n, this.configuration.maxNftIdsCount);
      return Promise.all(
        a.map((r) => this.getNonFungibleLocation(e, r))
      ).then((r) => r.flat());
    }
    return this.innerClient.nonFungibleLocation({
      stateNonFungibleLocationRequest: {
        resource_address: e,
        non_fungible_ids: n
      }
    }).then((a) => a.non_fungible_ids);
  }
  async getAllEntityMetadata(e, n) {
    return Go(
      this.getEntityMetadata.bind(this, e),
      n
    );
  }
  async getValidators(e) {
    return this.innerClient.stateValidatorsList({
      stateValidatorsListRequest: {
        cursor: e || null
      }
    }).then(({ validators: n }) => n);
  }
  async getAllValidators(e) {
    return Go(this.getValidators.bind(this), e);
  }
  async getValidatorsWithLedgerState(e) {
    return this.innerClient.stateValidatorsList({
      stateValidatorsListRequest: {
        cursor: e || null
      }
    });
  }
  async getAllValidatorsWithLedgerState(e) {
    return Wo(
      (n) => this.getValidatorsWithLedgerState(n).then((a) => ({
        items: a.validators.items,
        ledger_state: a.ledger_state
      })),
      e
    );
  }
  async getNonFungibleIds(e, n, a) {
    return this.innerClient.nonFungibleIds({
      stateNonFungibleIdsRequest: {
        resource_address: e,
        cursor: a,
        at_ledger_state: n
      }
    }).then(({ non_fungible_ids: r }) => r);
  }
  async getAllNonFungibleIds(e, n, a) {
    let r = a, i = n;
    const s = [];
    do {
      const o = await this.innerClient.nonFungibleIds({
        stateNonFungibleIdsRequest: {
          resource_address: e,
          cursor: i,
          at_ledger_state: r
        }
      });
      s.push(...o.non_fungible_ids.items), r = r || {
        state_version: o.ledger_state.state_version
      }, i = o.non_fungible_ids.next_cursor;
    } while (i);
    return s;
  }
  async getNonFungibleData(e, n, a) {
    const r = Array.isArray(n);
    if (r && n.length === 0)
      return Promise.resolve([]);
    if (r && n.length > this.configuration.maxNftIdsCount) {
      const s = qa(n, this.configuration.maxNftIdsCount);
      return Promise.all(
        s.map(
          (o) => this.getNonFungibleData(e, o, a)
        )
      ).then((o) => o.flat());
    }
    const { non_fungible_ids: i } = await this.innerClient.nonFungibleData({
      stateNonFungibleDataRequest: {
        resource_address: e,
        non_fungible_ids: r ? n : [n],
        at_ledger_state: a
      }
    });
    return r ? i : i[0];
  }
  async getEntityFungiblesPageVaultAggregated(e, n, a) {
    return this.innerClient.entityFungiblesPage({
      stateEntityFungiblesPageRequest: {
        address: e,
        cursor: n,
        aggregation_level: "Vault",
        at_ledger_state: a
      }
    });
  }
  async queryAllFungibles(e, n) {
    var a, r;
    const i = (a = e == null ? void 0 : e.fungible_resources) == null ? void 0 : a.next_cursor;
    if (!i)
      return Promise.resolve(e);
    const s = await Wo(
      (o) => this.getEntityFungiblesPageVaultAggregated(
        e.address,
        o,
        n
      ),
      i
    );
    return Promise.resolve({
      ...e,
      fungible_resources: {
        items: [
          ...((r = e == null ? void 0 : e.fungible_resources) == null ? void 0 : r.items) || [],
          ...s.aggregatedEntities
        ]
      }
    });
  }
  ensureResourcesProperties(e) {
    return {
      ...e,
      items: e.items.map((n) => ({
        ...n,
        fungible_resources: n.fungible_resources || {
          total_count: 0,
          items: []
        },
        non_fungible_resources: n.non_fungible_resources || {
          total_count: 0,
          items: []
        }
      }))
    };
  }
}
const lw = 20, cw = 29, es = 200, dw = "1.2.0", ie = {
  Mainnet: 1,
  Stokenet: 2,
  Alphanet: 10,
  Betanet: 11,
  Kisharnet: 12,
  RCnetV1: 12,
  Zabanet: 14,
  RCnetV3: 14,
  Gilganet: 32,
  Enkinet: 33,
  Hammunet: 34,
  Nergalnet: 35,
  Mardunet: 36,
  Dumunet: 37,
  LocalNet: 240,
  InternalTestNet: 241,
  Simulator: 242
}, fw = {
  Mainnet: {
    networkName: "Mainnet",
    networkId: ie.Mainnet,
    gatewayUrl: "https://mainnet.radixdlt.com",
    dashboardUrl: "https://dashboard.radixdlt.com"
  },
  Stokenet: {
    networkName: "Stokenet",
    networkId: ie.Stokenet,
    gatewayUrl: "https://babylon-stokenet-gateway.radixdlt.com",
    dashboardUrl: "https://stokenet-dashboard.radixdlt.com"
  },
  Kisharnet: {
    networkName: "Kisharnet",
    networkId: ie.Kisharnet,
    gatewayUrl: "https://kisharnet-gateway.radixdlt.com",
    dashboardUrl: "https://kisharnet-dashboard.radixdlt.com"
  },
  RCnetV1: {
    networkName: "RCnetV1",
    networkId: ie.RCnetV1,
    gatewayUrl: "https://rcnet.radixdlt.com",
    dashboardUrl: "https://rcnet-dashboard.radixdlt.com"
  },
  Zabanet: {
    networkName: "Zabanet",
    networkId: ie.Zabanet,
    gatewayUrl: "https://zabanet-gateway.radixdlt.com",
    dashboardUrl: "https://rcnet-v3-dashboard.radixdlt.com"
  },
  RCnetV3: {
    networkName: "RCNetV3",
    networkId: ie.RCnetV3,
    gatewayUrl: "https://zabanet-gateway.radixdlt.com",
    dashboardUrl: "https://rcnet-v3-dashboard.radixdlt.com"
  },
  Gilganet: {
    networkName: "Gilganet",
    networkId: ie.Gilganet,
    gatewayUrl: "https://gilganet-gateway.radixdlt.com",
    dashboardUrl: ""
  },
  Enkinet: {
    networkName: "Enkinet",
    networkId: ie.Enkinet,
    gatewayUrl: "https://enkinet-gateway.radixdlt.com",
    dashboardUrl: "https://enkinet-dashboard.rdx-works-main.extratools.works"
  },
  Hammunet: {
    networkName: "Hammunet",
    networkId: ie.Hammunet,
    gatewayUrl: "https://hammunet-gateway.radixdlt.com",
    dashboardUrl: "https://hammunet-dashboard.rdx-works-main.extratools.works"
  },
  Dumunet: {
    networkName: "Dumunet",
    networkId: ie.Dumunet,
    gatewayUrl: "https://dumunet-gateway.radixdlt.com",
    dashboardUrl: "https://dumunet-dashboard.rdx-works-main.extratools.works"
  }
}, Ho = Object.values(fw).reduce(
  (t, e) => (t[e.networkId] = e, t),
  {}
);
class pw {
  constructor(e, n) {
    this.innerClient = e, this.configuration = n;
  }
  getValidatorsUptimeFromTo(e, n, a) {
    var r, i;
    if (e.length > (((r = this.configuration) == null ? void 0 : r.maxValidatorsUptimeCount) || es)) {
      const s = qa(
        e,
        ((i = this.configuration) == null ? void 0 : i.maxValidatorsUptimeCount) || es
      );
      return Promise.all(
        s.map((o) => this.getValidatorsUptimeFromTo(o, n, a))
      ).then((o) => o.flat());
    }
    return this.innerClient.validatorsUptime({
      validatorsUptimeRequest: {
        validator_addresses: e,
        from_ledger_state: n !== void 0 ? n instanceof Date ? { timestamp: n } : { state_version: n } : void 0,
        at_ledger_state: a !== void 0 ? a instanceof Date ? { timestamp: a } : { state_version: a } : void 0
      }
    }).then((s) => s.validators.items);
  }
  getValidatorsUptime(e) {
    return this.innerClient.validatorsUptime({
      validatorsUptimeRequest: {
        validator_addresses: e
      }
    });
  }
}
class mw {
  constructor(e) {
    this.innerClient = e;
  }
  getCurrent() {
    return this.innerClient.gatewayStatus();
  }
  getNetworkConfiguration() {
    return this.innerClient.networkConfiguration();
  }
}
class yw {
  constructor(e) {
    this.innerClient = e;
  }
  getTransactionsList(e, n) {
    return this.innerClient.streamTransactions({
      streamTransactionsRequest: {
        cursor: n,
        affected_global_entities_filter: e
      }
    });
  }
}
class _w {
  constructor(e) {
    this.innerClient = e;
  }
  getStatus(e) {
    return this.innerClient.transactionStatus({
      transactionStatusRequest: {
        intent_hash: e
      }
    });
  }
  getCommittedDetails(e, n) {
    var a, r, i, s, o, l, u, f, m, y;
    return this.innerClient.transactionCommittedDetails({
      transactionCommittedDetailsRequest: {
        intent_hash: e,
        opt_ins: {
          raw_hex: (a = n == null ? void 0 : n.rawHex) != null ? a : !0,
          receipt_events: (r = n == null ? void 0 : n.receiptEvents) != null ? r : !0,
          receipt_fee_source: (i = n == null ? void 0 : n.receiptFeeSource) != null ? i : !0,
          receipt_fee_destination: (s = n == null ? void 0 : n.receiptFeeDestination) != null ? s : !0,
          receipt_costing_parameters: (o = n == null ? void 0 : n.receiptCostingParameters) != null ? o : !0,
          receipt_fee_summary: (l = n == null ? void 0 : n.receiptFeeSummary) != null ? l : !0,
          receipt_state_changes: (u = n == null ? void 0 : n.receiptStateChanges) != null ? u : !0,
          affected_global_entities: (f = n == null ? void 0 : n.affectedGlobalEntities) != null ? f : !0,
          balance_changes: (m = n == null ? void 0 : n.balanceChanges) != null ? m : !0,
          receipt_output: (y = n == null ? void 0 : n.receiptOutput) != null ? y : !0
        }
      }
    });
  }
}
class gw extends wl {
  constructor(e) {
    super(e), Xt(this, "extendedConfiguration"), this.extendedConfiguration = e;
  }
  get maxAddressesCount() {
    return this.extendedConfiguration.maxAddressesCount || lw;
  }
  get maxNftIdsCount() {
    return this.extendedConfiguration.maxNftIdsCount || cw;
  }
  get maxValidatorsUptimeCount() {
    return this.extendedConfiguration.maxValidatorsUptimeCount || es;
  }
}
const hw = (t) => t ? t.endsWith("/") ? t == null ? void 0 : t.slice(0, -1) : t : "";
class fr {
  constructor(e) {
    Xt(this, "state"), Xt(this, "stream"), Xt(this, "status"), Xt(this, "transaction"), Xt(this, "statistics"), Xt(this, "lowLevel"), this.lowLevel = {
      state: new aw(e),
      stream: new sw(e),
      status: new iw(e),
      transaction: new ow(e),
      statistics: new rw(e)
    }, this.state = new uw(this.lowLevel.state, e), this.stream = new yw(this.lowLevel.stream), this.status = new mw(this.lowLevel.status), this.transaction = new _w(this.lowLevel.transaction), this.statistics = new pw(this.lowLevel.statistics, e);
  }
  static initialize(e) {
    const n = fr.constructConfiguration(e);
    return new fr(n);
  }
  static constructConfiguration(e) {
    var n, a, r, i;
    const s = hw(e == null ? void 0 : e.basePath), o = (n = e == null ? void 0 : e.applicationName) != null ? n : "Unknown";
    return new gw({
      ...e,
      basePath: s,
      applicationName: o,
      headers: {
        ...(a = e == null ? void 0 : e.headers) != null ? a : {},
        "RDX-Client-Name": "@radixdlt/babylon-gateway-api-sdk",
        "RDX-Client-Version": dw,
        "RDX-App-Name": o,
        "RDX-App-Version": (r = e.applicationVersion) != null ? r : "Unknown",
        "RDX-App-Dapp-Definition": (i = e.applicationDappDefinitionAddress) != null ? i : "Unknown"
      }
    });
  }
}
const vw = (t) => {
  const e = t.logger, n = t.requestItemClient, a = t.walletSdk, r = t.gatewayClient, i = new Vt(), s = (f) => {
    const m = new Vt();
    return {
      eventCallback: (y) => {
        m.next(y);
      },
      requestControl: ({ cancelRequest: y, getRequest: _ }) => {
        oi(
          m.pipe(
            pe((S) => S === "receivedByWallet"),
            oe(() => _()),
            W((S) => {
              S.items.discriminator === "transaction" && n.patch(f, { showCancel: !1 });
            })
          )
        ), oi(
          Rn(t.onCancelRequestItem$, i).pipe(
            pe((S) => S === f),
            we(() => (n.cancel(f), n.updateStatus({
              id: f,
              status: "fail",
              error: "userCancelledRequest"
            }), y()))
          )
        );
      }
    };
  }, o = (f, m) => a.request(f, s(m)).map((y) => (e == null || e.debug("⬇️walletSuccessResponse", y), y)).mapErr((y) => (e == null || e.debug("⬇️walletErrorResponse", y), n.updateStatus({
    id: m,
    status: "fail",
    error: y.error
  }), y)), l = new _e();
  return {
    request: o,
    sendTransaction: ({
      onTransactionId: f,
      ...m
    }) => {
      const { id: y } = n.add("sendTransaction");
      return a.sendTransaction({ version: 1, ...m }, s(y)).mapErr((_) => (n.updateStatus({
        id: y,
        status: "fail",
        error: _.error
      }), e == null || e.debug("⬇️ walletErrorResponse", _), _)).map((_) => (e == null || e.debug("⬇️ walletSuccessResponse", _), _)).andThen(({ transactionIntentHash: _ }) => (f && f(_), r.pollTransactionStatus(_).map((S) => ({
        transactionIntentHash: _,
        status: S.status
      })))).andThen((_) => {
        const h = [
          Bo.Rejected,
          Bo.CommittedFailure
        ].includes(
          _.status
        );
        return n.updateStatus({
          id: y,
          status: h ? "fail" : "success",
          transactionIntentHash: _.transactionIntentHash
        }), e == null || e.debug("🔁 Gateway polling finished", _), h ? ee({ ..._, error: "transactionNotSuccessful" }) : bt(_);
      });
    },
    extensionStatus$: a.extensionStatus$,
    requestItems$: n.items$,
    resetRequestItems: n.reset,
    cancelRequest: (f) => i.next(f),
    destroy: () => {
      n.destroy(), a.destroy(), l.unsubscribe();
    }
  };
}, Se = (t) => t, bw = ({
  basePath: t,
  dAppDefinitionAddress: e,
  applicationName: n,
  applicationVersion: a
}) => {
  const { transaction: r, state: i, status: s } = fr.initialize({
    basePath: t,
    applicationName: n || e || "unknown",
    applicationVersion: a,
    applicationDappDefinitionAddress: e
  });
  return {
    getTransactionStatus: (_) => dt.fromPromise(
      r.getStatus(_),
      Se
    ),
    getTransactionDetails: (_) => dt.fromPromise(
      r.getCommittedDetails(_),
      Se
    ),
    getEntityDetails: (_) => dt.fromPromise(
      i.getEntityDetailsVaultAggregated(_),
      Se
    ),
    getEntitiesDetails: (_) => dt.fromPromise(
      i.getEntityDetailsVaultAggregated(_),
      Se
    ),
    getEntityNonFungibleIds: ({
      accountAddress: _,
      nftAddress: S,
      vaultAddress: h
    }) => dt.fromPromise(
      i.innerClient.entityNonFungibleIdsPage({
        stateEntityNonFungibleIdsPageRequest: {
          address: _,
          vault_address: h,
          resource_address: S
        }
      }),
      Se
    ),
    getNetworkConfiguration: () => dt.fromPromise(s.getNetworkConfiguration(), Se),
    transactionApi: r,
    stateApi: i,
    statusApi: s
  };
}, Sw = ({
  maxDelayTime: t = 1e4,
  multiplier: e = 2,
  timeout: n,
  interval: a = 2e3
} = {}) => {
  const r = new Vt();
  let i = 0;
  const s = Rn(
    ls(0),
    r.pipe(
      oe(() => (i = i + 1, i))
    )
  ).pipe(
    we((l) => {
      const u = l * a * e, f = u > t ? t : u;
      return ui(f).pipe(oe(() => bt(l)));
    })
  ), o = n ? Rn(
    s,
    ui(n).pipe(
      oe(() => ee(fn("failedToPollSubmittedTransaction", "")))
    )
  ) : s;
  return { trigger: r, withBackoff$: o };
}, Ow = (t) => {
  var n;
  const e = (n = t == null ? void 0 : t.value) == null ? void 0 : n.typed;
  return {
    stringified: e != null && e.value ? (e == null ? void 0 : e.value) || "" : e == null ? void 0 : e.values.join(", ")
  };
}, Nw = ({
  gatewayApi: t,
  logger: e,
  retryConfig: n
}) => ({ pollTransactionStatus: (r) => {
  const i = Sw(n), s = /* @__PURE__ */ new Set([
    "CommittedSuccess",
    "CommittedFailure",
    "Rejected"
  ]);
  return dt.fromPromise(
    oi(
      i.withBackoff$.pipe(
        we((o) => o.isErr() ? [o] : (e == null || e.debug(`pollingTxStatus retry #${o.value + 1}`), t.getTransactionStatus(r).map((l) => {
          if (s.has(l.status))
            return l;
          i.trigger.next();
        }).mapErr((l) => (e == null || e.debug(l), fn("failedToPollSubmittedTransaction", ""))))),
        pe(
          (o) => o.isOk() && !!o.value || o.isErr()
        ),
        vu()
      )
    ),
    (o) => o
  ).andThen((o) => o);
}, gatewayApi: t }), ww = () => ({
  initialized: new it(!1),
  onChange: new Vt(),
  items: new it([])
}), Tw = (t, e, n) => {
  const a = n.logger, r = /* @__PURE__ */ new Set(), i = new _e(), s = /* @__PURE__ */ new Map(), o = n.subjects || ww(), l = `${t}:requestItemStore`;
  e.getData(l).map((v) => {
    v && Object.keys(v).forEach((x) => {
      r.add(x), s.set(x, v[x]);
    }), o.items.next(F());
  });
  const u = (v, x) => o.onChange.next({ oldValue: v, newValue: x }), f = (v) => ({
    type: v,
    status: "pending",
    timestamp: Date.now(),
    id: crypto.randomUUID(),
    showCancel: !0
  }), m = (v) => {
    const x = f(v);
    return s.set(x.id, x), r.add(x.id), u(void 0, x), a == null || a.trace("addRequestItem", {
      id: x.id,
      status: x.status
    }), x;
  }, y = (v) => {
    if (s.has(v)) {
      const x = s.get(v);
      s.delete(v), r.delete(v), u(x, void 0), a == null || a.trace("removeRequestItem", v);
    }
  }, _ = (v, x) => {
    const q = s.get(v);
    if (q) {
      const U = {
        ...q,
        ...x
      };
      s.set(v, U), u(q, U), a == null || a.trace("patchRequestItemStatus", U);
    }
  }, S = (v) => {
    s.has(v) && (_(v, { status: "fail", error: Qn.canceledByUser }), a == null || a.trace("cancelRequestItem", v));
  }, h = () => {
    s.clear(), r.clear(), u(void 0, void 0), a == null || a.trace("resetRequestItems");
  }, $ = ({
    id: v,
    status: x,
    error: q,
    transactionIntentHash: U
  }) => {
    const I = s.get(v);
    if (I) {
      const D = {
        ...I,
        status: x
      };
      D.status === "fail" && (D.error = q), D.status === "success" && D.type === "sendTransaction" && (D.transactionIntentHash = U), s.set(v, D), u(I, D), a == null || a.trace("updateRequestItemStatus", D);
    }
  }, z = () => [...r].reverse(), F = () => z().map((v) => ({ id: v, ...s.get(v) })).filter((v) => !!v);
  return i.add(
    o.onChange.pipe(
      oe(() => F()),
      W((v) => o.items.next(v)),
      W(() => {
        const v = Array.from(s.entries());
        e.setData(
          l,
          Object.fromEntries(
            v.filter(([, x]) => x.status !== "pending")
          )
        );
      })
    ).subscribe()
  ), {
    add: m,
    remove: y,
    cancel: S,
    updateStatus: $,
    patch: _,
    reset: h,
    destroy: () => {
      i.unsubscribe();
    },
    items$: o.items,
    change$: o.onChange.asObservable()
  };
}, Aw = (t) => {
  try {
    return bt(JSON.parse(t));
  } catch (e) {
    return ee(Se(e));
  }
}, kw = () => {
  const t = (n) => new Promise((a, r) => {
    try {
      const i = localStorage.getItem(n);
      return a(i || void 0);
    } catch (i) {
      return r(i);
    }
  }), e = (n, a) => new Promise((r, i) => {
    try {
      return localStorage.setItem(n, JSON.stringify(a)), r();
    } catch (s) {
      return i(s);
    }
  });
  return {
    getData: (n) => dt.fromPromise(t(n), Se).andThen(
      (a) => a ? Aw(a) : bt(void 0)
    ),
    setData: (n, a) => dt.fromPromise(e(n, a), Se)
  };
}, Fw = (t) => (e) => {
  var a, r, i;
  let n = [];
  if (t.discriminator === "authorizedRequest") {
    const s = ((a = t.oneTimeAccounts) == null ? void 0 : a.accounts) ?? [], o = ((r = t.ongoingAccounts) == null ? void 0 : r.accounts) ?? [];
    n = [...s, ...o];
  } else
    t.discriminator === "unauthorizedRequest" && (n = ((i = t.oneTimeAccounts) == null ? void 0 : i.accounts) ?? []);
  return st(e, (s) => {
    s.accounts = n;
  });
}, ai = (t) => {
  const e = [];
  return t.name && e.push({
    entry: "fullName",
    fields: t.name
  }), t.emailAddresses && e.push({
    entry: "emailAddresses",
    fields: t.emailAddresses
  }), t.phoneNumbers && e.push({
    entry: "phoneNumbers",
    fields: t.phoneNumbers
  }), e;
}, xw = (t) => (e) => st(e, (n) => {
  t.discriminator === "authorizedRequest" ? (t.oneTimePersonaData && (n.personaData = ai(t.oneTimePersonaData)), t.ongoingPersonaData && (n.personaData = ai(t.ongoingPersonaData))) : t.discriminator === "unauthorizedRequest" && t.oneTimePersonaData && (n.personaData = ai(t.oneTimePersonaData));
}), Ew = (t) => (e) => st(e, (n) => {
  var a;
  t.discriminator === "authorizedRequest" && (n.persona = (a = t.auth) == null ? void 0 : a.persona);
}), Rw = (t) => (e) => st(e, (n) => {
  var a, r, i, s, o, l;
  if (n.proofs = [], t.discriminator === "authorizedRequest") {
    if (t.auth.discriminator === "loginWithChallenge" && n.proofs.push({
      challenge: t.auth.challenge,
      proof: t.auth.proof,
      address: t.auth.persona.identityAddress,
      type: An.persona
    }), (a = t.ongoingAccounts) != null && a.challenge && ((r = t.ongoingAccounts.proofs) != null && r.length)) {
      const u = t.ongoingAccounts.challenge, f = t.ongoingAccounts.proofs.map(
        ({ accountAddress: m, proof: y }) => ({
          proof: y,
          address: m,
          challenge: u,
          type: An.account
        })
      );
      n.proofs.push(...f);
    }
    if ((i = t.oneTimeAccounts) != null && i.challenge && ((s = t.oneTimeAccounts.proofs) != null && s.length)) {
      const u = t.oneTimeAccounts.challenge, f = t.oneTimeAccounts.proofs.map(
        ({ accountAddress: m, proof: y }) => ({
          proof: y,
          address: m,
          challenge: u,
          type: An.account
        })
      );
      n.proofs.push(...f);
    }
  }
  if (t.discriminator === "unauthorizedRequest" && (o = t.oneTimeAccounts) != null && o.challenge && (l = t.oneTimeAccounts.proofs) != null && l.length) {
    const u = t.oneTimeAccounts.challenge, f = t.oneTimeAccounts.proofs.map(
      ({ accountAddress: m, proof: y }) => ({
        proof: y,
        address: m,
        challenge: u,
        type: An.account
      })
    );
    n.proofs.push(...f);
  }
}), Iw = (t) => bt({
  accounts: [],
  personaData: [],
  proofs: [],
  persona: void 0
}).map(Fw(t)).map(xw(t)).map(Ew(t)).map(Rw(t));
Ot({
  accounts: Ot({
    numberOfAccounts: le,
    reset: Ut(),
    oneTime: Ut(),
    challenge: te().optional()
  }).optional(),
  personaData: Ot({
    fullName: Ut().optional(),
    phoneNumbers: le.optional(),
    emailAddresses: le.optional(),
    reset: Ut(),
    oneTime: Ut().optional()
  }).optional(),
  persona: Ot({
    identityAddress: te().optional(),
    label: te().optional(),
    challenge: te().optional()
  }).optional()
});
const Pw = (t) => {
  const { persona: e, accounts: n, personaData: a } = t, r = !!e, i = (n == null ? void 0 : n.reset) || (a == null ? void 0 : a.reset), s = n && !(n != null && n.oneTime), o = a && !(a != null && a.oneTime);
  return !!(i || s || o || r);
}, Vw = (t) => {
  var e, n, a;
  return (e = t.persona) != null && e.challenge ? {
    discriminator: "loginWithChallenge",
    challenge: t.persona.challenge
  } : (n = t.persona) != null && n.identityAddress ? {
    discriminator: "usePersona",
    identityAddress: (a = t.persona) == null ? void 0 : a.identityAddress
  } : {
    discriminator: "loginWithoutChallenge"
  };
}, Gd = (t) => (e) => {
  var r, i;
  const n = { ...e }, { accounts: a } = t;
  if (a) {
    const s = {
      challenge: a.challenge,
      numberOfAccounts: a.numberOfAccounts
    }, o = n.discriminator === "authorizedRequest" && !((r = t.accounts) != null && r.oneTime), l = n.discriminator === "authorizedRequest";
    (i = t.accounts) != null && i.oneTime ? n.oneTimeAccounts = s : (o || l) && (n.ongoingAccounts = s);
  }
  return n;
}, Wd = (t) => (e) => {
  var a, r;
  const n = { ...e };
  if (t.personaData) {
    const {
      fullName: i,
      phoneNumbers: s,
      emailAddresses: o
    } = t.personaData;
    (a = t.personaData) != null && a.oneTime && (n.oneTimePersonaData = {
      isRequestingName: i,
      numberOfRequestedPhoneNumbers: s,
      numberOfRequestedEmailAddresses: o
    });
    const l = n.discriminator === "authorizedRequest" && !((r = t.personaData) != null && r.oneTime), u = n.discriminator === "authorizedRequest";
    (l || u) && (n.ongoingPersonaData = {
      isRequestingName: i,
      numberOfRequestedPhoneNumbers: s,
      numberOfRequestedEmailAddresses: o
    });
  }
  return n;
}, Jw = (t) => (e) => {
  const { accounts: n, personaData: a } = t;
  return {
    ...e,
    reset: { accounts: !!(n != null && n.reset), personaData: !!(a != null && a.reset) }
  };
}, Cw = (t) => bt({
  discriminator: "unauthorizedRequest"
}).map(Gd(t)).map(Wd(t)), Dw = (t) => bt({
  discriminator: "authorizedRequest",
  auth: Vw(t)
}).map(Gd(t)).map(Wd(t)).map(Jw(t)), Mw = (t, e) => bt(
  t ? st(e, (n) => {
    n.accounts && (n.accounts.oneTime = !1, n.accounts.reset = !1), n.personaData && (n.personaData.oneTime = !1, n.personaData.reset = !1);
  }) : e
), qw = (t, e) => Mw(t, e).andThen(
  (n) => Pw(n) ? Dw(n) : Cw(n)
), $w = ({
  dataRequestState: t,
  isConnect: e,
  challenge: n,
  oneTime: a,
  stateClient: r
}) => qw(
  e,
  st({}, (i) => {
    var s;
    if (t.accounts && (i.accounts = {
      numberOfAccounts: t.accounts.numberOfAccounts || {
        quantifier: "atLeast",
        quantity: 1
      },
      oneTime: a,
      reset: !!t.accounts.reset,
      challenge: t.accounts.withProof ? n : void 0
    }), t.personaData && (i.personaData = {
      ...t.personaData,
      reset: !!t.personaData.reset,
      oneTime: a
    }), !a) {
      const o = r.getState().walletData.persona;
      r.getState().walletData.persona && (i.persona = o), (s = t.persona) != null && s.withProof && (i.persona = { ...i.persona ?? {}, challenge: n }), Object.values(t).length === 0 && (i.persona = { challenge: void 0 });
    }
  })
), Uw = (t, e) => {
  var n, a, r, i, s, o, l, u, f, m, y;
  if (t.discriminator === "authorizedRequest") {
    const _ = ((n = t.reset) == null ? void 0 : n.accounts) || ((a = t.reset) == null ? void 0 : a.personaData), S = !!(t.oneTimeAccounts || t.oneTimePersonaData), h = t.auth.discriminator === "loginWithChallenge" || !!((r = t.oneTimeAccounts) != null && r.challenge) || !!((i = t.ongoingAccounts) != null && i.challenge);
    if (_ || S || h)
      return !1;
    let $ = !1;
    if (t.ongoingAccounts) {
      const { quantifier: z, quantity: F } = t.ongoingAccounts.numberOfAccounts;
      $ = ((l = (o = (s = e.sharedData) == null ? void 0 : s.ongoingAccounts) == null ? void 0 : o.numberOfAccounts) == null ? void 0 : l.quantifier) === z && ((m = (f = (u = e.sharedData) == null ? void 0 : u.ongoingAccounts) == null ? void 0 : f.numberOfAccounts) == null ? void 0 : m.quantity) === F;
    }
    return t.ongoingPersonaData && ($ = Xi(
      t.ongoingPersonaData,
      (y = e.sharedData) == null ? void 0 : y.ongoingPersonaData
    )), $;
  }
  return !1;
}, Lw = (t, e) => t.discriminator === "authorizedRequest" ? st({}, (n) => {
  n.persona = { proof: !1 }, n.ongoingAccounts = {
    proof: !1,
    numberOfAccounts: void 0
  }, t.auth.discriminator === "loginWithChallenge" && (n.persona.proof = !!t.auth.challenge), t.ongoingAccounts && (n.ongoingAccounts = {
    proof: !!t.ongoingAccounts.challenge,
    numberOfAccounts: t.ongoingAccounts.numberOfAccounts
  }), t.ongoingPersonaData && (n.ongoingPersonaData = t.ongoingPersonaData);
}) : e, jw = (t) => st({}, (e) => {
  t.ongoingAccounts && (e.accounts = {
    numberOfAccounts: t.ongoingAccounts.numberOfAccounts,
    withProof: t.ongoingAccounts.proof,
    reset: !0
  }), t.ongoingPersonaData && (e.personaData = {
    fullName: t.ongoingPersonaData.isRequestingName,
    phoneNumbers: t.ongoingPersonaData.numberOfRequestedPhoneNumbers,
    emailAddresses: t.ongoingPersonaData.numberOfRequestedEmailAddresses,
    reset: !0
  }), t.persona && (e.persona = { withProof: !!t.persona.proof });
}), Kw = ({
  stateClient: t,
  requestItemClient: e,
  walletClient: n,
  useCache: a,
  dataRequestStateClient: r,
  requestInterceptor: i
}) => {
  let s, o, l;
  const u = (F) => {
    var v, x;
    return ((v = F.accounts) == null ? void 0 : v.withProof) || ((x = F.persona) == null ? void 0 : x.withProof);
  }, f = (F) => {
    if (!u(F))
      return Mo(void 0);
    if (!s)
      throw new Error("Expected proof but no challenge generator provided");
    return s();
  }, m = (F) => {
    s = () => dt.fromPromise(F(), () => ({
      error: "GenerateChallengeError",
      message: "Failed to generate challenge"
    }));
  }, y = (F) => {
    o = (v) => F(v);
  }, _ = (F) => {
    l = (v) => dt.fromPromise(F(v), () => ({
      error: "LoginRejectedByDapp",
      message: "Login rejected by dApp"
    }));
  }, S = (...F) => h({
    dataRequestState: r.toDataRequestState(...F),
    isConnect: !1,
    oneTime: !0
  }), h = ({
    isConnect: F,
    oneTime: v,
    dataRequestState: x
  }) => bt(x).asyncAndThen(
    (q) => f(q).andThen(
      (U) => $w({
        dataRequestState: q,
        isConnect: F,
        challenge: U,
        oneTime: v,
        stateClient: t
      })
    )
  ).andThen((q) => {
    const U = t.getState();
    if (Uw(q, U) && a)
      return Mo(U.walletData);
    const I = !t.getState().walletData.persona && q.discriminator === "authorizedRequest";
    return i({
      type: "dataRequest",
      payload: q
    }).map((D) => {
      const { id: lt } = e.add(
        I ? "loginRequest" : "dataRequest"
      );
      return { walletDataRequest: D, id: lt };
    }).andThen(
      ({ walletDataRequest: D, id: lt }) => n.request(D, lt).mapErr(
        ({ error: Nt, message: Wt }) => ({
          error: Nt,
          message: Wt
        })
      ).andThen(Iw).andThen((Nt) => l ? l(Nt).map(() => (e.updateStatus({ id: lt, status: "success" }), Nt)).mapErr((Wt) => (e.updateStatus({
        id: lt,
        status: "fail",
        error: Wt.error
      }), Wt)) : (e.updateStatus({ id: lt, status: "success" }), bt(Nt))).map((Nt) => (v || t.setState({
        loggedInTimestamp: Date.now().toString(),
        walletData: Nt,
        sharedData: Lw(
          D,
          t.getState().sharedData
        )
      }), Nt))
    );
  });
  return {
    provideChallengeGenerator: m,
    provideDataRequestControl: _,
    provideConnectResponseCallback: y,
    sendOneTimeRequest: S,
    setState: (...F) => (r.setState(...F), {
      sendRequest: () => h({
        dataRequestState: r.getState(),
        isConnect: !1,
        oneTime: !1
      })
    }),
    sendRequest: ({
      isConnect: F,
      oneTime: v
    }) => {
      const x = h({
        isConnect: F,
        oneTime: v,
        dataRequestState: r.getState()
      });
      return o && x.map((q) => {
        o(bt(q));
      }).mapErr((q) => {
        o(ee(q));
      }), x;
    },
    updateSharedData: () => h({
      dataRequestState: jw(
        t.getState().sharedData
      ),
      isConnect: !1,
      oneTime: !1
    })
  };
}, Bw = (t) => {
  var i;
  const e = t.accounts ?? [], n = ((i = t == null ? void 0 : t.persona) == null ? void 0 : i.label) ?? "", a = !!(t != null && t.persona), r = t.personaData.map((s) => {
    if (s.entry === "fullName") {
      const { variant: o, givenNames: l, familyName: u, nickname: f } = s.fields;
      return {
        value: o === "western" ? `${l}${f ? ` "${f}" ` : " "}${u}` : `${u}${f ? ` "${f}" ` : " "}${l}`,
        field: "fullName"
      };
    } else {
      if (s.entry === "emailAddresses")
        return {
          // currently only one email address is supported
          value: s.fields[0],
          field: "emailAddress"
        };
      if (s.entry === "phoneNumbers")
        return {
          // currently only one phone number is supported
          value: s.fields[0],
          field: "phoneNumber"
        };
    }
  }).filter(
    (s) => !!s && !!s.value.trim()
  );
  return { accounts: e, personaLabel: n, connected: a, personaData: r };
}, Zw = (t) => {
  const e = new it(t), n = () => e.next(t), a = (u) => e.next(u), r = () => e.getValue(), i = (...u) => u.filter((f) => typeof f._toObject == "function").reduce(
    (f, m) => ({
      ...f,
      ...m._toObject()
    }),
    {}
  );
  return {
    reset: n,
    setState: (...u) => {
      u.length === 0 ? n() : a(i(...u));
    },
    getState: r,
    patchState: (...u) => {
      u.length !== 0 && a({ ...r(), ...i(...u) });
    },
    removeState: (...u) => {
      a(
        st(r(), (f) => {
          u.forEach((m) => {
            delete f[m];
          });
        })
      );
    },
    toDataRequestState: i,
    state$: e.asObservable()
  };
}, zw = (t) => (e) => dt.fromPromise(
  t(e),
  (n) => ({
    error: "requestInterceptorError",
    jsError: n
  })
), O$ = (t) => {
  const {
    dAppDefinitionAddress: e,
    networkId: n,
    providers: a,
    logger: r,
    onDisconnect: i,
    explorer: s,
    gatewayBaseUrl: o,
    applicationName: l,
    applicationVersion: u,
    useCache: f = !0,
    requestInterceptor: m = async ({ payload: L }) => L
  } = t || {}, y = `rdt:${e}:${n}`, _ = new it(
    e
  ), S = new _e(), h = (a == null ? void 0 : a.connectButton) ?? Sg({
    logger: r
  });
  h.setIsMobile(bg());
  const $ = (a == null ? void 0 : a.gatewayClient) ?? Nw({
    logger: r,
    gatewayApi: bw({
      basePath: o ?? Ho[n].gatewayUrl,
      dAppDefinitionAddress: e,
      applicationName: l,
      applicationVersion: u
    })
  }), z = (a == null ? void 0 : a.storageClient) ?? kw(), F = (a == null ? void 0 : a.walletSdk) ?? E_({
    logger: r,
    networkId: n,
    dAppDefinitionAddress: e
  }), v = (a == null ? void 0 : a.requestItemClient) ?? Tw(y, z, {
    logger: r
  }), x = (a == null ? void 0 : a.walletClient) ?? vw({
    logger: r,
    onCancelRequestItem$: h.onCancelRequestItem$,
    walletSdk: F,
    gatewayClient: $,
    requestItemClient: v
  }), q = (a == null ? void 0 : a.stateClient) ?? hg(y, z, {
    logger: r
  }), U = (a == null ? void 0 : a.dataRequestStateClient) ?? Zw({}), I = zw(m), D = (a == null ? void 0 : a.dataRequestClient) ?? Kw({
    stateClient: q,
    requestItemClient: v,
    walletClient: x,
    useCache: f,
    dataRequestStateClient: U,
    requestInterceptor: I
  }), lt = () => {
    v.items$.value.forEach((L) => {
      L.showCancel && x.cancelRequest(L.id);
    }), q.reset(), x.resetRequestItems(), h.disconnect(), i && i();
  };
  S.add(
    _.pipe(
      pe((L) => !!L),
      we(
        (L) => $.gatewayApi.getEntityDetails(L).map(
          (gt) => Ow(
            gt == null ? void 0 : gt.metadata.items.find((It) => It.key === "name")
          ).stringified
        ).map((gt) => {
          h.setDappName(gt ?? "Unnamed dApp");
        })
      )
    ).subscribe()
  ), S.add(
    x.extensionStatus$.pipe(
      W((L) => {
        h.setIsExtensionAvailable(
          L.isExtensionAvailable
        ), h.setIsWalletLinked(L.isWalletLinked);
      })
    ).subscribe()
  ), S.add(
    h.onConnect$.pipe(
      we(() => (q.reset(), D.sendRequest({
        isConnect: !0,
        oneTime: !1
      })))
    ).subscribe()
  ), S.add(
    h.onLinkClick$.pipe(
      W(({ type: L, data: gt }) => {
        if (["account", "transaction"].includes(L)) {
          const { baseUrl: It, transactionPath: Pe, accountsPath: Ve } = s ?? {
            baseUrl: Ho[n].dashboardUrl,
            transactionPath: "/transaction/",
            accountsPath: "/account/"
          };
          if (!It || !window)
            return;
          const va = `${It}${L === "transaction" ? Pe : Ve}${gt}`;
          window.open(va);
        } else
          L === "setupGuide" ? window.open("https://wallet.radixdlt.com") : L === "showQrCode" && F.openPopup();
      })
    ).subscribe()
  ), S.add(
    h.onShowPopover$.pipe(
      jr(x.requestItems$),
      W(([L, gt]) => {
        gt.filter((It) => It.status === "pending").length > 0 && h.setActiveTab("requests");
      })
    ).subscribe()
  ), S.add(
    h.onDisconnect$.pipe(W(lt)).subscribe()
  ), S.add(
    q.state$.pipe(
      W((L) => {
        const { personaData: gt, accounts: It, personaLabel: Pe, connected: Ve } = Bw(L.walletData);
        h.setLoggedInTimestamp(L.loggedInTimestamp), h.setAccounts(It), h.setPersonaData(gt), h.setPersonaLabel(Pe), h.setConnected(Ve);
      })
    ).subscribe()
  ), S.add(
    x.requestItems$.pipe(W((L) => h.setRequestItems(L))).subscribe()
  ), S.add(
    v.change$.pipe(
      jr(v.items$),
      W(([, L]) => {
        L.find((It) => It.status === "pending") && h.setStatus("pending");
      }),
      mr(([L]) => {
        var Pe, Ve;
        const gt = (Pe = L.newValue) == null ? void 0 : Pe.status;
        return ((Ve = L.oldValue) == null ? void 0 : Ve.status) === "pending" && (gt === "success" || gt === "fail") ? (h.setStatus(
          gt === "success" ? "success" : "error"
        ), ui(2e3).pipe(
          jr(x.requestItems$),
          W(([va, Er]) => {
            const Rr = Er.find(
              (Ir) => Ir.status === "pending"
            );
            h.setStatus(
              Rr ? "pending" : "default"
            );
          })
        )) : ls();
      })
    ).subscribe()
  ), S.add(
    Rn(h.onUpdateSharedData$).pipe(we(() => D.updateSharedData())).subscribe()
  );
  const Nt = {
    state: $.gatewayApi.stateApi,
    status: $.gatewayApi.statusApi,
    transaction: $.gatewayApi.transactionApi
  }, Wt = {
    setRequestData: D.setState,
    sendRequest: () => D.sendRequest({
      isConnect: !1,
      oneTime: !1
    }),
    provideChallengeGenerator: (L) => D.provideChallengeGenerator(L),
    dataRequestControl: (L) => {
      D.provideDataRequestControl(L);
    },
    provideConnectResponseCallback: D.provideConnectResponseCallback,
    updateSharedData: () => D.updateSharedData(),
    sendOneTimeRequest: D.sendOneTimeRequest,
    sendTransaction: (L) => I({
      type: "sendTransaction",
      payload: L
    }).andThen(x.sendTransaction),
    walletData$: q.walletData$,
    getWalletData: () => q.getWalletData()
  }, Ie = {
    setTheme: h.setTheme,
    setMode: h.setMode,
    status$: h.status$
  };
  return {
    walletApi: Wt,
    gatewayApi: Nt,
    buttonApi: Ie,
    disconnect: lt,
    destroy: () => {
      q.destroy(), x.destroy(), S.unsubscribe(), h.destroy();
    }
  };
};
Ot({
  numberOfAccounts: le,
  withProof: Ut().optional(),
  reset: Ut().optional()
});
const Hd = () => {
  let e = st({
    numberOfAccounts: { quantifier: "atLeast", quantity: 1 }
  }, () => {
  });
  const o = {
    atLeast: (l) => (e = st(e, (u) => {
      u.numberOfAccounts.quantifier = "atLeast", u.numberOfAccounts.quantity = l;
    }), o),
    exactly: (l) => (e = st(e, (u) => {
      u.numberOfAccounts.quantifier = "exactly", u.numberOfAccounts.quantity = l;
    }), o),
    withProof: (l = !0) => (e = st(e, (u) => {
      u.withProof = l;
    }), o),
    reset: (l = !0) => (e = st(e, (u) => {
      u.reset = l;
    }), o),
    _toObject: () => ({
      accounts: e
    })
  };
  return o;
};
Ot({
  withProof: Ut().optional()
});
const Gw = (t = {
  withProof: !1
}) => {
  let e = st(t, () => {
  });
  const r = {
    withProof: (i = !0) => (e = st(e, (s) => {
      s.withProof = i;
    }), r),
    _toObject: () => ({
      persona: e
    })
  };
  return r;
};
Ot({
  fullName: Ut(),
  emailAddresses: le,
  phoneNumbers: le,
  reset: Ut()
}).partial();
const Yd = (t = {}) => {
  let e = st(t, () => {
  });
  const n = (u = !0) => (e = st(e, (f) => {
    f.fullName = u;
  }), l), a = (u) => ({
    atLeast: (f) => (e = st(e, (m) => {
      m[u] = { quantifier: "atLeast", quantity: f };
    }), l),
    exactly: (f) => (e = st(e, (m) => {
      m[u] = { quantifier: "exactly", quantity: f };
    }), l)
  }), l = {
    fullName: n,
    emailAddresses: (u = !0) => (a("emailAddresses").exactly(u ? 1 : 0), l),
    phoneNumbers: (u = !0) => (a("phoneNumbers").exactly(u ? 1 : 0), l),
    reset: (u = !0) => (e = st(e, (f) => {
      f.reset = u;
    }), l),
    _toObject: () => ({
      personaData: e
    })
  };
  return l;
}, Ww = (t) => ({
  _toObject: () => ({ ...t })
}), N$ = {
  accounts: Hd,
  personaData: Yd,
  persona: Gw,
  config: Ww
}, w$ = {
  accounts: Hd,
  personaData: Yd
};
export {
  xu as Account,
  Cm as AccountProof,
  Oi as AccountsRequestItem,
  Ni as AccountsRequestResponseItem,
  CT as AtLedgerStateMixinFromJSON,
  xg as AtLedgerStateMixinFromJSONTyped,
  DT as AtLedgerStateMixinToJSON,
  jm as AuthLoginRequestItem,
  ay as AuthLoginRequestResponseItem,
  Lm as AuthLoginWithChallengeRequestItem,
  ny as AuthLoginWithChallengeRequestResponseItem,
  Um as AuthLoginWithoutChallengeRequestItem,
  ey as AuthLoginWithoutChallengeRequestResponseItem,
  Km as AuthRequestItem,
  iy as AuthRequestResponseItem,
  $m as AuthUsePersonaRequestItem,
  wg as BASE_PATH,
  pa as BaseAPI,
  IT as BlobApiResponse,
  FT as COLLECTION_FORMATS,
  Ym as CancelRequest,
  Nr as CommittedTransactionInfoFromJSON,
  Oh as CommittedTransactionInfoFromJSONTyped,
  wr as CommittedTransactionInfoToJSON,
  Th as ComponentEntityRoleAssignmentEntryAssignmentFromJSON,
  Ah as ComponentEntityRoleAssignmentEntryAssignmentFromJSONTyped,
  kh as ComponentEntityRoleAssignmentEntryAssignmentToJSON,
  Rh as ComponentEntityRoleAssignmentEntryFromJSON,
  Ih as ComponentEntityRoleAssignmentEntryFromJSONTyped,
  Ph as ComponentEntityRoleAssignmentEntryToJSON,
  Zn as ComponentEntityRoleAssignmentsFromJSON,
  Vh as ComponentEntityRoleAssignmentsFromJSONTyped,
  zn as ComponentEntityRoleAssignmentsToJSON,
  wl as Configuration,
  hk as CursorLimitMixinFromJSON,
  Jh as CursorLimitMixinFromJSONTyped,
  vk as CursorLimitMixinToJSON,
  N$ as DataRequestBuilder,
  Zw as DataRequestStateClient,
  Tg as DefaultConfig,
  Tx as EntityMetadataCollectionAllOfFromJSON,
  kv as EntityMetadataCollectionAllOfFromJSONTyped,
  Ax as EntityMetadataCollectionAllOfToJSON,
  xe as EntityMetadataCollectionFromJSON,
  Av as EntityMetadataCollectionFromJSONTyped,
  Ee as EntityMetadataCollectionToJSON,
  bs as EntityMetadataItemFromJSON,
  Tv as EntityMetadataItemFromJSONTyped,
  Ss as EntityMetadataItemToJSON,
  Fx as EntityMetadataItemValueAllOfFromJSON,
  Fv as EntityMetadataItemValueAllOfFromJSONTyped,
  xx as EntityMetadataItemValueAllOfToJSON,
  Ov as EntityMetadataItemValueFromJSON,
  Nv as EntityMetadataItemValueFromJSONTyped,
  wv as EntityMetadataItemValueToJSON,
  Jx as EntityNotFoundErrorAllOfFromJSON,
  Ev as EntityNotFoundErrorAllOfFromJSONTyped,
  Cx as EntityNotFoundErrorAllOfToJSON,
  Px as EntityNotFoundErrorAllOfTypeEnum,
  Ix as EntityNotFoundErrorFromJSON,
  Dc as EntityNotFoundErrorFromJSONTyped,
  xv as EntityNotFoundErrorToJSON,
  Ex as EntityNotFoundErrorTypeEnum,
  aE as ErrorResponseFromJSON,
  Uv as ErrorResponseFromJSONTyped,
  rE as ErrorResponseToJSON,
  yh as EventsItemFromJSON,
  _h as EventsItemFromJSONTyped,
  gh as EventsItemToJSON,
  Sw as ExponentialBackoff,
  OT as ExtensionInteraction,
  sE as FromLedgerStateMixinFromJSON,
  Lv as FromLedgerStateMixinFromJSONTyped,
  oE as FromLedgerStateMixinToJSON,
  hE as FungibleResourcesCollectionAllOfFromJSON,
  Yv as FungibleResourcesCollectionAllOfFromJSONTyped,
  vE as FungibleResourcesCollectionAllOfToJSON,
  Gv as FungibleResourcesCollectionFromJSON,
  Wv as FungibleResourcesCollectionFromJSONTyped,
  OE as FungibleResourcesCollectionItemBaseFromJSON,
  tb as FungibleResourcesCollectionItemBaseFromJSONTyped,
  NE as FungibleResourcesCollectionItemBaseToJSON,
  Os as FungibleResourcesCollectionItemFromJSON,
  zv as FungibleResourcesCollectionItemFromJSONTyped,
  uE as FungibleResourcesCollectionItemGloballyAggregatedAggregationLevelEnum,
  wE as FungibleResourcesCollectionItemGloballyAggregatedAllOfAggregationLevelEnum,
  AE as FungibleResourcesCollectionItemGloballyAggregatedAllOfFromJSON,
  eb as FungibleResourcesCollectionItemGloballyAggregatedAllOfFromJSONTyped,
  kE as FungibleResourcesCollectionItemGloballyAggregatedAllOfToJSON,
  cE as FungibleResourcesCollectionItemGloballyAggregatedFromJSON,
  Zc as FungibleResourcesCollectionItemGloballyAggregatedFromJSONTyped,
  jv as FungibleResourcesCollectionItemGloballyAggregatedToJSON,
  Ns as FungibleResourcesCollectionItemToJSON,
  pE as FungibleResourcesCollectionItemVaultAggregatedAggregationLevelEnum,
  FE as FungibleResourcesCollectionItemVaultAggregatedAllOfAggregationLevelEnum,
  EE as FungibleResourcesCollectionItemVaultAggregatedAllOfFromJSON,
  nb as FungibleResourcesCollectionItemVaultAggregatedAllOfFromJSONTyped,
  RE as FungibleResourcesCollectionItemVaultAggregatedAllOfToJSON,
  yE as FungibleResourcesCollectionItemVaultAggregatedFromJSON,
  Wc as FungibleResourcesCollectionItemVaultAggregatedFromJSONTyped,
  Zv as FungibleResourcesCollectionItemVaultAggregatedToJSON,
  PE as FungibleResourcesCollectionItemVaultAggregatedVaultAllOfFromJSON,
  ab as FungibleResourcesCollectionItemVaultAggregatedVaultAllOfFromJSONTyped,
  VE as FungibleResourcesCollectionItemVaultAggregatedVaultAllOfToJSON,
  zc as FungibleResourcesCollectionItemVaultAggregatedVaultFromJSON,
  Bv as FungibleResourcesCollectionItemVaultAggregatedVaultFromJSONTyped,
  ya as FungibleResourcesCollectionItemVaultAggregatedVaultItemFromJSON,
  Kv as FungibleResourcesCollectionItemVaultAggregatedVaultItemFromJSONTyped,
  _a as FungibleResourcesCollectionItemVaultAggregatedVaultItemToJSON,
  Gc as FungibleResourcesCollectionItemVaultAggregatedVaultToJSON,
  Hv as FungibleResourcesCollectionToJSON,
  fr as GatewayApiClient,
  Nw as GatewayClient,
  CE as GatewayErrorBaseFromJSON,
  rb as GatewayErrorBaseFromJSONTyped,
  DE as GatewayErrorBaseToJSON,
  Mv as GatewayErrorFromJSON,
  qv as GatewayErrorFromJSONTyped,
  $v as GatewayErrorToJSON,
  qE as GatewayInfoResponseKnownTargetFromJSON,
  ib as GatewayInfoResponseKnownTargetFromJSONTyped,
  $E as GatewayInfoResponseKnownTargetToJSON,
  Hc as GatewayInfoResponseReleaseInfoFromJSON,
  sb as GatewayInfoResponseReleaseInfoFromJSONTyped,
  Yc as GatewayInfoResponseReleaseInfoToJSON,
  ZE as GatewayStatusResponseAllOfFromJSON,
  cb as GatewayStatusResponseAllOfFromJSONTyped,
  zE as GatewayStatusResponseAllOfToJSON,
  ub as GatewayStatusResponseFromJSON,
  lb as GatewayStatusResponseFromJSONTyped,
  KE as GatewayStatusResponseToJSON,
  HE as InternalServerErrorAllOfFromJSON,
  db as InternalServerErrorAllOfFromJSONTyped,
  YE as InternalServerErrorAllOfToJSON,
  GE as InternalServerErrorAllOfTypeEnum,
  qx as InternalServerErrorFromJSON,
  Mc as InternalServerErrorFromJSONTyped,
  Rv as InternalServerErrorToJSON,
  Dx as InternalServerErrorTypeEnum,
  tR as InvalidEntityErrorAllOfFromJSON,
  fb as InvalidEntityErrorAllOfFromJSONTyped,
  eR as InvalidEntityErrorAllOfToJSON,
  XE as InvalidEntityErrorAllOfTypeEnum,
  Lx as InvalidEntityErrorFromJSON,
  qc as InvalidEntityErrorFromJSONTyped,
  Iv as InvalidEntityErrorToJSON,
  $x as InvalidEntityErrorTypeEnum,
  rR as InvalidRequestErrorAllOfFromJSON,
  pb as InvalidRequestErrorAllOfFromJSONTyped,
  iR as InvalidRequestErrorAllOfToJSON,
  nR as InvalidRequestErrorAllOfTypeEnum,
  Zx as InvalidRequestErrorFromJSON,
  Lc as InvalidRequestErrorFromJSONTyped,
  Vv as InvalidRequestErrorToJSON,
  Kx as InvalidRequestErrorTypeEnum,
  uR as InvalidTransactionErrorAllOfFromJSON,
  mb as InvalidTransactionErrorAllOfFromJSONTyped,
  lR as InvalidTransactionErrorAllOfToJSON,
  sR as InvalidTransactionErrorAllOfTypeEnum,
  Wx as InvalidTransactionErrorFromJSON,
  jc as InvalidTransactionErrorFromJSONTyped,
  Jv as InvalidTransactionErrorToJSON,
  zx as InvalidTransactionErrorTypeEnum,
  ct as JSONApiResponse,
  yt as LedgerStateFromJSON,
  ob as LedgerStateFromJSONTyped,
  dR as LedgerStateMixinFromJSON,
  yb as LedgerStateMixinFromJSONTyped,
  fR as LedgerStateMixinToJSON,
  pt as LedgerStateSelectorFromJSON,
  Fg as LedgerStateSelectorFromJSONTyped,
  mt as LedgerStateSelectorToJSON,
  _t as LedgerStateToJSON,
  ST as LoginRequestResponseItem,
  dy as MessageLifeCycleEvent,
  NT as MessageLifeCycleExtensionStatusEvent,
  Ru as Metadata,
  yR as MetadataBoolArrayValueAllOfFromJSON,
  _b as MetadataBoolArrayValueAllOfFromJSONTyped,
  _R as MetadataBoolArrayValueAllOfToJSON,
  pR as MetadataBoolArrayValueAllOfTypeEnum,
  Ok as MetadataBoolArrayValueFromJSON,
  Yl as MetadataBoolArrayValueFromJSONTyped,
  Ch as MetadataBoolArrayValueToJSON,
  bk as MetadataBoolArrayValueTypeEnum,
  vR as MetadataBoolValueAllOfFromJSON,
  gb as MetadataBoolValueAllOfFromJSONTyped,
  bR as MetadataBoolValueAllOfToJSON,
  gR as MetadataBoolValueAllOfTypeEnum,
  Tk as MetadataBoolValueFromJSON,
  Xl as MetadataBoolValueFromJSONTyped,
  Dh as MetadataBoolValueToJSON,
  Nk as MetadataBoolValueTypeEnum,
  NR as MetadataDecimalArrayValueAllOfFromJSON,
  hb as MetadataDecimalArrayValueAllOfFromJSONTyped,
  wR as MetadataDecimalArrayValueAllOfToJSON,
  SR as MetadataDecimalArrayValueAllOfTypeEnum,
  Fk as MetadataDecimalArrayValueFromJSON,
  Ql as MetadataDecimalArrayValueFromJSONTyped,
  Mh as MetadataDecimalArrayValueToJSON,
  Ak as MetadataDecimalArrayValueTypeEnum,
  kR as MetadataDecimalValueAllOfFromJSON,
  vb as MetadataDecimalValueAllOfFromJSONTyped,
  FR as MetadataDecimalValueAllOfToJSON,
  TR as MetadataDecimalValueAllOfTypeEnum,
  Rk as MetadataDecimalValueFromJSON,
  tc as MetadataDecimalValueFromJSONTyped,
  qh as MetadataDecimalValueToJSON,
  xk as MetadataDecimalValueTypeEnum,
  RR as MetadataGlobalAddressArrayValueAllOfFromJSON,
  bb as MetadataGlobalAddressArrayValueAllOfFromJSONTyped,
  IR as MetadataGlobalAddressArrayValueAllOfToJSON,
  xR as MetadataGlobalAddressArrayValueAllOfTypeEnum,
  Vk as MetadataGlobalAddressArrayValueFromJSON,
  ec as MetadataGlobalAddressArrayValueFromJSONTyped,
  $h as MetadataGlobalAddressArrayValueToJSON,
  Ik as MetadataGlobalAddressArrayValueTypeEnum,
  JR as MetadataGlobalAddressValueAllOfFromJSON,
  Sb as MetadataGlobalAddressValueAllOfFromJSONTyped,
  CR as MetadataGlobalAddressValueAllOfToJSON,
  PR as MetadataGlobalAddressValueAllOfTypeEnum,
  Dk as MetadataGlobalAddressValueFromJSON,
  nc as MetadataGlobalAddressValueFromJSONTyped,
  Uh as MetadataGlobalAddressValueToJSON,
  Jk as MetadataGlobalAddressValueTypeEnum,
  qR as MetadataI32ArrayValueAllOfFromJSON,
  Ob as MetadataI32ArrayValueAllOfFromJSONTyped,
  $R as MetadataI32ArrayValueAllOfToJSON,
  DR as MetadataI32ArrayValueAllOfTypeEnum,
  $k as MetadataI32ArrayValueFromJSON,
  ac as MetadataI32ArrayValueFromJSONTyped,
  Lh as MetadataI32ArrayValueToJSON,
  Mk as MetadataI32ArrayValueTypeEnum,
  jR as MetadataI32ValueAllOfFromJSON,
  Nb as MetadataI32ValueAllOfFromJSONTyped,
  KR as MetadataI32ValueAllOfToJSON,
  UR as MetadataI32ValueAllOfTypeEnum,
  jk as MetadataI32ValueFromJSON,
  rc as MetadataI32ValueFromJSONTyped,
  jh as MetadataI32ValueToJSON,
  Uk as MetadataI32ValueTypeEnum,
  zR as MetadataI64ArrayValueAllOfFromJSON,
  wb as MetadataI64ArrayValueAllOfFromJSONTyped,
  GR as MetadataI64ArrayValueAllOfToJSON,
  BR as MetadataI64ArrayValueAllOfTypeEnum,
  Zk as MetadataI64ArrayValueFromJSON,
  ic as MetadataI64ArrayValueFromJSONTyped,
  Kh as MetadataI64ArrayValueToJSON,
  Kk as MetadataI64ArrayValueTypeEnum,
  YR as MetadataI64ValueAllOfFromJSON,
  Tb as MetadataI64ValueAllOfFromJSONTyped,
  XR as MetadataI64ValueAllOfToJSON,
  WR as MetadataI64ValueAllOfTypeEnum,
  Wk as MetadataI64ValueFromJSON,
  sc as MetadataI64ValueFromJSONTyped,
  Bh as MetadataI64ValueToJSON,
  zk as MetadataI64ValueTypeEnum,
  eI as MetadataInstantArrayValueAllOfFromJSON,
  Ab as MetadataInstantArrayValueAllOfFromJSONTyped,
  nI as MetadataInstantArrayValueAllOfToJSON,
  QR as MetadataInstantArrayValueAllOfTypeEnum,
  Xk as MetadataInstantArrayValueFromJSON,
  oc as MetadataInstantArrayValueFromJSONTyped,
  Zh as MetadataInstantArrayValueToJSON,
  Hk as MetadataInstantArrayValueTypeEnum,
  iI as MetadataInstantValueAllOfFromJSON,
  kb as MetadataInstantValueAllOfFromJSONTyped,
  sI as MetadataInstantValueAllOfToJSON,
  aI as MetadataInstantValueAllOfTypeEnum,
  eF as MetadataInstantValueFromJSON,
  uc as MetadataInstantValueFromJSONTyped,
  zh as MetadataInstantValueToJSON,
  Qk as MetadataInstantValueTypeEnum,
  lI as MetadataNonFungibleGlobalIdArrayValueAllOfFromJSON,
  Fb as MetadataNonFungibleGlobalIdArrayValueAllOfFromJSONTyped,
  cI as MetadataNonFungibleGlobalIdArrayValueAllOfToJSON,
  oI as MetadataNonFungibleGlobalIdArrayValueAllOfTypeEnum,
  lc as MetadataNonFungibleGlobalIdArrayValueAllOfValuesFromJSON,
  Gh as MetadataNonFungibleGlobalIdArrayValueAllOfValuesFromJSONTyped,
  cc as MetadataNonFungibleGlobalIdArrayValueAllOfValuesToJSON,
  iF as MetadataNonFungibleGlobalIdArrayValueFromJSON,
  dc as MetadataNonFungibleGlobalIdArrayValueFromJSONTyped,
  Wh as MetadataNonFungibleGlobalIdArrayValueToJSON,
  aF as MetadataNonFungibleGlobalIdArrayValueTypeEnum,
  pI as MetadataNonFungibleGlobalIdValueAllOfFromJSON,
  xb as MetadataNonFungibleGlobalIdValueAllOfFromJSONTyped,
  mI as MetadataNonFungibleGlobalIdValueAllOfToJSON,
  dI as MetadataNonFungibleGlobalIdValueAllOfTypeEnum,
  uF as MetadataNonFungibleGlobalIdValueFromJSON,
  fc as MetadataNonFungibleGlobalIdValueFromJSONTyped,
  Hh as MetadataNonFungibleGlobalIdValueToJSON,
  sF as MetadataNonFungibleGlobalIdValueTypeEnum,
  gI as MetadataNonFungibleLocalIdArrayValueAllOfFromJSON,
  Eb as MetadataNonFungibleLocalIdArrayValueAllOfFromJSONTyped,
  hI as MetadataNonFungibleLocalIdArrayValueAllOfToJSON,
  yI as MetadataNonFungibleLocalIdArrayValueAllOfTypeEnum,
  dF as MetadataNonFungibleLocalIdArrayValueFromJSON,
  pc as MetadataNonFungibleLocalIdArrayValueFromJSONTyped,
  Yh as MetadataNonFungibleLocalIdArrayValueToJSON,
  lF as MetadataNonFungibleLocalIdArrayValueTypeEnum,
  SI as MetadataNonFungibleLocalIdValueAllOfFromJSON,
  Rb as MetadataNonFungibleLocalIdValueAllOfFromJSONTyped,
  OI as MetadataNonFungibleLocalIdValueAllOfToJSON,
  vI as MetadataNonFungibleLocalIdValueAllOfTypeEnum,
  mF as MetadataNonFungibleLocalIdValueFromJSON,
  mc as MetadataNonFungibleLocalIdValueFromJSONTyped,
  Xh as MetadataNonFungibleLocalIdValueToJSON,
  fF as MetadataNonFungibleLocalIdValueTypeEnum,
  TI as MetadataOriginArrayValueAllOfFromJSON,
  Ib as MetadataOriginArrayValueAllOfFromJSONTyped,
  AI as MetadataOriginArrayValueAllOfToJSON,
  NI as MetadataOriginArrayValueAllOfTypeEnum,
  gF as MetadataOriginArrayValueFromJSON,
  yc as MetadataOriginArrayValueFromJSONTyped,
  Qh as MetadataOriginArrayValueToJSON,
  yF as MetadataOriginArrayValueTypeEnum,
  xI as MetadataOriginValueAllOfFromJSON,
  Pb as MetadataOriginValueAllOfFromJSONTyped,
  EI as MetadataOriginValueAllOfToJSON,
  kI as MetadataOriginValueAllOfTypeEnum,
  bF as MetadataOriginValueFromJSON,
  _c as MetadataOriginValueFromJSONTyped,
  tv as MetadataOriginValueToJSON,
  hF as MetadataOriginValueTypeEnum,
  PI as MetadataPublicKeyArrayValueAllOfFromJSON,
  Vb as MetadataPublicKeyArrayValueAllOfFromJSONTyped,
  VI as MetadataPublicKeyArrayValueAllOfToJSON,
  RI as MetadataPublicKeyArrayValueAllOfTypeEnum,
  xF as MetadataPublicKeyArrayValueFromJSON,
  vc as MetadataPublicKeyArrayValueFromJSONTyped,
  rv as MetadataPublicKeyArrayValueToJSON,
  kF as MetadataPublicKeyArrayValueTypeEnum,
  DI as MetadataPublicKeyHashArrayValueAllOfFromJSON,
  Jb as MetadataPublicKeyHashArrayValueAllOfFromJSONTyped,
  MI as MetadataPublicKeyHashArrayValueAllOfToJSON,
  JI as MetadataPublicKeyHashArrayValueAllOfTypeEnum,
  MF as MetadataPublicKeyHashArrayValueFromJSON,
  Oc as MetadataPublicKeyHashArrayValueFromJSONTyped,
  uv as MetadataPublicKeyHashArrayValueToJSON,
  CF as MetadataPublicKeyHashArrayValueTypeEnum,
  UI as MetadataPublicKeyHashValueAllOfFromJSON,
  Cb as MetadataPublicKeyHashValueAllOfFromJSONTyped,
  LI as MetadataPublicKeyHashValueAllOfToJSON,
  qI as MetadataPublicKeyHashValueAllOfTypeEnum,
  UF as MetadataPublicKeyHashValueFromJSON,
  Nc as MetadataPublicKeyHashValueFromJSONTyped,
  lv as MetadataPublicKeyHashValueToJSON,
  qF as MetadataPublicKeyHashValueTypeEnum,
  BI as MetadataPublicKeyValueAllOfFromJSON,
  Db as MetadataPublicKeyValueAllOfFromJSONTyped,
  ZI as MetadataPublicKeyValueAllOfToJSON,
  jI as MetadataPublicKeyValueAllOfTypeEnum,
  KF as MetadataPublicKeyValueFromJSON,
  wc as MetadataPublicKeyValueFromJSONTyped,
  cv as MetadataPublicKeyValueToJSON,
  LF as MetadataPublicKeyValueTypeEnum,
  WI as MetadataStringArrayValueAllOfFromJSON,
  Mb as MetadataStringArrayValueAllOfFromJSONTyped,
  HI as MetadataStringArrayValueAllOfToJSON,
  zI as MetadataStringArrayValueAllOfTypeEnum,
  zF as MetadataStringArrayValueFromJSON,
  Tc as MetadataStringArrayValueFromJSONTyped,
  dv as MetadataStringArrayValueToJSON,
  BF as MetadataStringArrayValueTypeEnum,
  QI as MetadataStringValueAllOfFromJSON,
  qb as MetadataStringValueAllOfFromJSONTyped,
  tP as MetadataStringValueAllOfToJSON,
  YI as MetadataStringValueAllOfTypeEnum,
  HF as MetadataStringValueFromJSON,
  Ac as MetadataStringValueFromJSONTyped,
  fv as MetadataStringValueToJSON,
  GF as MetadataStringValueTypeEnum,
  rP as MetadataTypedValueBaseFromJSON,
  Lb as MetadataTypedValueBaseFromJSONTyped,
  iP as MetadataTypedValueBaseToJSON,
  Jc as MetadataTypedValueFromJSON,
  Sv as MetadataTypedValueFromJSONTyped,
  Cc as MetadataTypedValueToJSON,
  uP as MetadataU32ArrayValueAllOfFromJSON,
  jb as MetadataU32ArrayValueAllOfFromJSONTyped,
  lP as MetadataU32ArrayValueAllOfToJSON,
  sP as MetadataU32ArrayValueAllOfTypeEnum,
  QF as MetadataU32ArrayValueFromJSON,
  kc as MetadataU32ArrayValueFromJSONTyped,
  pv as MetadataU32ArrayValueToJSON,
  YF as MetadataU32ArrayValueTypeEnum,
  fP as MetadataU32ValueAllOfFromJSON,
  Kb as MetadataU32ValueAllOfFromJSONTyped,
  pP as MetadataU32ValueAllOfToJSON,
  cP as MetadataU32ValueAllOfTypeEnum,
  nx as MetadataU32ValueFromJSON,
  Fc as MetadataU32ValueFromJSONTyped,
  mv as MetadataU32ValueToJSON,
  tx as MetadataU32ValueTypeEnum,
  _P as MetadataU64ArrayValueAllOfFromJSON,
  Bb as MetadataU64ArrayValueAllOfFromJSONTyped,
  gP as MetadataU64ArrayValueAllOfToJSON,
  mP as MetadataU64ArrayValueAllOfTypeEnum,
  ix as MetadataU64ArrayValueFromJSON,
  xc as MetadataU64ArrayValueFromJSONTyped,
  yv as MetadataU64ArrayValueToJSON,
  ax as MetadataU64ArrayValueTypeEnum,
  bP as MetadataU64ValueAllOfFromJSON,
  Zb as MetadataU64ValueAllOfFromJSONTyped,
  SP as MetadataU64ValueAllOfToJSON,
  hP as MetadataU64ValueAllOfTypeEnum,
  ux as MetadataU64ValueFromJSON,
  Ec as MetadataU64ValueFromJSONTyped,
  _v as MetadataU64ValueToJSON,
  sx as MetadataU64ValueTypeEnum,
  wP as MetadataU8ArrayValueAllOfFromJSON,
  zb as MetadataU8ArrayValueAllOfFromJSONTyped,
  TP as MetadataU8ArrayValueAllOfToJSON,
  OP as MetadataU8ArrayValueAllOfTypeEnum,
  dx as MetadataU8ArrayValueFromJSON,
  Rc as MetadataU8ArrayValueFromJSONTyped,
  gv as MetadataU8ArrayValueToJSON,
  lx as MetadataU8ArrayValueTypeEnum,
  FP as MetadataU8ValueAllOfFromJSON,
  Gb as MetadataU8ValueAllOfFromJSONTyped,
  xP as MetadataU8ValueAllOfToJSON,
  AP as MetadataU8ValueAllOfTypeEnum,
  mx as MetadataU8ValueFromJSON,
  Ic as MetadataU8ValueFromJSONTyped,
  hv as MetadataU8ValueToJSON,
  fx as MetadataU8ValueTypeEnum,
  IP as MetadataUrlArrayValueAllOfFromJSON,
  Wb as MetadataUrlArrayValueAllOfFromJSONTyped,
  PP as MetadataUrlArrayValueAllOfToJSON,
  EP as MetadataUrlArrayValueAllOfTypeEnum,
  gx as MetadataUrlArrayValueFromJSON,
  Pc as MetadataUrlArrayValueFromJSONTyped,
  vv as MetadataUrlArrayValueToJSON,
  yx as MetadataUrlArrayValueTypeEnum,
  CP as MetadataUrlValueAllOfFromJSON,
  Hb as MetadataUrlValueAllOfFromJSONTyped,
  DP as MetadataUrlValueAllOfToJSON,
  VP as MetadataUrlValueAllOfTypeEnum,
  bx as MetadataUrlValueFromJSON,
  Vc as MetadataUrlValueFromJSONTyped,
  bv as MetadataUrlValueToJSON,
  hx as MetadataUrlValueTypeEnum,
  Ow as MetadataValue,
  eP as MetadataValueType,
  $b as MetadataValueTypeFromJSON,
  Ub as MetadataValueTypeFromJSONTyped,
  nP as MetadataValueTypeToJSON,
  tS as NetworkConfigurationResponseFromJSON,
  eS as NetworkConfigurationResponseFromJSONTyped,
  $P as NetworkConfigurationResponseToJSON,
  Yb as NetworkConfigurationResponseWellKnownAddressesFromJSON,
  Xb as NetworkConfigurationResponseWellKnownAddressesFromJSONTyped,
  Qb as NetworkConfigurationResponseWellKnownAddressesToJSON,
  UP as NonFungibleIdType,
  kr as NonFungibleIdTypeFromJSON,
  nS as NonFungibleIdTypeFromJSONTyped,
  LP as NonFungibleIdTypeToJSON,
  BP as NonFungibleIdsCollectionAllOfFromJSON,
  rS as NonFungibleIdsCollectionAllOfFromJSONTyped,
  ZP as NonFungibleIdsCollectionAllOfToJSON,
  Xc as NonFungibleIdsCollectionFromJSON,
  aS as NonFungibleIdsCollectionFromJSONTyped,
  Qc as NonFungibleIdsCollectionToJSON,
  aV as NonFungibleResourcesCollectionAllOfFromJSON,
  pS as NonFungibleResourcesCollectionAllOfFromJSONTyped,
  rV as NonFungibleResourcesCollectionAllOfToJSON,
  cS as NonFungibleResourcesCollectionFromJSON,
  dS as NonFungibleResourcesCollectionFromJSONTyped,
  sV as NonFungibleResourcesCollectionItemBaseFromJSON,
  mS as NonFungibleResourcesCollectionItemBaseFromJSONTyped,
  oV as NonFungibleResourcesCollectionItemBaseToJSON,
  ws as NonFungibleResourcesCollectionItemFromJSON,
  lS as NonFungibleResourcesCollectionItemFromJSONTyped,
  zP as NonFungibleResourcesCollectionItemGloballyAggregatedAggregationLevelEnum,
  uV as NonFungibleResourcesCollectionItemGloballyAggregatedAllOfAggregationLevelEnum,
  cV as NonFungibleResourcesCollectionItemGloballyAggregatedAllOfFromJSON,
  yS as NonFungibleResourcesCollectionItemGloballyAggregatedAllOfFromJSONTyped,
  dV as NonFungibleResourcesCollectionItemGloballyAggregatedAllOfToJSON,
  WP as NonFungibleResourcesCollectionItemGloballyAggregatedFromJSON,
  td as NonFungibleResourcesCollectionItemGloballyAggregatedFromJSONTyped,
  iS as NonFungibleResourcesCollectionItemGloballyAggregatedToJSON,
  Ts as NonFungibleResourcesCollectionItemToJSON,
  XP as NonFungibleResourcesCollectionItemVaultAggregatedAggregationLevelEnum,
  fV as NonFungibleResourcesCollectionItemVaultAggregatedAllOfAggregationLevelEnum,
  mV as NonFungibleResourcesCollectionItemVaultAggregatedAllOfFromJSON,
  _S as NonFungibleResourcesCollectionItemVaultAggregatedAllOfFromJSONTyped,
  yV as NonFungibleResourcesCollectionItemVaultAggregatedAllOfToJSON,
  tV as NonFungibleResourcesCollectionItemVaultAggregatedFromJSON,
  ad as NonFungibleResourcesCollectionItemVaultAggregatedFromJSONTyped,
  uS as NonFungibleResourcesCollectionItemVaultAggregatedToJSON,
  gV as NonFungibleResourcesCollectionItemVaultAggregatedVaultAllOfFromJSON,
  gS as NonFungibleResourcesCollectionItemVaultAggregatedVaultAllOfFromJSONTyped,
  hV as NonFungibleResourcesCollectionItemVaultAggregatedVaultAllOfToJSON,
  ed as NonFungibleResourcesCollectionItemVaultAggregatedVaultFromJSON,
  oS as NonFungibleResourcesCollectionItemVaultAggregatedVaultFromJSONTyped,
  bV as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemAllOfFromJSON,
  hS as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemAllOfFromJSONTyped,
  SV as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemAllOfToJSON,
  ga as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemFromJSON,
  sS as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemFromJSONTyped,
  ha as NonFungibleResourcesCollectionItemVaultAggregatedVaultItemToJSON,
  nd as NonFungibleResourcesCollectionItemVaultAggregatedVaultToJSON,
  fS as NonFungibleResourcesCollectionToJSON,
  wV as NotSyncedUpErrorAllOfFromJSON,
  vS as NotSyncedUpErrorAllOfFromJSONTyped,
  TV as NotSyncedUpErrorAllOfToJSON,
  OV as NotSyncedUpErrorAllOfTypeEnum,
  Xx as NotSyncedUpErrorFromJSON,
  Kc as NotSyncedUpErrorFromJSONTyped,
  Cv as NotSyncedUpErrorToJSON,
  Hx as NotSyncedUpErrorTypeEnum,
  le as NumberOfValues,
  fk as ObjectModuleId,
  Fh as ObjectModuleIdFromJSON,
  xh as ObjectModuleIdFromJSONTyped,
  pk as ObjectModuleIdToJSON,
  w$ as OneTimeDataRequestBuilder,
  EV as OptionalNonFungibleIdsCollectionAllOfFromJSON,
  SS as OptionalNonFungibleIdsCollectionAllOfFromJSONTyped,
  RV as OptionalNonFungibleIdsCollectionAllOfToJSON,
  kV as OptionalNonFungibleIdsCollectionFromJSON,
  bS as OptionalNonFungibleIdsCollectionFromJSONTyped,
  FV as OptionalNonFungibleIdsCollectionToJSON,
  IV as PackageVmType,
  rd as PackageVmTypeFromJSON,
  OS as PackageVmTypeFromJSONTyped,
  PV as PackageVmTypeToJSON,
  da as Persona,
  Eu as PersonaDataName,
  Dm as PersonaDataNameVariant,
  za as PersonaDataRequestItem,
  wi as PersonaDataRequestResponseItem,
  CV as ProgrammaticScryptoSborValueArrayAllOfFromJSON,
  NS as ProgrammaticScryptoSborValueArrayAllOfFromJSONTyped,
  VV as ProgrammaticScryptoSborValueArrayAllOfKindEnum,
  DV as ProgrammaticScryptoSborValueArrayAllOfToJSON,
  GT as ProgrammaticScryptoSborValueArrayFromJSON,
  kl as ProgrammaticScryptoSborValueArrayFromJSONTyped,
  ZT as ProgrammaticScryptoSborValueArrayKindEnum,
  Bg as ProgrammaticScryptoSborValueArrayToJSON,
  qV as ProgrammaticScryptoSborValueBaseFromJSON,
  wS as ProgrammaticScryptoSborValueBaseFromJSONTyped,
  $V as ProgrammaticScryptoSborValueBaseToJSON,
  jV as ProgrammaticScryptoSborValueBoolAllOfFromJSON,
  TS as ProgrammaticScryptoSborValueBoolAllOfFromJSONTyped,
  UV as ProgrammaticScryptoSborValueBoolAllOfKindEnum,
  KV as ProgrammaticScryptoSborValueBoolAllOfToJSON,
  YT as ProgrammaticScryptoSborValueBoolFromJSON,
  Fl as ProgrammaticScryptoSborValueBoolFromJSONTyped,
  WT as ProgrammaticScryptoSborValueBoolKindEnum,
  Zg as ProgrammaticScryptoSborValueBoolToJSON,
  zV as ProgrammaticScryptoSborValueBytesAllOfFromJSON,
  AS as ProgrammaticScryptoSborValueBytesAllOfFromJSONTyped,
  BV as ProgrammaticScryptoSborValueBytesAllOfKindEnum,
  GV as ProgrammaticScryptoSborValueBytesAllOfToJSON,
  tA as ProgrammaticScryptoSborValueBytesFromJSON,
  xl as ProgrammaticScryptoSborValueBytesFromJSONTyped,
  XT as ProgrammaticScryptoSborValueBytesKindEnum,
  zg as ProgrammaticScryptoSborValueBytesToJSON,
  YV as ProgrammaticScryptoSborValueDecimalAllOfFromJSON,
  kS as ProgrammaticScryptoSborValueDecimalAllOfFromJSONTyped,
  WV as ProgrammaticScryptoSborValueDecimalAllOfKindEnum,
  XV as ProgrammaticScryptoSborValueDecimalAllOfToJSON,
  aA as ProgrammaticScryptoSborValueDecimalFromJSON,
  El as ProgrammaticScryptoSborValueDecimalFromJSONTyped,
  eA as ProgrammaticScryptoSborValueDecimalKindEnum,
  Gg as ProgrammaticScryptoSborValueDecimalToJSON,
  eJ as ProgrammaticScryptoSborValueEnumAllOfFromJSON,
  FS as ProgrammaticScryptoSborValueEnumAllOfFromJSONTyped,
  QV as ProgrammaticScryptoSborValueEnumAllOfKindEnum,
  nJ as ProgrammaticScryptoSborValueEnumAllOfToJSON,
  sA as ProgrammaticScryptoSborValueEnumFromJSON,
  Rl as ProgrammaticScryptoSborValueEnumFromJSONTyped,
  rA as ProgrammaticScryptoSborValueEnumKindEnum,
  Wg as ProgrammaticScryptoSborValueEnumToJSON,
  jt as ProgrammaticScryptoSborValueFromJSON,
  mh as ProgrammaticScryptoSborValueFromJSONTyped,
  iJ as ProgrammaticScryptoSborValueI128AllOfFromJSON,
  xS as ProgrammaticScryptoSborValueI128AllOfFromJSONTyped,
  aJ as ProgrammaticScryptoSborValueI128AllOfKindEnum,
  sJ as ProgrammaticScryptoSborValueI128AllOfToJSON,
  lA as ProgrammaticScryptoSborValueI128FromJSON,
  Il as ProgrammaticScryptoSborValueI128FromJSONTyped,
  oA as ProgrammaticScryptoSborValueI128KindEnum,
  Hg as ProgrammaticScryptoSborValueI128ToJSON,
  lJ as ProgrammaticScryptoSborValueI16AllOfFromJSON,
  ES as ProgrammaticScryptoSborValueI16AllOfFromJSONTyped,
  oJ as ProgrammaticScryptoSborValueI16AllOfKindEnum,
  cJ as ProgrammaticScryptoSborValueI16AllOfToJSON,
  fA as ProgrammaticScryptoSborValueI16FromJSON,
  Pl as ProgrammaticScryptoSborValueI16FromJSONTyped,
  cA as ProgrammaticScryptoSborValueI16KindEnum,
  Yg as ProgrammaticScryptoSborValueI16ToJSON,
  pJ as ProgrammaticScryptoSborValueI32AllOfFromJSON,
  RS as ProgrammaticScryptoSborValueI32AllOfFromJSONTyped,
  dJ as ProgrammaticScryptoSborValueI32AllOfKindEnum,
  mJ as ProgrammaticScryptoSborValueI32AllOfToJSON,
  yA as ProgrammaticScryptoSborValueI32FromJSON,
  Vl as ProgrammaticScryptoSborValueI32FromJSONTyped,
  pA as ProgrammaticScryptoSborValueI32KindEnum,
  Xg as ProgrammaticScryptoSborValueI32ToJSON,
  gJ as ProgrammaticScryptoSborValueI64AllOfFromJSON,
  IS as ProgrammaticScryptoSborValueI64AllOfFromJSONTyped,
  yJ as ProgrammaticScryptoSborValueI64AllOfKindEnum,
  hJ as ProgrammaticScryptoSborValueI64AllOfToJSON,
  hA as ProgrammaticScryptoSborValueI64FromJSON,
  Jl as ProgrammaticScryptoSborValueI64FromJSONTyped,
  _A as ProgrammaticScryptoSborValueI64KindEnum,
  Qg as ProgrammaticScryptoSborValueI64ToJSON,
  SJ as ProgrammaticScryptoSborValueI8AllOfFromJSON,
  PS as ProgrammaticScryptoSborValueI8AllOfFromJSONTyped,
  vJ as ProgrammaticScryptoSborValueI8AllOfKindEnum,
  OJ as ProgrammaticScryptoSborValueI8AllOfToJSON,
  SA as ProgrammaticScryptoSborValueI8FromJSON,
  Cl as ProgrammaticScryptoSborValueI8FromJSONTyped,
  vA as ProgrammaticScryptoSborValueI8KindEnum,
  th as ProgrammaticScryptoSborValueI8ToJSON,
  KT as ProgrammaticScryptoSborValueKind,
  Fe as ProgrammaticScryptoSborValueKindFromJSON,
  Kg as ProgrammaticScryptoSborValueKindFromJSONTyped,
  BT as ProgrammaticScryptoSborValueKindToJSON,
  TJ as ProgrammaticScryptoSborValueMapAllOfFromJSON,
  VS as ProgrammaticScryptoSborValueMapAllOfFromJSONTyped,
  NJ as ProgrammaticScryptoSborValueMapAllOfKindEnum,
  AJ as ProgrammaticScryptoSborValueMapAllOfToJSON,
  Dl as ProgrammaticScryptoSborValueMapEntryFromJSON,
  eh as ProgrammaticScryptoSborValueMapEntryFromJSONTyped,
  Ml as ProgrammaticScryptoSborValueMapEntryToJSON,
  TA as ProgrammaticScryptoSborValueMapFromJSON,
  ql as ProgrammaticScryptoSborValueMapFromJSONTyped,
  NA as ProgrammaticScryptoSborValueMapKindEnum,
  nh as ProgrammaticScryptoSborValueMapToJSON,
  xJ as ProgrammaticScryptoSborValueNonFungibleLocalIdAllOfFromJSON,
  JS as ProgrammaticScryptoSborValueNonFungibleLocalIdAllOfFromJSONTyped,
  kJ as ProgrammaticScryptoSborValueNonFungibleLocalIdAllOfKindEnum,
  EJ as ProgrammaticScryptoSborValueNonFungibleLocalIdAllOfToJSON,
  FA as ProgrammaticScryptoSborValueNonFungibleLocalIdFromJSON,
  $l as ProgrammaticScryptoSborValueNonFungibleLocalIdFromJSONTyped,
  AA as ProgrammaticScryptoSborValueNonFungibleLocalIdKindEnum,
  ah as ProgrammaticScryptoSborValueNonFungibleLocalIdToJSON,
  PJ as ProgrammaticScryptoSborValueOwnAllOfFromJSON,
  CS as ProgrammaticScryptoSborValueOwnAllOfFromJSONTyped,
  RJ as ProgrammaticScryptoSborValueOwnAllOfKindEnum,
  VJ as ProgrammaticScryptoSborValueOwnAllOfToJSON,
  RA as ProgrammaticScryptoSborValueOwnFromJSON,
  Ul as ProgrammaticScryptoSborValueOwnFromJSONTyped,
  xA as ProgrammaticScryptoSborValueOwnKindEnum,
  rh as ProgrammaticScryptoSborValueOwnToJSON,
  DJ as ProgrammaticScryptoSborValuePreciseDecimalAllOfFromJSON,
  DS as ProgrammaticScryptoSborValuePreciseDecimalAllOfFromJSONTyped,
  JJ as ProgrammaticScryptoSborValuePreciseDecimalAllOfKindEnum,
  MJ as ProgrammaticScryptoSborValuePreciseDecimalAllOfToJSON,
  VA as ProgrammaticScryptoSborValuePreciseDecimalFromJSON,
  Ll as ProgrammaticScryptoSborValuePreciseDecimalFromJSONTyped,
  IA as ProgrammaticScryptoSborValuePreciseDecimalKindEnum,
  ih as ProgrammaticScryptoSborValuePreciseDecimalToJSON,
  UJ as ProgrammaticScryptoSborValueReferenceAllOfFromJSON,
  MS as ProgrammaticScryptoSborValueReferenceAllOfFromJSONTyped,
  qJ as ProgrammaticScryptoSborValueReferenceAllOfKindEnum,
  LJ as ProgrammaticScryptoSborValueReferenceAllOfToJSON,
  DA as ProgrammaticScryptoSborValueReferenceFromJSON,
  jl as ProgrammaticScryptoSborValueReferenceFromJSONTyped,
  JA as ProgrammaticScryptoSborValueReferenceKindEnum,
  sh as ProgrammaticScryptoSborValueReferenceToJSON,
  BJ as ProgrammaticScryptoSborValueStringAllOfFromJSON,
  qS as ProgrammaticScryptoSborValueStringAllOfFromJSONTyped,
  jJ as ProgrammaticScryptoSborValueStringAllOfKindEnum,
  ZJ as ProgrammaticScryptoSborValueStringAllOfToJSON,
  $A as ProgrammaticScryptoSborValueStringFromJSON,
  Kl as ProgrammaticScryptoSborValueStringFromJSONTyped,
  MA as ProgrammaticScryptoSborValueStringKindEnum,
  oh as ProgrammaticScryptoSborValueStringToJSON,
  Kt as ProgrammaticScryptoSborValueToJSON,
  WJ as ProgrammaticScryptoSborValueTupleAllOfFromJSON,
  $S as ProgrammaticScryptoSborValueTupleAllOfFromJSONTyped,
  zJ as ProgrammaticScryptoSborValueTupleAllOfKindEnum,
  HJ as ProgrammaticScryptoSborValueTupleAllOfToJSON,
  jA as ProgrammaticScryptoSborValueTupleFromJSON,
  Bl as ProgrammaticScryptoSborValueTupleFromJSONTyped,
  UA as ProgrammaticScryptoSborValueTupleKindEnum,
  uh as ProgrammaticScryptoSborValueTupleToJSON,
  QJ as ProgrammaticScryptoSborValueU128AllOfFromJSON,
  US as ProgrammaticScryptoSborValueU128AllOfFromJSONTyped,
  YJ as ProgrammaticScryptoSborValueU128AllOfKindEnum,
  t1 as ProgrammaticScryptoSborValueU128AllOfToJSON,
  ZA as ProgrammaticScryptoSborValueU128FromJSON,
  Zl as ProgrammaticScryptoSborValueU128FromJSONTyped,
  KA as ProgrammaticScryptoSborValueU128KindEnum,
  lh as ProgrammaticScryptoSborValueU128ToJSON,
  a1 as ProgrammaticScryptoSborValueU16AllOfFromJSON,
  LS as ProgrammaticScryptoSborValueU16AllOfFromJSONTyped,
  e1 as ProgrammaticScryptoSborValueU16AllOfKindEnum,
  r1 as ProgrammaticScryptoSborValueU16AllOfToJSON,
  WA as ProgrammaticScryptoSborValueU16FromJSON,
  zl as ProgrammaticScryptoSborValueU16FromJSONTyped,
  zA as ProgrammaticScryptoSborValueU16KindEnum,
  ch as ProgrammaticScryptoSborValueU16ToJSON,
  o1 as ProgrammaticScryptoSborValueU32AllOfFromJSON,
  jS as ProgrammaticScryptoSborValueU32AllOfFromJSONTyped,
  i1 as ProgrammaticScryptoSborValueU32AllOfKindEnum,
  u1 as ProgrammaticScryptoSborValueU32AllOfToJSON,
  XA as ProgrammaticScryptoSborValueU32FromJSON,
  Gl as ProgrammaticScryptoSborValueU32FromJSONTyped,
  HA as ProgrammaticScryptoSborValueU32KindEnum,
  dh as ProgrammaticScryptoSborValueU32ToJSON,
  d1 as ProgrammaticScryptoSborValueU64AllOfFromJSON,
  KS as ProgrammaticScryptoSborValueU64AllOfFromJSONTyped,
  l1 as ProgrammaticScryptoSborValueU64AllOfKindEnum,
  f1 as ProgrammaticScryptoSborValueU64AllOfToJSON,
  ek as ProgrammaticScryptoSborValueU64FromJSON,
  Wl as ProgrammaticScryptoSborValueU64FromJSONTyped,
  QA as ProgrammaticScryptoSborValueU64KindEnum,
  fh as ProgrammaticScryptoSborValueU64ToJSON,
  y1 as ProgrammaticScryptoSborValueU8AllOfFromJSON,
  BS as ProgrammaticScryptoSborValueU8AllOfFromJSONTyped,
  p1 as ProgrammaticScryptoSborValueU8AllOfKindEnum,
  _1 as ProgrammaticScryptoSborValueU8AllOfToJSON,
  rk as ProgrammaticScryptoSborValueU8FromJSON,
  Hl as ProgrammaticScryptoSborValueU8FromJSONTyped,
  nk as ProgrammaticScryptoSborValueU8KindEnum,
  ph as ProgrammaticScryptoSborValueU8ToJSON,
  ca as Proof,
  b1 as PublicKeyBaseFromJSON,
  GS as PublicKeyBaseFromJSONTyped,
  S1 as PublicKeyBaseToJSON,
  w1 as PublicKeyEcdsaSecp256k1AllOfFromJSON,
  WS as PublicKeyEcdsaSecp256k1AllOfFromJSONTyped,
  O1 as PublicKeyEcdsaSecp256k1AllOfKeyTypeEnum,
  T1 as PublicKeyEcdsaSecp256k1AllOfToJSON,
  NF as PublicKeyEcdsaSecp256k1FromJSON,
  gc as PublicKeyEcdsaSecp256k1FromJSONTyped,
  SF as PublicKeyEcdsaSecp256k1KeyTypeEnum,
  ev as PublicKeyEcdsaSecp256k1ToJSON,
  F1 as PublicKeyEddsaEd25519AllOfFromJSON,
  HS as PublicKeyEddsaEd25519AllOfFromJSONTyped,
  A1 as PublicKeyEddsaEd25519AllOfKeyTypeEnum,
  x1 as PublicKeyEddsaEd25519AllOfToJSON,
  AF as PublicKeyEddsaEd25519FromJSON,
  hc as PublicKeyEddsaEd25519FromJSONTyped,
  wF as PublicKeyEddsaEd25519KeyTypeEnum,
  nv as PublicKeyEddsaEd25519ToJSON,
  gn as PublicKeyFromJSON,
  av as PublicKeyFromJSONTyped,
  P1 as PublicKeyHashBaseFromJSON,
  QS as PublicKeyHashBaseFromJSONTyped,
  V1 as PublicKeyHashBaseToJSON,
  D1 as PublicKeyHashEcdsaSecp256k1AllOfFromJSON,
  tO as PublicKeyHashEcdsaSecp256k1AllOfFromJSONTyped,
  J1 as PublicKeyHashEcdsaSecp256k1AllOfKeyHashTypeEnum,
  M1 as PublicKeyHashEcdsaSecp256k1AllOfToJSON,
  IF as PublicKeyHashEcdsaSecp256k1FromJSON,
  bc as PublicKeyHashEcdsaSecp256k1FromJSONTyped,
  EF as PublicKeyHashEcdsaSecp256k1KeyHashTypeEnum,
  iv as PublicKeyHashEcdsaSecp256k1ToJSON,
  U1 as PublicKeyHashEddsaEd25519AllOfFromJSON,
  eO as PublicKeyHashEddsaEd25519AllOfFromJSONTyped,
  q1 as PublicKeyHashEddsaEd25519AllOfKeyHashTypeEnum,
  L1 as PublicKeyHashEddsaEd25519AllOfToJSON,
  JF as PublicKeyHashEddsaEd25519FromJSON,
  Sc as PublicKeyHashEddsaEd25519FromJSONTyped,
  PF as PublicKeyHashEddsaEd25519KeyHashTypeEnum,
  sv as PublicKeyHashEddsaEd25519ToJSON,
  Tr as PublicKeyHashFromJSON,
  ov as PublicKeyHashFromJSONTyped,
  Ar as PublicKeyHashToJSON,
  E1 as PublicKeyHashType,
  YS as PublicKeyHashTypeFromJSON,
  XS as PublicKeyHashTypeFromJSONTyped,
  R1 as PublicKeyHashTypeToJSON,
  hn as PublicKeyToJSON,
  g1 as PublicKeyType,
  ZS as PublicKeyTypeFromJSON,
  zS as PublicKeyTypeFromJSONTyped,
  h1 as PublicKeyTypeToJSON,
  O$ as RadixDappToolkit,
  ie as RadixNetwork,
  fw as RadixNetworkConfig,
  Ho as RadixNetworkConfigById,
  bw as RdtGatewayApiClient,
  tg as RdtState,
  vt as RequiredError,
  Mm as ResetRequestItem,
  Xv as ResourceAggregationLevel,
  ze as ResourceAggregationLevelFromJSON,
  Qv as ResourceAggregationLevelFromJSONTyped,
  bE as ResourceAggregationLevelToJSON,
  dr as ResponseError,
  K1 as ResultSetCursorMixinFromJSON,
  nO as ResultSetCursorMixinFromJSONTyped,
  B1 as ResultSetCursorMixinToJSON,
  lk as RoleAssignmentResolution,
  Nh as RoleAssignmentResolutionFromJSON,
  wh as RoleAssignmentResolutionFromJSONTyped,
  ck as RoleAssignmentResolutionToJSON,
  Zo as RoleKeyFromJSON,
  Eh as RoleKeyFromJSONTyped,
  zo as RoleKeyToJSON,
  Qi as ScryptoSborValueFromJSON,
  aO as ScryptoSborValueFromJSONTyped,
  ts as ScryptoSborValueToJSON,
  zm as SendTransactionItem,
  Wm as SendTransactionResponseItem,
  Q_ as SharedData,
  z_ as SignedChallenge,
  Z_ as SignedChallengeAccount,
  B_ as SignedChallengePersona,
  uw as State,
  aw as StateApi,
  id as StateEntityDetailsOptInsFromJSON,
  rO as StateEntityDetailsOptInsFromJSONTyped,
  sd as StateEntityDetailsOptInsToJSON,
  Y1 as StateEntityDetailsRequestAllOfFromJSON,
  oO as StateEntityDetailsRequestAllOfFromJSONTyped,
  X1 as StateEntityDetailsRequestAllOfToJSON,
  W1 as StateEntityDetailsRequestFromJSON,
  iO as StateEntityDetailsRequestFromJSONTyped,
  sO as StateEntityDetailsRequestToJSON,
  AC as StateEntityDetailsResponseAllOfFromJSON,
  kO as StateEntityDetailsResponseAllOfFromJSONTyped,
  kC as StateEntityDetailsResponseAllOfToJSON,
  EC as StateEntityDetailsResponseComponentDetailsAllOfFromJSON,
  FO as StateEntityDetailsResponseComponentDetailsAllOfFromJSONTyped,
  RC as StateEntityDetailsResponseComponentDetailsAllOfToJSON,
  FC as StateEntityDetailsResponseComponentDetailsAllOfTypeEnum,
  nC as StateEntityDetailsResponseComponentDetailsFromJSON,
  od as StateEntityDetailsResponseComponentDetailsFromJSONTyped,
  dO as StateEntityDetailsResponseComponentDetailsToJSON,
  tC as StateEntityDetailsResponseComponentDetailsTypeEnum,
  TO as StateEntityDetailsResponseFromJSON,
  AO as StateEntityDetailsResponseFromJSONTyped,
  VC as StateEntityDetailsResponseFungibleResourceDetailsAllOfFromJSON,
  xO as StateEntityDetailsResponseFungibleResourceDetailsAllOfFromJSONTyped,
  JC as StateEntityDetailsResponseFungibleResourceDetailsAllOfToJSON,
  IC as StateEntityDetailsResponseFungibleResourceDetailsAllOfTypeEnum,
  iC as StateEntityDetailsResponseFungibleResourceDetailsFromJSON,
  ud as StateEntityDetailsResponseFungibleResourceDetailsFromJSONTyped,
  fO as StateEntityDetailsResponseFungibleResourceDetailsToJSON,
  aC as StateEntityDetailsResponseFungibleResourceDetailsTypeEnum,
  MC as StateEntityDetailsResponseFungibleVaultDetailsAllOfFromJSON,
  EO as StateEntityDetailsResponseFungibleVaultDetailsAllOfFromJSONTyped,
  qC as StateEntityDetailsResponseFungibleVaultDetailsAllOfToJSON,
  CC as StateEntityDetailsResponseFungibleVaultDetailsAllOfTypeEnum,
  uC as StateEntityDetailsResponseFungibleVaultDetailsFromJSON,
  ld as StateEntityDetailsResponseFungibleVaultDetailsFromJSONTyped,
  pO as StateEntityDetailsResponseFungibleVaultDetailsToJSON,
  sC as StateEntityDetailsResponseFungibleVaultDetailsTypeEnum,
  uO as StateEntityDetailsResponseItemAncestorIdentitiesFromJSON,
  lO as StateEntityDetailsResponseItemAncestorIdentitiesFromJSONTyped,
  cO as StateEntityDetailsResponseItemAncestorIdentitiesToJSON,
  jC as StateEntityDetailsResponseItemDetailsBaseFromJSON,
  PO as StateEntityDetailsResponseItemDetailsBaseFromJSONTyped,
  KC as StateEntityDetailsResponseItemDetailsBaseToJSON,
  SO as StateEntityDetailsResponseItemDetailsFromJSON,
  OO as StateEntityDetailsResponseItemDetailsFromJSONTyped,
  NO as StateEntityDetailsResponseItemDetailsToJSON,
  $C as StateEntityDetailsResponseItemDetailsType,
  RO as StateEntityDetailsResponseItemDetailsTypeFromJSON,
  IO as StateEntityDetailsResponseItemDetailsTypeFromJSONTyped,
  UC as StateEntityDetailsResponseItemDetailsTypeToJSON,
  Sd as StateEntityDetailsResponseItemFromJSON,
  wO as StateEntityDetailsResponseItemFromJSONTyped,
  Od as StateEntityDetailsResponseItemToJSON,
  zC as StateEntityDetailsResponseNonFungibleResourceDetailsAllOfFromJSON,
  VO as StateEntityDetailsResponseNonFungibleResourceDetailsAllOfFromJSONTyped,
  GC as StateEntityDetailsResponseNonFungibleResourceDetailsAllOfToJSON,
  BC as StateEntityDetailsResponseNonFungibleResourceDetailsAllOfTypeEnum,
  dC as StateEntityDetailsResponseNonFungibleResourceDetailsFromJSON,
  cd as StateEntityDetailsResponseNonFungibleResourceDetailsFromJSONTyped,
  mO as StateEntityDetailsResponseNonFungibleResourceDetailsToJSON,
  lC as StateEntityDetailsResponseNonFungibleResourceDetailsTypeEnum,
  YC as StateEntityDetailsResponseNonFungibleVaultDetailsAllOfFromJSON,
  JO as StateEntityDetailsResponseNonFungibleVaultDetailsAllOfFromJSONTyped,
  XC as StateEntityDetailsResponseNonFungibleVaultDetailsAllOfToJSON,
  WC as StateEntityDetailsResponseNonFungibleVaultDetailsAllOfTypeEnum,
  mC as StateEntityDetailsResponseNonFungibleVaultDetailsFromJSON,
  dd as StateEntityDetailsResponseNonFungibleVaultDetailsFromJSONTyped,
  yO as StateEntityDetailsResponseNonFungibleVaultDetailsToJSON,
  fC as StateEntityDetailsResponseNonFungibleVaultDetailsTypeEnum,
  eD as StateEntityDetailsResponsePackageDetailsAllOfFromJSON,
  CO as StateEntityDetailsResponsePackageDetailsAllOfFromJSONTyped,
  nD as StateEntityDetailsResponsePackageDetailsAllOfToJSON,
  QC as StateEntityDetailsResponsePackageDetailsAllOfTypeEnum,
  rD as StateEntityDetailsResponsePackageDetailsBlueprintCollectionAllOfFromJSON,
  DO as StateEntityDetailsResponsePackageDetailsBlueprintCollectionAllOfFromJSONTyped,
  iD as StateEntityDetailsResponsePackageDetailsBlueprintCollectionAllOfToJSON,
  md as StateEntityDetailsResponsePackageDetailsBlueprintCollectionFromJSON,
  gO as StateEntityDetailsResponsePackageDetailsBlueprintCollectionFromJSONTyped,
  yd as StateEntityDetailsResponsePackageDetailsBlueprintCollectionToJSON,
  fd as StateEntityDetailsResponsePackageDetailsBlueprintItemFromJSON,
  _O as StateEntityDetailsResponsePackageDetailsBlueprintItemFromJSONTyped,
  pd as StateEntityDetailsResponsePackageDetailsBlueprintItemToJSON,
  SC as StateEntityDetailsResponsePackageDetailsFromJSON,
  bd as StateEntityDetailsResponsePackageDetailsFromJSONTyped,
  oD as StateEntityDetailsResponsePackageDetailsSchemaCollectionAllOfFromJSON,
  MO as StateEntityDetailsResponsePackageDetailsSchemaCollectionAllOfFromJSONTyped,
  uD as StateEntityDetailsResponsePackageDetailsSchemaCollectionAllOfToJSON,
  hd as StateEntityDetailsResponsePackageDetailsSchemaCollectionFromJSON,
  vO as StateEntityDetailsResponsePackageDetailsSchemaCollectionFromJSONTyped,
  vd as StateEntityDetailsResponsePackageDetailsSchemaCollectionToJSON,
  _d as StateEntityDetailsResponsePackageDetailsSchemaItemFromJSON,
  hO as StateEntityDetailsResponsePackageDetailsSchemaItemFromJSONTyped,
  gd as StateEntityDetailsResponsePackageDetailsSchemaItemToJSON,
  bO as StateEntityDetailsResponsePackageDetailsToJSON,
  vC as StateEntityDetailsResponsePackageDetailsTypeEnum,
  wC as StateEntityDetailsResponseToJSON,
  fD as StateEntityFungibleResourceVaultsPageRequestAllOfFromJSON,
  UO as StateEntityFungibleResourceVaultsPageRequestAllOfFromJSONTyped,
  pD as StateEntityFungibleResourceVaultsPageRequestAllOfToJSON,
  cD as StateEntityFungibleResourceVaultsPageRequestFromJSON,
  qO as StateEntityFungibleResourceVaultsPageRequestFromJSONTyped,
  $O as StateEntityFungibleResourceVaultsPageRequestToJSON,
  LO as StateEntityFungibleResourceVaultsPageResponseFromJSON,
  jO as StateEntityFungibleResourceVaultsPageResponseFromJSONTyped,
  yD as StateEntityFungibleResourceVaultsPageResponseToJSON,
  bD as StateEntityFungiblesPageRequestAllOfFromJSON,
  zO as StateEntityFungiblesPageRequestAllOfFromJSONTyped,
  SD as StateEntityFungiblesPageRequestAllOfToJSON,
  hD as StateEntityFungiblesPageRequestFromJSON,
  BO as StateEntityFungiblesPageRequestFromJSONTyped,
  Nd as StateEntityFungiblesPageRequestOptInsFromJSON,
  KO as StateEntityFungiblesPageRequestOptInsFromJSONTyped,
  wd as StateEntityFungiblesPageRequestOptInsToJSON,
  ZO as StateEntityFungiblesPageRequestToJSON,
  GO as StateEntityFungiblesPageResponseFromJSON,
  WO as StateEntityFungiblesPageResponseFromJSONTyped,
  ND as StateEntityFungiblesPageResponseToJSON,
  kD as StateEntityMetadataPageRequestAllOfFromJSON,
  XO as StateEntityMetadataPageRequestAllOfFromJSONTyped,
  FD as StateEntityMetadataPageRequestAllOfToJSON,
  TD as StateEntityMetadataPageRequestFromJSON,
  HO as StateEntityMetadataPageRequestFromJSONTyped,
  YO as StateEntityMetadataPageRequestToJSON,
  QO as StateEntityMetadataPageResponseFromJSON,
  t0 as StateEntityMetadataPageResponseFromJSONTyped,
  ED as StateEntityMetadataPageResponseToJSON,
  VD as StateEntityNonFungibleIdsPageRequestAllOfFromJSON,
  a0 as StateEntityNonFungibleIdsPageRequestAllOfFromJSONTyped,
  JD as StateEntityNonFungibleIdsPageRequestAllOfToJSON,
  ID as StateEntityNonFungibleIdsPageRequestFromJSON,
  e0 as StateEntityNonFungibleIdsPageRequestFromJSONTyped,
  n0 as StateEntityNonFungibleIdsPageRequestToJSON,
  r0 as StateEntityNonFungibleIdsPageResponseFromJSON,
  i0 as StateEntityNonFungibleIdsPageResponseFromJSONTyped,
  DD as StateEntityNonFungibleIdsPageResponseToJSON,
  Td as StateEntityNonFungibleResourceVaultsPageOptInsFromJSON,
  s0 as StateEntityNonFungibleResourceVaultsPageOptInsFromJSONTyped,
  Ad as StateEntityNonFungibleResourceVaultsPageOptInsToJSON,
  LD as StateEntityNonFungibleResourceVaultsPageRequestAllOfFromJSON,
  l0 as StateEntityNonFungibleResourceVaultsPageRequestAllOfFromJSONTyped,
  jD as StateEntityNonFungibleResourceVaultsPageRequestAllOfToJSON,
  $D as StateEntityNonFungibleResourceVaultsPageRequestFromJSON,
  o0 as StateEntityNonFungibleResourceVaultsPageRequestFromJSONTyped,
  u0 as StateEntityNonFungibleResourceVaultsPageRequestToJSON,
  c0 as StateEntityNonFungibleResourceVaultsPageResponseFromJSON,
  d0 as StateEntityNonFungibleResourceVaultsPageResponseFromJSONTyped,
  BD as StateEntityNonFungibleResourceVaultsPageResponseToJSON,
  HD as StateEntityNonFungiblesPageRequestAllOfFromJSON,
  y0 as StateEntityNonFungiblesPageRequestAllOfFromJSONTyped,
  YD as StateEntityNonFungiblesPageRequestAllOfToJSON,
  GD as StateEntityNonFungiblesPageRequestFromJSON,
  p0 as StateEntityNonFungiblesPageRequestFromJSONTyped,
  kd as StateEntityNonFungiblesPageRequestOptInsFromJSON,
  f0 as StateEntityNonFungiblesPageRequestOptInsFromJSONTyped,
  Fd as StateEntityNonFungiblesPageRequestOptInsToJSON,
  m0 as StateEntityNonFungiblesPageRequestToJSON,
  _0 as StateEntityNonFungiblesPageResponseFromJSON,
  g0 as StateEntityNonFungiblesPageResponseFromJSONTyped,
  QD as StateEntityNonFungiblesPageResponseToJSON,
  rM as StateKeyValueStoreDataRequestAllOfFromJSON,
  S0 as StateKeyValueStoreDataRequestAllOfFromJSONTyped,
  iM as StateKeyValueStoreDataRequestAllOfToJSON,
  nM as StateKeyValueStoreDataRequestFromJSON,
  v0 as StateKeyValueStoreDataRequestFromJSONTyped,
  xd as StateKeyValueStoreDataRequestKeyItemFromJSON,
  h0 as StateKeyValueStoreDataRequestKeyItemFromJSONTyped,
  Ed as StateKeyValueStoreDataRequestKeyItemToJSON,
  b0 as StateKeyValueStoreDataRequestToJSON,
  cM as StateKeyValueStoreDataResponseAllOfFromJSON,
  T0 as StateKeyValueStoreDataResponseAllOfFromJSONTyped,
  dM as StateKeyValueStoreDataResponseAllOfToJSON,
  N0 as StateKeyValueStoreDataResponseFromJSON,
  w0 as StateKeyValueStoreDataResponseFromJSONTyped,
  Rd as StateKeyValueStoreDataResponseItemFromJSON,
  O0 as StateKeyValueStoreDataResponseItemFromJSONTyped,
  Id as StateKeyValueStoreDataResponseItemToJSON,
  uM as StateKeyValueStoreDataResponseToJSON,
  pM as StateNonFungibleDataRequestFromJSON,
  A0 as StateNonFungibleDataRequestFromJSONTyped,
  k0 as StateNonFungibleDataRequestToJSON,
  hM as StateNonFungibleDataResponseAllOfFromJSON,
  R0 as StateNonFungibleDataResponseAllOfFromJSONTyped,
  vM as StateNonFungibleDataResponseAllOfToJSON,
  x0 as StateNonFungibleDataResponseFromJSON,
  E0 as StateNonFungibleDataResponseFromJSONTyped,
  _M as StateNonFungibleDataResponseToJSON,
  Pd as StateNonFungibleDetailsResponseItemFromJSON,
  F0 as StateNonFungibleDetailsResponseItemFromJSONTyped,
  Vd as StateNonFungibleDetailsResponseItemToJSON,
  NM as StateNonFungibleIdsRequestAllOfFromJSON,
  V0 as StateNonFungibleIdsRequestAllOfFromJSONTyped,
  wM as StateNonFungibleIdsRequestAllOfToJSON,
  SM as StateNonFungibleIdsRequestFromJSON,
  I0 as StateNonFungibleIdsRequestFromJSONTyped,
  P0 as StateNonFungibleIdsRequestToJSON,
  FM as StateNonFungibleIdsResponseAllOfFromJSON,
  D0 as StateNonFungibleIdsResponseAllOfFromJSONTyped,
  xM as StateNonFungibleIdsResponseAllOfToJSON,
  J0 as StateNonFungibleIdsResponseFromJSON,
  C0 as StateNonFungibleIdsResponseFromJSONTyped,
  AM as StateNonFungibleIdsResponseToJSON,
  PM as StateNonFungibleLocationRequestAllOfFromJSON,
  $0 as StateNonFungibleLocationRequestAllOfFromJSONTyped,
  VM as StateNonFungibleLocationRequestAllOfToJSON,
  RM as StateNonFungibleLocationRequestFromJSON,
  M0 as StateNonFungibleLocationRequestFromJSONTyped,
  q0 as StateNonFungibleLocationRequestToJSON,
  qM as StateNonFungibleLocationResponseAllOfFromJSON,
  K0 as StateNonFungibleLocationResponseAllOfFromJSONTyped,
  $M as StateNonFungibleLocationResponseAllOfToJSON,
  L0 as StateNonFungibleLocationResponseFromJSON,
  j0 as StateNonFungibleLocationResponseFromJSONTyped,
  Jd as StateNonFungibleLocationResponseItemFromJSON,
  U0 as StateNonFungibleLocationResponseItemFromJSONTyped,
  Cd as StateNonFungibleLocationResponseItemToJSON,
  DM as StateNonFungibleLocationResponseToJSON,
  KM as StateValidatorsListRequestAllOfFromJSON,
  z0 as StateValidatorsListRequestAllOfFromJSONTyped,
  BM as StateValidatorsListRequestAllOfToJSON,
  LM as StateValidatorsListRequestFromJSON,
  B0 as StateValidatorsListRequestFromJSONTyped,
  Z0 as StateValidatorsListRequestToJSON,
  QM as StateValidatorsListResponseAllOfFromJSON,
  nN as StateValidatorsListResponseAllOfFromJSONTyped,
  tq as StateValidatorsListResponseAllOfToJSON,
  tN as StateValidatorsListResponseFromJSON,
  eN as StateValidatorsListResponseFromJSONTyped,
  YM as StateValidatorsListResponseToJSON,
  pw as Statistics,
  rw as StatisticsApi,
  mw as Status,
  iw as StatusApi,
  yw as Stream,
  sw as StreamApi,
  dq as StreamTransactionsRequestAllOfFromJSON,
  oN as StreamTransactionsRequestAllOfFromJSONTyped,
  uq as StreamTransactionsRequestAllOfKindFilterEnum,
  lq as StreamTransactionsRequestAllOfOrderEnum,
  fq as StreamTransactionsRequestAllOfToJSON,
  eq as StreamTransactionsRequestEventFilterItemEventEnum,
  Ud as StreamTransactionsRequestEventFilterItemFromJSON,
  aN as StreamTransactionsRequestEventFilterItemFromJSONTyped,
  Ld as StreamTransactionsRequestEventFilterItemToJSON,
  oq as StreamTransactionsRequestFromJSON,
  iN as StreamTransactionsRequestFromJSONTyped,
  rq as StreamTransactionsRequestKindFilterEnum,
  iq as StreamTransactionsRequestOrderEnum,
  sN as StreamTransactionsRequestToJSON,
  _q as StreamTransactionsResponseAllOfFromJSON,
  cN as StreamTransactionsResponseAllOfFromJSONTyped,
  gq as StreamTransactionsResponseAllOfToJSON,
  uN as StreamTransactionsResponseFromJSON,
  lN as StreamTransactionsResponseFromJSONTyped,
  mq as StreamTransactionsResponseToJSON,
  PT as TextApiResponse,
  _w as Transaction,
  ow as TransactionApi,
  Ug as TransactionBalanceChangesFromJSON,
  Lg as TransactionBalanceChangesFromJSONTyped,
  jg as TransactionBalanceChangesToJSON,
  Sq as TransactionCommittedDetailsRequestAllOfFromJSON,
  pN as TransactionCommittedDetailsRequestAllOfFromJSONTyped,
  Oq as TransactionCommittedDetailsRequestAllOfToJSON,
  vq as TransactionCommittedDetailsRequestFromJSON,
  dN as TransactionCommittedDetailsRequestFromJSONTyped,
  fN as TransactionCommittedDetailsRequestToJSON,
  Aq as TransactionCommittedDetailsResponseAllOfFromJSON,
  _N as TransactionCommittedDetailsResponseAllOfFromJSONTyped,
  kq as TransactionCommittedDetailsResponseAllOfToJSON,
  mN as TransactionCommittedDetailsResponseFromJSON,
  yN as TransactionCommittedDetailsResponseFromJSONTyped,
  wq as TransactionCommittedDetailsResponseToJSON,
  gN as TransactionConstructionResponseFromJSON,
  hN as TransactionConstructionResponseFromJSONTyped,
  xq as TransactionConstructionResponseToJSON,
  Fr as TransactionDetailsOptInsFromJSON,
  rN as TransactionDetailsOptInsFromJSONTyped,
  xr as TransactionDetailsOptInsToJSON,
  Eg as TransactionFungibleBalanceChangesFromJSON,
  Rg as TransactionFungibleBalanceChangesFromJSONTyped,
  Ig as TransactionFungibleBalanceChangesToJSON,
  qT as TransactionFungibleFeeBalanceChangeType,
  Pg as TransactionFungibleFeeBalanceChangeTypeFromJSON,
  Vg as TransactionFungibleFeeBalanceChangeTypeFromJSONTyped,
  $T as TransactionFungibleFeeBalanceChangeTypeToJSON,
  Jg as TransactionFungibleFeeBalanceChangesFromJSON,
  Cg as TransactionFungibleFeeBalanceChangesFromJSONTyped,
  Dg as TransactionFungibleFeeBalanceChangesToJSON,
  Eq as TransactionIntentStatus,
  jd as TransactionIntentStatusFromJSON,
  vN as TransactionIntentStatusFromJSONTyped,
  Rq as TransactionIntentStatusToJSON,
  Mg as TransactionNonFungibleBalanceChangesFromJSON,
  qg as TransactionNonFungibleBalanceChangesFromJSONTyped,
  $g as TransactionNonFungibleBalanceChangesToJSON,
  Vq as TransactionNotFoundErrorAllOfFromJSON,
  bN as TransactionNotFoundErrorAllOfFromJSONTyped,
  Jq as TransactionNotFoundErrorAllOfToJSON,
  Iq as TransactionNotFoundErrorAllOfTypeEnum,
  eE as TransactionNotFoundErrorFromJSON,
  Bc as TransactionNotFoundErrorFromJSONTyped,
  Dv as TransactionNotFoundErrorToJSON,
  Qx as TransactionNotFoundErrorTypeEnum,
  Cq as TransactionPayloadGatewayHandlingStatus,
  SN as TransactionPayloadGatewayHandlingStatusFromJSON,
  ON as TransactionPayloadGatewayHandlingStatusFromJSONTyped,
  Dq as TransactionPayloadGatewayHandlingStatusToJSON,
  Mq as TransactionPayloadStatus,
  NN as TransactionPayloadStatusFromJSON,
  wN as TransactionPayloadStatusFromJSONTyped,
  qq as TransactionPayloadStatusToJSON,
  TN as TransactionPreviewRequestFlagsFromJSON,
  AN as TransactionPreviewRequestFlagsFromJSONTyped,
  kN as TransactionPreviewRequestFlagsToJSON,
  Lq as TransactionPreviewRequestFromJSON,
  FN as TransactionPreviewRequestFromJSONTyped,
  xN as TransactionPreviewRequestToJSON,
  PN as TransactionPreviewResponseFromJSON,
  VN as TransactionPreviewResponseFromJSONTyped,
  EN as TransactionPreviewResponseLogsInnerFromJSON,
  RN as TransactionPreviewResponseLogsInnerFromJSONTyped,
  IN as TransactionPreviewResponseLogsInnerToJSON,
  Bq as TransactionPreviewResponseToJSON,
  vh as TransactionReceiptFromJSON,
  bh as TransactionReceiptFromJSONTyped,
  Sh as TransactionReceiptToJSON,
  Bo as TransactionStatus,
  ma as TransactionStatusFromJSON,
  hh as TransactionStatusFromJSONTyped,
  Wq as TransactionStatusRequestAllOfFromJSON,
  DN as TransactionStatusRequestAllOfFromJSONTyped,
  Hq as TransactionStatusRequestAllOfToJSON,
  zq as TransactionStatusRequestFromJSON,
  JN as TransactionStatusRequestFromJSONTyped,
  CN as TransactionStatusRequestToJSON,
  e$ as TransactionStatusResponseAllOfFromJSON,
  UN as TransactionStatusResponseAllOfFromJSONTyped,
  n$ as TransactionStatusResponseAllOfToJSON,
  qN as TransactionStatusResponseFromJSON,
  $N as TransactionStatusResponseFromJSONTyped,
  Kd as TransactionStatusResponseKnownPayloadItemFromJSON,
  MN as TransactionStatusResponseKnownPayloadItemFromJSONTyped,
  Bd as TransactionStatusResponseKnownPayloadItemToJSON,
  Qq as TransactionStatusResponseToJSON,
  sk as TransactionStatusToJSON,
  r$ as TransactionSubmitRequestFromJSON,
  LN as TransactionSubmitRequestFromJSONTyped,
  jN as TransactionSubmitRequestToJSON,
  KN as TransactionSubmitResponseFromJSON,
  BN as TransactionSubmitResponseFromJSONTyped,
  s$ as TransactionSubmitResponseToJSON,
  $c as ValidationErrorsAtPathFromJSON,
  Pv as ValidationErrorsAtPathFromJSONTyped,
  Uc as ValidationErrorsAtPathToJSON,
  u$ as ValidatorCollectionAllOfFromJSON,
  ZN as ValidatorCollectionAllOfFromJSONTyped,
  l$ as ValidatorCollectionAllOfToJSON,
  qd as ValidatorCollectionFromJSON,
  Q0 as ValidatorCollectionFromJSONTyped,
  G0 as ValidatorCollectionItemActiveInEpochFromJSON,
  W0 as ValidatorCollectionItemActiveInEpochFromJSONTyped,
  H0 as ValidatorCollectionItemActiveInEpochToJSON,
  Dd as ValidatorCollectionItemFromJSON,
  X0 as ValidatorCollectionItemFromJSONTyped,
  Md as ValidatorCollectionItemToJSON,
  $d as ValidatorCollectionToJSON,
  Zd as ValidatorUptimeCollectionFromJSON,
  HN as ValidatorUptimeCollectionFromJSONTyped,
  zN as ValidatorUptimeCollectionItemFromJSON,
  GN as ValidatorUptimeCollectionItemFromJSONTyped,
  WN as ValidatorUptimeCollectionItemToJSON,
  zd as ValidatorUptimeCollectionToJSON,
  Pa as ValidatorVaultItemFromJSON,
  Y0 as ValidatorVaultItemFromJSONTyped,
  Va as ValidatorVaultItemToJSON,
  y$ as ValidatorsUptimeRequestAllOfFromJSON,
  QN as ValidatorsUptimeRequestAllOfFromJSONTyped,
  _$ as ValidatorsUptimeRequestAllOfToJSON,
  p$ as ValidatorsUptimeRequestFromJSON,
  YN as ValidatorsUptimeRequestFromJSONTyped,
  XN as ValidatorsUptimeRequestToJSON,
  b$ as ValidatorsUptimeResponseAllOfFromJSON,
  nw as ValidatorsUptimeResponseAllOfFromJSONTyped,
  S$ as ValidatorsUptimeResponseAllOfToJSON,
  tw as ValidatorsUptimeResponseFromJSON,
  ew as ValidatorsUptimeResponseFromJSONTyped,
  h$ as ValidatorsUptimeResponseToJSON,
  RT as VoidApiResponse,
  Bm as WalletAuthorizedRequestItems,
  sy as WalletAuthorizedRequestResponseItems,
  X_ as WalletData,
  Y_ as WalletDataPersonaData,
  W_ as WalletDataPersonaDataEmailAddresses,
  G_ as WalletDataPersonaDataFullName,
  H_ as WalletDataPersonaDataPhoneNumbersAddresses,
  Qm as WalletInteraction,
  cy as WalletInteractionFailureResponse,
  Xm as WalletInteractionItems,
  Iu as WalletInteractionResponse,
  ly as WalletInteractionSuccessResponse,
  Zm as WalletRequestItems,
  oy as WalletRequestResponseItems,
  E_ as WalletSdk,
  Gm as WalletTransactionItems,
  qm as WalletUnauthorizedRequestItems,
  ET as canConsumeForm,
  qa as chunk,
  Ww as config,
  kT as createLogger,
  fn as createSdkError,
  Qn as errorType,
  xa as eventType,
  Go as exhaustPagination,
  Wo as exhaustPaginationWithLedgerState,
  c as exists,
  JT as instanceOfAtLedgerStateMixin,
  uk as instanceOfCommittedTransactionInfo,
  yk as instanceOfComponentEntityRoleAssignmentEntry,
  dk as instanceOfComponentEntityRoleAssignmentEntryAssignment,
  _k as instanceOfComponentEntityRoleAssignments,
  gk as instanceOfCursorLimitMixin,
  Nx as instanceOfEntityMetadataCollection,
  wx as instanceOfEntityMetadataCollectionAllOf,
  Ox as instanceOfEntityMetadataItem,
  Sx as instanceOfEntityMetadataItemValue,
  kx as instanceOfEntityMetadataItemValueAllOf,
  Rx as instanceOfEntityNotFoundError,
  Vx as instanceOfEntityNotFoundErrorAllOf,
  nE as instanceOfErrorResponse,
  ik as instanceOfEventsItem,
  iE as instanceOfFromLedgerStateMixin,
  _E as instanceOfFungibleResourcesCollection,
  gE as instanceOfFungibleResourcesCollectionAllOf,
  SE as instanceOfFungibleResourcesCollectionItemBase,
  lE as instanceOfFungibleResourcesCollectionItemGloballyAggregated,
  TE as instanceOfFungibleResourcesCollectionItemGloballyAggregatedAllOf,
  mE as instanceOfFungibleResourcesCollectionItemVaultAggregated,
  xE as instanceOfFungibleResourcesCollectionItemVaultAggregatedAllOf,
  fE as instanceOfFungibleResourcesCollectionItemVaultAggregatedVault,
  IE as instanceOfFungibleResourcesCollectionItemVaultAggregatedVaultAllOf,
  dE as instanceOfFungibleResourcesCollectionItemVaultAggregatedVaultItem,
  JE as instanceOfGatewayErrorBase,
  ME as instanceOfGatewayInfoResponseKnownTarget,
  UE as instanceOfGatewayInfoResponseReleaseInfo,
  jE as instanceOfGatewayStatusResponse,
  BE as instanceOfGatewayStatusResponseAllOf,
  Mx as instanceOfInternalServerError,
  WE as instanceOfInternalServerErrorAllOf,
  Ux as instanceOfInvalidEntityError,
  QE as instanceOfInvalidEntityErrorAllOf,
  Bx as instanceOfInvalidRequestError,
  aR as instanceOfInvalidRequestErrorAllOf,
  Gx as instanceOfInvalidTransactionError,
  oR as instanceOfInvalidTransactionErrorAllOf,
  LE as instanceOfLedgerState,
  cR as instanceOfLedgerStateMixin,
  VT as instanceOfLedgerStateSelector,
  Sk as instanceOfMetadataBoolArrayValue,
  mR as instanceOfMetadataBoolArrayValueAllOf,
  wk as instanceOfMetadataBoolValue,
  hR as instanceOfMetadataBoolValueAllOf,
  kk as instanceOfMetadataDecimalArrayValue,
  OR as instanceOfMetadataDecimalArrayValueAllOf,
  Ek as instanceOfMetadataDecimalValue,
  AR as instanceOfMetadataDecimalValueAllOf,
  Pk as instanceOfMetadataGlobalAddressArrayValue,
  ER as instanceOfMetadataGlobalAddressArrayValueAllOf,
  Ck as instanceOfMetadataGlobalAddressValue,
  VR as instanceOfMetadataGlobalAddressValueAllOf,
  qk as instanceOfMetadataI32ArrayValue,
  MR as instanceOfMetadataI32ArrayValueAllOf,
  Lk as instanceOfMetadataI32Value,
  LR as instanceOfMetadataI32ValueAllOf,
  Bk as instanceOfMetadataI64ArrayValue,
  ZR as instanceOfMetadataI64ArrayValueAllOf,
  Gk as instanceOfMetadataI64Value,
  HR as instanceOfMetadataI64ValueAllOf,
  Yk as instanceOfMetadataInstantArrayValue,
  tI as instanceOfMetadataInstantArrayValueAllOf,
  tF as instanceOfMetadataInstantValue,
  rI as instanceOfMetadataInstantValueAllOf,
  rF as instanceOfMetadataNonFungibleGlobalIdArrayValue,
  uI as instanceOfMetadataNonFungibleGlobalIdArrayValueAllOf,
  nF as instanceOfMetadataNonFungibleGlobalIdArrayValueAllOfValues,
  oF as instanceOfMetadataNonFungibleGlobalIdValue,
  fI as instanceOfMetadataNonFungibleGlobalIdValueAllOf,
  cF as instanceOfMetadataNonFungibleLocalIdArrayValue,
  _I as instanceOfMetadataNonFungibleLocalIdArrayValueAllOf,
  pF as instanceOfMetadataNonFungibleLocalIdValue,
  bI as instanceOfMetadataNonFungibleLocalIdValueAllOf,
  _F as instanceOfMetadataOriginArrayValue,
  wI as instanceOfMetadataOriginArrayValueAllOf,
  vF as instanceOfMetadataOriginValue,
  FI as instanceOfMetadataOriginValueAllOf,
  FF as instanceOfMetadataPublicKeyArrayValue,
  II as instanceOfMetadataPublicKeyArrayValueAllOf,
  DF as instanceOfMetadataPublicKeyHashArrayValue,
  CI as instanceOfMetadataPublicKeyHashArrayValueAllOf,
  $F as instanceOfMetadataPublicKeyHashValue,
  $I as instanceOfMetadataPublicKeyHashValueAllOf,
  jF as instanceOfMetadataPublicKeyValue,
  KI as instanceOfMetadataPublicKeyValueAllOf,
  ZF as instanceOfMetadataStringArrayValue,
  GI as instanceOfMetadataStringArrayValueAllOf,
  WF as instanceOfMetadataStringValue,
  XI as instanceOfMetadataStringValueAllOf,
  aP as instanceOfMetadataTypedValueBase,
  XF as instanceOfMetadataU32ArrayValue,
  oP as instanceOfMetadataU32ArrayValueAllOf,
  ex as instanceOfMetadataU32Value,
  dP as instanceOfMetadataU32ValueAllOf,
  rx as instanceOfMetadataU64ArrayValue,
  yP as instanceOfMetadataU64ArrayValueAllOf,
  ox as instanceOfMetadataU64Value,
  vP as instanceOfMetadataU64ValueAllOf,
  cx as instanceOfMetadataU8ArrayValue,
  NP as instanceOfMetadataU8ArrayValueAllOf,
  px as instanceOfMetadataU8Value,
  kP as instanceOfMetadataU8ValueAllOf,
  _x as instanceOfMetadataUrlArrayValue,
  RP as instanceOfMetadataUrlArrayValueAllOf,
  vx as instanceOfMetadataUrlValue,
  JP as instanceOfMetadataUrlValueAllOf,
  qP as instanceOfNetworkConfigurationResponse,
  MP as instanceOfNetworkConfigurationResponseWellKnownAddresses,
  jP as instanceOfNonFungibleIdsCollection,
  KP as instanceOfNonFungibleIdsCollectionAllOf,
  eV as instanceOfNonFungibleResourcesCollection,
  nV as instanceOfNonFungibleResourcesCollectionAllOf,
  iV as instanceOfNonFungibleResourcesCollectionItemBase,
  GP as instanceOfNonFungibleResourcesCollectionItemGloballyAggregated,
  lV as instanceOfNonFungibleResourcesCollectionItemGloballyAggregatedAllOf,
  QP as instanceOfNonFungibleResourcesCollectionItemVaultAggregated,
  pV as instanceOfNonFungibleResourcesCollectionItemVaultAggregatedAllOf,
  YP as instanceOfNonFungibleResourcesCollectionItemVaultAggregatedVault,
  _V as instanceOfNonFungibleResourcesCollectionItemVaultAggregatedVaultAllOf,
  HP as instanceOfNonFungibleResourcesCollectionItemVaultAggregatedVaultItem,
  vV as instanceOfNonFungibleResourcesCollectionItemVaultAggregatedVaultItemAllOf,
  Yx as instanceOfNotSyncedUpError,
  NV as instanceOfNotSyncedUpErrorAllOf,
  AV as instanceOfOptionalNonFungibleIdsCollection,
  xV as instanceOfOptionalNonFungibleIdsCollectionAllOf,
  zT as instanceOfProgrammaticScryptoSborValueArray,
  JV as instanceOfProgrammaticScryptoSborValueArrayAllOf,
  MV as instanceOfProgrammaticScryptoSborValueBase,
  HT as instanceOfProgrammaticScryptoSborValueBool,
  LV as instanceOfProgrammaticScryptoSborValueBoolAllOf,
  QT as instanceOfProgrammaticScryptoSborValueBytes,
  ZV as instanceOfProgrammaticScryptoSborValueBytesAllOf,
  nA as instanceOfProgrammaticScryptoSborValueDecimal,
  HV as instanceOfProgrammaticScryptoSborValueDecimalAllOf,
  iA as instanceOfProgrammaticScryptoSborValueEnum,
  tJ as instanceOfProgrammaticScryptoSborValueEnumAllOf,
  uA as instanceOfProgrammaticScryptoSborValueI128,
  rJ as instanceOfProgrammaticScryptoSborValueI128AllOf,
  dA as instanceOfProgrammaticScryptoSborValueI16,
  uJ as instanceOfProgrammaticScryptoSborValueI16AllOf,
  mA as instanceOfProgrammaticScryptoSborValueI32,
  fJ as instanceOfProgrammaticScryptoSborValueI32AllOf,
  gA as instanceOfProgrammaticScryptoSborValueI64,
  _J as instanceOfProgrammaticScryptoSborValueI64AllOf,
  bA as instanceOfProgrammaticScryptoSborValueI8,
  bJ as instanceOfProgrammaticScryptoSborValueI8AllOf,
  wA as instanceOfProgrammaticScryptoSborValueMap,
  wJ as instanceOfProgrammaticScryptoSborValueMapAllOf,
  OA as instanceOfProgrammaticScryptoSborValueMapEntry,
  kA as instanceOfProgrammaticScryptoSborValueNonFungibleLocalId,
  FJ as instanceOfProgrammaticScryptoSborValueNonFungibleLocalIdAllOf,
  EA as instanceOfProgrammaticScryptoSborValueOwn,
  IJ as instanceOfProgrammaticScryptoSborValueOwnAllOf,
  PA as instanceOfProgrammaticScryptoSborValuePreciseDecimal,
  CJ as instanceOfProgrammaticScryptoSborValuePreciseDecimalAllOf,
  CA as instanceOfProgrammaticScryptoSborValueReference,
  $J as instanceOfProgrammaticScryptoSborValueReferenceAllOf,
  qA as instanceOfProgrammaticScryptoSborValueString,
  KJ as instanceOfProgrammaticScryptoSborValueStringAllOf,
  LA as instanceOfProgrammaticScryptoSborValueTuple,
  GJ as instanceOfProgrammaticScryptoSborValueTupleAllOf,
  BA as instanceOfProgrammaticScryptoSborValueU128,
  XJ as instanceOfProgrammaticScryptoSborValueU128AllOf,
  GA as instanceOfProgrammaticScryptoSborValueU16,
  n1 as instanceOfProgrammaticScryptoSborValueU16AllOf,
  YA as instanceOfProgrammaticScryptoSborValueU32,
  s1 as instanceOfProgrammaticScryptoSborValueU32AllOf,
  tk as instanceOfProgrammaticScryptoSborValueU64,
  c1 as instanceOfProgrammaticScryptoSborValueU64AllOf,
  ak as instanceOfProgrammaticScryptoSborValueU8,
  m1 as instanceOfProgrammaticScryptoSborValueU8AllOf,
  v1 as instanceOfPublicKeyBase,
  OF as instanceOfPublicKeyEcdsaSecp256k1,
  N1 as instanceOfPublicKeyEcdsaSecp256k1AllOf,
  TF as instanceOfPublicKeyEddsaEd25519,
  k1 as instanceOfPublicKeyEddsaEd25519AllOf,
  I1 as instanceOfPublicKeyHashBase,
  RF as instanceOfPublicKeyHashEcdsaSecp256k1,
  C1 as instanceOfPublicKeyHashEcdsaSecp256k1AllOf,
  VF as instanceOfPublicKeyHashEddsaEd25519,
  $1 as instanceOfPublicKeyHashEddsaEd25519AllOf,
  j1 as instanceOfResultSetCursorMixin,
  mk as instanceOfRoleKey,
  Z1 as instanceOfScryptoSborValue,
  z1 as instanceOfStateEntityDetailsOptIns,
  G1 as instanceOfStateEntityDetailsRequest,
  H1 as instanceOfStateEntityDetailsRequestAllOf,
  NC as instanceOfStateEntityDetailsResponse,
  TC as instanceOfStateEntityDetailsResponseAllOf,
  eC as instanceOfStateEntityDetailsResponseComponentDetails,
  xC as instanceOfStateEntityDetailsResponseComponentDetailsAllOf,
  rC as instanceOfStateEntityDetailsResponseFungibleResourceDetails,
  PC as instanceOfStateEntityDetailsResponseFungibleResourceDetailsAllOf,
  oC as instanceOfStateEntityDetailsResponseFungibleVaultDetails,
  DC as instanceOfStateEntityDetailsResponseFungibleVaultDetailsAllOf,
  OC as instanceOfStateEntityDetailsResponseItem,
  Q1 as instanceOfStateEntityDetailsResponseItemAncestorIdentities,
  LC as instanceOfStateEntityDetailsResponseItemDetailsBase,
  cC as instanceOfStateEntityDetailsResponseNonFungibleResourceDetails,
  ZC as instanceOfStateEntityDetailsResponseNonFungibleResourceDetailsAllOf,
  pC as instanceOfStateEntityDetailsResponseNonFungibleVaultDetails,
  HC as instanceOfStateEntityDetailsResponseNonFungibleVaultDetailsAllOf,
  bC as instanceOfStateEntityDetailsResponsePackageDetails,
  tD as instanceOfStateEntityDetailsResponsePackageDetailsAllOf,
  _C as instanceOfStateEntityDetailsResponsePackageDetailsBlueprintCollection,
  aD as instanceOfStateEntityDetailsResponsePackageDetailsBlueprintCollectionAllOf,
  yC as instanceOfStateEntityDetailsResponsePackageDetailsBlueprintItem,
  hC as instanceOfStateEntityDetailsResponsePackageDetailsSchemaCollection,
  sD as instanceOfStateEntityDetailsResponsePackageDetailsSchemaCollectionAllOf,
  gC as instanceOfStateEntityDetailsResponsePackageDetailsSchemaItem,
  lD as instanceOfStateEntityFungibleResourceVaultsPageRequest,
  dD as instanceOfStateEntityFungibleResourceVaultsPageRequestAllOf,
  mD as instanceOfStateEntityFungibleResourceVaultsPageResponse,
  gD as instanceOfStateEntityFungiblesPageRequest,
  vD as instanceOfStateEntityFungiblesPageRequestAllOf,
  _D as instanceOfStateEntityFungiblesPageRequestOptIns,
  OD as instanceOfStateEntityFungiblesPageResponse,
  wD as instanceOfStateEntityMetadataPageRequest,
  AD as instanceOfStateEntityMetadataPageRequestAllOf,
  xD as instanceOfStateEntityMetadataPageResponse,
  RD as instanceOfStateEntityNonFungibleIdsPageRequest,
  PD as instanceOfStateEntityNonFungibleIdsPageRequestAllOf,
  CD as instanceOfStateEntityNonFungibleIdsPageResponse,
  MD as instanceOfStateEntityNonFungibleResourceVaultsPageOptIns,
  qD as instanceOfStateEntityNonFungibleResourceVaultsPageRequest,
  UD as instanceOfStateEntityNonFungibleResourceVaultsPageRequestAllOf,
  KD as instanceOfStateEntityNonFungibleResourceVaultsPageResponse,
  zD as instanceOfStateEntityNonFungiblesPageRequest,
  WD as instanceOfStateEntityNonFungiblesPageRequestAllOf,
  ZD as instanceOfStateEntityNonFungiblesPageRequestOptIns,
  XD as instanceOfStateEntityNonFungiblesPageResponse,
  eM as instanceOfStateKeyValueStoreDataRequest,
  aM as instanceOfStateKeyValueStoreDataRequestAllOf,
  tM as instanceOfStateKeyValueStoreDataRequestKeyItem,
  oM as instanceOfStateKeyValueStoreDataResponse,
  lM as instanceOfStateKeyValueStoreDataResponseAllOf,
  sM as instanceOfStateKeyValueStoreDataResponseItem,
  fM as instanceOfStateNonFungibleDataRequest,
  yM as instanceOfStateNonFungibleDataResponse,
  gM as instanceOfStateNonFungibleDataResponseAllOf,
  mM as instanceOfStateNonFungibleDetailsResponseItem,
  bM as instanceOfStateNonFungibleIdsRequest,
  OM as instanceOfStateNonFungibleIdsRequestAllOf,
  TM as instanceOfStateNonFungibleIdsResponse,
  kM as instanceOfStateNonFungibleIdsResponseAllOf,
  EM as instanceOfStateNonFungibleLocationRequest,
  IM as instanceOfStateNonFungibleLocationRequestAllOf,
  CM as instanceOfStateNonFungibleLocationResponse,
  MM as instanceOfStateNonFungibleLocationResponseAllOf,
  JM as instanceOfStateNonFungibleLocationResponseItem,
  UM as instanceOfStateValidatorsListRequest,
  jM as instanceOfStateValidatorsListRequestAllOf,
  HM as instanceOfStateValidatorsListResponse,
  XM as instanceOfStateValidatorsListResponseAllOf,
  sq as instanceOfStreamTransactionsRequest,
  cq as instanceOfStreamTransactionsRequestAllOf,
  nq as instanceOfStreamTransactionsRequestEventFilterItem,
  pq as instanceOfStreamTransactionsResponse,
  yq as instanceOfStreamTransactionsResponseAllOf,
  jT as instanceOfTransactionBalanceChanges,
  hq as instanceOfTransactionCommittedDetailsRequest,
  bq as instanceOfTransactionCommittedDetailsRequestAllOf,
  Nq as instanceOfTransactionCommittedDetailsResponse,
  Tq as instanceOfTransactionCommittedDetailsResponseAllOf,
  Fq as instanceOfTransactionConstructionResponse,
  aq as instanceOfTransactionDetailsOptIns,
  MT as instanceOfTransactionFungibleBalanceChanges,
  UT as instanceOfTransactionFungibleFeeBalanceChanges,
  LT as instanceOfTransactionNonFungibleBalanceChanges,
  tE as instanceOfTransactionNotFoundError,
  Pq as instanceOfTransactionNotFoundErrorAllOf,
  Uq as instanceOfTransactionPreviewRequest,
  $q as instanceOfTransactionPreviewRequestFlags,
  Kq as instanceOfTransactionPreviewResponse,
  jq as instanceOfTransactionPreviewResponseLogsInner,
  ok as instanceOfTransactionReceipt,
  Zq as instanceOfTransactionStatusRequest,
  Gq as instanceOfTransactionStatusRequestAllOf,
  Xq as instanceOfTransactionStatusResponse,
  t$ as instanceOfTransactionStatusResponseAllOf,
  Yq as instanceOfTransactionStatusResponseKnownPayloadItem,
  a$ as instanceOfTransactionSubmitRequest,
  i$ as instanceOfTransactionSubmitResponse,
  jx as instanceOfValidationErrorsAtPath,
  WM as instanceOfValidatorCollection,
  o$ as instanceOfValidatorCollectionAllOf,
  GM as instanceOfValidatorCollectionItem,
  ZM as instanceOfValidatorCollectionItemActiveInEpoch,
  d$ as instanceOfValidatorUptimeCollection,
  c$ as instanceOfValidatorUptimeCollectionItem,
  zM as instanceOfValidatorVaultItem,
  f$ as instanceOfValidatorsUptimeRequest,
  m$ as instanceOfValidatorsUptimeRequestAllOf,
  g$ as instanceOfValidatorsUptimeResponse,
  v$ as instanceOfValidatorsUptimeResponseAllOf,
  xT as mapValues,
  Nn as messageLifeCycleEventType,
  Oo as personaDataFullNameVariant,
  An as proofType,
  Tl as querystring,
  zw as requestInterceptorFactory,
  py as sdkError,
  Ki as walletDataDefault,
  wT as walletInteractionFactoryV2
};
